/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Kahuna.pages', [
    'ui.router',
    'Kahuna.pages.services',
    'Kahuna.pages.home',
    'Kahuna.pages.jerarquia',
    'Kahuna.pages.template',
    'Kahuna.pages.campo',
    'Kahuna.pages.proceso',
    'Kahuna.pages.grupo',
    'Kahuna.pages.grupos-usuarios',
    'Kahuna.pages.solicitud',
    'Kahuna.pages.reporte',
    'Kahuna.components',
    'Kahuna.pages.usuario',
    'Kahuna.pages.autosolicitud',
    'Kahuna.pages.autoautorizar',
    'Kahuna.pages.auxparametros'
  ]).config(routeConfig);

  /** @ngInject */
  function routeConfig($urlRouterProvider,$stateProvider, baSidebarServiceProvider) {
    $urlRouterProvider.otherwise('/home');
    $stateProvider
    .state('pages', {
      templateUrl: 'app/pages/shell.html',
      abstract: true,
      authenticate: true,
    });
    
  }

})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme', [
      'toastr',
      'chart.js',
      'angular-chartist',
      'angular.morris-chart',
      'textAngular',
      'BlurAdmin.theme.components',
      'BlurAdmin.theme.inputs'
  ]);

})();

(function () {
    'use strict';
    angular.module('Kahuna.pages.autoautorizar', []);
  })();
  
(function () {
    'use strict';
  
    angular.module('Kahuna.pages.autosolicitud', []);
  })();
  
(function () {
    'use strict';
    angular.module('Kahuna.pages.auxparametros', []);
  })();
  
(function () {
    'use strict';
  
    angular.module('Kahuna.pages.campo', []);
  })();
  
(function () {
    'use strict';
  
    angular.module('Kahuna.pages.grupo', []);
  })();
  
(function () {
    'use strict';
    angular.module('Kahuna.pages.grupos-usuarios', []);
  })();
  
(function () {
  'use strict';

  angular.module('Kahuna.pages.home', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('pages.home', {
          url: '/home',
          // templateUrl: 'app/pages/home/home.html',
          template : '<home-inicio></home-inicio>',
          title: 'Inicio',
          sidebarMeta: {
            icon: 'ion-android-home',
            order: 0,
          },
          authenticate:true
        });
  }

})();

(function () {
    'use strict';
  
    angular.module('Kahuna.pages.jerarquia', []);
  })();
  
(function () {
    'use strict';
  
    angular.module('Kahuna.pages.proceso', []);
  })();
  
(function () {
    'use strict';
  
    angular.module('Kahuna.pages.reporte', []);
  })();
  
(function () {
    'use strict';
  
    angular.module('Kahuna.pages.template', []);
  })();
  
(function () {
    'use strict';
  
    angular.module('Kahuna.pages.solicitud', []);
  })();
  
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Kahuna.pages.tables', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
        .state('tables', {
          url: '/tables',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          controller: 'TablesPageCtrl',
          title: 'Tables',
          sidebarMeta: {
            icon: 'ion-grid',
            order: 300,
          },
        }).state('tables.basic', {
          url: '/basic',
          templateUrl: 'app/pages/tables/basic/tables.html',
          title: 'Basic Tables',
          sidebarMeta: {
            order: 0,
          },
        }).state('tables.smart', {
          url: '/smart',
          templateUrl: 'app/pages/tables/smart/tables.html',
          title: 'Smart Tables',
          sidebarMeta: {
            order: 100,
          },
        });
    $urlRouterProvider.when('/tables','/tables/basic');
  }

})();

(function () {
    'use strict';
  
    angular.module('Kahuna.pages.usuario', []);
  })();
  
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs', []);

})();

'use strict';

angular.module('Kahuna', [
  'ngAnimate',
  'ui.bootstrap',
  'ui.sortable',
  'ui.router',
  'ngTouch',
  'ngFileUpload',
  'toastr',
  "xeditable",
  'ui.slimscroll',
  'ngJsTree',
  'angular-progress-button-styles',
  'BlurAdmin.theme',
  'Kahuna.pages',
  'Kahuna.auth',
  'angularTrix',
  'smart-table',
  'wysiwyg.module'
  //'SweetAlert'
]);

angular.module('Kahuna').constant('appConfig', {'apiUrl': 'http://localhost:58149/Kahuna.Api/api/','uploadUrl': 'http://localhost:58149/Kahuna.Api/uploads/',});

angular.module('Kahuna.pages.services',[]);
angular.module('Kahuna.components',[]);
angular.module('Kahuna.pages.tables',[]);
angular.module('Kahuna.auth',[]);
angular.module('Kahuna.factories',[]);
angular.module("Kahuna").factory('httpInterceptorFactory', httpInterceptorFactory);
angular.module('Kahuna').config(['$httpProvider', function($httpProvider) {
  //cfpLoadingBarProvider.includeSpinner = true;
  //console.log($httpProvider);
  $httpProvider.interceptors.push('httpInterceptorFactory');
}]);

angular.module('Kahuna').run(stateChangeStart);

httpInterceptorFactory.$inject = ['$q', '$injector', '$location', '$rootScope', 'localStorage'];
function httpInterceptorFactory($q, $injector, $location, $rootScope, localStorage) { //, DialogFactory) {

  var service = {
      request: request,
      response: response,
      responseError: responseError
  };

  return service;

  function request(config) 
  {
    config.headers = config.headers || {};
    
    var authData = localStorage.getObject('dataUser_kahuna');
    //console.log(authData.Clave);
    if (authData && authData.Clave) 
    {
        config.headers.Authorization = 'Bearer' + ' ' + authData.Clave;
    }

    return config;
  }

  function response(response) 
  {
    return response;
  }

  function responseError(rejection) 
  {
    if (rejection.status === 401 || rejection.status === 403) 
    {
      //localStorage.setObject('dataUser', {});
      $location.path('/login');
    } 
    else 
    {
      console.error("API call error.");
    }

    return $q.reject(rejection);
  }
}

/** @ngInject */
function stateChangeStart($rootScope, $state, dataService, sharedService) 
{
  $rootScope.$on("$stateChangeStart", function(event, toState, toParams, fromState, fromParams, $window, $location) 
  {
    if (toState.authenticate)
    {
      var authData = sharedService.getLoggedUser();

      if (!authData || !authData.Login)
      {
        $state.go('auth',{returnUrl:window.location.href});
        event.preventDefault();
      }
    }
  });
}



(function (angular) {
  'use strict';
  angular.module('Kahuna.auth').component('login', {
    templateUrl: 'app/auth/auth.html',
    controller: function($scope, $state, $window, dataService, sharedService, toastr, toastrConfig, $stateParams, $uibModal) {
      var ctrl = this;
      ctrl.model = {};
      ctrl.appVersion = sharedService.getSystemVersion();
      ctrl.buttonLoginText = 'Ingresar';
      ctrl.logoIcon = sharedService.getAssetsUrl() + 'img/app/KahunaLogoColor.png';

      this.$onInit = function () 
      {
        jQuery('.al-footer-main').css({color: '#d9d9d9'});
        jQuery('.al-footer-right i').css({color: '#d9d9d9'});
        jQuery('.al-footer-right a').css({color: '#d9d9d9'});

        jQuery('.al-footer').css({position: 'fixed', bottom: '65px'});

        var backgroundImageUrl = 'url(' + sharedService.getAssetsUrl() + 'img/app/login-background.jpg)';
        $('body').css('backgroundImage', backgroundImageUrl).css('background-size','100%,100%');
      };

      ctrl.login = function () 
      {
        ctrl.isBusy = true;
        ctrl.buttonLoginText = 'Ingresando...';

        dataService.loginUser(ctrl.model.Usuario,ctrl.model.Password)
          .then(function (response) 
          {
            if (response.data.Success) 
            {
              sharedService.setLoggedUser(response.data.Value.Usuario);
              sharedService.setLoggedUserPermisos(response.data.Value.Menues);
              sharedService.clearLocalData(response.data.Value.Usuario.Id);

              jQuery('.al-footer-main').css({color: ''});
              jQuery('.al-footer-right i').css({color: ''});
              jQuery('.al-footer-right a').css({color: ''});

              jQuery('.al-footer').css({position: 'inherit', bottom: '0'});
              $('body').css('backgroundImage','');

              if ($stateParams != null && $stateParams.returnUrl != null && $stateParams.returnUrl.length > 0)
                $window.location.href = $stateParams.returnUrl;
              else
                $state.go('pages.home');
            } 
            else 
            {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
            ctrl.buttonLoginText = 'Ingresar';
          }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage());
              ctrl.isBusy = false;
              ctrl.buttonLoginText = 'Ingresar';
          });
      }
    }
  });
})(window.angular);
(function () {
    'use strict';
    angular.module('Kahuna.auth').config(routeConfig);
    function routeConfig($stateProvider) {
      $stateProvider
        .state('auth', {
          url: '/login/:returnUrl',
          title: 'Auth',
          template : '<login></login>',
          params: {returnUrl:null},
          authenticate: false,
        });
    }
  })();
(function (angular) {
    'use strict';
    angular.module('Kahuna.components').component('altaJerarquia', {
      templateUrl: 'app/components/altaJerarquia.template.html',
      bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
      },
      controller: function(dataService, sharedService, toastr) {
        var ctrl = this;
        ctrl.model = {};
        ctrl.isBusy = false;

        this.$onInit = function () 
        {
          ctrl.model =
            {
              Nombre: "",
              JerarquiaPadre: ctrl.resolve.JerarquiaPadre,
              Activo: 1
            };
        };

        ctrl.save = function () 
        {
          if (ctrl.model.Nombre == null || ctrl.model.Nombre.length <= 0)
          {
            toastr.error("Ingrese el nombre de la jerarquía a dar de alta");
            return;
          }

          ctrl.isBusy = true;
          ctrl.model.Activo = 1;

          if(ctrl.model.JerarquiaPadre != null && ctrl.model.JerarquiaPadre.Id > 0)
            ctrl.model.JerarquiaPadreId = ctrl.model.JerarquiaPadre.Id;
          else
          {
            ctrl.model.JerarquiaPadreId = null;
            ctrl.model.JerarquiaPadre = null;
          }

          dataService.saveJerarquia(ctrl.model)
            .then(function (response) 
            {
              if (response.data.Success) 
              {
                toastr.info("Operacion exitosa.");
                ctrl.close({$value: response.data.Value});
              } 
              else 
              {
                toastr.error(response.data.ErrorSummary);
              }
              ctrl.isBusy = false;
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage());
              ctrl.isBusy = false;
            });
        }

        ctrl.cancel = function () 
        {
          ctrl.dismiss({});
        }

        ctrl.checkKey = function(event)
        {
          if (event.keyCode == 27)
            ctrl.cancel();

          if (event.keyCode == 13)
            ctrl.save();

          return true;
        }
      }
    });
  })(window.angular);
(function (angular) {
  'use strict';
  angular.module('Kahuna.components').component('baSidebar', {
    templateUrl: 'app/components/baSidebar.template.html',
    controller: function(sharedService,dataService,$state,$scope,baSidebarService,toastr) {
      var ctrl = this;

      this.$onInit = function () 
      {
        var authData = sharedService.getLoggedUser();        
        $scope.appVersion = sharedService.getSystemVersion();

        ctrl.appLogoIcon = sharedService.getAssetsUrl() + 'img/app/KahunaLogoColor.png';
        ctrl.clientLogoIcon = sharedService.getAssetsUrl() + 'img/app/ClienteLogo.png';
        
        if (authData != null && authData.Id > 0)
        {
          var permisosList = sharedService.getLoggedUserPermisos();

          if (permisosList != null && permisosList.length > 0)
          {
            var mainMenuList = getMainMenus(permisosList);

            if (mainMenuList != null)
            {
              for (var i=0; i<mainMenuList.length; i++)
              {
                $scope.menuItems.push(
                {
                  title: mainMenuList[i].Nombre,
                  icon: mainMenuList[i].Icono,
                  stateRef: mainMenuList[i].Ruta,
                  subMenu: getSubMenus(permisosList, mainMenuList[i].Id)
                });
              } //for
            }
            console.log($scope.menuItems);
          }
          else
            $scope.menuItems = {};        
        }
      };

      function getMainMenus(permisosList)
      {
        return permisosList.filter(function(item) {
                                    return item.MenuPadreId == null;
                                  });
      }

      function getSubMenus(permisosList, menuId)
      {
        var submenus =  permisosList.filter(function(item) {
                                              return item.MenuPadreId == menuId;
                                            });

        if (submenus != null && submenus.length > 0)
        {
          var menuList = [];
          for (var i=0; i<submenus.length; i++)
          {
            menuList.push({
                            title: submenus[i].Nombre, 
                            icon: submenus[i].Icono,
                            stateRef: submenus[i].Ruta,
                            subMenu: getSubMenus(permisosList, submenus[i].Id)
                          });
          }

          return menuList;
        }

        return null;
      }

      $scope.menuItems = baSidebarService.getMenuItems();
      //$scope.defaultSidebarState = $scope.menuItems[0].stateRef;

      $scope.hoverItem = function ($event) {
        $scope.showHoverElem = true;
        $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
        var menuTopValue = 66;
        $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
      };

      $scope.$on('$stateChangeSuccess', function () {
        if (baSidebarService.canSidebarBeHidden()) {
          baSidebarService.setMenuCollapsed(true);
        }
      });
    }
  });
})(window.angular);
(function (angular) {
    'use strict';
    angular.module('Kahuna.components').component('cambioClave', {
      templateUrl: 'app/components/cambioClave.template.html',
      bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
      },
      controller: function(dataService, sharedService, toastr) {
        var ctrl = this;
        ctrl.model = {};
        ctrl.isBusy = false;

        this.$onInit = function () 
        {
        };

        ctrl.save = function () 
        {
          if (ctrl.model.ClaveActual == null || ctrl.model.ClaveActual.length <= 0 ||
              ctrl.model.ClaveNueva == null || ctrl.model.ClaveNueva.length <= 0 ||
              ctrl.model.ClaveNuevaConfirmacion == null || ctrl.model.ClaveNuevaConfirmacion.length <= 0)
          {
            toastr.error('Debe completar todos los campos para continuar con la operación');
            return;
          }

          if (ctrl.model.ClaveNueva != ctrl.model.ClaveNuevaConfirmacion)
          {
            toastr.error('La nueva contraseña y su confirmación son distintas. Por revise revise ambas');
            return;
          }

          ctrl.model.UsuarioId = ctrl.resolve.usuarioId;
          ctrl.isBusy = true;

          dataService.saveClaveUsuario(ctrl.model)
            .then(function (response) 
            {
              if (response.data.Success) 
              {
                // ctrl.model = response.data.Value;
                toastr.info("Operacion exitosa.");
                ctrl.close({});
              } 
              else 
              {
                toastr.error(response.data.ErrorSummary);
              }
              ctrl.isBusy = false;
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage());
              ctrl.isBusy = false;
            });
        }

        ctrl.cancel = function () 
        {
          ctrl.dismiss({});
        }

        ctrl.checkKey = function(event)
        {
          if (event.keyCode == 27)
            ctrl.cancel();

          if (event.keyCode == 13)
            ctrl.save();

          return true;
        }
      }
    });
  })(window.angular);
(function (angular) {
    'use strict';
    angular.module('Kahuna.components').component('confirmation', {
      templateUrl: 'app/components/confirmation.template.html',
      bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
      },
      controller: function() {
        var ctrl = this;
        ctrl.model = {};
        this.$onInit = function () {
        };
        ctrl.confirm=function () {
          ctrl.close({})
        }
        ctrl.cancel=function () {
          ctrl.dismiss({})
        }
      }
    });
  })(window.angular);
(function (angular) {
  'use strict';
  angular.module('Kahuna.components').component('pageTop', {
    templateUrl: 'app/components/pageTop.template.html',
    controller: function (dataService, sharedService, $state, $scope, $uibModal) {
      var ctrl = this;
      ctrl.model = {};
      ctrl.appVersion = sharedService.getSystemVersion();
      ctrl.myStyle = {};
      ctrl.applicationProperties = {
        HEADCOLOR : "",
        HEADLINEA1 : "",
        HEADLINEA2 : ""
      };

      this.$onInit = function () {
        var authData = sharedService.getLoggedUser();
        getParametrosInicialesApp();        
        if (authData != null && authData.Login != null)
          ctrl.userMessage = 'Hola ' + authData.Login + '!';
        else
          ctrl.userMessage = 'Hola (sin nombre)';
      };

      function getParametrosInicialesApp() {
        dataService.obtenerParametrosApp()
          .then(function (response) {
            if (response.data.Success) {
              ctrl.applicationProperties = sharedService.arrayToObjProp(response.data.Value, "Ident", "Descripcion");
              sharedService.setLocalData("ApplicationProperties", ctrl.applicationProperties);
              if ( ctrl.applicationProperties.hasOwnProperty("HEADCOLOR")) {
                ctrl.myStyle = {
                  'background-color': ctrl.applicationProperties.HEADCOLOR
                };
              }
            }
          });
      };
      ctrl.cambioClave = function () {
        var authData = sharedService.getLoggedUser();

        if (authData != null && authData.Id > 0) {
          var confirmation = $uibModal.open({
            animation: true,
            component: "cambioClave",
            resolve: {
              title: function () {
                return "Cambio de Contraseña de Usuario " + authData.Login
              },
              usuarioId: function () {
                return authData.Id
              },
            }
          });

          confirmation.result.then(function (selectedItem) {
            ctrl.isBusy = false;
          }, function () {
            ctrl.isBusy = false;
          });
        } else {
          ctrl.logout();
        }
      }

      ctrl.logout = function () {
        var authData = sharedService.getLoggedUser();
        if (authData != null)
          sharedService.clearLocalData(authData.Id);

        sharedService.setLoggedUser({});

        $state.go('auth');
      }
    }
  });
})(window.angular);
(function (angular) {
    'use strict';
    angular.module('Kahuna.components').component('seleccionProceso', {
      templateUrl: 'app/components/seleccionProceso.template.html',
      bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
      },
      controller: function(dataService, sharedService, toastr) {
        var ctrl = this;
        ctrl.model = {};
        ctrl.isBusy = false;

        ctrl.gruposList = [];
        ctrl.procesosList = [];

        this.$onInit = function () 
        {
          ctrl.grupoLoading = true;
          ctrl.procesoLoading = false;

          ctrl.gruposList = [];
          ctrl.procesosList = [];

         /* if (ctrl.resolve.aceptaHijos != null && ctrl.resolve.aceptaHijos)
          {
            dataService.getGrupoByProcesoPadreList(ctrl.resolve.procesoPadreId)
              .then(function (response) 
              {
                if (response.data.Success) 
                {
                  ctrl.gruposList = response.data.Value;
                } 
                else 
                {
                  toastr.error(response.data.ErrorSummary);
                }
                ctrl.grupoLoading = false;
              }, function (error) {
                toastr.error(error.data || sharedService.getGenericErrorMessage());
                ctrl.grupoLoading = false;
            });
          }
          else
          {
            dataService.getGrupoList()
              .then(function (response) 
              {
                if (response.data.Success) 
                {
                  ctrl.gruposList = response.data.Value;
                } 
                else 
                {
                  toastr.error(response.data.ErrorSummary);
                }
                ctrl.grupoLoading = false;
              }, function (error) {
                toastr.error(error.data || sharedService.getGenericErrorMessage());
                ctrl.grupoLoading = false;
            });
          }*/
          ctrl.onSelectGrupo();
        };

        ctrl.onSelectGrupo = function()
        {
          ctrl.procesosList = [];
          ctrl.model.GrupoSeleccionado= {};
          ctrl.model.GrupoSeleccionado.Id = 0;//Default value.

         /* if (ctrl.model.GrupoSeleccionado == null || ctrl.model.GrupoSeleccionado.Id <= 0)
          {
            // toastr.error('Debe seleccionar un grupo');
            return;
          }*/

          ctrl.procesoLoading = true;

          if (ctrl.resolve.aceptaHijos != null && ctrl.resolve.aceptaHijos)
          {
            dataService.getProcesoHijoSeleccionableList(0, ctrl.resolve.procesoPadreId)
              .then(function (response) 
              {
                if (response.data.Success) 
                {
                  ctrl.procesosList = response.data.Value;
                } 
                else 
                {
                  toastr.error(response.data.ErrorSummary);
                }
                ctrl.procesoLoading = false;
              }, function (error) {
                toastr.error(error.data || sharedService.getGenericErrorMessage());
                ctrl.procesoLoading = false;
            });
          }
          else
          {
            var filtrosProceso = { PageSize: 100, SkipNumber: 0 };
            filtrosProceso.Grupo = {};
            filtrosProceso.Grupo.Id = ctrl.model.GrupoSeleccionado.Id;
            dataService.searchProceso(filtrosProceso)
              .then(function (response) 
              {
                if (response.data.Success) 
                {
                  ctrl.procesosList = response.data.Value.Resultados;
                } 
                else 
                {
                  toastr.error(response.data.ErrorSummary);
                }
                ctrl.procesoLoading = false;
              }, function (error) {
                toastr.error(error.data || sharedService.getGenericErrorMessage());
                ctrl.procesoLoading = false;
            });
          }
        }

        ctrl.save = function () 
        {
          if (ctrl.model.ProcesoSeleccionado != null && ctrl.model.ProcesoSeleccionado.Id > 0)
          {
            ctrl.close({$value: ctrl.model});
          }
          else
          {
            toastr.error("Debe seleccionar un proceso antes de continuar con la operación");
          }
        }

        ctrl.cancel = function () 
        {
          ctrl.dismiss({});
        }

        ctrl.checkKey = function(event)
        {
          if (event.keyCode == 27)
            ctrl.cancel();

          if (event.keyCode == 13)
            ctrl.save();

          return true;
        }
      }
    });
  })(window.angular);
(function () {
    'use strict';

    // angular.module("Kahuna.factories").factory('httpInterceptorFactory', httpInterceptorFactory);

    //httpInterceptorFactory.$inject = ['$q', '$injector', '$location', '$rootScope', 'localStorage'];

    function httpInterceptorFactory() { //$q, $injector, $location, $rootScope, localStorage) { //, DialogFactory) {

        // var service = {
        //     request: request,
        //     response: response,
        //     responseError: responseError
        // };

        // return service;

        // function request(config) {
        //     config.headers = config.headers || {};
            
        //     var authData = sharedService.getLoggedUser();
        //     console.log(authData.Clave);
        //     if (authData && authData.Clave) 
        //     {
        //         config.headers.Authorization = 'Bearer' + ' ' + authData.Clave;
        //     }

        //     return config;
        // }

        // function response(response) {
        //     return response;
        // }

        // function responseError(rejection) {
        //     if (rejection.status === 401 || rejection.status === 403) {
        //         //localStorage.setObject('dataUser', {});
        //         $location.path('/login');
        //     } else {
        //         console.error("API call error.")
        //     }

        //     return $q.reject(rejection);
        // }
    }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    //baConfigProvider.changeTheme({blur: true});
    // ``
    //baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    //});
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('BlurAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('BlurAdmin.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings, sharedService) {
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(3000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.appVersion = sharedService.getSystemVersion();
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 7000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
(function () {
    'use strict';
    angular.module('Kahuna.pages.autoautorizar').config(routeConfig);
    function routeConfig($stateProvider) {
      $stateProvider
        .state('pages.autoautorizar', {
          url: '/autoautorizar',
          title: 'autoautorizar',
          template : '<autoautorizar-list></autoautorizar-list>',
          authenticate: true,
        })
        .state('pages.autoautorizar-edit', {
          url: '/autoautorizar/edit/:id',
          title: 'autoautorizar',
          template : '<autoautorizar-edit></autoautorizar-edit>',
          params: {id:null},
          authenticate: true,
        });
    }
  })();
(function (angular) {
  "use strict";
  angular.module("Kahuna.pages.autoautorizar").component("autoautorizarEdit", {
    templateUrl: "app/pages/autoautorizar/edit.template.html",
    controller: function (
      $scope,
      $state,
      dataService,
      sharedService,
      toastr,
      toastrConfig,
      $stateParams,
      $timeout,
      $uibModal
    ) {
      var ctrl = this;
      ctrl.model = {};
      ctrl.isBusy = false;
      ctrl.enableDatosProcesoTab = false;
      ctrl.showDelete = false;
      ctrl.showCampoProcesoTituloSelect = false;
      ctrl.showCampoTemplateTituloSelect = false;
      ctrl.showTemplateTituloSelect = false;

      ctrl.title = "";
      ctrl.configuracionTituloText = "";
      ctrl.camposList = [];

      ctrl.procesoCamposDS = [];
      ctrl.procesoUsuariosDS = [];
      ctrl.procesoTemplatesDS = [];

      ctrl.campoCargado = {};

      ctrl.filtrosProcesos = {
        PageSize: 500,
        SkipNumber: 0,
      };
      ctrl.resultListProcesos = [];
      ctrl.resultListTemplatesProcesos = [];
      ctrl.listaAutoSolicitud = [];

      this.$onInit = function () {
        loadProcesos();
        getParametrosByIdent(ctrl.ident);
      };

      function loadView() {
        ctrl.enableDatosProcesoTab = sharedService.isSysAdminLoggedUser();
        if ($stateParams.id != "0") {
          ctrl.isTemplateSearching = true;
          ctrl.isTemplateUsuarioSearching = true;
          ctrl.isUsuarioSearching = true;
          ctrl.isCampoSearching = true;
          dataService.getAutoAutorizarById($stateParams.id).then(
            function (response) {
              if (response.data.Success) {
                ctrl.model = response.data.Value;
                ctrl.model.procesoId = "" + ctrl.model.procesoId + "";
                ctrl.model.CodigoProcedure =
                  "" + ctrl.model.CodigoProcedure + "";
                ctrl.model.campoId = "" + ctrl.model.campoId + "";
                ctrl.model.ProcesoTemplate = {
                  TemplateId: "" + ctrl.model.IdProcesoTemplate + "",
                };
                ctrl.loadTemplatesProcesos();
                ctrl.title = "Editar Auto Autorizar: " + ctrl.model.AutClave;
                ctrl.showDelete = sharedService.isSysAdminLoggedUser();
              } else {
                toastr.error(response.data.ErrorSummary);
              }
            },
            function (error) {
              toastr.error(
                error.data || sharedService.getGenericErrorMessage()
              );
            }
          );
        } else {
          ctrl.title = "Crear autoautorizar: -";
        }
      }

      function loadProcesos() {
        ctrl.isSearching = true;
        sharedService.showLoading();
        ctrl.listarAutoSolicitud();
        dataService.getCampoListLigth().then(
          function (response) {
            if (response.data.Success) {
              ctrl.camposList = response.data.Value;
              dataService.searchProceso(ctrl.filtrosProcesos).then(
                function (response) {
                  if (response.data.Success) {
                    ctrl.resultListProcesos = response.data.Value.Resultados;
                    sharedService.closeLoading();
                    loadView();
                  } else {
                    toastr.error(response.data.ErrorSummary);
                  }
                  ctrl.isSearching = false;
                },
                function (error) {
                  toastr.error(
                    error.data || sharedService.getGenericErrorMessage()
                  );
                  ctrl.isSearching = false;
                }
              );
            } else {
              toastr.error(response.data.ErrorSummary);
            }
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
          }
        );
      }

      ctrl.loadTemplatesProcesos = function () {
        ctrl.isSearching = true;
        dataService.searchTemplatesByProceso(ctrl.model.procesoId).then(
          function (response) {
            if (response.data.Success) {
              ctrl.resultListTemplatesProcesos = response.data.Value.Resultados;
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isSearching = false;
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
            ctrl.isSearching = false;
          }
        );
      };

      ctrl.listarAutoSolicitud = function buscar() {
        ctrl.isSearching = true;
        ctrl.filtros = {
          PageSize: 500,
          SkipNumber: 0,
        };
        ctrl.filtros.DetalleAcciones = "";
        ctrl.filtros.SubjectCorreo = "";
        ctrl.filtros.AutoId = "";
        dataService.searchAutoSolicitud(ctrl.filtros).then(
          function (response) {
            if (response.data.Success) {
              ctrl.listaAutoSolicitud = response.data.Value.Resultados;
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isSearching = false;
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
            ctrl.isSearching = false;
          }
        );
      };

      ctrl.setIdSSolicitudEstado = function () {
        ctrl.model.ProcesoTemplateTemp = ctrl.model.ProcesoTemplate;
        if (
          ctrl.model.ProcesoTemplate != null &&
          ctrl.model.ProcesoTemplate != undefined
        ) {
          ctrl.model.IdProcesoTemplate =
            ctrl.model.ProcesoTemplateTemp.TemplateId;
          ctrl.model.IdSolicitudEstado =
            ctrl.model.ProcesoTemplateTemp.SolicitudEstadoId;
        } else {
          ctrl.model.IdSolicitudEstado = "";
        }
      };

      ctrl.actualizarTitulo = function () {
        if (ctrl.model != null) {
          if ($stateParams.id != "0")
            ctrl.title = "Editar Auto Solicitud: " + ctrl.model.autoautorizarId;
          else
            ctrl.title = "Crear Auto Solicitud: " + ctrl.model.autoautorizarId;
        }
      };

      ctrl.save = function () {
        if (!ctrl.form.$valid) {
          toastr.error(
            "Por favor complete los datos obligatorios marcados con asterisco"
          );
          return;
        }

        ctrl.isBusy = true;
        ctrl.model.autoautorizarDetalle = ctrl.procesoCamposDS;
        dataService.saveAutoAutorizar(ctrl.model).then(
          function (response) {
            if (response.data.Success) {
              toastr.info("Operacion exitosa.");
              $state.transitionTo("pages.autoautorizar");
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
            ctrl.isBusy = false;
          }
        );
      };

      ctrl.cancel = function () {
        $state.transitionTo("pages.autoautorizar");
      };

      ctrl.delete = function () {
        ctrl.isBusy = true;
        var confirmation = $uibModal.open({
          animation: true,
          component: "confirmation",
          resolve: {
            title: function () {
              return "Atención";
            },
            message: function () {
              return "Confirma el borrado del registro seleccionado?";
            },
          },
        });
        confirmation.result.then(
          function (selectedItem) {
            dataService.deleteAutoAutorizar(ctrl.model.Id).then(
              function (response) {
                if (response.data.Success) {
                  toastr.info("Operacion exitosa.");
                  $state.transitionTo("pages.autoautorizar");
                } else {
                  toastr.error(response.data.ErrorSummary);
                }
                ctrl.isBusy = false;
              },
              function (error) {
                toastr.error(
                  error.data || sharedService.getGenericErrorMessage()
                );
                ctrl.isBusy = false;
              }
            );
          },
          function () {
            ctrl.isBusy = false;
          }
        );
      };

      ctrl.openAttachment = function (fileName) {
        window.open(appConfig.uploadUrl + fileName);
      };

      ctrl.uploadAttachment = function (file) {
        if (file == null) return;

        ctrl.isBusy = true;
        ctrl.model.isImageLoading = true;

        dataService.uploadImageFileProceso(file).then(
          function (response) {
            $timeout(function () {
              if (response.data.Success) {
                ctrl.model.UrlImagen = response.data.Value; //{ fileName: file.name, serverFileName: response.data.Value };
              } else {
                ctrl.model.UrlImagen = null;
              }
            });
            ctrl.isBusy = false;
            ctrl.model.isImageLoading = false;
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
            ctrl.isBusy = false;
            ctrl.model.isImageLoading = false;
          }
        );
      };

      ctrl.removeAttachment = function () {
        ctrl.model.UrlImagen = null;
      };

      /******************* Campos *******************/
      ctrl.editCampo = function () {
        if (!ctrl.formDetalle.$valid) {
          toastr.error(
            "Por favor complete los datos obligatorios marcados con asterisco para cargar el detalle de autoautorizar"
          );
          return;
        }
        ctrl.campoCargado.autoautorizarId = this.model.autoautorizarId;
        if (ctrl.procesoCamposList == null) ctrl.procesoCamposList = [];

        /*var index = -1;
        for (var i = 0; i < ctrl.procesoCamposList.length; i++) {
          index = i;
        }*/
        /*if (index >= 0)
          ctrl.procesoCamposList[index] = ctrl.campoCargado;
        else*/
        ctrl.procesoCamposList.push(ctrl.campoCargado);
        //ctrl.procesoCamposList.sort(function (a, b) { return (parseInt(a.Orden) > parseInt(b.Orden) ? 1 : (parseInt(b.Orden) > parseInt(a.Orden)) ? -1 : 0); });
        ctrl.procesoCamposDS.push(ctrl.campoCargado);
        ctrl.campoCargado = {};
      };

      ctrl.cargarCampo = function (campoSeleccionado) {
        if (campoSeleccionado == null) {
          toastr.error("Por favor seleccione un campo para poder visualizarlo");
          return;
        }

        ctrl.campoCargado = {};
        ctrl.campoCargado.autoautorizarId = campoSeleccionado.autoautorizarId;
        ctrl.campoCargado.OrigenCampo = campoSeleccionado.OrigenCampo;
        ctrl.campoCargado.IdCampoDestino = campoSeleccionado.IdCampoDestino;
        ctrl.campoCargado.IdCampoOrigen = campoSeleccionado.IdCampoOrigen;
        ctrl.campoCargado.OrigenCampoA = campoSeleccionado.OrigenCampoA;
        ctrl.campoCargado.IdCampoOrigenA = campoSeleccionado.IdCampoOrigenA;
        ctrl.campoCargado.OrigenCampoB = campoSeleccionado.OrigenCampoB;
        ctrl.campoCargado.IdCampoOrigenB = campoSeleccionado.IdCampoOrigenB;
        ctrl.campoCargado.OrigenCampoC = campoSeleccionado.OrigenCampoC;
        ctrl.campoCargado.IdCampoOrigenC = campoSeleccionado.IdCampoOrigenC;
        ctrl.campoCargado.ValCampoOrigen = campoSeleccionado.ValCampoOrigen;
        ctrl.campoCargado.UsuarioCreacionid =
          campoSeleccionado.UsuarioCreacionid;
        ctrl.campoCargado.UsuarioModificacionId =
          campoSeleccionado.UsuarioModificacionId;
      };

      ctrl.ident = "AUTOAUTORIZAR";
      ctrl.auxParams = [];
      function getParametrosByIdent(Ident) {
        if (Ident != "") {
          dataService
            .obtenerALLParametrosByIdent(Ident)
            .then(function (response) {
              if (response.data.Success && response.data.Value != null) {
                ctrl.showBtnLink = true;
                ctrl.auxParams = response.data.Value;
              }
            });
        }
      }

      ctrl.returnDescription = function (tipocampo) {
        if (ctrl.auxParams.length > 1) {
          return ctrl.auxParams.filter(function (p) {
            return p.TipoCampo == tipocampo;
          })[0].Descripcion;
        }
        return;
      };

      ctrl.eliminarCampo = function (index) {
        if (index < 0) {
          toastr.error("Campo seleccionado inválido");
          return;
        }

        if (ctrl.procesoCamposList != null && ctrl.procesoCamposList.length > 0)
          ctrl.procesoCamposList.splice(index, 1);
      };

      ctrl.clearCampo = function () {
        ctrl.campoCargado = {};
      };
    },
  });
})(window.angular);

(function (angular) {
    'use strict';
    angular.module('Kahuna.pages.autoautorizar').component('autoautorizarList', {
      templateUrl: 'app/pages/autoautorizar/list.template.html',
      controller: function ($scope,$state,dataService,sharedService,toastr) {
        var ctrl = this;
        ctrl.mostrarAgregar = false;
        
        this.$onInit = function () 
        {
          ctrl.mostrarAgregar = sharedService.isSysAdminLoggedUser();
        };

        ctrl.buscar = function buscar(tableState) 
        {
          ctrl.isSearching = true;

          var pagination = tableState.pagination;

          var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
          var number = pagination.number || 10;  // Number of entries showed per page.

          ctrl.filtros = { PageSize: number, SkipNumber: start };

          if (tableState.search.predicateObject != null)
          {
            ctrl.filtros.DetalleAcciones = tableState.search.predicateObject.DetalleAcciones;
            ctrl.filtros.SubjectCorreo = tableState.search.predicateObject.SubjectCorreo;
            ctrl.filtros.AutoId = tableState.search.predicateObject.AutoId;
            //ctrl.filtros.Grupo = tableState.search.predicateObject.Grupo;
            //ctrl.filtros.CantidadDiasCierre = tableState.search.predicateObject.CantidadDiasCierre;

            if (tableState.search.predicateObject.RequiereValidacion == 1 ||
                tableState.search.predicateObject.RequiereValidacion == 'true')
              ctrl.filtros.RequiereValidacion = true;
            else
            {
              if (tableState.search.predicateObject.RequiereValidacion == 0 ||
                  tableState.search.predicateObject.RequiereValidacion == 'false')
                ctrl.filtros.RequiereValidacion = false;
              else
                ctrl.filtros.RequiereValidacion = null;
            }

            if (tableState.search.predicateObject.RequiereVerificacion == 1 ||
                tableState.search.predicateObject.RequiereVerificacion == 'true') 
              ctrl.filtros.RequiereVerificacion = true;
            else
            {
              if (tableState.search.predicateObject.RequiereVerificacion == 0 ||
                  tableState.search.predicateObject.RequiereVerificacion == 'false')
                ctrl.filtros.RequiereVerificacion = false;
              else
                ctrl.filtros.RequiereVerificacion = null;
            }

            if (tableState.search.predicateObject.RequiereAutorizacion == 1 ||
                tableState.search.predicateObject.RequiereAutorizacion == 'true')
              ctrl.filtros.RequiereAutorizacion = true;
            else
            {
              if (tableState.search.predicateObject.RequiereAutorizacion == 0 ||
                  tableState.search.predicateObject.RequiereAutorizacion == 'false')
                ctrl.filtros.RequiereAutorizacion = false;
              else
                ctrl.filtros.RequiereAutorizacion = null;
            }
          }

          if (tableState.sort != null)
          {
            ctrl.filtros.OrderFieldName = tableState.sort.predicate;
            ctrl.filtros.OrderAscending = !tableState.sort.reverse;
          }

          dataService.searchAutoAutorizar(ctrl.filtros)
            .then(function (response)
            {
              if (response.data.Success)
              {
                ctrl.resultList = response.data.Value.Resultados;
                //ctrl.totalResultados = response.data.Value.TotalResultados;

                tableState.pagination.numberOfPages = Math.ceil(response.data.Value.TotalResultados/number); //result.numberOfPages;//set the number of pages so the pagination can update
              } 
              else 
              {
                toastr.error(response.data.ErrorSummary);
              }
              ctrl.isSearching = false;
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage());
              ctrl.isSearching = false;
          });
        };
        
        ctrl.add = function ()
        {
          console.log("");
          var authData =  sharedService.getLoggedUser();
          console.log(authData);
          console.log(ctrl);
          $state.go("pages.autoautorizar-edit",{id:0});
        }

        ctrl.edit = function (id)
        {
          $state.go("pages.autoautorizar-edit",{id:id});
        }
      }
    });
  })(window.angular);
(function () {
    'use strict';
    angular.module('Kahuna.pages.autosolicitud').config(routeConfig);
    function routeConfig($stateProvider) {
      $stateProvider
        .state('pages.autosolicitud', {
          url: '/autosolicitud',
          title: 'Autosolicitud',
          template : '<autosolicitud-list></autosolicitud-list>',
          authenticate: true,
        })
        .state('pages.autosolicitud-edit', {
          url: '/autosolicitud/edit/:id',
          title: 'Autosolicitud',
          template : '<autosolicitud-edit></autosolicitud-edit>',
          params: {id:null},
          authenticate: true,
        });
    }
  })();
(function (angular) {
  'use strict';
  angular.module('Kahuna.pages.autosolicitud' ).component('autosolicitudEdit', {
    templateUrl: 'app/pages/autosolicitud/edit.template.html',
    controller: function ($scope, $state, dataService, sharedService, toastr, toastrConfig, $stateParams, $timeout, $uibModal) {
      var ctrl = this;
      ctrl.model = {};
      ctrl.isBusy = false;
      ctrl.enableDatosProcesoTab = false;
      ctrl.showDelete = false;
      ctrl.showCampoProcesoTituloSelect = false;
      ctrl.showCampoTemplateTituloSelect = false;
      ctrl.showTemplateTituloSelect = false;

      ctrl.title = '';
      ctrl.configuracionTituloText = "";
 
      ctrl.procesoCamposList = [];

      ctrl.procesoCamposDS = [];
      ctrl.procesoUsuariosDS = [];
      ctrl.procesoTemplatesDS = [];

      ctrl.campoCargado = {};

      ctrl.filtrosProcesos = {
        PageSize: 500,
        SkipNumber: 0
      };
      ctrl.resultListProcesos = [];
      ctrl.ident= "AUTO";
      ctrl.auxParams=[];

      this.$onInit = function () {
        loadView();
        getParametrosByIdent(ctrl.ident);
      };

      function getParametrosByIdent (Ident) {
        if (Ident != "") {
          dataService.obtenerALLParametrosByIdent(Ident).then(function (response) {
            if (response.data.Success && response.data.Value != null) {
              ctrl.showBtnLink = true;
              ctrl.auxParams = response.data.Value;
              console.log(ctrl.auxParams)
            }
          });
        }
      };

      ctrl.returnDescription = function (tipocampo) {
        if (ctrl.auxParams.length>1) {
          return ctrl.auxParams.filter(
            function(p)
            {
              return p.TipoCampo == tipocampo
            }
          )[0].Descripcion;
        }
        return;
      }

      function loadView() {
        ctrl.enableDatosProcesoTab = sharedService.isSysAdminLoggedUser();
        if ($stateParams.id != "0") {
          ctrl.isTemplateSearching = true;
          ctrl.isTemplateUsuarioSearching = true;
          ctrl.isUsuarioSearching = true;
          ctrl.isCampoSearching = true;

          dataService.getAutoSolicitudById($stateParams.id)
            .then(function (response) {
              if (response.data.Success) {
                ctrl.model = response.data.Value;
                console.log("LLEGO PROCESOP");
                console.log(ctrl.model);
                ctrl.title = 'Editar AutoSolicitud: ' + ctrl.model.AutoId;
                ctrl.procesoCamposList = ctrl.model.autoSolicitudDetalle;
                ctrl.showDelete = sharedService.isSysAdminLoggedUser();
              } else {
                toastr.error(response.data.ErrorSummary);
              }

              ctrl.isTemplateSearching = false;
              ctrl.isTemplateUsuarioSearching = false;
              ctrl.isUsuarioSearching = false;
              ctrl.isCampoSearching = false;
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage());

              ctrl.isTemplateSearching = false;
              ctrl.isTemplateUsuarioSearching = false;
              ctrl.isUsuarioSearching = false;
              ctrl.isCampoSearching = false;
            });
        } else {
          ctrl.title = 'Crear AutoSolicitud: -';
        }
      }

      ctrl.actualizarTitulo = function () {
        if (ctrl.model != null) {
          if ($stateParams.id != "0")
            ctrl.title = 'Editar Auto Solicitud: ' + ctrl.model.AutoSolicitudId;
          else
            ctrl.title = 'Crear Auto Solicitud: ' + ctrl.model.AutoSolicitudId;
        }
      }     

      ctrl.save = function () {

        console.log(ctrl.form);
        if (!ctrl.form.$valid) {
          toastr.error('Por favor complete los datos obligatorios marcados con asterisco');
          return;
        }

        ctrl.isBusy = true;
        ctrl.model.autoSolicitudDetalle = ctrl.procesoCamposDS;

        dataService.saveAutoSolicitud(ctrl.model)
          .then(function (response) {
            if (response.data.Success) {
              toastr.info("Operacion exitosa.");
              $state.transitionTo("pages.autosolicitud");
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
            ctrl.isBusy = false;
          });
      }

      ctrl.cancel = function () {
        $state.transitionTo("pages.autosolicitud");
      }

      ctrl.delete = function () {
        ctrl.isBusy = true;
        var confirmation = $uibModal.open({
          animation: true,
          component: "confirmation",
          resolve: {
            title: function () {
              return "Atención"
            },
            message: function () {
              return "Confirma el borrado del registro seleccionado?"
            },
          }
        });
        confirmation.result.then(function (selectedItem) {
          dataService.deleteAutoSolicitud(ctrl.model.Id).then(function (response) {
            if (response.data.Success) {
              toastr.info("Operacion exitosa.");
              $state.transitionTo("pages.autosolicitud");
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
            ctrl.isBusy = false;
          });
        }, function () {
          ctrl.isBusy = false;
        });
      }

      ctrl.openAttachment = function (fileName) {
        window.open(appConfig.uploadUrl + fileName);
      }

      ctrl.uploadAttachment = function (file) {
        if (file == null)
          return;

        ctrl.isBusy = true;
        ctrl.model.isImageLoading = true;

        dataService.uploadImageFileProceso(file)
          .then(function (response) {
            $timeout(function () {
              //console.log(response);
              if (response.data.Success) {
                //console.log('uploadFileAttachment: ' + response.data.Value);
                ctrl.model.UrlImagen = response.data.Value; //{ fileName: file.name, serverFileName: response.data.Value };
              } else {
                ctrl.model.UrlImagen = null;
              }
            });
            ctrl.isBusy = false;
            ctrl.model.isImageLoading = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
            ctrl.isBusy = false;
            ctrl.model.isImageLoading = false;
          });
      }

      ctrl.removeAttachment = function () {
        ctrl.model.UrlImagen = null;
      }

      /******************* Campos *******************/
      ctrl.editCampo = function () {

        if (!ctrl.formDetalle.$valid) {
          toastr.error('Por favor complete los datos obligatorios marcados con asterisco para cargar el detalle de AutoSolicitud');
          return;
        }
        ctrl.campoCargado.AutoSolicitudId = this.model.AutoSolicitudId;
        if (ctrl.procesoCamposList == null)
          ctrl.procesoCamposList = [];

        /*var index = -1;
        for (var i = 0; i < ctrl.procesoCamposList.length; i++) {
          index = i;
        }*/
        /*if (index >= 0)
          ctrl.procesoCamposList[index] = ctrl.campoCargado;
        else*/
        console.log(ctrl.campoCargado);
        if (ctrl.campoCargado.Id != undefined && ctrl.campoCargado.Id != ""){
          ctrl.procesoCamposList = ctrl.procesoCamposList.filter(function(item){
            return item.Id != ctrl.campoCargado.Id 
          });
        }

        ctrl.procesoCamposList.push(ctrl.campoCargado);
        
        //ctrl.procesoCamposList.sort(function (a, b) { return (parseInt(a.Orden) > parseInt(b.Orden) ? 1 : (parseInt(b.Orden) > parseInt(a.Orden)) ? -1 : 0); });
        if (ctrl.campoCargado.Id != undefined && ctrl.campoCargado.Id != ""){
          ctrl.procesoCamposDS = ctrl.procesoCamposDS.filter(function(item){
            return item.Id != ctrl.campoCargado.Id
          });
        }
        ctrl.procesoCamposDS.push(ctrl.campoCargado);
        ctrl.campoCargado = {};
      }

      ctrl.cargarCampo = function (campoSeleccionado) {

        if (campoSeleccionado == null) {
          toastr.error('Por favor seleccione un campo para poder visualizarlo');
          return;
        } 
        
        ctrl.campoCargado = {};
        ctrl.campoCargado.AutoSolicitudId = campoSeleccionado.AutoSolicitudId;
        ctrl.campoCargado.Id= campoSeleccionado.Id;
        ctrl.campoCargado.OrigenCampo = campoSeleccionado.OrigenCampo;
        ctrl.campoCargado.IdCampoDestino = campoSeleccionado.IdCampoDestino;
        ctrl.campoCargado.IdCampoOrigen = campoSeleccionado.IdCampoOrigen;
        ctrl.campoCargado.OrigenCampoA = campoSeleccionado.OrigenCampoA;
        ctrl.campoCargado.IdCampoOrigenA = campoSeleccionado.IdCampoOrigenA;
        ctrl.campoCargado.OrigenCampoB = campoSeleccionado.OrigenCampoB;
        ctrl.campoCargado.IdCampoOrigenB = campoSeleccionado.IdCampoOrigenB;
        ctrl.campoCargado.OrigenCampoC = campoSeleccionado.OrigenCampoC;
        ctrl.campoCargado.IdCampoOrigenC = campoSeleccionado.IdCampoOrigenC;
        ctrl.campoCargado.ValCampoOrigen = campoSeleccionado.ValCampoOrigen;
        ctrl.campoCargado.UsuarioCreacionid = campoSeleccionado.UsuarioCreacionid;
        ctrl.campoCargado.UsuarioModificacionId = campoSeleccionado.UsuarioModificacionId;

      }

      ctrl.eliminarCampo = function (index) {
        if (index < 0) {
          toastr.error('Campo seleccionado inválido');
          return;
        }

        if (ctrl.procesoCamposList != null && ctrl.procesoCamposList.length > 0)
          ctrl.procesoCamposList.splice(index, 1);
      }

      ctrl.clearCampo = function () {
        ctrl.campoCargado = {};
      }


    }
  });
})(window.angular);
(function (angular) {
    'use strict';
    angular.module('Kahuna.pages.autosolicitud').component('autosolicitudList', {
      templateUrl: 'app/pages/autosolicitud/list.template.html',
      controller: function ($scope,$state,dataService,sharedService,toastr) {
        var ctrl = this;
        ctrl.mostrarAgregar = false;
        
        this.$onInit = function () 
        {
          ctrl.mostrarAgregar = sharedService.isSysAdminLoggedUser();
        };

        ctrl.buscar = function buscar(tableState) 
        {
          ctrl.isSearching = true;

          var pagination = tableState.pagination;

          var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
          var number = pagination.number || 10;  // Number of entries showed per page.

          ctrl.filtros = { PageSize: number, SkipNumber: start };

          if (tableState.search.predicateObject != null)
          {
            ctrl.filtros.DetalleAcciones = tableState.search.predicateObject.DetalleAcciones;
            ctrl.filtros.SubjectCorreo = tableState.search.predicateObject.SubjectCorreo;
            ctrl.filtros.AutoId = tableState.search.predicateObject.AutoId;
            //ctrl.filtros.Grupo = tableState.search.predicateObject.Grupo;
            //ctrl.filtros.CantidadDiasCierre = tableState.search.predicateObject.CantidadDiasCierre;

            if (tableState.search.predicateObject.RequiereValidacion == 1 ||
                tableState.search.predicateObject.RequiereValidacion == 'true')
              ctrl.filtros.RequiereValidacion = true;
            else
            {
              if (tableState.search.predicateObject.RequiereValidacion == 0 ||
                  tableState.search.predicateObject.RequiereValidacion == 'false')
                ctrl.filtros.RequiereValidacion = false;
              else
                ctrl.filtros.RequiereValidacion = null;
            }

            if (tableState.search.predicateObject.RequiereVerificacion == 1 ||
                tableState.search.predicateObject.RequiereVerificacion == 'true') 
              ctrl.filtros.RequiereVerificacion = true;
            else
            {
              if (tableState.search.predicateObject.RequiereVerificacion == 0 ||
                  tableState.search.predicateObject.RequiereVerificacion == 'false')
                ctrl.filtros.RequiereVerificacion = false;
              else
                ctrl.filtros.RequiereVerificacion = null;
            }

            if (tableState.search.predicateObject.RequiereAutorizacion == 1 ||
                tableState.search.predicateObject.RequiereAutorizacion == 'true')
              ctrl.filtros.RequiereAutorizacion = true;
            else
            {
              if (tableState.search.predicateObject.RequiereAutorizacion == 0 ||
                  tableState.search.predicateObject.RequiereAutorizacion == 'false')
                ctrl.filtros.RequiereAutorizacion = false;
              else
                ctrl.filtros.RequiereAutorizacion = null;
            }
          }

          if (tableState.sort != null)
          {
            ctrl.filtros.OrderFieldName = tableState.sort.predicate;
            ctrl.filtros.OrderAscending = !tableState.sort.reverse;
          }

          dataService.searchAutoSolicitud(ctrl.filtros)
            .then(function (response)
            {
              if (response.data.Success)
              {
                ctrl.resultList = response.data.Value.Resultados;
                //ctrl.totalResultados = response.data.Value.TotalResultados;

                tableState.pagination.numberOfPages = Math.ceil(response.data.Value.TotalResultados/number); //result.numberOfPages;//set the number of pages so the pagination can update
              } 
              else 
              {
                toastr.error(response.data.ErrorSummary);
              }
              ctrl.isSearching = false;
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage());
              ctrl.isSearching = false;
          });
        };
        
        ctrl.add = function ()
        {
          console.log("");
          var authData =  sharedService.getLoggedUser();
          console.log(authData);
          console.log(ctrl);
          $state.go("pages.autosolicitud-edit",{id:0});
        }

        ctrl.edit = function (id)
        {
          $state.go("pages.autosolicitud-edit",{id:id});
        }
      }
    });
  })(window.angular);
(function () {
    'use strict';
    angular.module('Kahuna.pages.auxparametros').config(routeConfig);
    function routeConfig($stateProvider) {
      $stateProvider
        .state('pages.auxparametros', {
          url: '/auxparametros',
          title: 'auxparametros',
          template : '<auxparametros-list></auxparametros-list>',
          authenticate: true,
        })
        .state('pages.auxparametros-edit', {
          url: '/auxparametros/edit/:id',
          title: 'auxparametros',
          template : '<auxparametros-edit></auxparametros-edit>',
          params: {id:null},
          authenticate: true,
        });
    }
  })();
(function (angular) {
  'use strict';
  angular.module('Kahuna.pages.auxparametros').component('auxparametrosEdit', {
    templateUrl: 'app/pages/auxparametros/edit.template.html',
    controller: function ($scope, $state, dataService, sharedService, toastr, toastrConfig, $stateParams, $timeout, $uibModal) {
      var ctrl = this;
      ctrl.model = {};
      ctrl.isBusy = false;
      ctrl.enableDatosProcesoTab = false;
      ctrl.showDelete = false;
      ctrl.showCampoProcesoTituloSelect = false;
      ctrl.showCampoTemplateTituloSelect = false;
      ctrl.showTemplateTituloSelect = false;
      ctrl.title = '';
      ctrl.configuracionTituloText = "";
      ctrl.camposList = [];

      ctrl.procesoCamposDS = [];
      ctrl.procesoUsuariosDS = [];
      ctrl.procesoTemplatesDS = [];

      ctrl.campoCargado = {};

      ctrl.filtrosProcesos = {
        PageSize: 500,
        SkipNumber: 0
      };
      ctrl.resultListProcesos = [];
      ctrl.resultListTemplatesProcesos = [];
      ctrl.listaAutoSolicitud = [];

      this.$onInit = function () {
        loadView();
        //loadCampos();
      };

      function loadView() {
        ctrl.enableDatosProcesoTab = sharedService.isSysAdminLoggedUser();
        if ($stateParams.id != "0") {
          ctrl.isTemplateSearching = true;
          ctrl.isTemplateUsuarioSearching = true;
          ctrl.isUsuarioSearching = true;
          ctrl.isCampoSearching = true;
          dataService.getAuxParametrosById($stateParams.id)
            .then(function (response) {
              if (response.data.Success) {
                ctrl.model = response.data.Value;
                console.log("LLEGO RESPONSE");
                console.log(ctrl.model);                                                
                ctrl.model.campoId = ""+ctrl.model.campoId + "";                
                ctrl.title = 'Editar Auto Autorizar: ' + ctrl.model.Ident;
                ctrl.model.campo =  {
                  Id : ctrl.model.Campo.Id,
                  Nombre : ctrl.model.Campo.Nombre,
                };
                ctrl.showDelete = sharedService.isSysAdminLoggedUser();
              } else {
                toastr.error(response.data.ErrorSummary);
              }
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage());
            });
        } else {
          ctrl.title = 'Crear auxparametros: -';
        }
      }
 
      /******************* Campos Filtros  *******************/
      ctrl.searchCampos = function (nombre) {
        var filtroCampos = { Nombre: nombre, PageSize: 20, SkipNumber: 0 };
        return dataService.searchCampo(filtroCampos)
          .then(function (response) {
            if (response.data.Success) {
              console.log(response.data.Value.Resultados);
              return response.data.Value.Resultados;
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
          });
      }

      ctrl.onSelectCampo = function (campoSeleccionado) {
        console.log("CAmpko SEleccionado");
        console.log(campoSeleccionado);
        ctrl.model.campoId = campoSeleccionado.Id;
      }


      function loadCampos() {
        ctrl.isSearching = true;        
        sharedService.showLoading();
        dataService.getCampoListLigth()
          .then(function (response) {
            if (response.data.Success) {
              loadView();
              var defaultCampo = {
                Id: 0,
                Nombre: ""
              };            
              ctrl.camposList = [];
              ctrl.camposList.push(defaultCampo);
              ctrl.camposList = ctrl.camposList.concat(response.data.Value);
              console.log(ctrl.camposList); 
              sharedService.closeLoading();
            } else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
          });          
      }

      ctrl.save = function () {
        console.log(ctrl.form);
        if (!ctrl.form.$valid) {
          toastr.error('Por favor complete los datos obligatorios marcados con asterisco');
          return;
        }
        ctrl.isBusy = true;
        dataService.saveAuxParametros(ctrl.model)
          .then(function (response) {
            if (response.data.Success) {
              toastr.info("Operacion exitosa.");
              $state.transitionTo("pages.auxparametros");
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
            ctrl.isBusy = false;
          });
      }

      ctrl.cancel = function () {
        $state.transitionTo("pages.auxparametros");
      }

      ctrl.delete = function () {
        ctrl.isBusy = true;
        var confirmation = $uibModal.open({
          animation: true,
          component: "confirmation",
          resolve: {
            title: function () {
              return "Atención"
            },
            message: function () {
              return "Confirma el borrado del registro seleccionado?"
            },
          }
        });
        confirmation.result.then(function (selectedItem) {
          dataService.deleteAuxParametros(ctrl.model.Id).then(function (response) {
            if (response.data.Success) {
              toastr.info("Operacion exitosa.");
              $state.transitionTo("pages.auxparametros");
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
            ctrl.isBusy = false;
          });
        }, function () {
          ctrl.isBusy = false;
        });
      }

 
 
    }
  });
})(window.angular);
(function (angular) {
    'use strict';
    angular.module('Kahuna.pages.auxparametros').component('auxparametrosList', {
      templateUrl: 'app/pages/auxparametros/list.template.html',
      controller: function ($scope,$state,dataService,sharedService,toastr) {
        var ctrl = this;
        ctrl.mostrarAgregar = false;
        
        this.$onInit = function () 
        {
          ctrl.mostrarAgregar = sharedService.isSysAdminLoggedUser();
        };

        ctrl.buscar = function buscar(tableState) 
        {
          ctrl.isSearching = true;

          var pagination = tableState.pagination;

          var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
          var number = pagination.number || 10;  // Number of entries showed per page.

          ctrl.filtros = { PageSize: number, SkipNumber: start };

          if (tableState.search.predicateObject != null)
          {
            ctrl.filtros.Ident = tableState.search.predicateObject.Ident;
            ctrl.filtros.Descripcion = tableState.search.predicateObject.Descripcion;
            ctrl.filtros.ObjetivoParametro = tableState.search.predicateObject.ObjetivoParametro;
            //ctrl.filtros.Grupo = tableState.search.predicateObject.Grupo;
          }

          if (tableState.sort != null)
          {
            ctrl.filtros.OrderFieldName = tableState.sort.predicate;
            ctrl.filtros.OrderAscending = !tableState.sort.reverse;
          }
          dataService.searchAuxParametros(ctrl.filtros)
            .then(function (response)
            {
              if (response.data.Success)
              {
                ctrl.resultList = response.data.Value.Resultados;
                //ctrl.totalResultados = response.data.Value.TotalResultados;
                tableState.pagination.numberOfPages = Math.ceil(response.data.Value.TotalResultados/number); //result.numberOfPages;//set the number of pages so the pagination can update
              } 
              else 
              {
                toastr.error(response.data.ErrorSummary);
              }
              ctrl.isSearching = false;
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage());
              ctrl.isSearching = false;
          });
        };
        
        ctrl.add = function ()
        {
          console.log("");
          var authData =  sharedService.getLoggedUser();
          console.log(authData);
          console.log(ctrl);
          $state.go("pages.auxparametros-edit",{id:0});
        }

        ctrl.edit = function (id)
        {
          $state.go("pages.auxparametros-edit",{id:id});
        }
      }
    });
  })(window.angular);
(function () {
    'use strict';
    angular.module('Kahuna.pages.campo').config(routeConfig);
    function routeConfig($stateProvider) {
      $stateProvider
        .state('pages.campo', {
          url: '/campo',
          title: 'Campo',
          template : '<campo-list></campo-list>',
          authenticate: true,
        })
        .state('pages.campo-edit', {
          url: '/campo/edit/:id',
          title: 'Campo',
          template : '<campo-edit></campo-edit>',
          params: {id:null},
          authenticate: true,
        });
    }
  })();
(function (angular) {
  'use strict';
  angular.module('Kahuna.pages.campo').component('campoEdit', {
    templateUrl: 'app/pages/campo/edit.template.html',
    controller: function ($scope, $state, dataService, sharedService, toastr, toastrConfig, $stateParams, $uibModal) {
      var ctrl = this;
      ctrl.model = {};
      ctrl.isBusy = false;
      ctrl.showDelete = false;
      ctrl.title = '';
      ctrl.campoTipoList = [];
      ctrl.jerarquiaList = [];
      ctrl.periodoList = [];
      ctrl.camposTablaList = [];

      this.$onInit = function () {
        dataService.getCampoTipoList()
          .then(function (response) {
            if (response.data.Success) {
              ctrl.campoTipoList = response.data.Value;
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
          });

        dataService.getJerarquiaPadreList()
          .then(function (response) {
            if (response.data.Success) {
              ctrl.jerarquiaList = response.data.Value;
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
          });

        dataService.getPeriodoList()
          .then(function (response) {
            if (response.data.Success) {
              ctrl.periodoList = response.data.Value;
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
          });

        if ($stateParams.id != "0") {
          ctrl.title = 'Editar Campo';

          dataService.getCampo($stateParams.id)
            .then(function (response) {
              if (response.data.Success) {
                ctrl.model = response.data.Value;
                if (ctrl.model != null) {
                  ctrl.showDelete = true;
                  console.log(ctrl.model.CampoTipo);
                  if (ctrl.model.CampoTipo.Codigo == "COND") {
                    ctrl.camposTablaListCondicional = ctrl.model.Columnas;
                  } else if (ctrl.model.CampoTipo.Codigo == "NUMERADOR") {
                    ctrl.camposTablaListNumerador = ctrl.model.Columnas;
                  } else {
                    ctrl.camposTablaList = ctrl.model.Columnas;
                  }
                  console.log(ctrl.camposTablaList);
                }
              }
              else {
                toastr.error(response.data.ErrorSummary);
              }
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage());
            });
        }
        else {
          ctrl.title = 'Crear Campo';
        }
      };

      ctrl.save = function (form) {
                

        if (ctrl.model.Nombre == null ||
          ctrl.model.Nombre == '' ||
          ctrl.model.CampoId == null ||
          ctrl.model.CampoId == '' ||
          ctrl.model.CampoTipo == null ||
          ctrl.model.CampoTipo.Id <= 0) {
          toastr.error('Por favor complete los datos obligatorios marcados con asterisco');
          return;
        }

        if ((ctrl.model.CampoTipo.Codigo == 'JERARQ' ||
          ctrl.model.CampoTipo.Codigo == 'LIST' ||
          ctrl.model.CampoTipo.Codigo == 'MULTI_LIST') &&
          (ctrl.model.Jerarquia == null || ctrl.model.Jerarquia.Id <= 0)) {
          toastr.error('Por favor seleccione una jerarquía para continuar con la operación');
          return;
        }

        if (ctrl.model.CampoTipo.Codigo == 'TABLE') {
          if (ctrl.model.TotalRegistrosTabla == null || ctrl.model.TotalRegistrosTabla <= 0) {
            toastr.error('Por favor ingrese la cantidad de filas que tendrá la tabla');
            return;
          }

          if (ctrl.camposTablaList == null || ctrl.camposTablaList.length <= 0) {
            toastr.error('Por favor seleccione al menos un campo para formar la tabla');
            return;
          }
        }

        ctrl.isBusy = true;

        ctrl.model.Activo = 1;
        ctrl.model.JerarquiaId = null;
        ctrl.model.CampoTipoId = ctrl.model.CampoTipo.Id;
        ctrl.model.Columnas = null;

        if (ctrl.model.CampoTipo.Codigo == 'TABLE')
          ctrl.model.Columnas = ctrl.camposTablaList;

        if (ctrl.model.CampoTipo.Codigo == 'COND') {
          ctrl.model.Columnas = ctrl.camposTablaListCondicional;
        }
        if (ctrl.model.CampoTipo.Codigo == 'NUMERADOR') {
          ctrl.model.Columnas = ctrl.camposTablaListNumerador;
        }

        if ((ctrl.model.CampoTipo.Codigo == 'JERARQ' ||
          ctrl.model.CampoTipo.Codigo == 'LIST' ||
          ctrl.model.CampoTipo.Codigo == 'MULTI_LIST') &&
          ctrl.model.Jerarquia != null)
          ctrl.model.JerarquiaId = ctrl.model.Jerarquia.Id;

        if (ctrl.model.CampoTipo.Codigo != 'JERARQ')
          ctrl.model.PermiteAltaJerarquia = false;

        dataService.saveCampo(ctrl.model)
          .then(function (response) {
            if (response.data.Success) {
              toastr.info("Operacion exitosa.");
              $state.transitionTo("pages.campo");
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
            ctrl.isBusy = false;
          });
      }

      ctrl.cancel = function () {
        $state.transitionTo("pages.campo");
      }

      ctrl.delete = function () {
        ctrl.isBusy = true;
        var confirmation = $uibModal.open({
          animation: true,
          component: "confirmation",
          resolve: {
            title: function () { return "Atención" },
            message: function () { return "Confirma el borrado del campo?" },
          }
        });

        confirmation.result.then(function (selectedItem) {
          dataService.deleteCampo(ctrl.model.Id).then(function (response) {
            if (response.data.Success) {
              toastr.info("Operacion exitosa.");
              $state.transitionTo("pages.campo");
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
            ctrl.isBusy = false;
          });
        }, function () {
          ctrl.isBusy = false;
        });
      }

      /*** COLUMNAS DE CAMPO TIPO TABLA **/
      ctrl.searchColumnaCampo = function (nombreCampo) {
        var filtroCampo = { Nombre: nombreCampo, PageSize: 20, SkipNumber: 0 };

        return dataService.searchCampo(filtroCampo)
          .then(function (response) {
            if (response.data.Success) {
              return response.data.Value.Resultados;
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
          });
      }

      ctrl.onSelectColumnaCampo = function (campoSeleccionado) {
        ctrl.campoCargado.ColumnaCampo = campoSeleccionado;
      }
      ctrl.editColumnaCampo = function () {
        if (ctrl.campoCargado == null ||
          ctrl.campoCargado.ColumnaCampo == null ||
          ctrl.campoCargado.ColumnaCampo.Id <= 0) {
          toastr.error('Por favor complete los datos obligatorios marcados con asterisco para cargar el campo');
          return;
        }

        if (ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'TEXT' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'INT' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'DECIMAL' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'DATE' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'BOOL' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'TEXTAREA' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'ATTACH' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'TITLE') {
          toastr.error('No puede agregar el tipo de campo ' + ctrl.campoCargado.ColumnaCampo.CampoTipo.Nombre + ' entre las columnas');
          return;
        }

        if (ctrl.campoCargado.ColumnaCampo.Id == ctrl.model.Id) {
          toastr.error('No puede agregar el mismo campo que está editando');
          return;
        }

        //ctrl.campoCargado.CampoId = ctrl.model.Id;
        ctrl.campoCargado.ColumnaCampoId = ctrl.campoCargado.ColumnaCampo.Id;

        if (ctrl.camposTablaList == null)
          ctrl.camposTablaList = [];

        var index = -1;
        for (var i = 0; i < ctrl.camposTablaList.length; i++) {
          if (ctrl.camposTablaList[i].ColumnaCampo.Id == ctrl.campoCargado.ColumnaCampo.Id) {
            index = i;
            break;
          }
        }

        if (index >= 0)
          ctrl.camposTablaList[index] = ctrl.campoCargado;
        else
          ctrl.camposTablaList.push(ctrl.campoCargado);

        ctrl.campoCargado = {};
      }

      ctrl.eliminarColumnaCampo = function (index) {
        if (index < 0) {
          toastr.error('Campo seleccionado inválido');
          return;
        }

        if (ctrl.camposTablaList != null && ctrl.camposTablaList.length > 0)
          ctrl.camposTablaList.splice(index, 1);
      }

      ctrl.editColumnaCampoCondicional = function () {

        if (ctrl.campoCargado == null ||
          ctrl.campoCargado.ColumnaCampo == null ||
          ctrl.campoCargado.ColumnaCampo.Id <= 0 ||
          !ctrl.campoCargado.hasOwnProperty("condicion")
        ) {
          toastr.error('Por favor complete los datos obligatorios marcados con asterisco para cargar el campo');
          return;
        }

        if (ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'TEXT' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'INT' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'DECIMAL' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'DATE' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'BOOL' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'TEXTAREA' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'ATTACH' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'IMG' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'TITLE'
        ) {
          toastr.error('No puede agregar el tipo de campo ' + ctrl.campoCargado.ColumnaCampo.CampoTipo.Nombre + ' entre las columnas');
          return;
        }

        if (ctrl.campoCargado.ColumnaCampo.Id == ctrl.model.Id) {
          toastr.error('No puede agregar el mismo campo que está editando');
          return;
        }

        ctrl.campoCargado.ColumnaCampoId = ctrl.campoCargado.ColumnaCampo.Id;
        if (ctrl.camposTablaListCondicional == null)
          ctrl.camposTablaListCondicional = [];

        var index = -1;
        for (var i = 0; i < ctrl.camposTablaListCondicional.length; i++) {
          if (ctrl.camposTablaListCondicional[i].ColumnaCampo.Id == ctrl.campoCargado.ColumnaCampo.Id) {
            index = i;
            break;
          }
        }

        if (ctrl.camposTablaListCondicional.length < 10) {
          if (index >= 0) {
            ctrl.camposTablaListCondicional[index] = ctrl.campoCargado;
          } else {
            ctrl.camposTablaListCondicional.push(ctrl.campoCargado);
          }
        } else {
          toastr.error('No puede agregar mas de 10 condicionales');
          return;
        }

        ctrl.campoCargado = {};
        console.log(ctrl.camposTablaListCondicional);
      }

      ctrl.editColumnaCampoNumerador = function () {

        if (ctrl.campoCargado == null ||
          ctrl.campoCargado.ColumnaCampo == null ||
          ctrl.campoCargado.ColumnaCampo.Id <= 0
        ) {
          toastr.error('Por favor complete los datos obligatorios marcados con asterisco para cargar el campo');
          return;
        }

        if (ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'TEXT' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'INT' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'DECIMAL' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'DATE' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'BOOL' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'TEXTAREA' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'ATTACH' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'IMG' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'TITLE'
        ) {
          toastr.error('No puede agregar el tipo de campo ' + ctrl.campoCargado.ColumnaCampo.CampoTipo.Nombre + ' entre las columnas');
          return;
        }

        if (ctrl.campoCargado.ColumnaCampo.Id == ctrl.model.Id) {
          toastr.error('No puede agregar el mismo campo que está editando');
          return;
        }

        ctrl.campoCargado.ColumnaCampoId = ctrl.campoCargado.ColumnaCampo.Id;
        if (ctrl.camposTablaListNumerador == null)
          ctrl.camposTablaListNumerador = [];

        var index = -1;
        for (var i = 0; i < ctrl.camposTablaListNumerador.length; i++) {
          if (ctrl.camposTablaListNumerador[i].ColumnaCampo.Id == ctrl.campoCargado.ColumnaCampo.Id) {
            index = i;
            break;
          }
        }

        if (ctrl.camposTablaListNumerador.length < 10) {
          if (index >= 0) {
            ctrl.camposTablaListNumerador[index] = ctrl.campoCargado;
          } else {
            ctrl.camposTablaListNumerador.push(ctrl.campoCargado);
          }
        } else {
          toastr.error('No puede agregar mas de 10 condicionales');
          return;
        }

        ctrl.campoCargado = {};
        console.log(ctrl.camposTablaListNumerador);
      }


      ctrl.eliminarColumnaCampoNumerador = function (index) {
        if (index < 0) {
          toastr.error('Campo seleccionado inválido');
          return;
        }
        if (ctrl.camposTablaListNumerador != null && ctrl.camposTablaListNumerador.length > 0)
          ctrl.camposTablaListNumerador.splice(index, 1);
      }

      ctrl.eliminarColumnaCampoCondicional = function (index) {
        if (index < 0) {
          toastr.error('Campo seleccionado inválido');
          return;
        }
        if (ctrl.camposTablaListCondicional != null && ctrl.camposTablaListCondicional.length > 0)
          ctrl.camposTablaListCondicional.splice(index, 1);
      }

    }
  });
})(window.angular);
(function (angular) {
  'use strict';
  angular.module('Kahuna.pages.campo').component('campoList', {
    templateUrl: 'app/pages/campo/list.template.html',
    controller: function ($scope,$state,dataService,sharedService,toastr) {
      var ctrl = this;
      ctrl.anularVista = true;
      
      this.$onInit = function () 
      {
        ctrl.anularVista = !sharedService.isSysAdminLoggedUser();
      };

      ctrl.buscar = function buscar(tableState) 
      {
        ctrl.isSearching = true;

        var pagination = tableState.pagination;

        var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
        var number = pagination.number || 10;  // Number of entries showed per page.

        ctrl.filtros = { PageSize: number, SkipNumber: start };

        if (tableState.search.predicateObject != null)
        {
          ctrl.filtros.Codigo = tableState.search.predicateObject.Codigo;
          ctrl.filtros.Nombre = tableState.search.predicateObject.Nombre;
          ctrl.filtros.CampoTipo = tableState.search.predicateObject.CampoTipo;
          ctrl.filtros.Jerarquia = tableState.search.predicateObject.Jerarquia;
        }

        if (tableState.sort != null)
        {
          ctrl.filtros.OrderFieldName = tableState.sort.predicate;
          ctrl.filtros.OrderAscending = !tableState.sort.reverse;
        }

        dataService.searchCampo(ctrl.filtros)
          .then(function (response) 
          {
            if (response.data.Success)
            {               
              ctrl.resultList = response.data.Value.Resultados;
              //ctrl.totalResultados = response.data.Value.TotalResultados;

              tableState.pagination.numberOfPages = Math.ceil(response.data.Value.TotalResultados/number); //result.numberOfPages;//set the number of pages so the pagination can update
            } 
            else 
            {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isSearching = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
            ctrl.isSearching = false;
        });
      };
      
      ctrl.add = function ()
      {
        $state.go("pages.campo-edit",{id:0});
      }

      ctrl.edit = function (id)
      {
        $state.go("pages.campo-edit",{id:id});
      }
    }
  });
})(window.angular);
(function (angular) {
    'use strict';
    angular.module('Kahuna.pages.grupo').component('grupoEdit', {
      templateUrl: 'app/pages/grupo/edit.template.html',
      controller: function ($scope, $state, dataService, sharedService, toastr, appConfig, toastrConfig, $timeout, $stateParams, $uibModal) {
        var ctrl = this;
        ctrl.model = {};
        ctrl.isBusy = false;
        ctrl.showDelete = false;
        ctrl.title = '';
  
        this.$onInit = function () 
        {
          if ($stateParams.id != "0") 
          {
            ctrl.title = 'Editar Grupo';

            dataService.getGrupoById($stateParams.id)
              .then(function (response) 
              {
                if (response.data.Success) 
                {
                  ctrl.model = response.data.Value;
                  ctrl.showDelete = true;
                } 
                else 
                {
                  toastr.error(response.data.ErrorSummary);
                }
              }, function (error) {
                toastr.error(error.data || sharedService.getGenericErrorMessage());
              });
          } 
          else 
          {
            ctrl.title = 'Crear Grupo';
          }
        };
  
        ctrl.save = function (form) 
        {
          // if (form.$invalid) 
          // {
          //   ctrl.showError = true;
          //   return;
          // }

          if (ctrl.model.Nombre == null ||
              ctrl.model.Nombre == '')
          {
            toastr.error('Por favor complete los datos obligatorios marcados con asterisco');
            return;
          }

          if (ctrl.model.MostrarEnHome && ctrl.model.HomeOrden <= 0)
          {
            toastr.error('Por favor ingrese el orden para mostrar en la home');
            return;
          }
  
          ctrl.isBusy = true;
  
          ctrl.model.Activo = 1;
            
          dataService.saveGrupo(ctrl.model)
            .then(function (response) 
            {
              if (response.data.Success) 
              {
                toastr.info("Operacion exitosa.");
                $state.transitionTo("pages.grupo");
              } 
              else 
              {
                toastr.error(response.data.ErrorSummary);
              }
              ctrl.isBusy = false;
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage());
              ctrl.isBusy = false;
            });
        }
  
        ctrl.cancel = function () 
        {
          $state.transitionTo("pages.grupo");
        }
  
        ctrl.delete = function () 
        {
          ctrl.isBusy = true;
          var confirmation = $uibModal.open({
            animation: true,
            component: "confirmation",
            resolve: {
              title: function () { return "Atención" },
              message: function () { return "Confirma el borrado del grupo?" },
            }
          });
  
          confirmation.result.then(function (selectedItem) 
          {
            dataService.deleteGrupo(ctrl.model.Id).then(function (response) 
            {
              if (response.data.Success) 
              {
                toastr.info("Operacion exitosa.");
                $state.transitionTo("pages.grupo");
              } 
              else 
              {
                toastr.error(response.data.ErrorSummary);
              }
              ctrl.isBusy = false;
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage());
              ctrl.isBusy = false;
            }); 
          }, function () {
            ctrl.isBusy = false;
          });
        }

        ctrl.openAttachment = function (fileName) 
        {
          window.open(appConfig.uploadUrl + fileName);
        }

        ctrl.uploadAttachment = function (file) 
        {
          if (file == null)
            return;

          ctrl.isBusy = true;
          ctrl.model.isImageLoading = true;

          dataService.uploadImageFileGrupo(file)
            .then(function (response) 
            {
              $timeout(function () 
              {
                //console.log(response);
                if (response.data.Success)
                {
                  //console.log('uploadFileAttachment: ' + response.data.Value);
                  ctrl.model.UrlImagen = response.data.Value; //{ fileName: file.name, serverFileName: response.data.Value };
                }
                else
                {
                  ctrl.model.UrlImagen = null;
                }
              });
              ctrl.isBusy = false;
              ctrl.model.isImageLoading = false;
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage());
              ctrl.isBusy = false;
              ctrl.model.isImageLoading = false;
            });
        }

        ctrl.removeAttachment = function () 
        {
          ctrl.model.UrlImagen = null;
        }
      }
    });
  })(window.angular);
(function () {
    'use strict';
    angular.module('Kahuna.pages.grupo').config(routeConfig);
    function routeConfig($stateProvider) {
      $stateProvider
        .state('pages.grupo', {
          url: '/grupo',
          title: 'Grupo',
          template : '<grupo-list></grupo-list>',
          authenticate: true,
        })
        .state('pages.grupo-edit', {
          url: '/grupo/edit/:id',
          title: 'Grupo',
          template : '<grupo-edit></grupo-edit>',
          params: {id:null},
          authenticate: true,
        });
    }
  })();
(function (angular) {
  'use strict';
  angular.module('Kahuna.pages.grupo').component('grupoList', {
    templateUrl: 'app/pages/grupo/list.template.html',
    controller: function ($scope,$state,dataService,sharedService,toastr) {
      var ctrl = this;
      ctrl.anularVista = true;
      
      this.$onInit = function () 
      {
        ctrl.anularVista = !sharedService.isSysAdminLoggedUser();
      };

      ctrl.buscar = function buscar(tableState) 
      {
        ctrl.isSearching = true;

        var pagination = tableState.pagination;

        var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
        var number = pagination.number || 10;  // Number of entries showed per page.

        ctrl.filtros = { PageSize: number, SkipNumber: start };

        if (tableState.search.predicateObject != null)
        {
          ctrl.filtros.Nombre = tableState.search.predicateObject.Nombre;
          ctrl.filtros.Resumen = tableState.search.predicateObject.Resumen;
        }

        if (tableState.sort != null)
        {
          ctrl.filtros.OrderFieldName = tableState.sort.predicate;
          ctrl.filtros.OrderAscending = !tableState.sort.reverse;
        }

        dataService.searchGrupo(ctrl.filtros)
          .then(function (response) 
          {
            if (response.data.Success)
            {               
              ctrl.resultList = response.data.Value.Resultados;
              //ctrl.totalResultados = response.data.Value.TotalResultados;

              tableState.pagination.numberOfPages = Math.ceil(response.data.Value.TotalResultados/number); //result.numberOfPages;//set the number of pages so the pagination can update
            } 
            else 
            {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isSearching = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
            ctrl.isSearching = false;
        });
      };
      
      ctrl.add = function ()
      {
        $state.go("pages.grupo-edit",{id:0});
      }

      ctrl.edit = function (id)
      {
        $state.go("pages.grupo-edit",{id:id});
      }
    }
  });
})(window.angular);
    (function (angular) {
      'use strict';
      angular.module('Kahuna.pages.grupos-usuarios').component('gruposUsuariosEdit', {
        templateUrl: 'app/pages/grupos-usuarios/edit.template.html',
        controller: function ($scope, $state, dataService, sharedService, toastr, appConfig, toastrConfig, $timeout, $stateParams, $uibModal) {
          var ctrl = this;
          ctrl.model = {};
          ctrl.isBusy = false;
          ctrl.showDelete = false;
          ctrl.title = '';
          ctrl.procesoUsuariosList;

          this.$onInit = function () {
            if ($stateParams.id != "0") {
              ctrl.title = 'Editar Grupo de Usuarios';

              dataService.getGruposUsuariosById($stateParams.id)
                .then(function (response) {
                  if (response.data.Success) {
                    ctrl.model = response.data.Value;
                    ctrl.procesoUsuariosList = ctrl.model.gruposUsuariosRelacion;
                    ctrl.showDelete = true;
                  } else {
                    toastr.error(response.data.ErrorSummary);
                  }
                }, function (error) {
                  toastr.error(error.data || sharedService.getGenericErrorMessage());
                });
            } else {
              ctrl.title = 'Crear Grupo de Usuarios';
            }
          };

          ctrl.save = function (form) {
            if (ctrl.model.Nombre == null ||
              ctrl.model.Nombre == '') {
              toastr.error('Por favor complete los datos obligatorios marcados con asterisco');
              return;
            }
            ctrl.isBusy = true;
            ctrl.model.Activo = 1;
            console.log(ctrl.procesoUsuariosList);
            ctrl.model.gruposUsuariosRelacion = [];
            //ctrl.model.GruposUsuariosRelacion = ctrl.procesoUsuariosList;
            var grupoUsuariosRelacion = {};

            for (var i = 0; i < ctrl.procesoUsuariosList.length; i++) {
              grupoUsuariosRelacion = {};
              grupoUsuariosRelacion.usuarioId = ctrl.procesoUsuariosList[i].Usuario.Id;
              grupoUsuariosRelacion.Usuario = ctrl.procesoUsuariosList[i].Usuario;
              grupoUsuariosRelacion.grupoId = ctrl.procesoUsuariosList[i].grupoId;
              ctrl.model.gruposUsuariosRelacion.push(grupoUsuariosRelacion);
            }

            console.log("OBJ TO SAVE");
            console.log(ctrl.model);
            dataService.saveGruposUsuarios(ctrl.model)
              .then(function (response) {
                if (response.data.Success) {
                  toastr.info("Operacion exitosa.");
                  $state.transitionTo("pages.grupos-usuarios");
                } else {
                  toastr.error(response.data.ErrorSummary);
                }
                ctrl.isBusy = false;
              }, function (error) {
                toastr.error(error.data || sharedService.getGenericErrorMessage());
                ctrl.isBusy = false;
              });
          }

          ctrl.cancel = function () {
            $state.transitionTo("pages.grupos-usuarios");
          }

          ctrl.delete = function () {
            ctrl.isBusy = true;
            var confirmation = $uibModal.open({
              animation: true,
              component: "confirmation",
              resolve: {
                title: function () {
                  return "Atención"
                },
                message: function () {
                  return "Confirma el borrado del grupo de usuarios?"
                },
              }
            });

            confirmation.result.then(function (selectedItem) {
              dataService.deleteGruposUsuarios(ctrl.model.Id).then(function (response) {
                if (response.data.Success) {
                  toastr.info("Operacion exitosa.");
                  $state.transitionTo("pages.grupos-usuarios");
                } else {
                  toastr.error(response.data.ErrorSummary);
                }
                ctrl.isBusy = false;
              }, function (error) {
                toastr.error(error.data || sharedService.getGenericErrorMessage());
                ctrl.isBusy = false;
              });
            }, function () {
              ctrl.isBusy = false;
            });
          }



          /******************* Proceso Usuarios *******************/
          ctrl.searchUsuario = function (nombreUsuario) {
            var filtroUsuario = {
              Login: nombreUsuario,
              PageSize: 20,
              SkipNumber: 0
            };

            return dataService.searchUsuario(filtroUsuario)
              .then(function (response) {
                if (response.data.Success) {
                  return response.data.Value.Resultados;
                } else {
                  toastr.error(response.data.ErrorSummary);
                }
              }, function (error) {
                toastr.error(error.data || sharedService.getGenericErrorMessage());
              });
          }

          ctrl.onSelectUsuario = function (usuarioSeleccionado) {
            ctrl.usuarioCargado.Usuario = usuarioSeleccionado;
          }

          ctrl.editUsuario = function () {
            if (ctrl.usuarioCargado == null ||
              ctrl.usuarioCargado.Usuario == null ||
              ctrl.usuarioCargado.Usuario.Id == 0) {
              toastr.error('Por favor complete los datos obligatorios marcados con asterisco para cargar el usuario');
              return;
            }

            ctrl.usuarioCargado.ProcesoId = ctrl.model.Id;
            ctrl.usuarioCargado.UsuarioId = ctrl.usuarioCargado.Usuario.Id;

            if (ctrl.procesoUsuariosList == null)
              ctrl.procesoUsuariosList = [];

            var index = -1;
            for (var i = 0; i < ctrl.procesoUsuariosList.length; i++) {
              if (ctrl.procesoUsuariosList[i].Usuario.Login == ctrl.usuarioCargado.Usuario.Login)
                index = i;
            }

            if (index >= 0)
              ctrl.procesoUsuariosList[index] = ctrl.usuarioCargado;
            else
              ctrl.procesoUsuariosList.push(ctrl.usuarioCargado);

            ctrl.procesoUsuariosDS = ctrl.procesoUsuariosList;
            ctrl.usuarioCargado = {};

            //Actualizo los permisos para el usuario cargado
            //ctrl.loadSeguridadTemplatesTab();            
          }

          ctrl.cargarUsuario = function (usuarioSeleccionado) {
            if (usuarioSeleccionado == null) {
              toastr.error('Por favor seleccione un usuario para poder visualizarlo');
              return;
            }

            ctrl.usuarioCargado = {};

            ctrl.usuarioCargado.ProcesoId = usuarioSeleccionado.ProcesoId;
            ctrl.usuarioCargado.Usuario = usuarioSeleccionado.Usuario;
            ctrl.usuarioCargado.UsuarioInput = usuarioSeleccionado.Usuario.Login;
            ctrl.usuarioCargado.RolProcesoList = usuarioSeleccionado.RolProcesoList;
          }

          ctrl.eliminarUsuario = function (index) {
            if (index < 0) {
              toastr.error('Usuario seleccionado inválido');
              return;
            }

            if (ctrl.procesoUsuariosList != null && ctrl.procesoUsuariosList.length > 0) {
              ctrl.procesoUsuariosList.splice(index, 1);
              //Actualizo los permisos de templates para los usuarios que quedaron
              //ctrl.loadSeguridadTemplatesTab();
            }
          }

          ctrl.clearUsuario = function () {
            ctrl.usuarioCargado = {};
          }

          ctrl.concatRolesString = function (values) {
            return values.map(function (elem) {
              if (elem != null)
                return elem.Nombre;
              return "";
            }).join(", ");
          }

        }
      });
    })(window.angular);
(function () {
    'use strict';
    angular.module('Kahuna.pages.grupos-usuarios').config(routeConfig);
    function routeConfig($stateProvider) {
      $stateProvider
        .state('pages.grupos-usuarios', {
          url: '/grupos-usuarios',
          title: 'Grupos Usuario',
          template : '<grupos-usuarios-list></grupos-usuarios-list>',
          authenticate: true,
        })
        .state('pages.grupos-usuarios-edit', {
          url: '/grupos-usuarios/edit/:id',
          title: 'Grupos Usuario',
          template : '<grupos-usuarios-edit></grupos-usuarios-edit>',
          params: {id:null},
          authenticate: true,
        });
    }
  })();
(function (angular) {
  'use strict';
  angular.module('Kahuna.pages.grupo').component('gruposUsuariosList', {
    templateUrl: 'app/pages/grupos-usuarios/list.template.html',
    controller: function ($scope, $state, dataService, sharedService, toastr) {
      var ctrl = this;
      ctrl.anularVista = true;

      
      this.$onInit = function () {
        ctrl.anularVista = !sharedService.isSysAdminLoggedUser();
      };
      console.log(ctrl.anularVista);

      ctrl.buscar = function buscar(tableState) {
        ctrl.isSearching = true;

        var pagination = tableState.pagination;

        var start = pagination.start || 0; // This is NOT the page number, but the index of item in the list that you want to use to display the table.
        var number = pagination.number || 10; // Number of entries showed per page.

        ctrl.filtros = {
          PageSize: number,
          SkipNumber: start
        };

        if (tableState.search.predicateObject != null) {
          ctrl.filtros.Nombre = tableState.search.predicateObject.Nombre;
          ctrl.filtros.Resumen = tableState.search.predicateObject.Resumen;
        }

        if (tableState.sort != null) {
          ctrl.filtros.OrderFieldName = tableState.sort.predicate;
          ctrl.filtros.OrderAscending = !tableState.sort.reverse;
        }

        dataService.searchGruposUsuarios(ctrl.filtros)
          .then(function (response) {
            if (response.data.Success) {
              ctrl.resultList = response.data.Value.Resultados;
              //ctrl.totalResultados = response.data.Value.TotalResultados;
              tableState.pagination.numberOfPages = Math.ceil(response.data.Value.TotalResultados / number); //result.numberOfPages;//set the number of pages so the pagination can update
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isSearching = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
            ctrl.isSearching = false;
          });
      };

      ctrl.add = function () {
        $state.go("pages.grupos-usuarios-edit", {
          id: 0
        });
      }

      ctrl.edit = function (id) {
        console.log("EDITO!!!" + id  );
        $state.go("pages.grupos-usuarios-edit", {
          id: id
        });
      }
    }
  });
})(window.angular);
(function (angular) {
    'use strict';
    angular.module('Kahuna.pages.home').component('homeInicio', {
      templateUrl: 'app/pages/home/home.html',
      controller: function ($scope,$state,dataService,sharedService,toastr) {
        var ctrl = this;
        ctrl.grupos = [];
        ctrl.appLogoIcon = sharedService.getAssetsUrl() + 'img/app/KahunaLogoColor.png';
        ctrl.clientLogoIcon = sharedService.getAssetsUrl() + 'img/app/ClienteLogo.png';        
        ctrl.appVersion = sharedService.getSystemVersion();
       
        this.$onInit = function () 
        {
            ctrl.isGroupSearching = true;

            dataService.getGrupoHomeList()
                .then(function (response) 
                {
                if (response.data.Success) 
                {
                    ctrl.grupos = response.data.Value;
                } 
                else 
                {
                    toastr.error(response.data.ErrorSummary);
                }
                ctrl.isGroupSearching = false;
                }, function (error) {
                toastr.error(error.data || sharedService.getGenericErrorMessage());
                ctrl.isGroupSearching = false;
            });
        };

        ctrl.setGrupoSeleccionado = function (grupoId)
        {
            $state.go('pages.solicitud-procesos',{grupoId:grupoId});
        };
      }
    });
  })(window.angular);
(function (angular) {
  "use strict";
  angular.module("Kahuna.pages.jerarquia").component("jerarquiaEdit", {
    templateUrl: "app/pages/jerarquia/edit.template.html",
    controller: function (
      $scope,
      $state,
      dataService,
      sharedService,
      toastr,
      toastrConfig,
      $stateParams,
      $uibModal
    ) {
      var ctrl = this;
      ctrl.model = {};
      ctrl.model.Permisos = {};
      ctrl.model.TieneJerarquiaPermisosCampos = false;
      ctrl.GruposUsuariosList = {};
      ctrl.isBusy = false;
      ctrl.showDelete = false;
      ctrl.title = "";
      ctrl.resultListProcesos = [];
      ctrl.resultListCamposProceso = [];
      ctrl.arrayTemplateSeleccionados = [];
      ctrl.campoCargado = {};
      ctrl.contadorProcesoSelected = 0;
      ctrl.filtrosProcesos = {
        PageSize: 500,
        SkipNumber: 0,
      };
      ctrl.resultListJerarquiaProcesos = [];
      ctrl.model.listaProcesosTemplates = [];

      function initialize() {
        ctrl.loadGrupos();
        loadProcesos();
        afterInitialize();
      }

      function afterInitialize() {
        if ($stateParams.id != "0") {
          ctrl.title = "Editar Jerarquía";
          dataService.getJerarquiaById($stateParams.id).then(
            function (response) {
              if (response.data.Success) {
                ctrl.showDelete = true;
                ctrl.model = response.data.Value;
                if (ctrl.model != null) {
                  if (ctrl.model.JerarquiaPadre != null) {
                    ctrl.model.JerarquiaPadreInput =
                      ctrl.model.JerarquiaPadre.Nombre;
                  }
                  if (
                    ctrl.model.listaProcesosTemplates != null &&
                    ctrl.model.listaProcesosTemplates.length > 0
                  ) {
                    ctrl.model.procesoId =
                      ctrl.model.listaProcesosTemplates[0].ProcesoId;
                    console.log(ctrl.model.procesoId);
                    if (ctrl.model.procesoId != 0) {
                      ctrl.loadJerarquiaProcesos();
                    }
                    //ctrl.model.listaProcesosTemplates
                    //todo: clear
                    angular.forEach(
                      ctrl.model.listaProcesosTemplates,
                      function (procesoTemplate, key) {
                        console.log(procesoTemplate);
                        console.log(ctrl.resultListJerarquiaProcesos);
                        ctrl.resultListJerarquiaProcesos = ctrl.resultListJerarquiaProcesos.filter(
                          function (item) {
                            return (
                              item.Template.Id != procesoTemplate.Template.Id
                            );
                          }
                        );
                      }
                    );
                  }
                }
              } else {
                toastr.error(response.data.ErrorSummary);
              }
            },
            function (error) {
              toastr.error(
                error.data || sharedService.getGenericErrorMessage()
              );
            }
          );
        } else {
          ctrl.title = "Crear Jerarquía";
        }
      }

      this.$onInit = function () {
        initialize();
      };

      ctrl.loadJerarquiaProcesos = function () {
        console.log("ejecuto loadTemplatesProcesos " + ctrl.model.procesoId);
        ctrl.isSearching = true;

        dataService.searchTemplatesByProceso(ctrl.model.procesoId).then(
          function (response) {
            ctrl.resultListJerarquiaProcesos = response.data.Value.Resultados;
            dataService
              .SearchTemplatesByProcesoJerarquia(
                ctrl.model.Id,
                ctrl.model.procesoId
              )
              .then(function (response) {
                if (response.data.Success) {
                  ctrl.arrayTemplateSeleccionados =
                    response.data.Value.Resultados;
                  if (ctrl.contadorProcesoSelected != 0) {
                    ctrl.arrayTemplateSeleccionados;
                  } else {
                    console.log("INGESO PORQUE YA EXISTE.....");
                    if (
                      ctrl.arrayTemplateSeleccionados != null &&
                      ctrl.arrayTemplateSeleccionados.length > 0
                    ) {
                      angular.forEach(
                        ctrl.arrayTemplateSeleccionados,
                        function (procesoTemplate, key) {
                          ctrl.resultListJerarquiaProcesos = ctrl.resultListJerarquiaProcesos.filter(
                            function (item) {
                              return (
                                item.Template.Id != procesoTemplate.Template.Id
                              );
                            }
                          );
                        }
                      );
                    }
                  }

                  ctrl.arrayTemplateSeleccionados.forEach(function (template) {
                    ctrl.resultListJerarquiaProcesos = ctrl.resultListJerarquiaProcesos.filter(
                      function (item) {
                        return item.Template.Id != template.Template.Id;
                      }
                    );
                  });

                  ctrl.contadorProcesoSelected = 1;
                } else {
                  toastr.error(response.data.ErrorSummary);
                }
                ctrl.isSearching = false;
              });
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
            ctrl.isSearching = false;
          }
        );
      };

      ctrl.actionAddOnClick = function (j) {
        //ctrl.model.listaProcesosTemplates
        //ctrl.resultListJerarquiaProcesos
        ctrl.resultListJerarquiaProcesos = ctrl.resultListJerarquiaProcesos.filter(
          function (item) {
            return item.Template.Id != j.Template.Id;
          }
        );

        if (
          ctrl.arrayTemplateSeleccionados === null ||
          ctrl.arrayTemplateSeleccionados === undefined
        ) {
          console.log("LLEGÓ NULL");
          ctrl.arrayTemplateSeleccionados = [];
        }

        if (ctrl.model.listaProcesosTemplates.indexOf(j) == -1) {
          //verifica si el elemento ya está adentro
          ctrl.model.listaProcesosTemplates.push(j);
        }

        ctrl.arrayTemplateSeleccionados.push(j);
      };

      ctrl.actionRemoveOnClick = function (j) {
        ctrl.arrayTemplateSeleccionados = ctrl.arrayTemplateSeleccionados.filter(
          function (item) {
            return item.Template.Id != j.Template.Id;
          }
        );

        // ctrl.model.listaProcesosTemplates = ctrl.model.listaProcesosTemplates.filter(
        //   function (item){
        //     console.log("ES DIFERENTE DEL ITEM" ,item.ProcesoId != j.ProcesoId &&  item.JerarquiaId != j.JerarquiaId);
        //     return item.ProcesoId != j.ProcesoId &&  item.JerarquiaId != j.JerarquiaId
        //   }
        // );

        ctrl.model.listaProcesosTemplates.forEach(function (item, i) {
          if (
            item.ProcesoId == j.ProcesoId &&
            item.JerarquiaId == j.JerarquiaId
          ) {
            ctrl.model.listaProcesosTemplates.splice(i, 1);
            console.log("removed", item, "at position", i);
          }
        });
        ctrl.resultListJerarquiaProcesos.push(j);
      };

      function loadProcesos() {
        ctrl.isSearching = true;
        sharedService.showLoading();
        dataService.getCampoListLigth().then(
          function (response) {
            if (response.data.Success) {
              ctrl.camposList = response.data.Value;
              dataService.searchProceso(ctrl.filtrosProcesos).then(
                function (response) {
                  if (response.data.Success) {
                    ctrl.resultListProcesos = response.data.Value.Resultados;
                    console.log("Listado de procesos.");
                    console.log(ctrl.resultListProcesos);
                    sharedService.closeLoading();
                  } else {
                    toastr.error(response.data.ErrorSummary);
                  }
                  ctrl.isSearching = false;
                },
                function (error) {
                  toastr.error(
                    error.data || sharedService.getGenericErrorMessage()
                  );
                  ctrl.isSearching = false;
                }
              );
            } else {
              toastr.error(response.data.ErrorSummary);
            }
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
          }
        );
      }

      ctrl.loadCamposProceso = function (procesoId) {
        console.log("cargar campos del proceso: " + procesoId);
        sharedService.showLoading();
        dataService.getCamposLigthByProceso(procesoId).then(
          function (response) {
            if (response.data.Success) {
              console.log(response);
              ctrl.resultListCamposProceso = response.data.Value;
              console.log("Listado de procesos.");
              console.log(ctrl.resultListCamposProceso);
              sharedService.closeLoading();
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isSearching = false;
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
            ctrl.isSearching = false;
          }
        );

        if (ctrl.model.Id != 0) {
          dataService.getJerarquiaProcesoCampos(procesoId, ctrl.model.Id).then(
            function (response) {
              if (response.data.Success) {
                console.log(response);
                ctrl.procesoCamposList = response.data.Value.Resultados;
                ctrl.procesoCamposDS = ctrl.procesoCamposList;
                console.log("Listado de campos Proceso Jerarquia.");
                sharedService.closeLoading();
              } else {
                toastr.error(response.data.ErrorSummary);
              }
              ctrl.isSearching = false;
            },
            function (error) {
              toastr.error(
                error.data || sharedService.getGenericErrorMessage()
              );
              ctrl.isSearching = false;
            }
          );
        }
      };

      ctrl.loadGrupos = function () {
        ctrl.filtros = {
          PageSize: 1000,
          SkipNumber: 0,
        };

        dataService.searchGruposUsuarios(ctrl.filtros).then(
          function (response) {
            if (response.data.Success) {
              console.log("TRESPONSE USUARIOS");

              var defaultUser = {
                Id: 0,
                Nombre: "",
              };
              ctrl.GruposUsuariosList = [];
              ctrl.GruposUsuariosList.push(defaultUser);
              ctrl.GruposUsuariosList = ctrl.GruposUsuariosList.concat(
                response.data.Value.Resultados
              );
              console.log(ctrl.GruposUsuariosList);
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isSearching = false;
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
            ctrl.isSearching = false;
          }
        );
      };

      /******************* Campos *******************/
      ctrl.editCampo = function () {
        if (
          ctrl.campoCargado.Campo == null ||
          ctrl.campoCargado.Campo.Id == 0
        ) {
          toastr.error(
            "Por favor complete los datos obligatorios marcados con asterisco para cargar el campo"
          );
          return;
        }

        ctrl.campoCargado.campoId = ctrl.campoCargado.Campo.Id;
        ctrl.campoCargado.procesoId = ctrl.model.procesoId;

        if (ctrl.procesoCamposList == null) ctrl.procesoCamposList = [];

        var index = -1;
        for (var i = 0; i < ctrl.procesoCamposList.length; i++) {
          /*if (ctrl.procesoCamposList[i].Campo.Id != ctrl.campoCargado.Campo.Id &&
            ctrl.procesoCamposList[i].Orden == ctrl.campoCargado.Orden) {
            toastr.error('Por favor ingrese un número de orden distinto ya que el ingresado ya existe');
            return;
          }*/
          if (ctrl.procesoCamposList[i].campoId == ctrl.campoCargado.campoId)
            index = i;
        }

        if (index >= 0) ctrl.procesoCamposList[index] = ctrl.campoCargado;
        else ctrl.procesoCamposList.push(ctrl.campoCargado);

        ctrl.procesoCamposList.sort(function (a, b) {
          return parseInt(a.Orden) > parseInt(b.Orden)
            ? 1
            : parseInt(b.Orden) > parseInt(a.Orden)
            ? -1
            : 0;
        });
        ctrl.procesoCamposDS = ctrl.procesoCamposList;
        ctrl.campoCargado = {};
      };

      ctrl.cargarCampo = function (campoSeleccionado) {
        if (campoSeleccionado == null) {
          toastr.error("Por favor seleccione un campo para poder visualizarlo");
          return;
        }
        ctrl.campoCargado = {};
        ctrl.campoCargado.Id = campoSeleccionado.Id;
        ctrl.campoCargado.procesoId = ctrl.model.procesoId;
        ctrl.campoCargado.Campo = campoSeleccionado.Campo;
        ctrl.campoCargado.campoId = campoSeleccionado.Campo.Id;
      };

      ctrl.eliminarCampo = function (index) {
        if (index < 0) {
          toastr.error("Campo seleccionado inválido");
          return;
        }

        if (ctrl.procesoCamposList != null && ctrl.procesoCamposList.length > 0)
          ctrl.procesoCamposList.splice(index, 1);
      };
      ctrl.clearCampo = function () {
        ctrl.campoCargado = {};
      };

      ctrl.save = function (form) {
        console.log("GUARDAR JERARQUIA.....");
        console.log("***********************");
        console.log(ctrl.procesoCamposList);
        ctrl.model.jerarquiaProcesoCampos = ctrl.procesoCamposList;
        console.log("***********************");
        // if (form.$invalid)
        // {
        //   ctrl.showError = true;
        //   return;
        // }

        console.log(ctrl.model.Activo);

        if (ctrl.model.Codigo == null || ctrl.model.Codigo.length <= 0) {
          toastr.error("Debe completar el Código de la jerarquía");
          return;
        }

        if (ctrl.model.Nombre == null || ctrl.model.Nombre.length <= 0) {
          toastr.error("Debe completar el nombre de la jerarquía");
          return;
        }

        if (
          ctrl.model.MostrarDetalle &&
          (ctrl.model.Detalles == null || ctrl.model.Detalles.lenght <= 0)
        ) {
          toastr.error(
            "Debe ingresar por lo menos un detalle para la jerarquía"
          );
          return;
        }

        ctrl.isBusy = true;

        if (
          ctrl.model.JerarquiaPadreInput == null ||
          ctrl.model.JerarquiaPadreInput.length <= 0
        )
          ctrl.model.JerarquiaPadre = null;

        if (!ctrl.model.MostrarDetalle) ctrl.model.Detalles = null;

        //ctrl.model.Activo = 1;
        if (
          ctrl.model.JerarquiaPadre != null &&
          ctrl.model.JerarquiaPadre.Id > 0
        ) {
          ctrl.model.JerarquiaPadreId = ctrl.model.JerarquiaPadre.Id;
        } else {
          ctrl.model.JerarquiaPadreId = null;
          ctrl.model.JerarquiaPadre = null;
        }

        dataService.saveJerarquia(ctrl.model).then(
          function (response) {
            if (response.data.Success) {
              toastr.info("Operacion exitosa.");
              $state.transitionTo("pages.jerarquia");
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
            ctrl.isBusy = false;
          }
        );
      };

      ctrl.cancel = function () {
        $state.transitionTo("pages.jerarquia");
      };

      ctrl.delete = function () {
        ctrl.isBusy = true;

        var confirmation = $uibModal.open({
          animation: true,
          component: "confirmation",
          resolve: {
            title: function () {
              return "Atención";
            },
            message: function () {
              return "Confirma el borrado de la jerarquía?";
            },
          },
        });

        confirmation.result.then(
          function (selectedItem) {
            dataService.deleteJerarquia(ctrl.model.Id).then(
              function (response) {
                if (response.data.Success) {
                  toastr.info("Operacion exitosa.");
                  $state.transitionTo("pages.jerarquia");
                } else {
                  toastr.error(response.data.ErrorSummary);
                }
                ctrl.isBusy = false;
              },
              function (error) {
                toastr.error(
                  error.data || sharedService.getGenericErrorMessage()
                );
                ctrl.isBusy = false;
              }
            );
          },
          function () {
            ctrl.isBusy = false;
          }
        );
      };

      ctrl.searchJerarquiaPadre = function (nombreJerarquia) {
        var filtroJerarquia = {
          Nombre: nombreJerarquia,
          PageSize: 20,
          SkipNumber: 0,
        };

        return dataService.searchJerarquia(filtroJerarquia).then(
          function (response) {
            if (response.data.Success) {
              return response.data.Value.Resultados;
            } else {
              toastr.error(response.data.ErrorSummary);
            }
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
          }
        );
      };

      ctrl.onSelectJerarquia = function (jerarquiaSeleccionada) {
        ctrl.model.JerarquiaPadre = jerarquiaSeleccionada;

        if (jerarquiaSeleccionada != null)
          ctrl.model.JerarquiaPadreInput = jerarquiaSeleccionada.Nombre;
        else ctrl.model.JerarquiaPadreInput = null;
      };

      ctrl.editDetalle = function () {
        if (
          ctrl.detalleCargado.Orden <= 0 ||
          ctrl.detalleCargado.Orden == null ||
          ctrl.detalleCargado.Orden.lenght <= 0 ||
          ctrl.detalleCargado.Titulo == null ||
          ctrl.detalleCargado.Titulo.lenght <= 0 ||
          ctrl.detalleCargado.Valor == null ||
          ctrl.detalleCargado.Valor.lenght <= 0
        ) {
          toastr.error(
            "Por favor complete los datos obligatorios marcados con asterisco para cargar el detalle"
          );
          return;
        }

        ctrl.detalleCargado.JerarquiaId = ctrl.model.Id;

        if (ctrl.model.Detalles == null) ctrl.model.Detalles = [];

        var index = -1;
        for (var i = 0; i < ctrl.model.Detalles.length; i++) {
          if (
            ctrl.model.Detalles[i].Titulo != ctrl.detalleCargado.Titulo &&
            ctrl.model.Detalles[i].Orden == ctrl.detalleCargado.Orden
          ) {
            toastr.error(
              "Por favor ingrese un número de orden distinto ya que el ingresado ya existe"
            );
            return;
          }

          if (ctrl.model.Detalles[i].Titulo == ctrl.detalleCargado.Titulo)
            index = i;
        }

        if (index >= 0) ctrl.model.Detalles[index] = ctrl.detalleCargado;
        else ctrl.model.Detalles.push(ctrl.detalleCargado);

        ctrl.model.Detalles.sort(function (a, b) {
          return parseInt(a.Orden) > parseInt(b.Orden)
            ? 1
            : parseInt(b.Orden) > parseInt(a.Orden)
            ? -1
            : 0;
        });
        ctrl.jerarquiaDetalleDS = ctrl.model.Detalles;
        ctrl.detalleCargado = {};
      };

      ctrl.cargarDetalle = function (detalleSeleccionado) {
        if (detalleSeleccionado == null) {
          toastr.error(
            "Por favor seleccione un detalle para poder visualizarlo"
          );
          return;
        }

        ctrl.detalleCargado = {};

        ctrl.detalleCargado.Id = detalleSeleccionado.Id;
        ctrl.detalleCargado.JerarquiaId = detalleSeleccionado.JerarquiaId;
        ctrl.detalleCargado.Titulo = detalleSeleccionado.Titulo;
        ctrl.detalleCargado.Valor = detalleSeleccionado.Valor;
        ctrl.detalleCargado.Orden = detalleSeleccionado.Orden;
      };

      ctrl.eliminarDetalle = function (index) {
        if (index < 0) {
          toastr.error("Detalle seleccionado inválido");
          return;
        }

        if (ctrl.model.Detalles != null && ctrl.model.Detalles.length > 0)
          ctrl.model.Detalles.splice(index, 1);
      };

      ctrl.clearDetalle = function () {
        ctrl.detalleCargado = {};
      };
    },
  });
})(window.angular);

(function () {
    'use strict';
    angular.module('Kahuna.pages.jerarquia').config(routeConfig);
    function routeConfig($stateProvider) {
      $stateProvider
        .state('pages.jerarquia', {
          url: '/jerarquia',
          title: 'Jerarquia',
          template : '<jerarquia-list></jerarquia-list>',
          authenticate: true,
        })
        .state('pages.jerarquia-edit', {
          url: '/jerarquia/edit/:id',
          title: 'Jerarquia',
          template : '<jerarquia-edit></jerarquia-edit>',
          params: {id:null},
          authenticate: true,
        });
    }
  })();
(function (angular) {
    'use strict';
    angular.module('Kahuna.pages.jerarquia').component('jerarquiaList', {
      templateUrl: 'app/pages/jerarquia/list.template.html',
      controller: function ($scope,$state,dataService, sharedService,toastr) {
        var ctrl = this;
        ctrl.filtros = {};
        ctrl.resultList = [];
       
        this.$onInit = function () 
        {
        };

        ctrl.buscar = function buscar(tableState) 
        {
          ctrl.isSearching = true;

          var pagination = tableState.pagination;

          var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
          var number = pagination.number || 10;  // Number of entries showed per page.

          ctrl.filtros = { PageSize: number, SkipNumber: start };

          if (tableState.search.predicateObject != null)
          {
            ctrl.filtros.Codigo = tableState.search.predicateObject.Codigo;
            ctrl.filtros.Nombre = tableState.search.predicateObject.Nombre;
            ctrl.filtros.JerarquiaPadre = tableState.search.predicateObject.JerarquiaPadre;
          }

          if (tableState.sort != null)
          {
            ctrl.filtros.OrderFieldName = tableState.sort.predicate;
            ctrl.filtros.OrderAscending = !tableState.sort.reverse;
          }

          dataService.searchJerarquia(ctrl.filtros)
            .then(function (response) 
            {
              if (response.data.Success)
              {               
                ctrl.resultList = response.data.Value.Resultados;
                //ctrl.totalResultados = response.data.Value.TotalResultados;

                tableState.pagination.numberOfPages = Math.ceil(response.data.Value.TotalResultados/number); //result.numberOfPages;//set the number of pages so the pagination can update
              } 
              else 
              {
                toastr.error(response.data.ErrorSummary);
              }
              ctrl.isSearching = false;
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage());
              ctrl.isSearching = false;
          });
        };
        
        ctrl.add = function ()
        {
          $state.go("pages.jerarquia-edit",{id:0});
        }

        ctrl.edit = function (id)
        {
          $state.go("pages.jerarquia-edit",{id:id});
        }
      }
    });
  })(window.angular);
(function (angular) {
  'use strict';
  angular.module('Kahuna.pages.proceso').component('procesoEdit', {
    templateUrl: 'app/pages/proceso/edit.template.html',
    controller: function ($scope, $state, dataService, sharedService, toastr, toastrConfig, $stateParams, $timeout, $uibModal) {
      var ctrl = this;
      ctrl.model = {};
      ctrl.isBusy = false;
      ctrl.enableDatosProcesoTab = false;
      ctrl.showDelete = false;

      ctrl.showCampoProcesoTituloSelect = false;
      ctrl.showCampoTemplateTituloSelect = false;
      ctrl.showTemplateTituloSelect = false;

      ctrl.title = '';
      ctrl.configuracionTituloText = "";

      ctrl.estadosFilteredList = [];
      ctrl.rolProcesoFilteredList = [];
      ctrl.usuarioFilteredList = [];
      ctrl.rolProcesoList = [];
      ctrl.rolTemplateList = [];
      ctrl.estadosList = [];
      ctrl.gruposList = [];
      ctrl.camposList = [];
      ctrl.tipoCampoSolicitudList = [];

      ctrl.columnasProcesoList = [];
      ctrl.procesoUsuariosList = [];
      ctrl.templatesCamposList = [];
      ctrl.procesoTemplatesList = [];
      ctrl.procesoTemplateCamposList = [];
      ctrl.procesoTemplateUsuariosList = [];
      ctrl.procesoLinksList = [];
      ctrl.procesoCamposList = [];
      ctrl.procesoHijosSeleccionables = [];
      ctrl.allProcesosList = [];

      ctrl.procesoCamposDS = [];
      ctrl.procesoUsuariosDS = [];
      ctrl.procesoTemplatesDS = [];

      ctrl.campoCargado = {};
      ctrl.usuarioCargado = {};
      ctrl.templateCargado = {};
      ctrl.usuarioTemplateCargado = {};
      ctrl.campoTemplateCargado = {};

      ctrl.filtrosProcesos = { PageSize: 500, SkipNumber: 0 };
      ctrl.resultListProcesos = [];
      ctrl.lsuarioLogueadoIsSysAdmin = false;
      
      this.$onInit = function () {
        ctrl.lsuarioLogueadoIsSysAdmin = sharedService.isSuperAdminLoggedUser();
        loadView();
      };

      ctrl.evaluatenumberDigit = function (event) {
        var charCode = (event.which) ? event.which : event.keyCode;
        if (charCode == 8 || charCode == 35 || charCode == 36 || charCode == 37 || charCode == 39 || charCode == 45 || charCode == 46 || charCode == 96 || charCode == 109) {
          return true;
        } else if (charCode >= 97 && charCode <= 105) {
          return true;
        } else if (charCode < 48 || charCode > 57) {
          event.preventDefault();
          return false;
        } else {
          return true;
        }
      }


      function loadProcesos() {
        dataService.searchProceso(ctrl.filtrosProcesos)
          .then(function (response) {
            if (response.data.Success) {
              ctrl.resultListProcesos = response.data.Value.Resultados;
              console.log("Listado de procesos.");
              console.log(ctrl.resultListProcesos);
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isSearching = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
            ctrl.isSearching = false;
          });
      }

      function loadView() {
        loadProcesos();
        ctrl.enableDatosProcesoTab = sharedService.isSysAdminLoggedUser();

        dataService.getRolProcesoList()
          .then(function (response) {
            if (response.data.Success) {
              ctrl.rolProcesoList = response.data.Value;
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
          });

        dataService.getRolTemplateList()
          .then(function (response) {
            if (response.data.Success) {
              ctrl.rolTemplateList = response.data.Value;
              console.log(ctrl.rolTemplateList);
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
          });

        dataService.getSolicitudEstadoSeleccionablesList()
          .then(function (response) {
            if (response.data.Success) {
              ctrl.estadosList = response.data.Value;
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
          });

        dataService.getGrupoList()
          .then(function (response) {
            if (response.data.Success) {
              ctrl.gruposList = response.data.Value;
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
          });

        dataService.getProcesoList()
          .then(function (response) {
            if (response.data.Success) {
              var grupoIndex = -1;
              var procesosList = response.data.Value;
              var finalList = [];

              ctrl.allProcesosList = [];

              if (procesosList == null)
                procesosList = [];

              for (var i = 0; i < procesosList.length; i++) {
                grupoIndex = -1;
                var p = procesosList[i];

                for (var k = 0; k < finalList.length; k++) {
                  if (finalList[k].Grupo.Id == p.Grupo.Id) {
                    grupoIndex = k;
                    break;
                  }
                }

                if (grupoIndex < 0) {
                  grupoIndex = finalList.length;

                  finalList.push({
                    Grupo: p.Grupo,
                    ProcesosHijosList: []
                  });
                }

                finalList[grupoIndex].ProcesosHijosList.push(p);
              }

              ctrl.allProcesosList = finalList;
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
          });

        dataService.getCampoList()
          .then(function (response) {
            if (response.data.Success) {
              ctrl.camposList = response.data.Value;
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
          });

        dataService.getTipoCampoSolicitudList()
          .then(function (response) {
            if (response.data.Success) {
              ctrl.tipoCampoSolicitudList = response.data.Value;
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
          });

        if ($stateParams.id != "0") {
          ctrl.isTemplateSearching = true;
          ctrl.isTemplateUsuarioSearching = true;
          ctrl.isUsuarioSearching = true;
          ctrl.isCampoSearching = true;

          dataService.getProcesoById($stateParams.id)
            .then(function (response) {
              if (response.data.Success) {
                ctrl.model = response.data.Value;
                console.log("LLEGO PROCESOP");
                console.log(ctrl.model);
                ctrl.title = 'Editar Proceso: ' + ctrl.model.Nombre;

                ctrl.procesoTemplatesList = ctrl.model.Templates;
                console.log(ctrl.procesoTemplatesList);
                ctrl.procesoCamposList = ctrl.model.Campos;
                console.log(ctrl.procesoCamposList);
                ctrl.procesoHijosSeleccionables = ctrl.model.HijosSeleccionables;
                ctrl.procesoLinksList = ctrl.model.Links;

                ctrl.procesoUsuariosList = [];
                ctrl.procesoTemplateUsuariosList = [];
                ctrl.procesoTemplateCamposList = [];

                ctrl.model.procesoIdObsoletos = "" + ctrl.model.procesoIdObsoletos + "";
                ctrl.model.procesoIdVersiones = "" + ctrl.model.procesoIdVersiones + "";
                ctrl.model.campoIdAutorizacion = "" + ctrl.model.campoIdAutorizacion + "";
                ctrl.model.jerarquiatemplate = "" + ctrl.model.jerarquiatemplate + "";
                ctrl.model.tipoDocumentoId = "" + ctrl.model.tipoDocumentoId + "";
                ctrl.model.documentoPublicableId = "" + ctrl.model.documentoPublicableId + "";
                ctrl.model.numeradorDocumentalId = "" + ctrl.model.numeradorDocumentalId + "";

                /*ctrl.found =  ctrl.resultListProcesos.find(x => x.id === ctrl.model.procesoIdObsoletos);
                ctrl.found2 = ctrl.resultListProcesos.find(x => x.id === ctrl.model.procesoIdVersiones);
                console.log(ctrl.found2);
                console.log(ctrl.found);*/


                //Carga de usuarios del proceso
                if (ctrl.model.Usuarios != null && ctrl.model.Usuarios.length > 0) {
                  var index;

                  for (var i = 0; i < ctrl.model.Usuarios.length; i++) {
                    index = -1;

                    for (var x = 0; x < ctrl.procesoUsuariosList.length; x++) {
                      if (ctrl.procesoUsuariosList[x].Usuario.Id == ctrl.model.Usuarios[i].Usuario.Id) {
                        index = x;
                        break;
                      }
                    }

                    if (index < 0) {
                      ctrl.procesoUsuariosList.push({ Usuario: ctrl.model.Usuarios[i].Usuario, RolProcesoList: [] });
                      index = ctrl.procesoUsuariosList.length - 1;
                    }

                    //Existe el usuario
                    ctrl.procesoUsuariosList[index].RolProcesoList.push(ctrl.model.Usuarios[i].RolProceso);
                  }
                }

                //Carga de usuarios de cada template del proceso
                if (ctrl.model.Templates != null && ctrl.model.Templates.length > 0) {
                  var index2;

                  for (var i = 0; i < ctrl.model.Templates.length; i++) {
                    if (ctrl.model.Templates[i].Usuarios != null) {
                      for (var j = 0; j < ctrl.model.Templates[i].Usuarios.length; j++) {
                        index2 = -1;

                        for (var x = 0; x < ctrl.procesoTemplateUsuariosList.length; x++) {
                          if (ctrl.procesoTemplateUsuariosList[x].Usuario.Id == ctrl.model.Templates[i].Usuarios[j].Usuario.Id &&
                            ctrl.procesoTemplateUsuariosList[x].ProcesoTemplate.Id == ctrl.model.Templates[i].Usuarios[j].ProcesoTemplateId) {
                            index2 = x;
                            break;
                          }
                        }

                        if (index2 < 0) {
                          ctrl.procesoTemplateUsuariosList.push({
                            ProcesoTemplate: ctrl.model.Templates[i],
                            Usuario: ctrl.model.Templates[i].Usuarios[j].Usuario,
                            RolTemplateList: []
                          });
                          index2 = ctrl.procesoTemplateUsuariosList.length - 1;
                        }

                        //Existe el usuario
                        ctrl.procesoTemplateUsuariosList[index2].RolTemplateList.push(ctrl.model.Templates[i].Usuarios[j].RolTemplate);
                      }
                    }
                  }
                }

                console.log(ctrl.model.Templates);
                //Carga de campos de cada template del proceso
                if (ctrl.model.Templates != null && ctrl.model.Templates.length > 0) {
                  var index2;

                  for (var i = 0; i < ctrl.model.Templates.length; i++) {
                    if (ctrl.model.Templates[i].Campos != null) {
                      for (var j = 0; j < ctrl.model.Templates[i].Campos.length; j++) {
                        index2 = -1;
                        for (var x = 0; x < ctrl.procesoTemplateCamposList.length; x++) {
                          if (ctrl.procesoTemplateCamposList[x].Campo.Id == ctrl.model.Templates[i].Campos[j].Campo.Id &&
                            ctrl.procesoTemplateCamposList[x].ProcesoTemplate.Id == ctrl.model.Templates[i].Campos[j].ProcesoTemplateId) {
                            index2 = x;
                            break;
                          }
                        }

                        if (index2 < 0) {
                          ctrl.procesoTemplateCamposList.push({
                            ProcesoTemplate: ctrl.model.Templates[i],
                            Campo: ctrl.model.Templates[i].Campos[j].Campo,
                            orden : ctrl.model.Templates[i].Campos[j].orden
                          });
                          index2 = ctrl.procesoTemplateCamposList.length - 1;
                        }                      
                      }
                    }
                  }
                }
                console.log(ctrl.procesoTemplateCamposList);

                //Carga de columnas del proceso
                dataService.getSolicitudNombreCamposList()
                  .then(function (response) {
                    if (response.data.Success) {
                      ctrl.columnasProcesoList = response.data.Value;
                      var found = false;

                      if (ctrl.model.CamposListado != null && ctrl.model.CamposListado.length > 0) {
                        for (var i = 0; i < ctrl.model.CamposListado.length; i++) {
                          found = false;

                          if (ctrl.columnasProcesoList != null) {
                            for (var x = 0; x < ctrl.columnasProcesoList.length; x++) {
                              if (ctrl.columnasProcesoList[x].Id == ctrl.model.CamposListado[i].SolicitudColumnaId) {
                                ctrl.columnasProcesoList[x].SeleccionLista = true;
                                ctrl.columnasProcesoList[x].CampoId = null;
                                ctrl.columnasProcesoList[x].SolicitudColumnaId = ctrl.model.CamposListado[i].SolicitudColumnaId;
                                ctrl.columnasProcesoList[x].OrdenLista = ctrl.model.CamposListado[i].Orden;
                                ctrl.columnasProcesoList[x].IdLista = ctrl.model.CamposListado[i].Id;
                                found = true;
                                break;
                              }
                            }
                          }

                          if (!found && ctrl.procesoCamposList != null) {
                            for (var x = 0; x < ctrl.procesoCamposList.length; x++) {
                              if (ctrl.procesoCamposList[x].CampoId == ctrl.model.CamposListado[i].CampoId) {
                                ctrl.procesoCamposList[x].SeleccionLista = true;
                                ctrl.procesoCamposList[x].CampoId = ctrl.model.CamposListado[i].CampoId;
                                ctrl.procesoCamposList[x].SolicitudColumnaId = null;
                                ctrl.procesoCamposList[x].OrdenLista = ctrl.model.CamposListado[i].Orden;
                                ctrl.procesoCamposList[x].IdLista = ctrl.model.CamposListado[i].Id;
                                found = true;
                                break;
                              }
                            }
                          }
                        }
                      }
                    }
                    else {
                      toastr.error(response.data.ErrorSummary);
                    }
                  }, function (error) {
                    toastr.error(error.data || sharedService.getGenericErrorMessage());
                  });

                ctrl.showDelete = sharedService.isSysAdminLoggedUser();
                ctrl.actualizarTituloConfigText();
              }
              else {
                toastr.error(response.data.ErrorSummary);
              }

              ctrl.isTemplateSearching = false;
              ctrl.isTemplateUsuarioSearching = false;
              ctrl.isUsuarioSearching = false;
              ctrl.isCampoSearching = false;
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage());

              ctrl.isTemplateSearching = false;
              ctrl.isTemplateUsuarioSearching = false;
              ctrl.isUsuarioSearching = false;
              ctrl.isCampoSearching = false;
            });
        }
        else {
          ctrl.title = 'Crear Proceso: -';

          dataService.getProcesoDefault()
            .then(function (response) {
              if (response.data.Success) {
                ctrl.model = response.data.Value;
              }
              else {
                toastr.error(response.data.ErrorSummary);
              }
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage());
            });
        }
      }

      ctrl.actualizarTitulo = function () {
        if (ctrl.model != null) {
          if ($stateParams.id != "0")
            ctrl.title = 'Editar Proceso: ' + ctrl.model.Nombre;
          else
            ctrl.title = 'Crear Proceso: ' + ctrl.model.Nombre;
        }
      }

      ctrl.buscarCampoProcesoTitulo = function (show) {
        ctrl.templateTituloSeleccionado = null;

        ctrl.showCampoProcesoTituloSelect = show;
        ctrl.showTemplateTituloSelect = false;
        ctrl.showCampoTemplateTituloSelect = false;
      }

      ctrl.onSelectCampoProcesoTitulo = function (campoSeleccionado) {
        if (campoSeleccionado != null && campoSeleccionado.Campo != null) {
          if (ctrl.model.ConfiguracionTitulo == null)
            ctrl.model.ConfiguracionTitulo = "";

          var position = $("#configuracionTitulo")[0].selectionStart;
          ctrl.model.ConfiguracionTitulo = [ctrl.model.ConfiguracionTitulo.slice(0, position), "[[" + campoSeleccionado.Campo.Id + "]]", ctrl.model.ConfiguracionTitulo.slice(position)].join('');
          ctrl.actualizarTituloConfigText();

          ctrl.showCampoProcesoTituloSelect = false;
          ctrl.campoTituloSeleccionado = null;
        }
      }

      ctrl.buscarCampoTemplateTitulo = function (show) {
        ctrl.templateTituloSeleccionado = null;
        ctrl.campoTituloSeleccionado = null;

        ctrl.showTemplateTituloSelect = show;
        ctrl.showCampoTemplateTituloSelect = false;
        ctrl.showCampoProcesoTituloSelect = false;

        ctrl.templateCamposList = null;
      }

      ctrl.onSelectTemplateTitulo = function (templateSeleccionado) {
        ctrl.templateCamposList = null;

        if (templateSeleccionado != null && templateSeleccionado.Template != null) {
          ctrl.showCampoTemplateTituloSelect = true;

          dataService.getCampoListByTemplate(templateSeleccionado.Template.Id)
            .then(function (response) {
              if (response.data.Success) {
                ctrl.templateCamposList = response.data.Value;
              }
              else {
                toastr.error(response.data.ErrorSummary);
              }
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage());
            });
        }
        else
          ctrl.showCampoTemplateTituloSelect = false;
      }

      ctrl.onSelectCampoTemplateTitulo = function (templateSeleccionado, campoSeleccionado) {
        if (templateSeleccionado != null && templateSeleccionado.Template != null &&
          campoSeleccionado != null) {
          if (ctrl.model.ConfiguracionTitulo == null)
            ctrl.model.ConfiguracionTitulo = "";

          var position = $("#configuracionTitulo")[0].selectionStart;
          ctrl.model.ConfiguracionTitulo = [ctrl.model.ConfiguracionTitulo.slice(0, position), "{{" + templateSeleccionado.Template.Id + "|" + campoSeleccionado.Id + "}}", ctrl.model.ConfiguracionTitulo.slice(position)].join('');
          ctrl.actualizarTituloConfigText();

          ctrl.showTemplateTituloSelect = false;
          ctrl.showCampoTemplateTituloSelect = false;
          ctrl.templateTituloSeleccionado = null;
          ctrl.campoTituloSeleccionado = null;
        }
      }

      ctrl.actualizarTituloConfigText = function () {
        ctrl.configuracionTituloText = "...";

        if (ctrl.model.ConfiguracionTitulo != null && ctrl.model.ConfiguracionTitulo.length > 0) {
          dataService.getProcesoTituloConfigText(ctrl.model)
            .then(function (response) {
              if (response.data.Success) {
                ctrl.configuracionTituloText = response.data.Value;
              }
              else {
                toastr.error(response.data.ErrorSummary);
                ctrl.configuracionTituloText = "";
              }
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage());
              ctrl.configuracionTituloText = "";
            });
        }
        else
          ctrl.configuracionTituloText = "";
      }

      ctrl.save = function (form) {

        if (ctrl.model.isDocumental) {
          if (ctrl.model.procesoIdVersiones == "" || ctrl.model.procesoIdVersiones == 0 || ctrl.model.procesoIdVersiones == null) {
            toastr.error('El proceso id de versiones es obligatorio cuando es un proceso documental.');
            return;
          }
          if (ctrl.model.procesoIdObsoletos == "" || ctrl.model.procesoIdObsoletos == 0 || ctrl.model.procesoIdObsoletos == null) {
            toastr.error('El proceso id de obsoletos es obligatorio cuando es un proceso documental.');
            return;
          }
        }

        if (ctrl.model.Codigo == null ||
          ctrl.model.Codigo == '' ||
          ctrl.model.Nombre == null ||
          ctrl.model.Nombre == '' ||
          ctrl.model.CantidadDiasCierre == null ||
          ctrl.model.CantidadDiasCierre <= 0 ||
          ctrl.model.Grupo == null ||
          ctrl.model.Grupo.Id <= 0) {
          toastr.error('Por favor complete los datos obligatorios marcados con asterisco');
          return;
        }

        if (ctrl.model.MostrarEnHome && ctrl.model.HomeOrden <= 0) {
          toastr.error('Por favor ingrese el orden para mostrar en la home');
          return;
        }

        if (ctrl.procesoTemplatesList == null ||
          ctrl.procesoTemplatesList.length <= 0) {
          toastr.error('Por favor seleccione al menos un template para el proceso');
          return;
        }

        if (ctrl.model.AceptaHijos &&
          (ctrl.procesoHijosSeleccionables == null ||
            ctrl.procesoHijosSeleccionables.length <= 0)) {
          toastr.error('Por favor seleccione al menos un proceso para ser hijo');
          return;
        }

        ctrl.isBusy = true;

        if (!ctrl.model.AceptaHijos)
          ctrl.procesoHijosSeleccionables = [];

        ctrl.model.Campos = ctrl.procesoCamposList;
        ctrl.model.Templates = ctrl.procesoTemplatesList;
        ctrl.model.HijosSeleccionables = ctrl.procesoHijosSeleccionables;
        ctrl.model.Links = ctrl.procesoLinksList;

        ctrl.model.Usuarios = [];
        ctrl.model.GrupoId = ctrl.model.Grupo.Id;
        ctrl.model.Activo = 1;

        for (var i = 0; i < ctrl.model.Templates.length; i++) {
          ctrl.model.Templates[i].Usuarios = [];
          ctrl.model.Templates[i].Campos = [];
        }

        //Usuarios del proceso
        if (ctrl.procesoUsuariosList != null && ctrl.procesoUsuariosList.length > 0) {
          for (var i = 0; i < ctrl.procesoUsuariosList.length; i++) {
            if (ctrl.procesoUsuariosList[i].RolProcesoList != null) {
              for (var j = 0; j < ctrl.procesoUsuariosList[i].RolProcesoList.length; j++) {
                ctrl.model.Usuarios.push({
                  ProcesoId: ctrl.model.Id,
                  UsuarioId: ctrl.procesoUsuariosList[i].Usuario.Id,
                  RolProcesoId: ctrl.procesoUsuariosList[i].RolProcesoList[j].Id
                });
              }
            }
          }
        }

        //Si no tiene cargado nada en la lista, cargo el default
        if (ctrl.procesoTemplateUsuariosList == null || ctrl.procesoTemplateUsuariosList.length <= 0)
          ctrl.loadSeguridadTemplatesTab();

        //Usuarios de cada template del proceso
        if (ctrl.procesoTemplateUsuariosList != null && ctrl.procesoTemplateUsuariosList.length > 0) {
          var index = -1;

          for (var i = 0; i < ctrl.procesoTemplateUsuariosList.length; i++) {
            if (ctrl.procesoTemplateUsuariosList[i].RolTemplateList != null) {
              for (var x = 0; x < ctrl.model.Templates.length; x++) {
                if (ctrl.model.Templates[x].TemplateId == ctrl.procesoTemplateUsuariosList[i].ProcesoTemplate.Template.Id) {
                  index = x;
                  break;
                }
              }

              if (index >= 0) {
                for (var j = 0; j < ctrl.procesoTemplateUsuariosList[i].RolTemplateList.length; j++) {
                  ctrl.model.Templates[index].Usuarios.push({
                    ProcesoTemplateId: ctrl.procesoTemplateUsuariosList[i].ProcesoTemplate.Id,
                    UsuarioId: ctrl.procesoTemplateUsuariosList[i].Usuario.Id,
                    RolTemplateId: ctrl.procesoTemplateUsuariosList[i].RolTemplateList[j].Id
                  });
                }//for
              }
            }
          }//for
        }

        //Campos de cada template del proceso
        console.log(ctrl.procesoTemplateCamposList);
        if (ctrl.procesoTemplateCamposList != null && ctrl.procesoTemplateCamposList.length > 0) {
          var index = -1;
          for (var i = 0; i < ctrl.procesoTemplateCamposList.length; i++) {
            for (var x = 0; x < ctrl.model.Templates.length; x++) {
              if (ctrl.model.Templates[x].TemplateId == ctrl.procesoTemplateCamposList[i].ProcesoTemplate.Template.Id) {
                var lOrden = 0;
                var lCamposTemplate = ctrl.procesoTemplateCamposList[i].ProcesoTemplate.Campos;
                for (var t = 0; t < lCamposTemplate.length; t++) {
                    lOrden = lCamposTemplate[t].orden;
                    console.log(lCamposTemplate[t].orden);
                }
                ctrl.model.Templates[x].Campos.push({
                  ProcesoTemplateId: ctrl.procesoTemplateCamposList[i].ProcesoTemplate.Id,
                  CampoId: ctrl.procesoTemplateCamposList[i].Campo.Id,
                  orden: ctrl.procesoTemplateCamposList[i].orden
                });
              }
            }//for
          }//for
        }

        ctrl.model.CamposListado = [];
        if (ctrl.columnasProcesoList != null && ctrl.columnasProcesoList.length > 0) {
          for (var i = 0; i < ctrl.columnasProcesoList.length; i++) {
            if (ctrl.columnasProcesoList[i].SeleccionLista)
              ctrl.model.CamposListado.push(
                {
                  ProcesoId: ctrl.model.Id,
                  SolicitudColumnaId: ctrl.columnasProcesoList[i].Id,
                  CampoId: null,
                  Orden: ctrl.columnasProcesoList[i].OrdenLista,
                  Id: ctrl.columnasProcesoList[i].IdLista
                });
          }
        }

        if (ctrl.procesoCamposList != null && ctrl.procesoCamposList.length > 0) {
          for (var i = 0; i < ctrl.procesoCamposList.length; i++) {
            if (ctrl.procesoCamposList[i].SeleccionLista)
              ctrl.model.CamposListado.push(
                {
                  ProcesoId: ctrl.model.Id,
                  SolicitudColumnaId: null,
                  CampoId: ctrl.procesoCamposList[i].CampoId,
                  Orden: ctrl.procesoCamposList[i].OrdenLista,
                  Id: ctrl.procesoCamposList[i].IdLista
                });
          }
        }

        dataService.saveProceso(ctrl.model)
          .then(function (response) {
            if (response.data.Success) {
              toastr.info("Operacion exitosa.");
              $state.transitionTo("pages.proceso");
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
            ctrl.isBusy = false;
          });
      }

      ctrl.cancel = function () {
        $state.transitionTo("pages.proceso");
      }

      ctrl.delete = function () {
        ctrl.isBusy = true;
        var confirmation = $uibModal.open({
          animation: true,
          component: "confirmation",
          resolve: {
            title: function () { return "Atención" },
            message: function () { return "Confirma el borrado del proceso?" },
          }
        });

        confirmation.result.then(function (selectedItem) {
          dataService.deleteProceso(ctrl.model.Id).then(function (response) {
            if (response.data.Success) {
              toastr.info("Operacion exitosa.");
              $state.transitionTo("pages.proceso");
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
            ctrl.isBusy = false;
          });
        }, function () {
          ctrl.isBusy = false;
        });
      }

      ctrl.loadTemplatesTab = function () {
        var index;
        ctrl.estadosFilteredList = Object.create(ctrl.estadosList);

        if (!ctrl.model.RequiereValidacion) {
          index = -1;
          for (var i = 0; i < ctrl.estadosFilteredList.length; i++) {
            if (ctrl.estadosFilteredList[i].Codigo == 'ACEP') {
              index = i;
              break;
            }
          }

          if (index >= 0)
            ctrl.estadosFilteredList.splice(index, 1);
        }

        if (!ctrl.model.RequiereVerificacion) {
          index = -1;
          for (var i = 0; i < ctrl.estadosFilteredList.length; i++) {
            if (ctrl.estadosFilteredList[i].Codigo == 'VALI') {
              index = i;
              break;
            }
          }

          if (index >= 0)
            ctrl.estadosFilteredList.splice(index, 1);
        }

        if (!ctrl.model.RequiereAutorizacion) {
          index = -1;
          for (var i = 0; i < ctrl.estadosFilteredList.length; i++) {
            if (ctrl.estadosFilteredList[i].Codigo == 'VERI') {
              index = i;
              break;
            }
          }

          if (index >= 0)
            ctrl.estadosFilteredList.splice(index, 1);
        }
      }

      ctrl.loadSeguridadProcesosTab = function () {
        var index;
        ctrl.rolProcesoFilteredList = Object.create(ctrl.rolProcesoList);

        if (!ctrl.model.RequiereValidacion) {
          index = -1;
          for (var i = 0; i < ctrl.rolProcesoFilteredList.length; i++) {
            if (ctrl.rolProcesoFilteredList[i].Codigo == 'GESTOR') {
              index = i;
              break;
            }
          }

          if (index >= 0)
            ctrl.rolProcesoFilteredList.splice(index, 1);
        }

        if (!ctrl.model.RequiereVerificacion) {
          index = -1;
          for (var i = 0; i < ctrl.rolProcesoFilteredList.length; i++) {
            if (ctrl.rolProcesoFilteredList[i].Codigo == 'VERIF') {
              index = i;
              break;
            }
          }

          if (index >= 0)
            ctrl.rolProcesoFilteredList.splice(index, 1);
        }

        if (!ctrl.model.RequiereAutorizacion) {
          index = -1;
          for (var i = 0; i < ctrl.rolProcesoFilteredList.length; i++) {
            if (ctrl.rolProcesoFilteredList[i].Codigo == 'APROB') {
              index = i;
              break;
            }
          }

          if (index >= 0)
            ctrl.rolProcesoFilteredList.splice(index, 1);
        }
      }

      ctrl.loadSeguridadTemplatesTab = function () {
        ctrl.usuarioTemplateCargado = {};

        var finalList = [];
        var existePtu = false;
        var rolTemplateLector = {};

        if (ctrl.procesoUsuariosList == null)
          ctrl.procesoUsuariosList = [];

        if (ctrl.procesoTemplateUsuariosList == null)
          ctrl.procesoTemplateUsuariosList = [];

        if (ctrl.rolTemplateList != null && ctrl.rolTemplateList.length > 0) {
          for (var i = 0; i < ctrl.rolTemplateList.length; i++) {
            if (ctrl.rolTemplateList[i].Codigo == 'LECTOR') {
              rolTemplateLector = ctrl.rolTemplateList[i];
              break;
            }
          }
        }

        if (ctrl.procesoTemplatesList != null) {
          for (var i = 0; i < ctrl.procesoTemplatesList.length; i++) {
            var pt = ctrl.procesoTemplatesList[i];

            for (var j = 0; j < ctrl.procesoUsuariosList.length; j++) {
              var pu = ctrl.procesoUsuariosList[j];
              existePtu = false;

              for (var k = 0; k < ctrl.procesoTemplateUsuariosList.length; k++) {
                if (ctrl.procesoTemplateUsuariosList[k].ProcesoTemplate.Template.Id == pt.Template.Id &&
                  ctrl.procesoTemplateUsuariosList[k].Usuario.Id == pu.Usuario.Id) {
                  existePtu = true;
                  finalList.push({
                    ProcesoTemplate: pt,
                    Usuario: pu.Usuario,
                    RolTemplateList: ctrl.procesoTemplateUsuariosList[k].RolTemplateList
                  });
                  break;
                }
              }

              //Si no tiene ningun rol asociado al template, lo sumo como LECTOR como default
              if (!existePtu) {
                finalList.push({
                  ProcesoTemplate: pt,
                  Usuario: pu.Usuario,
                  RolTemplateList: []
                });

                finalList[finalList.length - 1].RolTemplateList.push(rolTemplateLector);
              }
            }
          }
        }

        ctrl.procesoTemplateUsuariosList = finalList;
      }

      ctrl.loadCamposTemplatesTab = function () {
        // console.log("loadCamposTemplatesTab");
        // console.log(ctrl.procesoTemplateCamposList);
        ctrl.campoTemplateCargado = {};

        // var finalList = [];

        if (ctrl.procesoCamposList == null)
          ctrl.procesoCamposList = [];

        if (ctrl.procesoTemplateCamposList == null)
          ctrl.procesoTemplateCamposList = [];

        // if (ctrl.procesoTemplatesList != null)
        // {
        //   for (var i=0;i<ctrl.procesoTemplatesList.length;i++)
        //   {
        //     var pt = ctrl.procesoTemplatesList[i];

        //     finalList.push({
        //                       ProcesoTemplate: pt,
        //                       CampoList: []
        //                     });

        //     for (var k=0;k<ctrl.procesoTemplateCamposList.length;k++)
        //     {
        //       if (ctrl.procesoTemplateCamposList[k].ProcesoTemplate.Template.Id == pt.Template.Id)
        //       {
        //         finalList[i].CampoList.push(ctrl.procesoTemplateCamposList[k].Campo);
        //       }
        //     }
        //   }
        // }
        // ctrl.procesoTemplateCamposList = finalList;
      }

      ctrl.loadProcesosHijoTab = function (aceptaHijos) {
        ctrl.procesoHijoCargado = {};

        if (!aceptaHijos) {
          ctrl.procesoHijosSeleccionables = [];
        }
      }

      ctrl.openAttachment = function (fileName) {
        window.open(appConfig.uploadUrl + fileName);
      }

      ctrl.uploadAttachment = function (file) {
        if (file == null)
          return;

        ctrl.isBusy = true;
        ctrl.model.isImageLoading = true;

        dataService.uploadImageFileProceso(file)
          .then(function (response) {
            $timeout(function () {
              //console.log(response);
              if (response.data.Success) {
                //console.log('uploadFileAttachment: ' + response.data.Value);
                ctrl.model.UrlImagen = response.data.Value; //{ fileName: file.name, serverFileName: response.data.Value };
              }
              else {
                ctrl.model.UrlImagen = null;
              }
            });
            ctrl.isBusy = false;
            ctrl.model.isImageLoading = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
            ctrl.isBusy = false;
            ctrl.model.isImageLoading = false;
          });
      }

      ctrl.removeAttachment = function () {
        ctrl.model.UrlImagen = null;
      }

      /******************* Templates *******************/
      ctrl.searchTemplate = function (nombreTemplate) {
        var filtroTemplate = { Nombre: nombreTemplate, PageSize: 20, SkipNumber: 0 };

        return dataService.searchTemplate(filtroTemplate)
          .then(function (response) {
            if (response.data.Success) {
              return response.data.Value.Resultados;
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
          });
      }

      ctrl.onSelectTemplate = function (templateSeleccionado) {
        ctrl.templateCargado.Template = templateSeleccionado;
      }

      ctrl.editTemplate = function () {
        if (ctrl.templateCargado == null ||
          ctrl.templateCargado.Template == null ||
          ctrl.templateCargado.Template.Id == 0 ||
          ctrl.templateCargado.Ocurrencia == null ||
          ctrl.templateCargado.Ocurrencia <= 0) {
          toastr.error('Por favor complete los datos obligatorios marcados con asterisco para cargar el template');
          return;
        }

        if (ctrl.templateCargado.Obligatorio == true &&
          ctrl.templateCargado.SolicitudEstado == null) {
          toastr.error('No puede dar de alta un template obligatorio sin definir el estado en el cual se deberá validar el mismo');
          return;
        }

        ctrl.templateCargado.ProcesoId = ctrl.model.Id;
        ctrl.templateCargado.TemplateId = ctrl.templateCargado.Template.Id;
        ctrl.templateCargado.SolicitudEstadoId = null;

        if (ctrl.templateCargado.SolicitudEstado != null)
          ctrl.templateCargado.SolicitudEstadoId = ctrl.templateCargado.SolicitudEstado.Id;

        if (ctrl.procesoTemplatesList == null)
          ctrl.procesoTemplatesList = [];

        var index = -1;
        for (var i = 0; i < ctrl.procesoTemplatesList.length; i++) {
          if (ctrl.procesoTemplatesList[i].TemplateId == ctrl.templateCargado.TemplateId)
            index = i;
        }

        if (index >= 0)
          ctrl.procesoTemplatesList[index] = ctrl.templateCargado;
        else
          ctrl.procesoTemplatesList.push(ctrl.templateCargado);

        ctrl.procesoTemplatesDS = ctrl.procesoTemplatesList;
        ctrl.templateCargado = {};
      }

      ctrl.cargarTemplate = function (templateSeleccionado) {
        if (templateSeleccionado == null) {
          toastr.error('Por favor seleccione un template para poder visualizarlo');
          return;
        }

        ctrl.templateCargado = {};

        ctrl.templateCargado.Id = templateSeleccionado.Id;
        ctrl.templateCargado.ProcesoId = templateSeleccionado.ProcesoId;
        ctrl.templateCargado.Template = templateSeleccionado.Template;
        ctrl.templateCargado.TemplateInput = templateSeleccionado.Template.Nombre;
        ctrl.templateCargado.SolicitudEstado = templateSeleccionado.SolicitudEstado;
        ctrl.templateCargado.Ocurrencia = templateSeleccionado.Ocurrencia;
        ctrl.templateCargado.Obligatorio = templateSeleccionado.Obligatorio;
      }

      ctrl.eliminarTemplate = function (index) {
        if (index < 0) {
          toastr.error('Template seleccionado inválido');
          return;
        }

        if (ctrl.procesoTemplatesList != null && ctrl.procesoTemplatesList.length > 0)
          ctrl.procesoTemplatesList.splice(index, 1);
      }

      ctrl.clearTemplate = function () {
        ctrl.templateCargado = {};
      }

      /******************* Campos *******************/
      ctrl.editCampo = function () {
        if (ctrl.campoCargado.Orden <= 0 ||
          ctrl.campoCargado.Orden == null ||
          ctrl.campoCargado.Orden == '' ||
          ctrl.campoCargado.Campo == null ||
          ctrl.campoCargado.TipoCampoSolicitud == '' ||
          ctrl.campoCargado.TipoCampoSolicitud == null ||
          ctrl.campoCargado.Campo.Id == 0) {
          toastr.error('Por favor complete los datos obligatorios marcados con asterisco para cargar el campo');
          return;
        }

        if (ctrl.campoCargado.Obligatorio == null)
          ctrl.campoCargado.Obligatorio = false;

        ctrl.campoCargado.ProcesoId = ctrl.model.Id;
        ctrl.campoCargado.CampoId = ctrl.campoCargado.Campo.Id;
        ctrl.campoCargado.tipoCampoSolicitudId = ctrl.campoCargado.TipoCampoSolicitud.Id;

        if (ctrl.procesoCamposList == null)
          ctrl.procesoCamposList = [];

        var index = -1;
        for (var i = 0; i < ctrl.procesoCamposList.length; i++) {
          if (ctrl.procesoCamposList[i].Campo.Id != ctrl.campoCargado.Campo.Id &&
            ctrl.procesoCamposList[i].Orden == ctrl.campoCargado.Orden) {
            toastr.error('Por favor ingrese un número de orden distinto ya que el ingresado ya existe');
            return;
          }

          if (ctrl.procesoCamposList[i].CampoId == ctrl.campoCargado.CampoId)
            index = i;
        }

        if (index >= 0)
          ctrl.procesoCamposList[index] = ctrl.campoCargado;
        else
          ctrl.procesoCamposList.push(ctrl.campoCargado);

        ctrl.procesoCamposList.sort(function (a, b) { return (parseInt(a.Orden) > parseInt(b.Orden) ? 1 : (parseInt(b.Orden) > parseInt(a.Orden)) ? -1 : 0); });
        ctrl.procesoCamposDS = ctrl.procesoCamposList;
        ctrl.campoCargado = {};
      }

      ctrl.cargarCampo = function (campoSeleccionado) {
        if (campoSeleccionado == null) {
          toastr.error('Por favor seleccione un campo para poder visualizarlo');
          return;
        }

        ctrl.campoCargado = {};

        ctrl.campoCargado.Id = campoSeleccionado.Id;
        ctrl.campoCargado.ProcesoId = campoSeleccionado.ProcesoId;
        ctrl.campoCargado.Campo = campoSeleccionado.Campo;
        ctrl.campoCargado.Orden = campoSeleccionado.Orden;
        ctrl.campoCargado.Obligatorio = campoSeleccionado.Obligatorio;
        ctrl.campoCargado.TipoCampoSolicitud = campoSeleccionado.TipoCampoSolicitud;
      }

      ctrl.eliminarCampo = function (index) {
        if (index < 0) {
          toastr.error('Campo seleccionado inválido');
          return;
        }

        if (ctrl.procesoCamposList != null && ctrl.procesoCamposList.length > 0)
          ctrl.procesoCamposList.splice(index, 1);
      }

      ctrl.clearCampo = function () {
        ctrl.campoCargado = {};
      }

      /******************* Proceso Usuarios *******************/
      ctrl.searchUsuario = function (nombreUsuario) {
        var filtroUsuario = { Login: nombreUsuario, PageSize: 20, SkipNumber: 0 };

        return dataService.searchUsuario(filtroUsuario)
          .then(function (response) {
            if (response.data.Success) {
              return response.data.Value.Resultados;
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
          });
      }

      ctrl.onSelectUsuario = function (usuarioSeleccionado) {
        ctrl.usuarioCargado.Usuario = usuarioSeleccionado;
      }

      ctrl.editUsuario = function () {
        if (ctrl.usuarioCargado == null ||
          ctrl.usuarioCargado.Usuario == null ||
          ctrl.usuarioCargado.Usuario.Id == 0 ||
          ctrl.usuarioCargado.RolProcesoList == null ||
          ctrl.usuarioCargado.RolProcesoList.length <= 0) {
          toastr.error('Por favor complete los datos obligatorios marcados con asterisco para cargar el usuario');
          return;
        }

        ctrl.usuarioCargado.ProcesoId = ctrl.model.Id;
        ctrl.usuarioCargado.UsuarioId = ctrl.usuarioCargado.Usuario.Id;

        if (ctrl.procesoUsuariosList == null)
          ctrl.procesoUsuariosList = [];

        var index = -1;
        for (var i = 0; i < ctrl.procesoUsuariosList.length; i++) {
          if (ctrl.procesoUsuariosList[i].Usuario.Login == ctrl.usuarioCargado.Usuario.Login)
            index = i;
        }

        if (index >= 0)
          ctrl.procesoUsuariosList[index] = ctrl.usuarioCargado;
        else
          ctrl.procesoUsuariosList.push(ctrl.usuarioCargado);

        ctrl.procesoUsuariosDS = ctrl.procesoUsuariosList;
        ctrl.usuarioCargado = {};

        //Actualizo los permisos para el usuario cargado
        ctrl.loadSeguridadTemplatesTab();
      }

      ctrl.cargarUsuario = function (usuarioSeleccionado) {
        if (usuarioSeleccionado == null) {
          toastr.error('Por favor seleccione un usuario para poder visualizarlo');
          return;
        }

        ctrl.usuarioCargado = {};

        ctrl.usuarioCargado.ProcesoId = usuarioSeleccionado.ProcesoId;
        ctrl.usuarioCargado.Usuario = usuarioSeleccionado.Usuario;
        ctrl.usuarioCargado.UsuarioInput = usuarioSeleccionado.Usuario.Login;
        ctrl.usuarioCargado.RolProcesoList = usuarioSeleccionado.RolProcesoList;
      }

      ctrl.eliminarUsuario = function (index) {
        if (index < 0) {
          toastr.error('Usuario seleccionado inválido');
          return;
        }

        if (ctrl.procesoUsuariosList != null && ctrl.procesoUsuariosList.length > 0) {
          ctrl.procesoUsuariosList.splice(index, 1);

          //Actualizo los permisos de templates para los usuarios que quedaron
          ctrl.loadSeguridadTemplatesTab();
        }
      }

      ctrl.clearUsuario = function () {
        ctrl.usuarioCargado = {};
      }

      ctrl.concatRolesString = function (values) {
        return values.map(function (elem) {
          if (elem != null)
            return elem.Nombre;
          return "";
        }).join(", ");
      }

      /******************* Templates Usuarios *******************/
      ctrl.loadTemplateUsuarioSeleccionado = function () {
        ctrl.usuarioTemplateCargado.Usuarios = [];
        var uIndex;

        if (ctrl.usuarioTemplateCargado.ProcesoTemplate == null)
          return;

        for (var i = 0; i < ctrl.procesoTemplateUsuariosList.length; i++) {
          uIndex = -1;

          if (ctrl.procesoTemplateUsuariosList[i].ProcesoTemplate.Template.Id == ctrl.usuarioTemplateCargado.ProcesoTemplate.Template.Id) {
            for (var j = 0; j < ctrl.usuarioTemplateCargado.Usuarios.length; j++) {
              if (ctrl.usuarioTemplateCargado.Usuarios[j].Id == ctrl.procesoTemplateUsuariosList[i].Usuario.Id) {
                uIndex = j;
                break;
              }
            }

            if (uIndex < 0) {
              ctrl.usuarioTemplateCargado.Usuarios.push(ctrl.procesoTemplateUsuariosList[i].Usuario);
              uIndex = ctrl.usuarioTemplateCargado.Usuarios.length - 1;
              ctrl.usuarioTemplateCargado.Usuarios[uIndex].RolTemplateList = [];
            }

            // ctrl.usuarioTemplateCargado.Usuarios[uIndex].RolTemplateList.push(ctrl.procesoTemplateUsuariosList[i].RolTemplate);
            ctrl.usuarioTemplateCargado.Usuarios[uIndex].RolTemplateList = ctrl.procesoTemplateUsuariosList[i].RolTemplateList;
          }
        }
      }

      ctrl.onRolTemplateSeleccionado = function (procesoTemplate, usuarioTemplate) {
        var i = ctrl.procesoTemplateUsuariosList.length;

        while (i--) {
          if (ctrl.procesoTemplateUsuariosList[i].ProcesoTemplate.Template.Id == procesoTemplate.Template.Id &&
            ctrl.procesoTemplateUsuariosList[i].Usuario.Id == usuarioTemplate.Id) {
            ctrl.procesoTemplateUsuariosList.splice(i, 1);
          }
        }

        if (usuarioTemplate.RolTemplateList != null && usuarioTemplate.RolTemplateList.length > 0) {
          ctrl.procesoTemplateUsuariosList.push({
            ProcesoTemplate: procesoTemplate,
            Usuario: usuarioTemplate,
            RolTemplateList: usuarioTemplate.RolTemplateList
          });
        }
      }

      ctrl.searchTemplateUsuario = function (nombreUsuario) {
        var filtroUsuario = { Login: nombreUsuario, PageSize: 20, SkipNumber: 0 };

        return dataService.searchUsuario(filtroUsuario)
          .then(function (response) {
            if (response.data.Success) {
              return response.data.Value.Resultados;
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
          });
      }

      ctrl.onSelectTemplateUsuario = function (usuarioSeleccionado) {
        ctrl.usuarioTemplateCargado.Usuario = usuarioSeleccionado;
      }

      ctrl.editTemplateUsuario = function () {
        if (ctrl.usuarioTemplateCargado == null ||
          ctrl.usuarioTemplateCargado.ProcesoTemplate == null ||
          ctrl.usuarioTemplateCargado.ProcesoTemplate.Id == 0 ||
          ctrl.usuarioTemplateCargado.Usuario == null ||
          ctrl.usuarioTemplateCargado.Usuario.Id == 0 ||
          ctrl.usuarioTemplateCargado.RolTemplateList == null ||
          ctrl.usuarioTemplateCargado.RolTemplateList.length <= 0) {
          toastr.error('Por favor complete los datos obligatorios marcados con asterisco para cargar el usuario');
          return;
        }

        //ctrl.usuarioTemplateCargado.ProcesoId = ctrl.model.Id;
        ctrl.usuarioTemplateCargado.ProcesoTemplateId = ctrl.usuarioTemplateCargado.ProcesoTemplate.Id;
        ctrl.usuarioTemplateCargado.UsuarioId = ctrl.usuarioTemplateCargado.Usuario.Id;

        if (ctrl.procesoTemplateUsuariosList == null)
          ctrl.procesoTemplateUsuariosList = [];

        var index = -1;
        for (var i = 0; i < ctrl.procesoTemplateUsuariosList.length; i++) {
          if (ctrl.procesoTemplateUsuariosList[i].ProcesoTemplate.TemplateId == ctrl.usuarioTemplateCargado.ProcesoTemplate.TemplateId &&
            ctrl.procesoTemplateUsuariosList[i].Usuario.Id == ctrl.usuarioTemplateCargado.Usuario.Id) {
            index = i;
            break;
          }
        }

        if (index >= 0)
          ctrl.procesoTemplateUsuariosList[index] = ctrl.usuarioTemplateCargado;
        else
          ctrl.procesoTemplateUsuariosList.push(ctrl.usuarioTemplateCargado);

        ctrl.usuarioTemplateCargado = {};
      }

      ctrl.cargarTemplateUsuario = function (usuarioTemplateSeleccionado) {
        if (usuarioTemplateSeleccionado == null) {
          toastr.error('Por favor seleccione un usuario para poder visualizarlo');
          return;
        }

        ctrl.usuarioTemplateCargado = {};

        ctrl.usuarioTemplateCargado.ProcesoId = usuarioTemplateSeleccionado.ProcesoId;
        ctrl.usuarioTemplateCargado.ProcesoTemplate = usuarioTemplateSeleccionado.ProcesoTemplate;
        ctrl.usuarioTemplateCargado.Usuario = usuarioTemplateSeleccionado.Usuario;
        ctrl.usuarioTemplateCargado.UsuarioInput = usuarioTemplateSeleccionado.Usuario.Login;
        ctrl.usuarioTemplateCargado.RolTemplateList = usuarioTemplateSeleccionado.RolTemplateList;
      }

      ctrl.eliminarTemplateUsuario = function (index) {
        if (index < 0) {
          toastr.error('Usuario seleccionado inválido');
          return;
        }

        if (ctrl.procesoTemplateUsuariosList != null && ctrl.procesoTemplateUsuariosList.length > 0)
          ctrl.procesoTemplateUsuariosList.splice(index, 1);
      }

      ctrl.clearTemplateUsuario = function () {
        ctrl.usuarioTemplateCargado = {};
      }

      ctrl.concatTemplateRolesString = function (values) {
        return values.map(function (elem) {
          if (elem != null)
            return elem.Nombre;
          return "";
        }).join(", ");
      }

      /******************* Templates Campos *******************/
      ctrl.loadTemplateCampoSeleccionado = function () {
        if (ctrl.campoTemplateCargado.ProcesoTemplate == null)
          return;

        for (var i = 0; i < ctrl.procesoCamposList.length; i++) {
          ctrl.procesoCamposList[i].Seleccionado = false;

          if (ctrl.procesoTemplateCamposList != null && ctrl.procesoTemplateCamposList.length > 0) {
            for (var j = 0; j < ctrl.procesoTemplateCamposList.length; j++) {
              if (ctrl.procesoTemplateCamposList[j].ProcesoTemplate.Template.Id == ctrl.campoTemplateCargado.ProcesoTemplate.Template.Id &&
                ctrl.procesoTemplateCamposList[j].Campo.Id == ctrl.procesoCamposList[i].Campo.Id) {
                ctrl.procesoCamposList[i].Seleccionado = true;
                /*var lCamposTemplate = ctrl.procesoTemplateCamposList[j].ProcesoTemplate.Campos;
                  for (var t = 0; t < lCamposTemplate.length; t++) {
                    if (ctrl.procesoCamposList[i].CampoId == lCamposTemplate[t].CampoId) {
                      ctrl.procesoCamposList[i].orden = lCamposTemplate[t].orden;
                      break;
                    }
                  }*/
                console.log(ctrl.procesoCamposList[i]);
                break;
              } else {
                ctrl.procesoCamposList[i].orden = "";
              }
            }
          }
        }


        /*Update Orden*/
        if (ctrl.procesoTemplateCamposList != null && ctrl.procesoTemplateCamposList.length > 0) {
          for (var i = 0; i < ctrl.procesoCamposList.length; i++) {
            if (ctrl.procesoCamposList[i].Seleccionado) {
              for (var j = 0; j < ctrl.procesoTemplateCamposList.length; j++) {
                if (ctrl.procesoTemplateCamposList[j].ProcesoTemplate.Template.Id == ctrl.campoTemplateCargado.ProcesoTemplate.Template.Id) {
                  var lCamposTemplate = ctrl.procesoTemplateCamposList[j].ProcesoTemplate.Campos;
                  for (var t = 0; t < lCamposTemplate.length; t++) {
                    if (ctrl.procesoCamposList[i].CampoId == lCamposTemplate[t].CampoId) {
                      ctrl.procesoCamposList[i].orden = lCamposTemplate[t].orden;
                      break;
                    }
                  }
                }
              }
            }
          }
        }
      }

      ctrl.onTemplateCampoSeleccionado = function (procesoCampo) {
        if (procesoCampo == null)
          return;

        var index = -1;

        for (var i = 0; i < ctrl.procesoTemplateCamposList.length; i++) {
          if (ctrl.procesoTemplateCamposList[i].ProcesoTemplate.Template.Id == ctrl.campoTemplateCargado.ProcesoTemplate.Template.Id &&
            ctrl.procesoTemplateCamposList[i].Campo.Id == procesoCampo.Campo.Id) {
            ctrl.procesoTemplateCamposList[i].orden = procesoCampo.orden;
            index = i;
            break;
          }
        }//for

        //Seleccionado y no esta en el listado
        if (procesoCampo.Seleccionado && index == -1)
          ctrl.procesoTemplateCamposList.push(
            {
              ProcesoTemplate: ctrl.campoTemplateCargado.ProcesoTemplate,
              Campo: procesoCampo.Campo,
              ProcesoTemplateId: ctrl.campoTemplateCargado.ProcesoTemplate.Id,
              CampoId: procesoCampo.Campo.Id,
              orden: procesoCampo.orden
            });

        //Deseleccionado y esta en el listado
        if (!procesoCampo.Seleccionado && index >= 0){
          procesoCampo.orden = "";
          ctrl.procesoTemplateCamposList.splice(index, 1);
        }
      }

      ctrl.onTemplateCampoSeleccionadoOrden = function (procesoCampo) {
        if (procesoCampo == null)
          return;

        var index = -1;
        console.log(ctrl.procesoTemplateCamposList);
        for (var i = 0; i < ctrl.procesoTemplateCamposList.length; i++) {
          if (ctrl.procesoTemplateCamposList[i].ProcesoTemplate.Template.Id == ctrl.campoTemplateCargado.ProcesoTemplate.Template.Id &&
            ctrl.procesoTemplateCamposList[i].Campo.Id == procesoCampo.Campo.Id) {
            ctrl.procesoTemplateCamposList[i].orden = procesoCampo.orden;
            index = i;
            break;
          }
        }

        //Seleccionado y no esta en el listado
        if (index != -1) {
          if (procesoCampo.orden != "") {
            ctrl.procesoTemplateCamposList[index].orden = procesoCampo.orden;
            console.log(ctrl.procesoTemplateCamposList[index]);
          }
        }
      }

      /******************* Procesos Hijo *******************/
      ctrl.loadProcesosByGrupo = function () {
        if (ctrl.procesoHijoCargado != null) {
          ctrl.procesoHijoCargado.ProcesosHijoSeleccionados = [];

          if (ctrl.procesoHijosSeleccionables != null && ctrl.procesoHijosSeleccionables.length > 0) {
            for (var i = 0; i < ctrl.procesoHijosSeleccionables.length; i++) {
              var ph = ctrl.procesoHijosSeleccionables[i];

              for (var j = 0; j < ctrl.procesoHijoCargado.ProcesosHijosList.length; j++) {
                if (ph.ProcesoHijoId == ctrl.procesoHijoCargado.ProcesosHijosList[j].Id) {
                  ctrl.procesoHijoCargado.ProcesosHijoSeleccionados.push(ctrl.procesoHijoCargado.ProcesosHijosList[j]);
                  break;
                }
              }
            }
          }
        }
      }

      ctrl.onProcesoHijoSeleccionado = function () {
        if (ctrl.procesoHijosSeleccionables == null)
          ctrl.procesoHijosSeleccionables = [];

        var i = ctrl.procesoHijosSeleccionables.length;

        while (i--) {
          if (ctrl.procesoHijosSeleccionables[i].ProcesoHijoId == ctrl.model.Id) {
            if (ctrl.model.Grupo.Id == ctrl.procesoHijoCargado.Grupo.Id) {
              ctrl.procesoHijosSeleccionables.splice(i, 1);
            }
          }
          else {
            if (ctrl.procesoHijosSeleccionables[i].ProcesoHijo.Grupo.Id == ctrl.procesoHijoCargado.Grupo.Id) {
              ctrl.procesoHijosSeleccionables.splice(i, 1);
            }
          }
        }

        if (ctrl.procesoHijoCargado.ProcesosHijoSeleccionados != null && ctrl.procesoHijoCargado.ProcesosHijoSeleccionados.length > 0) {
          for (var i = 0; i < ctrl.procesoHijoCargado.ProcesosHijoSeleccionados.length; i++) {
            ctrl.procesoHijosSeleccionables.push({
              ProcesoId: ctrl.model.Id,
              // Proceso: ctrl.model,
              ProcesoHijoId: ctrl.procesoHijoCargado.ProcesosHijoSeleccionados[i].Id,
              ProcesoHijo: ctrl.procesoHijoCargado.ProcesosHijoSeleccionados[i]
            });
          }
        }
      }

      /******************* Procesos Link *******************/
      ctrl.editProcesoLink = function () {
        if (ctrl.procesoLinkCargado.NombreLink == null ||
          ctrl.procesoLinkCargado.NombreLink.length == 0 ||
          ctrl.procesoLinkCargado.UrlLink == null ||
          ctrl.procesoLinkCargado.UrlLink.length == 0) {
          toastr.error('Por favor complete los datos obligatorios marcados con asterisco para cargar el link');
          return;
        }

        ctrl.procesoLinkCargado.ProcesoId = ctrl.model.Id;

        if (ctrl.procesoLinksList == null)
          ctrl.procesoLinksList = [];

        var index = -1;
        for (var i = 0; i < ctrl.procesoLinksList.length; i++) {
          if (ctrl.procesoLinksList[i].NombreLink == ctrl.procesoLinkCargado.NombreLink)
            index = i;
        }

        if (index >= 0)
          ctrl.procesoLinksList[index] = ctrl.procesoLinkCargado;
        else
          ctrl.procesoLinksList.push(ctrl.procesoLinkCargado);

        ctrl.procesoLinkCargado = {};
      }

      ctrl.cargarProcesoLink = function (linkSeleccionado) {
        if (linkSeleccionado == null) {
          toastr.error('Por favor seleccione un link para poder visualizarlo');
          return;
        }

        ctrl.procesoLinkCargado = {};

        ctrl.procesoLinkCargado.Id = linkSeleccionado.Id;
        ctrl.procesoLinkCargado.ProcesoId = linkSeleccionado.ProcesoId;
        ctrl.procesoLinkCargado.NombreLink = linkSeleccionado.NombreLink;
        ctrl.procesoLinkCargado.UrlLink = linkSeleccionado.UrlLink;
        ctrl.procesoLinkCargado.solicitudLevel = linkSeleccionado.solicitudLevel;
        ctrl.procesoLinkCargado.ejecutaProcedure = linkSeleccionado.ejecutaProcedure;
      }

      ctrl.eliminarProcesoLink = function (index) {
        if (index < 0) {
          toastr.error('Link seleccionado inválido');
          return;
        }

        if (ctrl.procesoLinksList != null && ctrl.procesoLinksList.length > 0)
          ctrl.procesoLinksList.splice(index, 1);
      }

      ctrl.clearProcesoLink = function () {
        ctrl.procesoLinkCargado = {};
      }
    }
  });
})(window.angular);
(function (angular) {
    'use strict';
    angular.module('Kahuna.pages.proceso').component('procesoList', {
      templateUrl: 'app/pages/proceso/list.template.html',
      controller: function ($scope,$state,dataService,sharedService,toastr) {
        var ctrl = this;
        ctrl.mostrarAgregar = false;
        
        this.$onInit = function () 
        {          
          ctrl.mostrarAgregar = sharedService.isSuperAdminLoggedUserId();
        };

        ctrl.buscar = function buscar(tableState) 
        {
          ctrl.mostrarAgregar = sharedService.isSuperAdminLoggedUserId();
          ctrl.isSearching = true;

          var pagination = tableState.pagination;

          var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
          var number = pagination.number || 10;  // Number of entries showed per page.

          ctrl.filtros = { PageSize: number, SkipNumber: start };

          if (tableState.search.predicateObject != null)
          {
            ctrl.filtros.Codigo = tableState.search.predicateObject.Codigo;
            ctrl.filtros.Nombre = tableState.search.predicateObject.Nombre;
            ctrl.filtros.Grupo = tableState.search.predicateObject.Grupo;
            ctrl.filtros.CantidadDiasCierre = tableState.search.predicateObject.CantidadDiasCierre;

            if (tableState.search.predicateObject.RequiereValidacion == 1 ||
                tableState.search.predicateObject.RequiereValidacion == 'true')
              ctrl.filtros.RequiereValidacion = true;
            else
            {
              if (tableState.search.predicateObject.RequiereValidacion == 0 ||
                  tableState.search.predicateObject.RequiereValidacion == 'false')
                ctrl.filtros.RequiereValidacion = false;
              else
                ctrl.filtros.RequiereValidacion = null;
            }

            if (tableState.search.predicateObject.RequiereVerificacion == 1 ||
                tableState.search.predicateObject.RequiereVerificacion == 'true') 
              ctrl.filtros.RequiereVerificacion = true;
            else
            {
              if (tableState.search.predicateObject.RequiereVerificacion == 0 ||
                  tableState.search.predicateObject.RequiereVerificacion == 'false')
                ctrl.filtros.RequiereVerificacion = false;
              else
                ctrl.filtros.RequiereVerificacion = null;
            }

            if (tableState.search.predicateObject.RequiereAutorizacion == 1 ||
                tableState.search.predicateObject.RequiereAutorizacion == 'true')
              ctrl.filtros.RequiereAutorizacion = true;
            else
            {
              if (tableState.search.predicateObject.RequiereAutorizacion == 0 ||
                  tableState.search.predicateObject.RequiereAutorizacion == 'false')
                ctrl.filtros.RequiereAutorizacion = false;
              else
                ctrl.filtros.RequiereAutorizacion = null;
            }
          }

          if (tableState.sort != null)
          {
            ctrl.filtros.OrderFieldName = tableState.sort.predicate;
            ctrl.filtros.OrderAscending = !tableState.sort.reverse;
          }

          dataService.searchProceso(ctrl.filtros)
            .then(function (response)
            {
              if (response.data.Success)
              {
                ctrl.resultList = response.data.Value.Resultados;
                //ctrl.totalResultados = response.data.Value.TotalResultados;

                tableState.pagination.numberOfPages = Math.ceil(response.data.Value.TotalResultados/number); //result.numberOfPages;//set the number of pages so the pagination can update
              } 
              else 
              {
                toastr.error(response.data.ErrorSummary);
              }
              ctrl.isSearching = false;
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage());
              ctrl.isSearching = false;
          });
        };
        
        ctrl.add = function ()
        {
          console.log("");
          var authData =  sharedService.getLoggedUser();
          console.log(authData);
          console.log(ctrl);
          $state.go("pages.proceso-edit",{id:0});
        }

        ctrl.edit = function (id)
        {
          $state.go("pages.proceso-edit",{id:id});
        }
      }
    });
  })(window.angular);
(function () {
    'use strict';
    angular.module('Kahuna.pages.proceso').config(routeConfig);
    function routeConfig($stateProvider) {
      $stateProvider
        .state('pages.proceso', {
          url: '/proceso',
          title: 'Proceso',
          template : '<proceso-list></proceso-list>',
          authenticate: true,
        })
        .state('pages.proceso-edit', {
          url: '/proceso/edit/:id',
          title: 'Proceso',
          template : '<proceso-edit></proceso-edit>',
          params: {id:null},
          authenticate: true,
        });
    }
  })();
(function () {
    'use strict';
    angular.module('Kahuna.pages.reporte').config(routeConfig);
    function routeConfig($stateProvider) {
      $stateProvider
        .state('pages.reporte-templates-pendientes', {
          url: '/reporte/templatespendientes',
          title: 'Reporte de Gestiones Pendientes',
          template : '<reporte-templates-pendientes-list></reporte-templates-pendientes-list>',
          authenticate: true,
        });
    }
  })();
(function (angular) {
  "use strict";
  angular
    .module("Kahuna.pages.reporte")
    .component("reporteTemplatesPendientesList", {
      templateUrl: "app/pages/reporte/templatespendienteslist.template.html",
      controller: function (
        $scope,
        $state,
        dataService,
        sharedService,
        toastr
      ) {
        var ctrl = this;
        ctrl.anularVista = true;
        ctrl.isSearching = true;
        ctrl.totalResultados = 0;
        ctrl.tableState = {};
        ctrl.authData = {};
        ctrl.ident = "URL_TEMPLATES_PEND";
        ctrl.urlLink = "";

        this.$onInit = function () {
          ctrl.authData = sharedService.getLoggedUser();

          //Sobre reportes reemplazar link (GESTIONES PENDIENTES)
          //&VarUsuarioId parasar el id del usuario autenticado.
          //http://reportes.kahunasoft.com.ar/ReportServer?%2fKhnDocV2APAAustin&rs:Command=Render&Usuario=VarUsuarioId

          if (ctrl.authData != null && ctrl.authData.Id > 0) {
            ctrl.viewLoading = true;
            dataService.checkMenuFuncion("REPO_TEMPLATES_PENDIENTES").then(
              function (response) {
                if (response.data.Success) {
                  if (response.data.Value == true) {
                    ctrl.anularVista = false;
                    loadView();
                  } else {
                    ctrl.anularVista = true;
                    ctrl.motivoBloqueo =
                      "No tiene permisos para visualizar esta vista.";
                  }
                } else {
                  toastr.error(response.data.ErrorSummary);
                }
                ctrl.viewLoading = false;
              },
              function (error) {
                toastr.error(
                  error.data || sharedService.getGenericErrorMessage()
                );
                ctrl.viewLoading = false;
              }
            );
          } else {
            $state.go("auth", { returnUrl: window.location.href });
            return;
          }
        };

        function loadView() {
          //ctrl.buscar(ctrl.tableState);
          //Ejecutar llamado al link
          ctrl.getParametrosByIdent(ctrl.ident);
        }

        ctrl.openLinkTemplate = function () {
          if (
            ctrl.authData.Id != null &&
            ctrl.authData.Id != "" &&
            ctrl.urlLink !== ""
          ) {
            ctrl.urlLink = ctrl.urlLink.replace(
              "&VarUsuarioId",
              ctrl.authData.Id
            );
            ctrl.urlLink = ctrl.urlLink.replace(
              "&varusuarioid",
              ctrl.authData.Id
            );
            window.open(ctrl.urlLink, "_blank");
          }
        };

        ctrl.getParametrosByIdent = function (Ident) {
          if (Ident != "") {
            dataService
              .obtenerParametrosByIdent(Ident)
              .then(function (response) {
                if (response.data.Success && response.data.Value != null) {
                  ctrl.urlLink = response.data.Value.UrlDocumentos;
                  ctrl.showBtnLink = true;
                  ctrl.openLinkTemplate();
                }
              });
          }
        };

        ctrl.buscar = function buscar(tableState) {
          ctrl.isSearching = true;

          var pagination = tableState.pagination;

          var start = pagination.start || 0; // This is NOT the page number, but the index of item in the list that you want to use to display the table.
          var number = pagination.number || 20; // Number of entries showed per page.

          ctrl.filtros = {
            PageSize: number,
            SkipNumber: start,
            UsuarioId: ctrl.authData.Id,
          };

          if (tableState.sort != null) {
            ctrl.filtros.OrderFieldName = tableState.sort.predicate;
            ctrl.filtros.OrderAscending = !tableState.sort.reverse;
          }

          dataService.reporteTemplatesPendientesCarga(ctrl.filtros).then(
            function (response) {
              if (response.data.Success) {
                ctrl.resultList = response.data.Value.Resultados;
                ctrl.totalResultados = response.data.Value.TotalResultados;

                tableState.pagination.numberOfPages = Math.ceil(
                  response.data.Value.TotalResultados / number
                ); //result.numberOfPages;//set the number of pages so the pagination can update
                ctrl.tableState = tableState;
              } else {
                toastr.error(response.data.ErrorSummary);
              }
              ctrl.isSearching = false;
            },
            function (error) {
              toastr.error(
                error.data || sharedService.getGenericErrorMessage()
              );
              ctrl.isSearching = false;
            }
          );
        };

        ctrl.ver = function (solicitudProcesoTemplate) {
          if (solicitudProcesoTemplate != null) {
            $state.go("pages.solicitud-template", {
              solicitud: solicitudProcesoTemplate.SolicitudId,
              solicitudEstado: solicitudProcesoTemplate.Solicitud.EstadoId,
              procesoTemplate: solicitudProcesoTemplate.ProcesoTemplateId,
              template: solicitudProcesoTemplate.ProcesoTemplate.TemplateId,
              proceso: solicitudProcesoTemplate.ProcesoTemplate.ProcesoId,
              solicitudProcesoTemplate: solicitudProcesoTemplate.Id,
            });
          } else
            toastr.error(
              "Debe seleccionar un registro para ejecutar la operación"
            );
        };
      },
    });
})(window.angular);

(function () {
  'use strict';

  angular.module('Kahuna.pages.services').service('dataService', dataService);

  /** @ngInject */
  function dataService($http, appConfig, Upload, localStorage, $timeout) {

    var service = {
      //Seguridad
      loginUser: loginUser,
      checkpassword: checkpassword,
      //AuxParametros
      obtenerParametrosApp: obtenerParametrosApp,
      obtenerParametrosByIdent: obtenerParametrosByIdent,
      obtenerALLParametrosByIdent: obtenerALLParametrosByIdent,
      getAuxParametrosById: getAuxParametrosById,
      searchAuxParametros: searchAuxParametros,
      saveAuxParametros: saveAuxParametros,
      deleteAuxParametros: deleteAuxParametros,

      //Jerarquia
      getJerarquiaList: getJerarquiaList,
      getJerarquiaPadreList: getJerarquiaPadreList,
      getJerarquiaByPadreList: getJerarquiaByPadreList,
      getJerarquiaById: getJerarquiaById,
      getJerarquiaAutorizacionesById: getJerarquiaAutorizacionesById,
      isUserAbleToCreateDocumentFromJerarquia: isUserAbleToCreateDocumentFromJerarquia,
      isUserAbleToCreateDocumentFromSolicitud: isUserAbleToCreateDocumentFromSolicitud,
      checkIfUserTieneMarcaObsoleto: checkIfUserTieneMarcaObsoleto,
      listadoUsuariosAutorizanSolicitudEtapa: listadoUsuariosAutorizanSolicitudEtapa,
      historialAutorizaciones: historialAutorizaciones,
      getJerarquiaCompleta: getJerarquiaCompleta,
      getJerarquiaMuestra: getJerarquiaMuestra,
      searchJerarquia: searchJerarquia,
      searchJerarquiaByPadre: searchJerarquiaByPadre,
      validarJerarquiaTienePadre: validarJerarquiaTienePadre,
      saveJerarquia: saveJerarquia,
      deleteJerarquia: deleteJerarquia,
      getJerarquiaProcesoCampos: getJerarquiaProcesoCampos,

      // Autosolicitud
      getAutoSolicitudById: getAutoSolicitudById,
      searchAutoSolicitud: searchAutoSolicitud,
      saveAutoSolicitud: saveAutoSolicitud,
      deleteAutoSolicitud: deleteAutoSolicitud,

      // Auto Autorizar
      getAutoAutorizarById: getAutoAutorizarById,
      searchAutoAutorizar: searchAutoAutorizar,
      saveAutoAutorizar: saveAutoAutorizar,
      deleteAutoAutorizar: deleteAutoAutorizar,

      //Periodo
      getPeriodoList: getPeriodoList,

      //Campo
      getCampoList: getCampoList,
      getCampoListLigth: getCampoListLigth,
      getCampoListByTemplate: getCampoListByTemplate,
      getCamposLigthByProceso: getCamposLigthByProceso,
      searchCampo: searchCampo,
      getCampo: getCampo,
      saveCampo: saveCampo,
      deleteCampo: deleteCampo,

      //CampoTipo
      getCampoTipoList: getCampoTipoList,
      //TipoCampoSolicitud
      getTipoCampoSolicitudList: getTipoCampoSolicitudList,


      //Proceso
      getProcesoList: getProcesoList,
      getProcesoByGrupo: getProcesoByGrupo,
      getProcesoDefault: getProcesoDefault,
      searchProceso: searchProceso,
      searchProceso_doc: searchProceso_doc,
      searchProcesoTemplate: searchProcesoTemplate,
      searchProcesoUsuarios: searchProcesoUsuarios,
      searchUsuariosdeUnProceso: searchUsuariosdeUnProceso,
      getProcesoTituloConfigText: getProcesoTituloConfigText,
      getProcesoById: getProcesoById,
      getProcesoSolicitudGrid: getProcesoSolicitudGrid,
      getProcesoTemplateById: getProcesoTemplateById,
      getProcesoUsuarioListByProceso: getProcesoUsuarioListByProceso,
      getProcesoHijoSeleccionableList: getProcesoHijoSeleccionableList,
      saveProceso: saveProceso,
      deleteProceso: deleteProceso,
      uploadImageFileProceso: uploadImageFileProceso,
      searchTemplatesByProceso: searchTemplatesByProceso,
      executeProcedure: executeProcedure,
      SearchTemplatesByProcesoJerarquia: SearchTemplatesByProcesoJerarquia,

      //Grupo
      getGrupoList: getGrupoList,
      getGrupoHomeList: getGrupoHomeList,
      getGrupoByProcesoPadreList: getGrupoByProcesoPadreList,
      getGrupoById: getGrupoById,
      searchGrupo: searchGrupo,
      saveGrupo: saveGrupo,
      deleteGrupo: deleteGrupo,
      uploadImageFileGrupo: uploadImageFileGrupo,


      //Grupo
      getGruposUsuariosList: getGruposUsuariosList,
      getGruposUsuariosById: getGruposUsuariosById,
      searchGruposUsuarios: searchGruposUsuarios,
      saveGruposUsuarios: saveGruposUsuarios,
      deleteGruposUsuarios: deleteGruposUsuarios,
      userInGroup: userInGroup,

      //TipoTemplate
      getTipoTemplateList: getTipoTemplateList,
      getTipoTemplateEnvioMailConfiguracion: getTipoTemplateEnvioMailConfiguracion,
      getTipoTemplateHabilitacionUsuarioConfiguracion: getTipoTemplateHabilitacionUsuarioConfiguracion,
      getTipoTemplateRecursivoConfiguracion: getTipoTemplateRecursivoConfiguracion,
      saveTipoTemplateEnvioMailConfiguracion: saveTipoTemplateEnvioMailConfiguracion,
      saveTipoTemplateHabilitacionUsuarioConfiguracion: saveTipoTemplateHabilitacionUsuarioConfiguracion,
      saveTipoTemplateRecursivoConfiguracion: saveTipoTemplateRecursivoConfiguracion,
      deleteTipoTemplateConfiguracion: deleteTipoTemplateConfiguracion,

      //Autorizaciones     
      guardarAutorizacion: guardarAutorizacion,
      guardarAutorizacionTemplate: guardarAutorizacionTemplate,
      rechazarAutorizacion: rechazarAutorizacion,
      listarAutorizaciones: listarAutorizaciones,
      eliminarAutorizacionesEtapa: eliminarAutorizacionesEtapa,

      //Template
      getTemplateList: getTemplateList,
      getTemplateTituloConfigText: getTemplateTituloConfigText,
      searchTemplate: searchTemplate,
      getTemplatePendientesBySolicitudList: getTemplatePendientesBySolicitudList,
      getTemplateAllPendientesBySolicitudList: getTemplateAllPendientesBySolicitudList,
      getTemplateById: getTemplateById,
      getCargadosBySolicitudList: getCargadosBySolicitudList,
      saveTemplate: saveTemplate,
      deleteTemplate: deleteTemplate,

      //Rol
      getRolesList: getRolesList,
      getRolById: getRolById,
      saveRol: saveRol,
      deleteRol: deleteRol,

      //RolProceso
      getRolProcesoList: getRolProcesoList,
      getRolProcesoByProcesoUsuario: getRolProcesoByProcesoUsuario,

      //RolTemplate
      getRolTemplateList: getRolTemplateList,
      getRolTemplateByProcesoTemplateUsuario: getRolTemplateByProcesoTemplateUsuario,

      //Solicitud
      getSolicitudList: getSolicitudList,
      searchSolicitud: searchSolicitud,
      searchSolicitud_doc: searchSolicitud_doc,
      getSolicitudById: getSolicitudById,
      getSolicitudDefault: getSolicitudDefault,
      getSolicitudProcesoTemplateById: getSolicitudProcesoTemplateById,
      getSolicitudesByPadre: getSolicitudesByPadre,
      getSolicitudNombreCamposList: getSolicitudNombreCamposList,
      saveSolicitud: saveSolicitud,
      saveObsoleto: saveObsoleto,
      deleteSolicitud: deleteSolicitud,
      deleteSolicitudesByProceso: deleteSolicitudesByProceso,
      saveSolicitudVersion: saveSolicitudVersion,
      saveSolicitudCopia: saveSolicitudCopia,

      //SolicitudEstado
      getAnteriorEstadoSolicitud: getAnteriorEstadoSolicitud,
      getSiguienteEstadoSolicitud: getSiguienteEstadoSolicitud,
      getSolicitudEstadoSeleccionablesList: getSolicitudEstadoSeleccionablesList,

      //SolicitudEtapa
      saveSolicitudEtapa: saveSolicitudEtapa,
      saveSolicitudEtapaDerivarRes: saveSolicitudEtapaDerivarRes,
      getSolicitudEtapaDefault: getSolicitudEtapaDefault,
      getSolicitudEtapaBySolicitud: getSolicitudEtapaBySolicitud,

      //TRAZABILIDAD    
      getSolicitudTrazabilidad: getSolicitudTrazabilidad,

      //SolicitudCampoValor
      saveSolicitudCampoValor: saveSolicitudCampoValor,
      updateFileSolicitudCampoValor: updateFileSolicitudCampoValor,
      checkSolicitudCampoValor: checkSolicitudCampoValor,
      getSolicitudCampoValorCompleto: getSolicitudCampoValorCompleto,
      getSolicitudCampoValorDefault: getSolicitudCampoValorDefault,
      getSolicitudCampoValorTextosCompleto: getSolicitudCampoValorTextosCompleto,
      getSolicitudCampoValorProcesoTemplate: getSolicitudCampoValorProcesoTemplate,
      SaveSolicitudCampoValorGeneraProcesos: saveSolicitudCampoValorGeneraProcesos,
      SaveSolicitudCampoValorGeneraProcesosTemplates: saveSolicitudCampoValorGeneraProcesosTemplates,
      saveSolicitudCampoValorVersion: saveSolicitudCampoValorVersion,

      //Usuario
      getUsuarioList: getUsuarioList,
      getUsuarioById: getUsuarioById,
      getUsuarioListByProcesoEstado: getUsuarioListByProcesoEstado,
      searchUsuario: searchUsuario,
      saveClaveUsuario: saveClaveUsuario,
      saveUsuario: saveUsuario,
      deleteUsuario: deleteUsuario,

      //MenuFuncion
      checkMenuFuncion: checkMenuFuncion,

      //Reporte
      reporteTemplatesPendientesCarga: reporteTemplatesPendientesCarga,

      generateImagesPdf: generateImagesPdf,

      //CampoValor
      saveCampoValor: saveCampoValor,
      deleteCampoValor: deleteCampoValor,
      updateFileCampoValor: updateFileCampoValor,
      getCampoValorCompleto: getCampoValorCompleto,
      getCampoValorTextosCompleto: getCampoValorTextosCompleto,
      notificacionesCampoValor: notificacionesCampoValor
    }

    return service;

    //AuxParametros.
    function obtenerParametrosApp() {
      return $http.get(appConfig.apiUrl + 'AuxParametros/obtenerParametrosApp/');
    }


    //AuxParametros.
    function obtenerParametrosByIdent(Ident) {
      return $http.get(appConfig.apiUrl + 'AuxParametros/AuxParametrosByIdent/' + Ident);
    }

    function obtenerALLParametrosByIdent(Ident) {
      return $http.get(appConfig.apiUrl + 'AuxParametros/AuxParametrosByIdentALL/' + Ident);
    }

    //Autorizaciones.
    function listarAutorizaciones(SolicitudId, EtapaId) {
      return $http.get(appConfig.apiUrl + 'Autorizar/listarAutorizadas/' + SolicitudId + '/' + EtapaId);
    }

    function guardarAutorizacion(value) {
      return $http.post(appConfig.apiUrl + 'Autorizar', value);
    }
    function guardarAutorizacionTemplate(value) {
      return $http.post(appConfig.apiUrl + 'AutorizarTemplate', value);
    }

    function rechazarAutorizacion(value) {
      return $http.post(appConfig.apiUrl + 'RechazarAutorizacion', value);
    }

    function eliminarAutorizacionesEtapa(SolicitudId, EtapaId) {
      return $http.get(appConfig.apiUrl + 'Autorizaciones/eliminar/' + SolicitudId + '/' + EtapaId);
    }


    function convertToHex(str) {
      var hex = '';
      for (var i = 0; i < str.length; i++) {
        hex += '' + str.charCodeAt(i).toString(16);
      }
      return hex;
    }


    function checkpassword(inputtxt) {
      var passw = /^(?=.*[0-9])(?=.+[!"#$%&/()=?¡¨*:_;@^+-])(?=.+[a-zA-Z])[a-zA-Z0-9!"#$%&/()=?¡¨*:_;@^+-]{6,30}$/;
      if (inputtxt.match(passw)) {
        return true;
      }
      else {
        return false;
      }
    }
    //Seguridad
    function loginUser(user, password) {
      var result = convertToHex(password);
      var userL = {
        Login: user,
        Clave: btoa(result)
      }
      console.log(userL);
      return $http.post(appConfig.apiUrl + 'Usuario/UsuarioLogin', userL);
    }

    //Autosolicitud
    function getAutoSolicitudById(value) {
      return $http.get(appConfig.apiUrl + 'AutoSolicitud/' + value);
    }

    function saveAutoSolicitud(value) {
      return $http.post(appConfig.apiUrl + 'AutoSolicitud', value);
    }

    function deleteAutoSolicitud(id) {
      return $http.delete(appConfig.apiUrl + 'AutoSolicitud/' + id);
    }

    //Auto Solicitud
    function searchAutoSolicitud(value) {
      return $http.post(appConfig.apiUrl + 'AutoSolicitud/Search', value);
    }

    //Auto Autorizar
    function getAutoAutorizarById(value) {
      return $http.get(appConfig.apiUrl + 'AutoAutorizar/' + value);
    }
    function saveAutoAutorizar(value) {
      return $http.post(appConfig.apiUrl + 'AutoAutorizar', value);
    }
    function deleteAutoAutorizar(id) {
      return $http.delete(appConfig.apiUrl + 'AutoAutorizar/' + id);
    }
    //Autosolicitud
    function searchAutoAutorizar(value) {
      return $http.post(appConfig.apiUrl + 'AutoAutorizar/Search', value);
    }


    //Aux Parametros
    function getAuxParametrosById(value) {
      return $http.get(appConfig.apiUrl + 'AuxParametros/' + value);
    }
    function saveAuxParametros(value) {
      return $http.post(appConfig.apiUrl + 'AuxParametros', value);
    }
    function deleteAuxParametros(id) {
      return $http.delete(appConfig.apiUrl + 'AuxParametros/' + id);
    }
    //Autosolicitud
    function searchAuxParametros(value) {
      return $http.post(appConfig.apiUrl + 'AuxParametros/Search', value);
    }


    //Periodo
    function getPeriodoList() {
      return $http.get(appConfig.apiUrl + 'Periodo');
    }

    //Jerarquia
    function getJerarquiaList() {
      return $http.get(appConfig.apiUrl + 'Jerarquia');
    }

    function getJerarquiaPadreList() {
      return $http.get(appConfig.apiUrl + 'Jerarquia/Padre');
    }

    function getJerarquiaByPadreList(jerarquiaPadreId) {
      return $http.get(appConfig.apiUrl + 'Jerarquia/Padre/' + jerarquiaPadreId);
    }

    function getJerarquiaById(id) {
      return $http.get(appConfig.apiUrl + 'Jerarquia/' + id);
    }

    //Validar si el usaurio es parte de la jerarquia.
    function isUserAbleToCreateDocumentFromJerarquia(procesoId, jerarquiaValor) {
      return $http.get(appConfig.apiUrl + 'Jerarquia/puedeCrearDocumento/' + procesoId + '/' + jerarquiaValor);
    }

    //Validar si el usuario es parte de la jerarquia filtrando por Solicitud
    function isUserAbleToCreateDocumentFromSolicitud(solicitudId) {
      return $http.get(appConfig.apiUrl + 'Jerarquia/puedeCrearDocumento/' + solicitudId);
    }
    //Validar si el usuario tiene marca de objeto en La vista.
    function checkIfUserTieneMarcaObsoleto(solicitudId) {
      return $http.get(appConfig.apiUrl + 'Jerarquia/tieneMarcaObsoleto/' + solicitudId);
    }

    //Usuarios que pueden autorizar una solicitud en una etapa especifica.
    function listadoUsuariosAutorizanSolicitudEtapa(solicitudId, campoId) {
      return $http.get(appConfig.apiUrl + 'Jerarquia/listadoUsuariosAutorizanSolicitudEtapa/' + solicitudId + '/' + campoId);
    }

    //Usuarios que pueden autorizar una solicitud en una etapa especifica.
    function historialAutorizaciones(solicitudId) {
      return $http.get(appConfig.apiUrl + 'Autorizar/listarHistorialAutorizacion/' + solicitudId);
    }

    //Obtiene La jerarquia de Autorizaciones Mediante Solicitud y campoID
    function getJerarquiaAutorizacionesById(solicitudId, campoId) {
      return $http.get(appConfig.apiUrl + 'Jerarquia/Autorizaciones/' + solicitudId + '/' + campoId);
    }

    function getJerarquiaCompleta(id) {
      return $http.get(appConfig.apiUrl + 'Jerarquia/Completa/' + id);
    }

    function getJerarquiaMuestra(jerarquiaPadreId, cantidad) {
      return $http.get(appConfig.apiUrl + 'Jerarquia/Muestra/' + jerarquiaPadreId + '/' + cantidad);
    }

    function searchJerarquia(value) {
      return $http.post(appConfig.apiUrl + 'Jerarquia/Search', value);
    }

    function searchJerarquiaByPadre(nombreJerarquia, padreId) {
      return $http.get(appConfig.apiUrl + 'Jerarquia/SearchByPadre/' + padreId + '/' + nombreJerarquia);
    }

    function validarJerarquiaTienePadre(jerarquiaId) {
      return $http.get(appConfig.apiUrl + 'Jerarquia/TienePadre/' + jerarquiaId);
    }

    function saveJerarquia(value) {
      return $http.post(appConfig.apiUrl + 'Jerarquia', value);
    }

    function deleteJerarquia(id) {
      return $http.delete(appConfig.apiUrl + 'Jerarquia/' + id);
    }

    function getJerarquiaProcesoCampos(procesoId, jerarquiaId) {
      return $http.get(appConfig.apiUrl + 'Jerarquia/getJerarquiaProcesoCampos/' + procesoId + "/" + jerarquiaId);
    }

    //Campo
    function getCampoList() {
      return $http.get(appConfig.apiUrl + 'Campo');
    }

    function getCampoListLigth() {
      return $http.get(appConfig.apiUrl + 'CamposLigth');
    }

    function getCampo(id) {
      return $http.get(appConfig.apiUrl + 'Campo/' + id);
    }

    function getCampoListByTemplate(templateId) {
      return $http.get(appConfig.apiUrl + 'Campo/Template/' + templateId);
    }

    function getCamposLigthByProceso(procesoId) {
      return $http.get(appConfig.apiUrl + 'Campo/CamposLigthByProceso/' + procesoId);
    }

    function searchCampo(value) {
      return $http.post(appConfig.apiUrl + 'Campo/Search', value);
    }

    function saveCampo(value) {
      return $http.post(appConfig.apiUrl + 'Campo', value);
    }

    function deleteCampo(id) {
      return $http.delete(appConfig.apiUrl + 'Campo/' + id);
    }

    //Tipo Campo Solicitud
    function getTipoCampoSolicitudList() {
      return $http.get(appConfig.apiUrl + 'TipoCampoSolicitud');
    }

    //CampoTipo
    function getCampoTipoList() {
      return $http.get(appConfig.apiUrl + 'CampoTipo');
    }

    //Proceso
    function getProcesoList() {
      return $http.get(appConfig.apiUrl + 'Proceso');
    }

    function getProcesoByGrupo(grupoId) {
      return $http.get(appConfig.apiUrl + 'Proceso/Grupo/' + grupoId);
    }

    function getProcesoDefault() {
      return $http.get(appConfig.apiUrl + 'Proceso/Default');
    }

    function searchProceso(value) {
      return $http.post(appConfig.apiUrl + 'Proceso/Search', value);
    }
    function searchProceso_doc(value) {
      return $http.post(appConfig.apiUrl + 'Proceso/Search_doc', value);
    }

    function searchProcesoTemplate(value) {
      return $http.post(appConfig.apiUrl + 'Proceso/SearchTemplates', value);
    }

    function searchProcesoUsuarios(value) {
      return $http.post(appConfig.apiUrl + 'Proceso/SearchUsuarios', value);
    }

    function searchUsuariosdeUnProceso(value) {
      return $http.post(appConfig.apiUrl + 'Proceso/SearchUsuariosdeUnProceso', value);
    }

    function getProcesoTituloConfigText(value) {
      return $http.post(appConfig.apiUrl + 'Proceso/GetTituloConfigText', value);
    }

    function getProcesoById(id) {
      return $http.get(appConfig.apiUrl + 'Proceso/' + id);
    }

    function getProcesoSolicitudGrid(id) {
      return $http.get(appConfig.apiUrl + 'Proceso/SolicitudGrid/' + id);
    }

    function getProcesoTemplateById(id) {
      return $http.get(appConfig.apiUrl + 'Proceso/ProcesoTemplate/' + id);
    }

    function getProcesoUsuarioListByProceso(procesoId) {
      return $http.get(appConfig.apiUrl + 'Proceso/UsuariosProceso/' + procesoId);
    }

    function getProcesoHijoSeleccionableList(grupoId, procesoPadreId) {
      return $http.get(appConfig.apiUrl + 'Proceso/ProcesosHijoSeleccionables/' + grupoId + '/' + procesoPadreId);
    }

    function saveProceso(value) {
      return $http.post(appConfig.apiUrl + 'Proceso', value);
    }

    function deleteProceso(id) {
      return $http.delete(appConfig.apiUrl + 'Proceso/' + id);
    }

    function uploadImageFileProceso(file) {
      return Upload.upload({
        url: appConfig.apiUrl + 'Proceso/UploadProcesoImage',
        data: {
          file: file
        }
      });
    }

    //searchTemplatesByProceso
    function searchTemplatesByProceso(procesoId) {
      return $http.get(appConfig.apiUrl + 'Proceso/SearchTemplatesByProceso/' + procesoId);
    }
    function executeProcedure(solicitudId, nombreProcedure) {
      return $http.post(appConfig.apiUrl + 'Proceso/' + solicitudId + "/" + nombreProcedure);
    }
    function SearchTemplatesByProcesoJerarquia(procesoId, jerarquiaId) {
      return $http.get(appConfig.apiUrl + 'Proceso/SearchTemplatesByProcesoJerarquia/' + procesoId + '/' + jerarquiaId);
    }
    //Grupo
    function getGrupoList() {
      return $http.get(appConfig.apiUrl + 'Grupo');
    }

    function getGrupoHomeList() {
      return $http.get(appConfig.apiUrl + 'Grupo/Home');
    }

    function getGrupoByProcesoPadreList(procesoPadreId) {
      return $http.get(appConfig.apiUrl + 'Grupo/ProcesoPadre/' + procesoPadreId);
    }

    function getGrupoById(id) {
      return $http.get(appConfig.apiUrl + 'Grupo/' + id);
    }

    function searchGrupo(value) {
      return $http.post(appConfig.apiUrl + 'Grupo/Search', value);
    }

    function saveGrupo(value) {
      return $http.post(appConfig.apiUrl + 'Grupo', value);
    }

    function deleteGrupo(id) {
      return $http.delete(appConfig.apiUrl + 'Grupo/' + id);
    }

    function uploadImageFileGrupo(file) {
      return Upload.upload({
        url: appConfig.apiUrl + 'Grupo/UploadGrupoImage',
        data: {
          file: file
        }
      });
    }


    //Grupos Usuarios
    function getGruposUsuariosList() {
      return $http.get(appConfig.apiUrl + 'Grupo');
    }

    function getGruposUsuariosById(id) {
      return $http.get(appConfig.apiUrl + 'GruposUsuarios/' + id);
    }

    function searchGruposUsuarios(value) {
      return $http.post(appConfig.apiUrl + 'GruposUsuarios/Search', value);
    }

    function saveGruposUsuarios(value) {
      return $http.post(appConfig.apiUrl + 'GruposUsuarios', value);
    }

    function deleteGruposUsuarios(id) {
      return $http.delete(appConfig.apiUrl + 'GruposUsuarios/' + id);
    }

    function userInGroup(grupoId, usuarioId) {
      return $http.get(appConfig.apiUrl + 'GruposUsuarios/UserInGroup/' + grupoId + '/' + usuarioId);
    }

    //TipoTemplate
    function getTipoTemplateList() {
      return $http.get(appConfig.apiUrl + 'TipoTemplate');
    }

    function getTipoTemplateEnvioMailConfiguracion(templateId) {
      return $http.get(appConfig.apiUrl + 'TipoTemplate/Configuracion/EnvioMail/' + templateId);
    }

    function getTipoTemplateHabilitacionUsuarioConfiguracion(templateId) {
      return $http.get(appConfig.apiUrl + 'TipoTemplate/Configuracion/HabilitacionUsuario/' + templateId);
    }

    function getTipoTemplateRecursivoConfiguracion(templateId) {
      return $http.get(appConfig.apiUrl + 'TipoTemplate/Configuracion/Recursivo/' + templateId);
    }

    function saveTipoTemplateEnvioMailConfiguracion(value) {
      return $http.post(appConfig.apiUrl + 'TipoTemplate/Configuracion/EnvioMail', value);
    }

    function saveTipoTemplateHabilitacionUsuarioConfiguracion(value) {
      return $http.post(appConfig.apiUrl + 'TipoTemplate/Configuracion/HabilitacionUsuario', value);
    }

    function saveTipoTemplateRecursivoConfiguracion(value) {
      return $http.post(appConfig.apiUrl + 'TipoTemplate/Configuracion/Recursivo', value);
    }

    function deleteTipoTemplateConfiguracion(templateId) {
      return $http.delete(appConfig.apiUrl + 'TipoTemplate/Configuracion/' + templateId);
    }

    //Template
    function getTemplateList() {
      return $http.get(appConfig.apiUrl + 'Template');
    }

    function getTemplateTituloConfigText(value) {
      return $http.post(appConfig.apiUrl + 'Template/GetTituloConfigText', value);
    }

    function searchTemplate(value) {
      return $http.post(appConfig.apiUrl + 'Template/Search', value);
    }

    function getTemplatePendientesBySolicitudList(solicitudId) {
      return $http.get(appConfig.apiUrl + 'Template/Pendientes/' + solicitudId);
    }

    function getTemplateAllPendientesBySolicitudList(solicitudId) {
      return $http.get(appConfig.apiUrl + 'Template/AllPendientes/' + solicitudId);
    }

    function getTemplateById(id) {
      return $http.get(appConfig.apiUrl + 'Template/' + id);
    }

    function getCargadosBySolicitudList(value) {
      return $http.post(appConfig.apiUrl + 'Solicitud/Cargadas', value);
    }

    function saveTemplate(value) {
      return $http.post(appConfig.apiUrl + 'Template', value);
    }

    function deleteTemplate(id) {
      return $http.delete(appConfig.apiUrl + 'Template/' + id);
    }

    //Rol
    function getRolesList() {
      return $http.get(appConfig.apiUrl + 'Rol');
    }

    function getRolById(id) {
      return $http.get(appConfig.apiUrl + 'Rol/' + id);
    }

    function saveRol(value) {
      return $http.post(appConfig.apiUrl + 'Rol', value);
    }

    function deleteRol(id) {
      return $http.delete(appConfig.apiUrl + 'Rol/' + id);
    }

    //RolProceso
    function getRolProcesoList() {
      return $http.get(appConfig.apiUrl + 'RolProceso');
    }

    function getRolProcesoByProcesoUsuario(solicitudId, procesoId, usuarioId) {
      return $http.get(appConfig.apiUrl + 'RolProceso/ProcesoUsuario/' + solicitudId + '/' + procesoId + '/' + usuarioId);
    }

    //RolTemplate
    function getRolTemplateList() {
      return $http.get(appConfig.apiUrl + 'RolTemplate');
    }

    function getRolTemplateByProcesoTemplateUsuario(solicitudId, procesoTemplateId, usuarioId) {
      return $http.get(appConfig.apiUrl + 'RolTemplate/ProcesoTemplateUsuario/' + solicitudId + '/' + procesoTemplateId + '/' + usuarioId);
    }

    //Solicitud
    function getSolicitudList() {
      return $http.get(appConfig.apiUrl + 'Solicitud');
    }

    function searchSolicitud(value) {
      return $http.post(appConfig.apiUrl + 'Solicitud/Search', value);
    }

    function searchSolicitud_doc(value) {
      return $http.post(appConfig.apiUrl + 'Solicitud/Search_doc', value);
    }

    function getSolicitudById(id) {
      return $http.get(appConfig.apiUrl + 'Solicitud/' + id);
    }

    function getSolicitudDefault(proceso, solicitudPadreId) {
      return $http.get(appConfig.apiUrl + 'Solicitud/GetNewSolicitud/' + proceso + '/' + solicitudPadreId);
    }

    function getSolicitudesByPadre(solicitudId, verTodos) {
      return $http.get(appConfig.apiUrl + 'Solicitud/Padre/' + solicitudId + '/' + verTodos);
    }

    function getSolicitudNombreCamposList() {
      return $http.get(appConfig.apiUrl + 'Solicitud/NombreCampos');
    }

    function saveSolicitud(value) {
      return $http.post(appConfig.apiUrl + 'Solicitud', value);
    }

    function saveObsoleto(value) {
      return $http.post(appConfig.apiUrl + 'Solicitud/obsoleto', value);
    }

    function saveSolicitudVersion(value) {
      return $http.post(appConfig.apiUrl + 'SolicitudCrearVersion', value);
    }

    function saveSolicitudCopia(value) {
      return $http.post(appConfig.apiUrl + 'SolicitudCopia', value);
    }


    function deleteSolicitud(id) {
      return $http.delete(appConfig.apiUrl + 'Solicitud/' + id);
    }

    function deleteSolicitudesByProceso(procesoId) {
      return $http.delete(appConfig.apiUrl + 'Solicitud/Proceso/' + procesoId);
    }

    function getSolicitudProcesoTemplateById(solicitudProcesoTemplateId) {
      return $http.get(appConfig.apiUrl + 'Solicitud/SolicitudProcesoTemplate/' + solicitudProcesoTemplateId);
    }

    //SolicitudEstado
    function getAnteriorEstadoSolicitud(solicitudId) {
      return $http.get(appConfig.apiUrl + 'SolicitudEstado/AnteriorEstado/' + solicitudId);
    }

    function getSiguienteEstadoSolicitud(solicitudId) {
      return $http.get(appConfig.apiUrl + 'SolicitudEstado/SiguienteEstado/' + solicitudId);
    }

    function getSolicitudEstadoSeleccionablesList() {
      return $http.get(appConfig.apiUrl + 'SolicitudEstado/Seleccionables');
    }


    //SolicitudEtapa     
    function saveSolicitudEtapa(value) {
      return $http.post(appConfig.apiUrl + 'SolicitudEtapa', value);
    }

    function saveSolicitudEtapaDerivarRes(value) {
      return $http.post(appConfig.apiUrl + 'SolicitudEtapaDerivar', value);
    }

    function getSolicitudEtapaDefault() {
      return $http.get(appConfig.apiUrl + 'SolicitudEtapa/GetDefault');
    }

    function getSolicitudEtapaBySolicitud(solicitudId) {
      return $http.get(appConfig.apiUrl + 'SolicitudEtapa/Solicitud/' + solicitudId);
    }

    function getSolicitudTrazabilidad(procesoId, solicitudId, numero) {
      return $http.get(appConfig.apiUrl + 'Trazabilidad' + '/' + procesoId + '/' + solicitudId + '/' + numero);
    }

    //SolicitudCampoValor
    function getSolicitudCampoValorCompleto(solicitudId) {
      return $http.get(appConfig.apiUrl + 'SolicitudCampoValor/ValoresCompletos/' + solicitudId);
    }

    function getSolicitudCampoValorDefault(value) {
      return $http.post(appConfig.apiUrl + 'SolicitudCampoValor/Default', value);
    }

    function getSolicitudCampoValorTextosCompleto(solicitudId) {
      return $http.get(appConfig.apiUrl + 'SolicitudCampoValor/ValoresTextosCompletos/' + solicitudId);
    }

    function getSolicitudCampoValorProcesoTemplate(solicitudId, procesoTemplateId) {
      return $http.get(appConfig.apiUrl + 'SolicitudCampoValor/ValoresProcesoTemplate/' + solicitudId + '/' + procesoTemplateId);
    }

    function checkSolicitudCampoValor(value) {
      return $http.post(appConfig.apiUrl + 'SolicitudCampoValor/ChequearValores', value);
    }

    function saveSolicitudCampoValorGeneraProcesos(value) {
      value.generaProcesos = true;
      return $http.post(appConfig.apiUrl + 'SolicitudCampoValor/generaprocesos', value);
    }

    function saveSolicitudCampoValorGeneraProcesosTemplates(value) {
      value.generaProcesos = true;
      return $http.post(appConfig.apiUrl + 'SolicitudCampoValor/generaprocesostemplates', value);
    }

    function saveSolicitudCampoValor(value) {
      value.generaProcesos = true;
      return $http.post(appConfig.apiUrl + 'SolicitudCampoValor', value);
    }

    function saveSolicitudCampoValorVersion(value) {
      return $http.post(appConfig.apiUrl + 'SolicitudCampoValorVersion', value);
    }


    function updateFileSolicitudCampoValor(file) {
      return Upload.upload({
        url: appConfig.apiUrl + 'SolicitudCampoValor/UploadFile',
        data: {
          file: file
        }
      });
    }

    //Usuario
    function getUsuarioList() {
      return $http.get(appConfig.apiUrl + 'Usuario');
    }

    function getUsuarioById(id) {
      return $http.get(appConfig.apiUrl + 'Usuario/' + id);
    }

    function getUsuarioListByProcesoEstado(procesoId, solicitudId, solicitudEstadoId) {
      return $http.get(appConfig.apiUrl + 'Usuario/ProcesoEstado/' + procesoId + '/' + solicitudId + '/' + solicitudEstadoId);
    }

    function searchUsuario(value) {
      return $http.post(appConfig.apiUrl + 'Usuario/Search', value);
    }

    function saveClaveUsuario(value) {
      return $http.post(appConfig.apiUrl + 'Usuario/Clave', value);
    }

    function saveUsuario(value) {
      return $http.post(appConfig.apiUrl + 'Usuario', value);
    }

    function deleteUsuario(id) {
      return $http.delete(appConfig.apiUrl + 'Usuario/' + id);
    }

    //MenuFuncion
    function checkMenuFuncion(codFuncion) {
      return $http.get(appConfig.apiUrl + 'MenuFuncion/Validar/' + codFuncion);
    }

    //Reporte
    function reporteTemplatesPendientesCarga(value) {
      return $http.post(appConfig.apiUrl + 'Reporte/GetTemplatesPendientesCarga', value);
    }


    function generateImagesPdf(solicitudId) {
      return $http.get(appConfig.apiUrl + 'Reporte/generateImagesPdf/' + solicitudId);
    }

    //CampoValor
    function getCampoValorCompleto(solicitudProcesoTemplateId, solicitudId, solicitudEstadoId, procesoTemplateId, templateId) {
      return $http.get(appConfig.apiUrl + 'CampoValor/ValoresCompletos/' + solicitudProcesoTemplateId + '/' + solicitudId + '/' + solicitudEstadoId + '/' + procesoTemplateId + '/' + templateId);
    }

    function getCampoValorTextosCompleto(solicitudProcesoTemplateId, solicitudId, solicitudEstadoId, procesoTemplateId, templateId) {
      return $http.get(appConfig.apiUrl + 'CampoValor/ValoresTextosCompletos/' + solicitudProcesoTemplateId + '/' + solicitudId + '/' + solicitudEstadoId + '/' + procesoTemplateId + '/' + templateId);
    }

    function notificacionesCampoValor(value) {
      return $http.post(appConfig.apiUrl + 'CampoValor/Notificaciones', value);
    }

    function saveCampoValor(value) {
      return $http.post(appConfig.apiUrl + 'CampoValor', value);
    }

    function deleteCampoValor(solicitudProcesoTemplateId) {
      return $http.delete(appConfig.apiUrl + 'CampoValor/' + solicitudProcesoTemplateId);
    }

    function updateFileCampoValor(file) {
      return Upload.upload({
        url: appConfig.apiUrl + 'CampoValor/UploadFile',
        data: {
          file: file
        }
      });
    }

  }
})();
(function() {
  'use strict';

  angular.module('Kahuna.pages.services').service('localStorage', localStorage);

  /** @ngInject */
  function localStorage($window) {
    var service = {
      set: set,
      get: get,
      setObject: setObject,
      getObject: getObject,
      clear: clear
    }

    return service;

    function set(key, value) {
      if ($window.fakeLocalStorage) {
        $window.fakeLocalStorage[key] = value;
      } else {
        $window.localStorage[key] = value;
      }
    }

    function get(key, defaultValue) {
      return !$window.fakeLocalStorage ? $window.localStorage[key] || defaultValue : $window.fakeLocalStorage[key] || defaultValue;
    }

    function setObject(key, value) {
      if ($window.fakeLocalStorage) {
        $window.fakeLocalStorage[key] = angular.toJson(value);
      } else {
        $window.localStorage[key] = angular.toJson(value);
      }
    }

    function getObject(key) {
      return !$window.fakeLocalStorage ? angular.fromJson($window.localStorage[key] || '{}') : angular.fromJson($window.fakeLocalStorage[key] || '{}');
    }

    function clear() {
      if ($window.fakeLocalStorage) {
        $window.fakeLocalStorage = {};
      } else {
        $window.localStorage.clear();
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('Kahuna.pages.services').service('sharedService', sharedService);

  /** @ngInject */
  function sharedService($http, appConfig, localStorage) {

    var lSuperAdminId = 1;
    var service = {
      getAssetsUrl: getAssetsUrl,
      getSystemVersion: getSystemVersion,
      getGenericErrorMessage: getGenericErrorMessage,

      getLoggedUser: getLoggedUser,
      getLoggedUserPermisos: getLoggedUserPermisos,
      setLoggedUser: setLoggedUser,
      setLoggedUserPermisos: setLoggedUserPermisos,
      isSysAdminLoggedUser: isSysAdminLoggedUser,
      isSuperAdminLoggedUser: isSuperAdminLoggedUser, 
      isSuperAdminLoggedUserId: isSuperAdminLoggedUserId, 
      getLocalData: getLocalData,
      setLocalData: setLocalData,
      clearLocalData: clearLocalData,
      
      replaceAll: replaceAll,
      RGB2Hex: RGB2Hex,
      getArrayColors: getArrayColors,

      addThousandSeparator: addThousandSeparator,

      checkEmailFormat: checkEmailFormat,

      formatDate: formatDate,
      convertDate: convertDate,
      formatDateForGetUrl: formatDateForGetUrl,
      uniqById : uniqById,
      arrayToObjProp: arrayToObjProp, 
      startWith : startWith,
      contains : contains, 

      showLoading: showLoading,
      closeLoading: closeLoading
    }

    return service;

    function showLoading(){
      Swal.fire({
        title: '',
        text: "Cargando...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        onOpen: function (){
            swal.showLoading();
        }
    })
    .then(function (result) {});
    }
    
    function closeLoading(){
      swal.close();
    }

    /*este filtro permite sacar resultados de un array mediante una propiedad,  si la propiedad empieza por.. */
    function startWith(arr, prop, valueProp) {
      var obj = {};
      for (var i = 0, len = arr.length; i < len; i++) {
        if (!obj[arr[i][prop]]) {
          if (arr[i][prop].toLowerCase().startsWith(valueProp.toLowerCase())) {
            obj[arr[i][prop]] = arr[i];
          }
        }
      }
      var newArr = [];
      for (var key in obj) {
        newArr.push(obj[key]);
      }
      return newArr;
    }

    function contains(arr, prop, valueProp) {
      var obj = {};
      for (var i = 0, len = arr.length; i < len; i++) {
        if (!obj[arr[i][prop]]) {
          if (String(arr[i][prop]).toLowerCase().includes( String(valueProp).toLowerCase())) {
            obj[arr[i][prop]] = arr[i];
          }
        }
      }
      var newArr = [];
      for (var key in obj) {
        newArr.push(obj[key]);
      }
      return newArr;
    }


    /*este filtro permite sacar resultados de un array mediante una propiedad,  si la propiedad es igual a valueProp*/
    function uniqById(arr, prop, valueProp) {
      var obj = {};
      for (var i = 0, len = arr.length; i < len; i++) {
        if (!obj[arr[i][prop]]) { 
          if (arr[i][prop] == valueProp) {
            obj[arr[i][prop]] = arr[i];
          }
        }
      }
      var newArr = [];
      for (var key in obj) {
        newArr.push(obj[key]);
      }
      return newArr;
    }

    /*Sirve para sacar  de un array una propiedad y su valor PropValue y devolver un OBJ*/
    function arrayToObjProp(arr, prop, propValue) {
      var obj = {};
      for (var i = 0, len = arr.length; i < len; i++) {        
          obj[arr[i][prop]] = arr[i][propValue];
      }
      return obj;
    }


    function getAssetsUrl() {
      //return '/Kahuna.Web/assets/'; //Produccion
      return '/assets/'; //Local
    }

    function getSystemVersion() {
      return '3.06.03';
    }

    function getGenericErrorMessage() {
      return "Ocurrió un error al intentar comunicarse con el servidor";
    }

    function getLoggedUser() {
      return localStorage.getObject('dataUser_kahuna');
    }

    function setLoggedUser(user) {
      localStorage.setObject('dataUser_kahuna', user);
    }

    function getLocalData(key) {
      return localStorage.getObject(key);
    }

    function setLocalData(key, data) {
      localStorage.setObject(key, data);
    }

    function clearLocalData(usuarioId) {
      localStorage.setObject("BUSQUEDA_SOLICITUDES_" + usuarioId, null);
    }

    function isSysAdminLoggedUser() {
      var authData = getLoggedUser();

      if (authData != null && authData.Id > 0) {
        for (var i = 0; i < authData.Roles.length; i++) {
          if (authData.Roles[i].Rol.EsSysAdmin)
            return true;
        }
      }

      return false;
    }

    function isSuperAdminLoggedUser() {
      var authData = getLoggedUser();
      console.log(authData.Id);
      if (authData != null && authData.Id > 0) {
        for (var i = 0; i < authData.Roles.length; i++) {
          if (authData.Roles[i].Rol.Id == lSuperAdminId)
            return true;
        }
      }

      return false;
    }
    

    function isSuperAdminLoggedUserId() {
      var authData = getLoggedUser();
      console.log(authData.Id);
      if (authData.Id == lSuperAdminId){
        return true;
      }
      return false;
    }

    function replaceAll(text, search, replacement) {
      if (text != null)
        return text.split(search).join(replacement);

      return "";
    };

    function addThousandSeparator(nStr) {
      if (nStr == null)
        nStr = "";

      nStr = replaceAll(nStr, ",", "");
      var x = nStr.split(',');
      var x1 = x[0];
      var x2 = x.length > 1 ? ',' + x[1] : '';
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
      }
      return x1 + x2;
    }

    function RGB2Hex(rgb) {
      var  sep = rgb.indexOf(",") > -1 ? "," : " ";      
      rgb = rgb.substr(4).split(")")[0].split(sep);    
      var  r = (+rgb[0]).toString(16),
          g = (+rgb[1]).toString(16),
          b = (+rgb[2]).toString(16);
    
      if (r.length == 1)
        r = "0" + r;
      if (g.length == 1)
        g = "0" + g;
      if (b.length == 1)
        b = "0" + b;
    
      return "#" + r + g + b;
    }

    function getArrayColors(cadena) {
      var regexp = /(#([\da-f]{3}){1,2}|(rgb|hsl)a\((\d{1,3}%?,\s?){3}(1|0?\.\d+)\)|(rgb|hsl)\(\d{1,3}%?(,\s?\d{1,3}%?){2}\))/g;
      //var array = [...cadena.matchAll(regexp)];
      var results= [];
      var obj = cadena.matchAll(regexp);
      var array = Array.from(obj ,  function(x) {return x[0]} );
      console.log(array);
      return array;
    }
    


    function getLoggedUserPermisos(callback) {
      return localStorage.getObject('dataPermisos_kahuna');
    }

    function setLoggedUserPermisos(permisos) {
      localStorage.setObject('dataPermisos_kahuna', permisos);
    }

    function formatDate(inputDate) {
      function pad(s) { return (s < 10) ? '0' + s : s; }

      if (inputDate == null)
        return null;

      var d = new Date(inputDate);
      var r = new Date([pad(d.getMonth() + 1), pad(d.getDate()), d.getFullYear()].join('/'));

      console.log('formatDate -> Original: ' + inputDate + ' || Resultado: ' + r);
      return r;
    }

    function convertDate(inputDate) {
      function pad(s) { return (s < 10) ? '0' + s : s; }

      if (inputDate == null)
        return null;

      inputDate = inputDate.toString().replace(new RegExp('-', 'g'), '/');

      var split = inputDate.split('/');
      var r = new Date([split[1], split[0], split[2]].join('/'));

      console.log('convertDate -> Original: ' + inputDate + ' || Resultado: ' + r);
      return r;
    }

    function formatDateForGetUrl(inputDate) {
      function pad(s) { return (s < 10) ? '0' + s : s; }

      if (inputDate == null)
        return null;

      var d = new Date(inputDate);
      var r = [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('-');

      console.log('formatDate -> Original: ' + inputDate + ' || Resultado: ' + r);
      return r;
    }

    function checkEmailFormat(email) {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  }
})();
(function (angular) {
  'use strict';
  angular.module('Kahuna.pages.template').component('templateEdit', {
    templateUrl: 'app/pages/template/edit.template.html',
    controller: function ($scope, $state, $filter, dataService, sharedService, toastr, toastrConfig, $stateParams, $uibModal) {
      var ctrl = this;
      ctrl.model = {};
      ctrl.isBusy = false;
      ctrl.showDelete = false;
      ctrl.showCampoTituloSelect = false;
      ctrl.title = '';

      ctrl.campoCargado = {};

      ctrl.templateCamposList = [];
      ctrl.tipoEnvioMailConfig = {};
      ctrl.tipoHabilitacionUsuarioConfig = {};
      ctrl.tipoRecursivoConfig = {};
      ctrl.campoTituloSeleccionado = null;

      ctrl.templateCamposDS = [];

      ctrl.camposList = [];
      ctrl.tipoTemplateList = [];
      ctrl.camposUsuarioList = [];
      ctrl.camposTemplateList = [];
      ctrl.camposBasicosList = [];
      ctrl.camposPeriodoList = [];
      ctrl.camposFechaList = [];

      this.$onInit = function () {
        loadView();
        ctrl.loadGrupos();
      };

      ctrl.loadGrupos = function () {
        ctrl.filtros = {
          PageSize: 1000,
          SkipNumber: 0
        };

        dataService.searchGruposUsuarios(ctrl.filtros)
          .then(function (response) {
            if (response.data.Success) {
              console.log("TRESPONSE USUARIOS");

              var defaultUser = {
                Id: 0,
                Nombre: ""
              }
              ctrl.GruposUsuariosList = [];
              ctrl.GruposUsuariosList.push(defaultUser);
              ctrl.GruposUsuariosList = ctrl.GruposUsuariosList.concat(response.data.Value.Resultados);
              console.log(ctrl.GruposUsuariosList);

            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isSearching = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
            ctrl.isSearching = false;
          });

      }


      function loadView() {
        dataService.getTipoTemplateList()
          .then(function (response) {
            if (response.data.Success) {
              ctrl.tipoTemplateList = response.data.Value;
            } else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
          });

        dataService.getCampoList()
          .then(function (response) {
            if (response.data.Success) {
              ctrl.camposList = response.data.Value;
            } else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
          });

        if ($stateParams.id != "0") {
          dataService.getTemplateById($stateParams.id)
            .then(function (response) {
              if (response.data.Success) {
                ctrl.showDelete = true;
                ctrl.model = response.data.Value;

                ctrl.title = 'Editar Template: ' + ctrl.model.Nombre;

                ctrl.templateCamposList = ctrl.model.Campos;
                ctrl.actualizarTituloConfigText();

                switch (ctrl.model.TipoTemplate.Codigo) {
                  case 'CREA_NOTI_DOC':
                    dataService.getTipoTemplateEnvioMailConfiguracion($stateParams.id)
                      .then(function (response) {
                        if (response.data.Success) {
                          ctrl.tipoEnvioMailConfig = response.data.Value;
                          ctrl.model.CuerpoMensaje =  ctrl.tipoEnvioMailConfig.CuerpoMensaje;
                        } else {
                          toastr.error(response.data.ErrorSummary);
                        }
                      }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage());
                      });
                    break;
                  case 'ENVIO_MAIL':
                    dataService.getTipoTemplateEnvioMailConfiguracion($stateParams.id)
                      .then(function (response) {
                        if (response.data.Success) {
                          ctrl.tipoEnvioMailConfig = response.data.Value;
                        } else {
                          toastr.error(response.data.ErrorSummary);
                        }
                      }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage());
                      });

                    break;

                  case 'HAB_USUARIO':

                    dataService.getTipoTemplateHabilitacionUsuarioConfiguracion($stateParams.id)
                      .then(function (response) {
                        if (response.data.Success) {
                          ctrl.tipoHabilitacionUsuarioConfig = response.data.Value;
                        } else {
                          toastr.error(response.data.ErrorSummary);
                        }
                      }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage());
                      });

                    break;

                  case 'RECURSIVO':

                    dataService.getTipoTemplateRecursivoConfiguracion($stateParams.id)
                      .then(function (response) {
                        if (response.data.Success) {
                          ctrl.tipoRecursivoConfig = response.data.Value;

                          if (ctrl.templateCamposList != null &&
                            ctrl.tipoRecursivoConfig.CamposPorRepetirObject != null && ctrl.tipoRecursivoConfig.CamposPorRepetirObject.length > 0) {
                            for (var i = 0; i < ctrl.templateCamposList.length; i++) {
                              ctrl.templateCamposList[i].Campo.Seleccionado = false;

                              for (var j = 0; j < ctrl.tipoRecursivoConfig.CamposPorRepetirObject.length; j++) {
                                if (ctrl.tipoRecursivoConfig.CamposPorRepetirObject[j] == ctrl.templateCamposList[i].CampoId) {
                                  ctrl.templateCamposList[i].Campo.Seleccionado = true;
                                  break;
                                }
                              }
                            }
                          }
                        } else {
                          toastr.error(response.data.ErrorSummary);
                        }
                      }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage());
                      });

                    break;
                }
              } else {
                toastr.error(response.data.ErrorSummary);
              }
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage());
            });
        } else {
          ctrl.title = 'Crear Template: -';
        }
      }

      ctrl.loadTipoTemplateTab = function () {
        ctrl.camposUsuarioList = [];
        ctrl.camposTemplateList = [];
        ctrl.camposBasicosList = [];
        ctrl.camposPeriodoList = [];
        ctrl.camposFechaList = [];

        if (ctrl.templateCamposList == null || ctrl.templateCamposList.length <= 0)
          return;

        for (var i = 0; i < ctrl.templateCamposList.length; i++) {
          var tipo = ctrl.templateCamposList[i].Campo.CampoTipo.Codigo;

          if (tipo == 'PERIODO')
            ctrl.camposPeriodoList.push(ctrl.templateCamposList[i].Campo);

          if (tipo == 'DATE')
            ctrl.camposFechaList.push(ctrl.templateCamposList[i].Campo);

          switch (tipo) {
            case 'USER':
              ctrl.camposUsuarioList.push(ctrl.templateCamposList[i].Campo);
              break;

            case 'TEMPLATE':
              ctrl.camposTemplateList.push(ctrl.templateCamposList[i].Campo);
              break;

            default:
              ctrl.camposBasicosList.push(ctrl.templateCamposList[i].Campo);
              break;
          }
        }
      }

      ctrl.actualizarTitulo = function () {
        if (ctrl.model != null) {
          if ($stateParams.id != "0")
            ctrl.title = 'Editar Template: ' + ctrl.model.Nombre;
          else
            ctrl.title = 'Crear Template: ' + ctrl.model.Nombre;
        }
      }

      ctrl.editCampo = function () {
        if (ctrl.campoCargado.Orden <= 0 ||
          ctrl.campoCargado.Orden == null ||
          ctrl.campoCargado.Orden == '' ||
          ctrl.campoCargado.Campo == null ||
          ctrl.campoCargado.Campo.Id == 0) {
          toastr.error('Por favor complete todos los campos obligatorios del campo para agregarlo');
          return;
        }

        if (ctrl.campoCargado.Obligatorio == null)
          ctrl.campoCargado.Obligatorio = false;

        ctrl.campoCargado.TemplateId = ctrl.model.Id;
        ctrl.campoCargado.CampoId = ctrl.campoCargado.Campo.Id;

        if (ctrl.templateCamposList == null)
          ctrl.templateCamposList = [];

        var index = -1;
        for (var i = 0; i < ctrl.templateCamposList.length; i++) {
          if (ctrl.templateCamposList[i].Campo.Id != ctrl.campoCargado.Campo.Id &&
            ctrl.templateCamposList[i].Orden == ctrl.campoCargado.Orden) {
            toastr.error('Por favor ingrese un número de orden distinto ya que el ingresado ya existe');
            return;
          }

          if (ctrl.templateCamposList[i].Campo.Id == ctrl.campoCargado.Campo.Id)
            index = i;
        }

        if (index >= 0)
          ctrl.templateCamposList[index] = ctrl.campoCargado;
        else
          ctrl.templateCamposList.push(ctrl.campoCargado);

        ctrl.templateCamposList.sort(function (a, b) {
          return (parseInt(a.Orden) > parseInt(b.Orden) ? 1 : (parseInt(b.Orden) > parseInt(a.Orden)) ? -1 : 0);
        });
        ctrl.templateCamposDS = ctrl.templateCamposList;
        ctrl.campoCargado = {};
      }

      ctrl.cargarCampo = function (campoSeleccionado) {
        if (campoSeleccionado == null) {
          toastr.error('Por favor seleccione un campo para poder visualizarlo');
          return;
        }

        ctrl.campoCargado = {};

        ctrl.campoCargado.Id = campoSeleccionado.Id;
        ctrl.campoCargado.TemplateId = campoSeleccionado.TemplateId;
        ctrl.campoCargado.Campo = campoSeleccionado.Campo;
        ctrl.campoCargado.Orden = campoSeleccionado.Orden;
        ctrl.campoCargado.Obligatorio = campoSeleccionado.Obligatorio;
      }

      ctrl.eliminarCampo = function (index) {
        if (index < 0) {
          toastr.error('Campo seleccionado inválido');
          return;
        }

        if (ctrl.templateCamposList != null && ctrl.templateCamposList.length > 0)
          ctrl.templateCamposList.splice(index, 1);
      }

      ctrl.clearCampo = function () {
        ctrl.campoCargado = {};
      }

      ctrl.buscarCampoTitulo = function (show) {
        ctrl.showCampoTituloSelect = show;
      }

      ctrl.onSelectCampoTitulo = function (campoSeleccionado) {
        if (campoSeleccionado != null && campoSeleccionado.Campo != null) {
          if (ctrl.model.ConfiguracionTitulo == null)
            ctrl.model.ConfiguracionTitulo = "";

          var position = $("#configuracionTitulo")[0].selectionStart;
          ctrl.model.ConfiguracionTitulo = [ctrl.model.ConfiguracionTitulo.slice(0, position), "{{" + campoSeleccionado.Campo.Id + "}}", ctrl.model.ConfiguracionTitulo.slice(position)].join('');
          ctrl.actualizarTituloConfigText();

          ctrl.showCampoTituloSelect = false;
          ctrl.campoTituloSeleccionado = null;
        }
      }

      ctrl.actualizarTituloConfigText = function () {
        ctrl.configuracionTituloText = "...";

        if (ctrl.model.ConfiguracionTitulo != null && ctrl.model.ConfiguracionTitulo.length > 0) {
          dataService.getTemplateTituloConfigText(ctrl.model)
            .then(function (response) {
              if (response.data.Success) {
                ctrl.configuracionTituloText = response.data.Value;
              } else {
                toastr.error(response.data.ErrorSummary);
                ctrl.configuracionTituloText = "";
              }
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage());
              ctrl.configuracionTituloText = "";
            });
        } else
          ctrl.configuracionTituloText = "";
      }

      ctrl.save = function (form) {
        if (ctrl.model.Codigo == null ||
          ctrl.model.Codigo == '' ||
          ctrl.model.Nombre == null ||
          ctrl.model.Nombre == '' ||
          ctrl.model.TipoTemplate == null ||
          ctrl.model.TipoTemplate.Id <= 0) {
          toastr.error('Por favor complete todos los datos obligatorios marcados con asterisco');
          return;
        }

        if (ctrl.templateCamposList == null ||
          ctrl.templateCamposList.length <= 0) {
          toastr.error('Seleccione al menos un campo para formar parte del template');
          return;
        }

        switch (ctrl.model.TipoTemplate.Codigo) {
          case 'ESTANDAR':
            ctrl.tipoEnvioMailConfig = {};
            ctrl.tipoHabilitacionUsuarioConfig = {};
            break;
          case 'CREA_NOTI_DOC':
            if (ctrl.tipoEnvioMailConfig.CampoDestinatario == null ||
              ctrl.model.CuerpoMensaje == null) {
              toastr.error('Por favor complete todos los datos obligatorios para el tipo de template Creacion y Notificacion Documental');
              return;
            }
            //ctrl.tipoEnvioMailConfig.CampoMensajeId = ctrl.tipoEnvioMailConfig.CampoMensaje.Id;
            break;
          case 'ENVIO_MAIL':
            if (ctrl.tipoEnvioMailConfig == null ||
              ctrl.tipoEnvioMailConfig.CampoMensaje == null ||
              ctrl.tipoEnvioMailConfig.CampoMensaje.Id <= 0) {
              toastr.error('Por favor complete todos los datos obligatorios para el tipo de template Envío de Mail');
              return;
            }
            ctrl.tipoEnvioMailConfig.CampoMensajeId = ctrl.tipoEnvioMailConfig.CampoMensaje.Id;
            break;
          case 'HAB_USUARIO':
            if (ctrl.tipoHabilitacionUsuarioConfig == null ||
              ctrl.tipoHabilitacionUsuarioConfig.CampoMensaje == null ||
              ctrl.tipoHabilitacionUsuarioConfig.CampoMensaje.Id <= 0 ||
              ctrl.tipoHabilitacionUsuarioConfig.CampoUsuarioHabilitar == null ||
              ctrl.tipoHabilitacionUsuarioConfig.CampoUsuarioHabilitar.Id <= 0 ||
              ctrl.tipoHabilitacionUsuarioConfig.CampoTemplatesHabilitar == null ||
              ctrl.tipoHabilitacionUsuarioConfig.CampoTemplatesHabilitar.Id <= 0) {
              toastr.error('Por favor complete todos los datos obligatorios para el tipo de template Habilitación de Usuario');
              return;
            }

            ctrl.tipoHabilitacionUsuarioConfig.CampoMensajeId = ctrl.tipoHabilitacionUsuarioConfig.CampoMensaje.Id;
            ctrl.tipoHabilitacionUsuarioConfig.CampoUsuarioHabilitarId = ctrl.tipoHabilitacionUsuarioConfig.CampoUsuarioHabilitar.Id;
            ctrl.tipoHabilitacionUsuarioConfig.CampoTemplatesHabilitarId = ctrl.tipoHabilitacionUsuarioConfig.CampoTemplatesHabilitar.Id;
            break;
          case 'RECURSIVO':
            if (ctrl.tipoRecursivoConfig == null ||
              ctrl.tipoRecursivoConfig.CampoCondicion == null ||
              ctrl.tipoRecursivoConfig.CampoCondicion.Id <= 0 ||
              ctrl.tipoRecursivoConfig.CampoFechaInicia == null ||
              ctrl.tipoRecursivoConfig.CampoFechaInicia.Id <= 0 ||
              ctrl.tipoRecursivoConfig.CampoPeriodicidad == null ||
              ctrl.tipoRecursivoConfig.CampoPeriodicidad.Id <= 0) {
              toastr.error('Por favor complete todos los datos obligatorios para el tipo de template Recursivo');
              return;
            }
            ctrl.tipoRecursivoConfig.CampoFechaIniciaId = ctrl.tipoRecursivoConfig.CampoFechaInicia.Id;
            ctrl.tipoRecursivoConfig.CampoPeriodicidadId = ctrl.tipoRecursivoConfig.CampoPeriodicidad.Id;
            break;
          default:
            toastr.error('Tipo de template desconocido (' + ctrl.model.TipoTemplate.Codigo + ')');
            return;
            break;
        }

        ctrl.isBusy = true;

        // ctrl.model.Activo = 1;
        ctrl.model.TipoTemplateId = ctrl.model.TipoTemplate.Id;
        ctrl.model.Campos = ctrl.templateCamposList;

        dataService.saveTemplate(ctrl.model)
          .then(function (response) {
            if (response.data.Success) {
              ctrl.model.Id = response.data.Value.Id;

              switch (ctrl.model.TipoTemplate.Codigo) {
                case 'CREA_NOTI_DOC':
                  ctrl.tipoEnvioMailConfig.TemplateId = ctrl.model.Id;
                  if (ctrl.tipoEnvioMailConfig.CampoDestinatario != null)
                    ctrl.tipoEnvioMailConfig.CampoDestinatarioId = ctrl.tipoEnvioMailConfig.CampoDestinatario.Id;

                  if (ctrl.tipoEnvioMailConfig.CampoCopia != null)
                    ctrl.tipoEnvioMailConfig.CampoCopiaId = ctrl.tipoEnvioMailConfig.CampoCopia.Id;

                  if (ctrl.tipoEnvioMailConfig.CampoAsunto != null)
                    ctrl.tipoEnvioMailConfig.CampoAsuntoId = ctrl.tipoEnvioMailConfig.CampoAsunto.Id;

                  if (ctrl.model.CuerpoMensaje != null)
                    ctrl.tipoEnvioMailConfig.CuerpoMensaje = ctrl.model.CuerpoMensaje;

                  dataService.saveTipoTemplateEnvioMailConfiguracion(ctrl.tipoEnvioMailConfig)
                    .then(function (response) {
                      if (response.data.Success) {
                        toastr.info("Operacion exitosa.");
                        $state.transitionTo("pages.template");
                      } else {
                        toastr.error(response.data.ErrorSummary);
                      }
                      ctrl.isBusy = false;
                    }, function (error) {
                      toastr.error(error.data || sharedService.getGenericErrorMessage());
                      ctrl.isBusy = false;
                    });

                  break;
                  case 'ENVIO_MAIL':
                      ctrl.tipoEnvioMailConfig.TemplateId = ctrl.model.Id;
                      if (ctrl.tipoEnvioMailConfig.CampoDestinatario != null)
                        ctrl.tipoEnvioMailConfig.CampoDestinatarioId = ctrl.tipoEnvioMailConfig.CampoDestinatario.Id;
                        
                      if (ctrl.tipoEnvioMailConfig.CampoCopia != null)
                        ctrl.tipoEnvioMailConfig.CampoCopiaId = ctrl.tipoEnvioMailConfig.CampoCopia.Id;
    
                      if (ctrl.tipoEnvioMailConfig.CampoAsunto != null)
                        ctrl.tipoEnvioMailConfig.CampoAsuntoId = ctrl.tipoEnvioMailConfig.CampoAsunto.Id;
    
                      if (ctrl.tipoEnvioMailConfig.CampoMensaje != null)
                        ctrl.tipoEnvioMailConfig.CampoMensajeId = ctrl.tipoEnvioMailConfig.CampoMensaje.Id;
    
                      dataService.saveTipoTemplateEnvioMailConfiguracion(ctrl.tipoEnvioMailConfig)
                        .then(function (response) {
                          if (response.data.Success) {
                            toastr.info("Operacion exitosa.");
                            $state.transitionTo("pages.template");
                          } else {
                            toastr.error(response.data.ErrorSummary);
                          }
                          ctrl.isBusy = false;
                        }, function (error) {
                          toastr.error(error.data || sharedService.getGenericErrorMessage());
                          ctrl.isBusy = false;
                        });
    
                      break;

                case 'HAB_USUARIO':

                  ctrl.tipoHabilitacionUsuarioConfig.TemplateId = ctrl.model.Id;

                  if (ctrl.tipoHabilitacionUsuarioConfig.CampoUsuarioHabilitar != null)
                    ctrl.tipoHabilitacionUsuarioConfig.CampoUsuarioHabilitarId = ctrl.tipoHabilitacionUsuarioConfig.CampoUsuarioHabilitar.Id;

                  if (ctrl.tipoHabilitacionUsuarioConfig.CampoTemplatesHabilitar != null)
                    ctrl.tipoHabilitacionUsuarioConfig.CampoTemplatesHabilitarId = ctrl.tipoHabilitacionUsuarioConfig.CampoTemplatesHabilitar.Id;

                  if (ctrl.tipoHabilitacionUsuarioConfig.CampoCopia != null)
                    ctrl.tipoHabilitacionUsuarioConfig.CampoCopiaId = ctrl.tipoHabilitacionUsuarioConfig.CampoCopia.Id;

                  if (ctrl.tipoHabilitacionUsuarioConfig.CampoAsunto != null)
                    ctrl.tipoHabilitacionUsuarioConfig.CampoAsuntoId = ctrl.tipoHabilitacionUsuarioConfig.CampoAsunto.Id;

                  if (ctrl.tipoHabilitacionUsuarioConfig.CampoMensaje != null)
                    ctrl.tipoHabilitacionUsuarioConfig.CampoMensajeId = ctrl.tipoHabilitacionUsuarioConfig.CampoMensaje.Id;

                  dataService.saveTipoTemplateHabilitacionUsuarioConfiguracion(ctrl.tipoHabilitacionUsuarioConfig)
                    .then(function (response) {
                      if (response.data.Success) {
                        toastr.info("Operacion exitosa.");
                        $state.transitionTo("pages.template");
                      } else {
                        toastr.error(response.data.ErrorSummary);
                      }
                      ctrl.isBusy = false;
                    }, function (error) {
                      toastr.error(error.data || sharedService.getGenericErrorMessage());
                      ctrl.isBusy = false;
                    });

                  break;

                case 'RECURSIVO':

                  ctrl.tipoRecursivoConfig.TemplateId = ctrl.model.Id;

                  if (ctrl.tipoRecursivoConfig.CampoCondicion != null)
                    ctrl.tipoRecursivoConfig.CampoCondicionId = ctrl.tipoRecursivoConfig.CampoCondicion.Id;

                  if (ctrl.tipoRecursivoConfig.CampoFechaInicia != null)
                    ctrl.tipoRecursivoConfig.CampoFechaIniciaId = ctrl.tipoRecursivoConfig.CampoFechaInicia.Id;

                  if (ctrl.tipoRecursivoConfig.CampoPeriodicidad != null)
                    ctrl.tipoRecursivoConfig.CampoPeriodicidadId = ctrl.tipoRecursivoConfig.CampoPeriodicidad.Id;

                  ctrl.tipoRecursivoConfig.CamposPorRepetirObject = [];

                  if (ctrl.templateCamposList != null) {
                    for (var i = 0; i < ctrl.templateCamposList.length; i++) {
                      if (ctrl.templateCamposList[i].Campo.Seleccionado)
                        ctrl.tipoRecursivoConfig.CamposPorRepetirObject.push(ctrl.templateCamposList[i].CampoId);
                    }
                  }

                  dataService.saveTipoTemplateRecursivoConfiguracion(ctrl.tipoRecursivoConfig)
                    .then(function (response) {
                      if (response.data.Success) {
                        toastr.info("Operacion exitosa.");
                        $state.transitionTo("pages.template");
                      } else {
                        toastr.error(response.data.ErrorSummary);
                      }
                      ctrl.isBusy = false;
                    }, function (error) {
                      toastr.error(error.data || sharedService.getGenericErrorMessage());
                      ctrl.isBusy = false;
                    });

                  break;

                default:
                  dataService.deleteTipoTemplateConfiguracion(ctrl.model.Id)
                    .then(function (response) {
                      if (response.data.Success) {
                        toastr.info("Operacion exitosa.");
                        $state.transitionTo("pages.template");
                      } else {
                        toastr.error(response.data.ErrorSummary);
                      }
                      ctrl.isBusy = false;
                    }, function (error) {
                      toastr.error(error.data || sharedService.getGenericErrorMessage());
                      ctrl.isBusy = false;
                    });
                  break;
              }
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
            ctrl.isBusy = false;
          });
      }

      ctrl.cancel = function () {
        $state.transitionTo("pages.template");
      }

      ctrl.delete = function () {
        ctrl.isBusy = true;
        var confirmation = $uibModal.open({
          animation: true,
          component: "confirmation",
          resolve: {
            title: function () {
              return "Atención"
            },
            message: function () {
              return "Confirma el borrado del template?"
            },
          }
        });

        confirmation.result.then(function (selectedItem) {
          dataService.deleteTemplate(ctrl.model.Id)
            .then(function (response) {
              if (response.data.Success) {
                toastr.info("Operacion exitosa.");
                $state.transitionTo("pages.template");
              } else {
                toastr.error(response.data.ErrorSummary);
              }
              ctrl.isBusy = false;
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage());
              ctrl.isBusy = false;
            });
        }, function () {
          ctrl.isBusy = false;
        });
      }
    }
  });
})(window.angular);
(function (angular) {
  'use strict';
  angular.module('Kahuna.pages.template').component('templateList', {
    templateUrl: 'app/pages/template/list.template.html',
    controller: function ($scope,$state,dataService,sharedService,toastr) {
      var ctrl = this;
      ctrl.anularVista = true;
      
      this.$onInit = function () 
      {
        ctrl.anularVista = !sharedService.isSysAdminLoggedUser();
      };

      ctrl.buscar = function buscar(tableState) 
      {
        ctrl.isSearching = true;

        var pagination = tableState.pagination;

        var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
        var number = pagination.number || 10;  // Number of entries showed per page.

        ctrl.filtros = { PageSize: number, SkipNumber: start };

        if (tableState.search.predicateObject != null)
        {
          ctrl.filtros.Codigo = tableState.search.predicateObject.Codigo;
          ctrl.filtros.Nombre = tableState.search.predicateObject.Nombre;
          ctrl.filtros.TipoTemplate = tableState.search.predicateObject.TipoTemplate;

          if (tableState.search.predicateObject.Activo != null)
          {
            if (tableState.search.predicateObject.Activo == "1" || tableState.search.predicateObject.Activo.toLowerCase() == "true")
              ctrl.filtros.Activo = true;

            if (tableState.search.predicateObject.Activo == "0" || tableState.search.predicateObject.Activo.toLowerCase() == "false")
              ctrl.filtros.Activo = false;
          }
        }

        if (tableState.sort != null)
        {
          ctrl.filtros.OrderFieldName = tableState.sort.predicate;
          ctrl.filtros.OrderAscending = !tableState.sort.reverse;
        }

        dataService.searchTemplate(ctrl.filtros)
          .then(function (response) 
          {
            if (response.data.Success)
            {               
              ctrl.resultList = response.data.Value.Resultados;
              //ctrl.totalResultados = response.data.Value.TotalResultados;

              tableState.pagination.numberOfPages = Math.ceil(response.data.Value.TotalResultados/number); //result.numberOfPages;//set the number of pages so the pagination can update
            } 
            else 
            {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isSearching = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
            ctrl.isSearching = false;
        });
      };
      
      ctrl.add = function ()
      {
        $state.go("pages.template-edit",{id:0});
      }

      ctrl.edit = function (id)
      {
        $state.go("pages.template-edit",{id:id});
      }
    }
  });
})(window.angular);
(function () {
    'use strict';
    angular.module('Kahuna.pages.template').config(routeConfig);
    function routeConfig($stateProvider) {
      $stateProvider
        .state('pages.template', {
          url: '/template',
          title: 'Template',
          template : '<template-list></template-list>',
          authenticate: true,
        })
        .state('pages.template-edit', {
          url: '/template/edit/:id',
          title: 'Template',
          template : '<template-edit></template-edit>',
          params: {id:null},
          authenticate: true,
        });
    }
  })();
// import swal from 'sweetalert';
(function (angular) {
    'use strict';
    angular.module('Kahuna.pages.solicitud').component('solicitudEdit', {
        templateUrl: 'app/pages/solicitud/edit.template.html',
        controller: function ($scope, $state, dataService, sharedService, toastr, appConfig, toastrConfig, $stateParams, $uibModal, $timeout, $window, $location) {
            var ctrl = this;
            var authData = {};
            ctrl.model = {};
            ctrl.isBusy = false;
            ctrl.isNew = false;
            ctrl.CurrentDate = new Date();
            ctrl.showDelete = false;
            ctrl.showModalDataContainer = false;
            ctrl.templateCargadosIsSearching = true;
            ctrl.templatePendientesIsSearching = false;
            ctrl.mostrarAprobacion = false;
            ctrl.mostrarTemplates = false;
            ctrl.mostrarCamposBoton = false;
            ctrl.puedeEditarSolicitud = false;
            ctrl.puedeCargarTemplates = false;
            ctrl.puedeVerBtnQuitarPadre = false;
            ctrl.historialIsSearchingTrazabilidad = false;
            ctrl.showCopiaControlada = false;
            ctrl.solicitudHasProceduresField = false;
            ctrl.generaProcesoRelacionados = false;
            ctrl.usuarioPuedeAutorizar = false;
            ctrl.usuarioYaAutorizo = false;
            ctrl.gruposFilledLectores = false;
            ctrl.procesomcaOcultaAvanzarEtapa = false;
            ctrl.SourceObjetoTemp = [];

            ctrl.showProcesosHijosEtapaActual = false;
            ctrl.showForzarCierreEtapa = false;
            ctrl.verTodosProcesosAsociados = false;
            ctrl.lProcesoIsDocumental = false; //Guardar propiedad del proceso.
            ctrl.lProcesoIsDocumentalAutorizacionesV2 = false; //Guardar propiedad del proceso.
            ctrl.lsuarioLogueadoIsEditorDocV2 = false;
            ctrl.IdSolicitudEtapa = 0; //Guardar el Nombre de la Etapa.
            ctrl.lsuarioLogueadoIsAdminProceso = false;
            ctrl.lsuarioLogueadoIsSupervisorProceso = false;
            ctrl.lsuarioLogueadoIsSysAdmin = false;
            ctrl.lsuarioLogueadoIsLectorOnly = false;
            ctrl.lsuarioLogueadoIsNoCreateOnly = false;
            ctrl.lDocIsUserAbleToCreateDocumentV2 = false;
            ctrl.userTieneMarcaObsoleto = false;
            ctrl.lUsuarioLogeado = {};
            ctrl.procesoIdObsoleto = 99;
            ctrl.procesoIdversiones = 999;


            ctrl.anularVista = true;
            ctrl.viewLoading = true;
            ctrl.motivoBloqueo = '';
            ctrl.title = 'Carga de Proceso';
            ctrl.buttonSaveCabeceraText = 'Guardar Cabecera';
            ctrl.active = 0;
            ctrl.active2 = 66;
            ctrl.imgFile = appConfig.uploadUrl;
            //ctrl.evaluatenumber = evaluatenumber;        
            ctrl.testTrixModel = "<div><!--block--><em>Lorem ipsum dolor sit amet, consectetur adipiscing elit. In porttitor ante ut est ultrices, in scelerisque augue tempor. Vestibulum sodales vel risus ac feugiat. Sed efficitur, diam porttitor laoreet sollicitudin, neque libero pulvinar quam, vel molestie libero enim eget tellus. Nunc at velit porta, tincidunt nunc eu, dignissim ipsum. Vestibulum consectetur neque id aliquam malesuada. Vivamus feugiat nibh in lorem accumsan, sed vestibulum velit malesuada. Quisque consectetur, eros sit amet molestie iaculis, erat nunc sagittis turpis, rhoncus semper mi magna sit amet leo. Donec eu orci eu purus congue elementum. Pellentesque congue vitae lectus nec feugiat. Praesent et dui et lacus convallis finibus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Donec quis ante ipsum. Cras feugiat mauris ipsum, nec consectetur leo pretium at. Sed pharetra, enim ut egestas dictum, lorem ipsum condimentum orci, nec pulvinar tortor nibh a sapien. Aliquam consectetur, orci sed vulputate rhoncus, lacus nibh faucibus leo, a ullamcorper justo lacus in enim. Vivamus quis aliquet nibh.</em><br><strong><br>Sed euismod vestibulum euismod. Pellentesque vel faucibus leo, vel elementum dolor. Aenean vitae ipsum ac massa aliquam feugiat consectetur at urna. Etiam tincidunt consectetur sem at consequat. Vestibulum pulvinar pellentesque magna, ac placerat neque dapibus at. Nam posuere euismod nulla iaculis interdum. Ut fringilla pulvinar maximus. Phasellus auctor dolor porttitor vestibulum faucibus. Pellentesque ut dolor luctus, vestibulum erat in, luctus libero. In quis diam in ipsum commodo egestas. Suspendisse in pharetra magna. Aliquam sit amet faucibus risus, eget porttitor ex. Proin eu ipsum non ipsum porttitor facilisis.<br></strong><br></div><ul><li><!--block-->Maecenas vulputate orci posuere, fringilla erat at, vestibulum lorem.&nbsp;</li><li><!--block-->Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nulla facilisi. Proin malesuada scelerisque augue at commodo. Vivamus interdum, sem vehicula egestas suscipit, est tellus molestie enim, ut porttitor libero lorem a arcu.&nbsp;</li></ul><div><!--block--><br></div><ol><li><!--block-->Fusce condimentum velit non turpis ultrices maximus. Mauris pharetra faucibus est, vel dictum eros.</li><li><!--block-->Maecenas blandit lorem a fermentum consequat. Phasellus malesuada sollicitudin erat, id consectetur metus vulputate et.&nbsp;</li><li><!--block-->Duis sit amet fringilla risus. Proin lobortis, urna sed sagittis imperdiet, urna ligula imperdiet est, et mollis velit eros vitae neque.&nbsp;</li><li><!--block-->Curabitur viverra augue nec sapien tincidunt, eu bibendum velit aliquam.</li></ol><div><!--block--><br></div><blockquote><!--block-->Aenean non arcu quis ligula sodales lobortis eu a libero. Sed lacinia gravida nisi, in scelerisque ante laoreet vel. Aenean arcu metus, ornare quis tempor ut, dignissim ac nisi. Pellentesque id aliquet quam, in pretium quam. Sed iaculis faucibus purus, in porta arcu congue nec. Integer eget finibus ante. Duis neque quam, congue non finibus non, luctus eu dui. Sed at eros ante. Mauris maximus nec metus non aliquam. Suspendisse sit amet fermentum turpis, tincidunt volutpat arcu. Pellentesque sollicitudin ligula nisl, vel aliquet metus ullamcorper at. Morbi malesuada tellus at orci facilisis pharetra.</blockquote><div><!--block--><br></div><div><!--block--><br><del>Donec fermentum, sem eu venenatis facilisis, erat turpis auctor sapien, eget pellentesque risus nibh sed sapien. Proin vestibulum sed dui vel varius. Aliquam dictum in ipsum ac feugiat. Curabitur in nulla ac justo ullamcorper aliquet sit amet vitae mi. Cras lorem urna, rutrum quis rutrum a, facilisis sit amet arcu. Maecenas volutpat eros eget ornare sollicitudin. Nunc nec imperdiet mauris. Quisque facilisis, urna vel sodales porttitor, nisi massa dignissim tortor, ut pretium massa leo at nulla. Curabitur nec blandit elit. Etiam quis diam lobortis velit tincidunt tempor ut nec ante. Etiam velit libero, interdum in tempor nec, molestie ac augue.</del></div><div><!--block-->&nbsp;</div>";
            ctrl.testTrixModelText = "";

            ctrl.fechaEtapa = '';
            ctrl.fechaEtapaForzarCierre = '';
            ctrl.aceptadoEtapa = false;
            ctrl.usuarioEtapaSiguiente = {};
            ctrl.usuarioEtapaAnterior = {};
            ctrl.justificacionEtapa = '';
            ctrl.solicitudEtapaModel = {};

            ctrl.rolProcesoList = [];
            ctrl.camposList = [];
            ctrl.templatesPendientesList = [];
            ctrl.templatesPendientesAccesoDirectoList = [];
            ctrl.templatesCargadosList = [];
            ctrl.procesoTemplateSeleccionado = {};

            ctrl.listadoDeProcesos = [];
            ctrl.listadoDeProcesos_doc = [];
            ctrl.listadoAutorizadasEtapa = [];

            ctrl.gruposList = [];
            ctrl.procesosList = [];
            ctrl.solicitudPadre = {};
            ctrl.solicitudesPadreList = [];

            ctrl.listadoUsuariosAutorizanSolicitudEtapa = [];
            ctrl.listaUsuariosDerivarResponsabilidadTmp = [];
            ctrl.listaUsuariosDerivarResponsabilidad = [];
            ctrl.listadoHistorialAutorizaciones = [];
            ctrl.siguienteEstadoUsuariosList = [];
            ctrl.siguienteEstadoUsuariosListTmp = [];
            ctrl.anteriorEstadoUsuariosList = [];
            ctrl.anteriorEstadoUsuariosListTmp = [];
            ctrl.siguienteEstadoSolicitud = {};
            ctrl.anteriorEstadoSolicitud = {};

            ctrl.solicitudesHijoList = [];
            ctrl.historialSolicitud = [];
            ctrl.TrazabilidadSolicitud = [];

            ctrl.campoUsuarioList = [];
            ctrl.campoTemplateList = [];
            ctrl.campoJerarquiaList = [];

            ctrl.grupoUsuariosObj = {
                grupo1: 0,
                grupo1Obj: {
                    gruposUsuariosRelacion: null,
                    GrupoIsAutorizated: false
                },
                grupo2: 0,
                grupo2Obj: {
                    gruposUsuariosRelacion: null,
                    GrupoIsAutorizated: false
                },
                grupo3: 0,
                grupo3Obj: {
                    gruposUsuariosRelacion: null,
                    GrupoIsAutorizated: false
                },
                grupo1Lectores: 0,
                grupo1LectoresObj: {
                    gruposUsuariosRelacion: null
                },
                grupo2Lectores: 0,
                grupo2LectoresObj: {
                    gruposUsuariosRelacion: null
                },
                grupo3Lectores: 0,
                grupo3LectoresObj: {
                    gruposUsuariosRelacion: null
                },
                grupoUsersSiguienteEtapa: null,
                grupoUsersSiguienteEtapaV2: null
            };

            ctrl.jerarquia = {}
            ctrl.jerarquia.Permisos = {
                grupo1Etapa2Id: null,
                grupo2Etapa2Id: null,
                grupo3Etapa2Id: null,
                grupo1Etapa3Id: null,
                grupo2Etapa3Id: null,
                grupo3Etapa3Id: null,
                grupo1Etapa4Id: null,
                grupo2Etapa4Id: null,
                grupo3Etapa4Id: null,
                grupo1Etapa5Id: null,
                grupo2Etapa5Id: null,
                grupo3Etapa5Id: null,
                grupo1EtapaLectoresId: null,
                grupo2EtapaLectoresId: null,
                grupo3EtapaLectoresId: null
            }

            /*
             * STEPER
             */
            ctrl.myDynamicClassStep = "step";
            ctrl.ConstantcheckText = "✔";
            ctrl.ConstantCssDone = "step stepDone";
            ctrl.ConstantCssstepOnIt = "step stepOnIt";

            ctrl.step1Text = 1;
            ctrl.step2Text = 2;
            ctrl.step3Text = 3;
            ctrl.step4Text = 4;
            ctrl.step5Text = 5;

            ctrl.objSteps = [];


            function Step(id, ngclass, text, label) {
                this.id = id;
                this.ngclass = ngclass;
                this.text = text;
                this.label = label;
            };

            function setStep(indice) {
                angular.forEach(ctrl.objSteps, function (value, key) {
                    if (value.id <= indice) {
                        value.ngclass = ctrl.ConstantCssDone;
                        value.Imgtext = ctrl.ConstantcheckText;
                    } else {
                        value.ngclass = ctrl.myDynamicClassStep;
                        value.Imgtext = value.id;
                        return;
                    }
                });
            };

            ctrl.testTrix = function () { }

            this.$onInit = function () {
                authData = sharedService.getLoggedUser();

                if (authData != null && authData.Id > 0) {
                    ctrl.lUsuarioLogeado = authData;
                    loadView(authData);
                } else
                    $state.go('auth');
            };

            ctrl.trixInitialize = function (e, editor) {
            };
            ctrl.trixChange = function (e, editor) {
                var document = editor.getDocument()
                ctrl.testTrixModelText = document.toString();
            };

            function fillStepsEtapas() {
                //model.Proceso.EtapasNombres
                if (ctrl.model != null && ctrl.model.Proceso != null) {
                    var etapas = ctrl.model.Proceso.EtapasNombres;
                    var estadIdActual = ctrl.model.EstadoId;
                    var contador = 1;
                    ctrl.cantidadEtapas = 1;
                    if (etapas != null && etapas != undefined) {
                        for (var i = 0; i < etapas.length; i++) {
                            var etapanombre = etapas[i].NombreEtapa;
                            var step1 = new Step();
                            step1.id = ctrl.cantidadEtapas;
                            step1.ngclass = ctrl.myDynamicClassStep;
                            step1.Imgtext = ctrl.cantidadEtapas;
                            step1.label = etapanombre;
                            ctrl.objSteps.push(step1);
                            ctrl.cantidadEtapas += 1;
                            if (etapanombre == "Cerrado") {
                                break;
                            }
                        }
                        if (estadIdActual != 6) {
                            setStep(estadIdActual);
                        } else {
                            setStep(ctrl.cantidadEtapas);
                        }
                    }

                }
            }

            function listarAutorizadasEtapa() {
                if ($stateParams.id != null && $stateParams.id != undefined &&
                    ctrl.model.EstadoId != null && ctrl.model.EstadoId != undefined) {
                    dataService.listarAutorizaciones($stateParams.id, ctrl.model.EstadoId)
                        .then(function (response) {
                            if (response.data.Success) {
                                ctrl.listadoAutorizadasEtapa = response.data.Value;
                                if (ctrl.lProcesoIsDocumentalAutorizacionesV2 && ctrl.IdSolicitudEtapa == 1) {
                                    if (!ctrl.lsuarioLogueadoIsSysAdmin && ctrl.lsuarioLogueadoIsEditorDocV2)
                                        ctrl.showDelete = false;
                                }
                                verifyGruposListadoAutorizados();
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage());
                        });
                } else {
                }
            }

            ctrl.actionAddOnClick = function (j, item) {
                item.SourceObjetoTemp = item.SourceObjetoTemp.filter(function (item) {
                    return item.Id != j.Id;
                });
                item.SourceObjeto = item.SourceObjetoTemp;
                if (item.ValorObjeto === null) {
                    item.ValorObjeto = [];
                }
                item.ValorObjeto.push(j);
                item.TextoBusqueda = "";
            };

            ctrl.actionRemoveOnClick = function (j, item) {
                item.ValorObjeto = item.ValorObjeto.filter(function (item) {
                    return item.Id != j.Id;
                });
                item.SourceObjeto.push(j);
                item.SourceObjetoTemp = item.SourceObjeto;
                item.TextoBusqueda = "";
            };

            ctrl.RechazarAction = function () {
                if (ctrl.AutorizarMsg == undefined || ctrl.AutorizarMsg == "") {
                    Swal.fire({
                        title: "Debe ingresar comentario.",
                        type: "warning",
                        showCancelButton: false,
                        confirmButtonColor: "#3085d6",
                        confirmButtonText: "Aceptar",
                        cancelButtonText: "Cancel",
                        heightAuto: false,
                    }).then(function (result) { });
                    return;
                }
                var obj = {
                    UsuarioId: authData.Id,
                    SolicitudId: $stateParams.id,
                    EtapaId: ctrl.model.EstadoId,
                    Comentario: ctrl.AutorizarMsg,
                    EtapaNombre: ctrl.model.SolicitudEtapaNombre,
                };
                sharedService.showLoading();
                dataService.rechazarAutorizacion(obj).then(
                    function (response) {
                        if (response.data.Success) {
                            Swal.fire({
                                title: "Autorización Rechazada Correctamente.",
                                type: "success",
                                showCancelButton: false,
                                confirmButtonColor: "#3085d6",
                                confirmButtonText: "Aceptar",
                                heightAuto: false,
                            }).then(function (result) {
                                //.then((result) => {
                                //listarAutorizadasEtapa();
                                $state.reload();
                            });
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                    },
                    function (error) {
                        toastr.error(
                            error.data || sharedService.getGenericErrorMessage()
                        );
                    }
                );
            };

            ctrl.AutorizarAction = function () {
                if (ctrl.AutorizarMsg == undefined || ctrl.AutorizarMsg == "") {
                    Swal.fire({
                        title: 'Debe ingresar comentario.',
                        type: 'warning',
                        showCancelButton: false,
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'Aceptar',
                        heightAuto: false
                    })
                        .then(function (result) {

                        });
                    return;
                }
                var obj = {
                    UsuarioId: authData.Id,
                    SolicitudId: $stateParams.id,
                    EtapaId: ctrl.model.EstadoId,
                    Comentario: ctrl.AutorizarMsg,
                    EtapaNombre: ctrl.model.SolicitudEtapaNombre
                };
                sharedService.showLoading();
                dataService.guardarAutorizacion(obj)
                    .then(function (response) {
                        if (response.data.Success) {
                            Swal.fire({
                                title: 'Autorización Guardada Correctamente.',
                                type: 'success',
                                showCancelButton: false,
                                confirmButtonColor: '#3085d6',
                                confirmButtonText: 'Aceptar',
                                heightAuto: false
                            })
                                .then(function (result) {
                                    //.then((result) => {
                                    $state.reload();
                                    //listarAutorizadasEtapa();
                                });
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage());
                    });
            }

            function getJerarquiaAutorizaciones() {
                if (ctrl.model.Proceso.autorizaciones) {
                    var campoIdAutorizacion = ctrl.model.Proceso.campoIdAutorizacion;

                    var jerarquiaIdValor = 0;
                    if (campoIdAutorizacion != null && campoIdAutorizacion != undefined && campoIdAutorizacion != 0) {
                        listarAutorizadasEtapa();
                    }
                    angular.forEach(ctrl.camposList, function (value, key) {
                        if (value.CampoId == campoIdAutorizacion && value.Valor != "") {
                            jerarquiaIdValor = value.Valor;
                            getJerarquiaById(campoIdAutorizacion, jerarquiaIdValor);
                            listadoUsuariosAutorizanSolicitudEtapa(campoIdAutorizacion);
                            historialAutorizaciones();
                        }
                    });
                } else {
                    return;
                }
            }

            //function para GEstion documental V2
            // Objetivo Verificar si mi usuario es miembro de algun grupo de la Jerarquia y puede crear Solicitud
            ctrl.isUserAbleToCreateDocument = function (campoAutorizacion, jerarquiaIdValor) {
                dataService.isUserAbleToCreateDocumentFromJerarquia(ctrl.model.ProcesoId, jerarquiaIdValor)
                    .then(function (response) {
                        if (response.data.Success) {
                            if (response.data.Value == "false" || response.data.Value == false) {
                                Swal.fire({
                                    title: 'No tienes permisos de Edicion para la Nomenclatura Documental.',
                                    type: 'success',
                                    showCancelButton: false,
                                    confirmButtonColor: '#3085d6',
                                    confirmButtonText: 'Aceptar',
                                    heightAuto: false
                                })
                                    .then(function (result) {
                                        ctrl.goListado();
                                    });
                            } else {
                                var jerarquiaTemp = null;
                                dataService.getJerarquiaById(jerarquiaIdValor)
                                    .then(function (response) {
                                        if (response.data.Success) {
                                            jerarquiaTemp = response.data.Value;
                                            if (jerarquiaTemp != undefined && jerarquiaTemp.TieneJerarquiaPermisosCampos) {
                                                dataService.getJerarquiaProcesoCampos(ctrl.model.ProcesoId, jerarquiaIdValor)
                                                    .then(function (response) {
                                                        if (response.data.Success) {
                                                            ctrl.procesoCamposListJerarquia = response.data.Value.Resultados;
                                                            ctrl.camposList = ctrl.camposList.filter(function (item) {
                                                                return ctrl.procesoCamposListJerarquia.some(function (c) {
                                                                    return item.CampoId == c.campoId
                                                                });
                                                            });
                                                        } else {
                                                            toastr.error(response.data.ErrorSummary);
                                                        }
                                                        ctrl.isSearching = false;
                                                    }, function (error) {
                                                        toastr.error(error.data || sharedService.getGenericErrorMessage());
                                                        ctrl.isSearching = false;
                                                    });
                                            }
                                        } else {
                                            toastr.error(response.data.ErrorSummary);
                                        }
                                        ctrl.isSearching = false;
                                    }, function (error) {
                                        toastr.error(error.data || sharedService.getGenericErrorMessage());
                                        ctrl.isSearching = false;
                                    });


                            }
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage());
                    });
            }

            ctrl.isUserAbleToCreateDocumentFromSolicitud = function () {
                ctrl.lDocIsUserAbleToCreateDocumentV2 = false;
                var isAutorizacionesDocumentalV2 = ctrl.model.Proceso.campoIdAutorizacion;
                if (ctrl.model.Id != 0 && isAutorizacionesDocumentalV2 && ctrl.IdSolicitudEtapa == 6) {
                    dataService.isUserAbleToCreateDocumentFromSolicitud(ctrl.model.Id)
                        .then(function (response) {
                            if (response.data.Success) {
                                if (response.data.Value == "false" || response.data.Value == false) {
                                    ctrl.lDocIsUserAbleToCreateDocumentV2 = false;
                                } else {
                                    ctrl.lDocIsUserAbleToCreateDocumentV2 = true;
                                }
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage());
                        });
                }
            }

            ctrl.userTieneMarcaObsoleto = function () {
                ctrl.userTieneMarcaObsoleto = false;
                var isAutorizacionesDocumentalV2 = ctrl.model.Proceso.campoIdAutorizacion;
                if (ctrl.model.Id != 0 && isAutorizacionesDocumentalV2 && ctrl.IdSolicitudEtapa == 6) {
                    dataService.checkIfUserTieneMarcaObsoleto(ctrl.model.Id)
                        .then(function (response) {
                            if (response.data.Success) {
                                if (response.data.Value == "false" || response.data.Value == false) {
                                    ctrl.userTieneMarcaObsoleto = false;
                                } else {
                                    ctrl.userTieneMarcaObsoleto = true;
                                }
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage());
                        });
                }
            }


            //listado Usuarios Autorizan Solicitud Segun la Etapa Actual
            function listadoUsuariosAutorizanSolicitudEtapa(campoAutorizacion) {
                if (ctrl.model.Proceso.autorizacionesDocumental) {
                    dataService.listadoUsuariosAutorizanSolicitudEtapa(ctrl.model.Id, campoAutorizacion)
                        .then(function (response) {
                            if (response.data.Success) {
                                ctrl.listadoUsuariosAutorizanSolicitudEtapa = response.data.Value;
                                checkIfUserIsAllowedToAutorizeByEtapa(); //V2
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage());
                        });
                }
            }

            //Historial de autorizaciones de todas las etapas.
            function historialAutorizaciones() {
                if (ctrl.model.Proceso.autorizacionesDocumental) {
                    dataService.historialAutorizaciones(ctrl.model.Id)
                        .then(function (response) {
                            if (response.data.Success) {
                                ctrl.listadoHistorialAutorizaciones = response.data.Value;
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage());
                        });
                }
            }

            //Mediante el campo de autorizacion o id de la jerarquia obteine la jerarquia completa con permisos.
            // tambien recibe como filtro la solicitud ID
            function getJerarquiaById(campoAutorizacion, jerarquiaIdValor) {
                dataService.getJerarquiaAutorizacionesById(ctrl.model.Id, campoAutorizacion)
                    .then(function (response) {
                        if (response.data.Success) {
                            ctrl.jerarquia = response.data.Value;
                            gruposByEtapa();
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage());
                    });
            }

            function gruposByEtapa() {
                switch (ctrl.model.EstadoId) {
                    case 1:
                        ctrl.grupoUsuariosObj.grupo1Obj = validateNullUndefined(ctrl.jerarquia.Permisos.grupo1Etapa2);
                        ctrl.grupoUsuariosObj.grupo2Obj = validateNullUndefined(ctrl.jerarquia.Permisos.grupo2Etapa2);
                        ctrl.grupoUsuariosObj.grupo3Obj = validateNullUndefined(ctrl.jerarquia.Permisos.grupo3Etapa2);
                        ctrl.grupoUsuariosObj.grupoUsersSiguienteEtapa = ctrl.jerarquia.Permisos.grupo1Etapa2;
                        ctrl.grupoUsuariosObj.grupoUsersSiguienteEtapaV2 = ctrl.jerarquia.Permisos.grupo1Etapa3;
                        break;
                    case 2:
                        if (ctrl.jerarquia.Permisos != null) {
                            ctrl.grupoUsuariosObj.grupo1Obj = validateNullUndefined(ctrl.jerarquia.Permisos.grupo1Etapa2);
                            ctrl.grupoUsuariosObj.grupo2Obj = validateNullUndefined(ctrl.jerarquia.Permisos.grupo2Etapa2);
                            ctrl.grupoUsuariosObj.grupo3Obj = validateNullUndefined(ctrl.jerarquia.Permisos.grupo3Etapa2);

                            ctrl.grupoUsuariosObj.grupoUsersSiguienteEtapa = ctrl.jerarquia.Permisos.grupo1Etapa3;
                            ctrl.grupoUsuariosObj.grupoUsersSiguienteEtapaV2 = ctrl.jerarquia.Permisos.grupo1Etapa4;
                        }
                        break;
                    case 3:
                        if (ctrl.jerarquia.Permisos != null) {
                            ctrl.grupoUsuariosObj.grupo1Obj = validateNullUndefined(ctrl.jerarquia.Permisos.grupo1Etapa3);
                            ctrl.grupoUsuariosObj.grupo2Obj = validateNullUndefined(ctrl.jerarquia.Permisos.grupo2Etapa3);
                            ctrl.grupoUsuariosObj.grupo3Obj = validateNullUndefined(ctrl.jerarquia.Permisos.grupo3Etapa3);

                            ctrl.grupoUsuariosObj.grupoUsersSiguienteEtapa = ctrl.jerarquia.Permisos.grupo1Etapa4;
                            ctrl.grupoUsuariosObj.grupoUsersSiguienteEtapaV2 = ctrl.jerarquia.Permisos.grupo1Etapa5;
                        }
                        break;
                    case 4:
                        if (ctrl.jerarquia.Permisos != null) {
                            ctrl.grupoUsuariosObj.grupo1Obj = validateNullUndefined(ctrl.jerarquia.Permisos.grupo1Etapa4);
                            ctrl.grupoUsuariosObj.grupo2Obj = validateNullUndefined(ctrl.jerarquia.Permisos.grupo2Etapa4);
                            ctrl.grupoUsuariosObj.grupo3Obj = validateNullUndefined(ctrl.jerarquia.Permisos.grupo3Etapa4);

                            ctrl.grupoUsuariosObj.grupoUsersSiguienteEtapa = ctrl.jerarquia.Permisos.grupo1Etapa5;
                            ctrl.grupoUsuariosObj.grupoUsersSiguienteEtapaV2 = ctrl.jerarquia.Permisos.grupo1Etapa6;
                        }
                        break;
                    case 5:
                        if (ctrl.jerarquia.Permisos != null) {
                            ctrl.grupoUsuariosObj.grupo1Obj = validateNullUndefined(ctrl.jerarquia.Permisos.grupo1Etapa5);
                            ctrl.grupoUsuariosObj.grupo2Obj = validateNullUndefined(ctrl.jerarquia.Permisos.grupo2Etapa5);
                            ctrl.grupoUsuariosObj.grupo3Obj = validateNullUndefined(ctrl.jerarquia.Permisos.grupo3Etapa5);
                        }
                        break;
                    case 6:
                        break;
                    default:
                        break;
                }

                checkIfUserIsAllowedToAutorize(ctrl.grupoUsuariosObj.grupo1Obj);
                checkIfUserIsAllowedToAutorize(ctrl.grupoUsuariosObj.grupo2Obj);
                checkIfUserIsAllowedToAutorize(ctrl.grupoUsuariosObj.grupo3Obj);
                verifyGruposListadoAutorizados();

                var campoIdAutorizacion = ctrl.model.Proceso.campoIdAutorizacion;
                var isAutorizacionesDocumentalV2 = ctrl.model.Proceso.autorizacionesDocumental;
                var isAutorizaciones = ctrl.model.Proceso.autorizaciones;
                if (isAutorizacionesDocumentalV2 && isAutorizaciones &&
                    campoIdAutorizacion != null && campoIdAutorizacion != undefined && campoIdAutorizacion != 0) {
                    fillUsuariosEtapaSiguiente(ctrl.grupoUsuariosObj.grupoUsersSiguienteEtapaV2);
                } else {
                    fillUsuariosEtapaSiguiente(ctrl.grupoUsuariosObj.grupoUsersSiguienteEtapa);
                }
            }

            function fillUsuariosEtapaSiguiente(obj) {
                ctrl.siguienteEstadoUsuariosList = [];
                ctrl.siguienteEstadoUsuariosListTmp = [];
                if (obj != null && obj != undefined) {
                    angular.forEach(obj.gruposUsuariosRelacion, function (value, key) {
                        ctrl.siguienteEstadoUsuariosList.push(value.Usuario);
                        ctrl.siguienteEstadoUsuariosListTmp.push(value.Usuario);
                    });
                }
            }

            function validateNullUndefined(obj) {
                if (obj != null && obj != undefined)
                    return obj;
                else {
                    return null;
                }
            }

            function verifyGruposListadoAutorizados() {
                if (ctrl.grupoUsuariosObj.grupo1Obj != null ||
                    ctrl.grupoUsuariosObj.grupo1Obj.gruposUsuariosRelacion != null ||
                    ctrl.grupoUsuariosObj.grupo1Obj.gruposUsuariosRelacion != undefined ||
                    ctrl.grupoUsuariosObj.grupo1Obj.gruposUsuariosRelacion.length > 0) {
                    ctrl.grupoUsuariosObj.grupo1Obj.GrupoIsAutorizated = false;
                } else {
                    if (ctrl.grupoUsuariosObj.grupo1Obj == null) {
                        ctrl.grupoUsuariosObj.grupo1Obj = {};
                        ctrl.grupoUsuariosObj.grupo1Obj.GrupoIsAutorizated = true;
                    }
                }
                if (ctrl.grupoUsuariosObj.grupo2Obj != null) {
                    ctrl.grupoUsuariosObj.grupo2Obj.GrupoIsAutorizated = true;
                    if (ctrl.grupoUsuariosObj.grupo2Obj.gruposUsuariosRelacion != null ||
                        ctrl.grupoUsuariosObj.grupo2Obj.gruposUsuariosRelacion != undefined) {
                        if (ctrl.grupoUsuariosObj.grupo2Obj.gruposUsuariosRelacion.length > 0) {
                            ctrl.grupoUsuariosObj.grupo2Obj.GrupoIsAutorizated = false;
                        }
                    }
                } else {
                    if (ctrl.grupoUsuariosObj.grupo2Obj == null) {
                        ctrl.grupoUsuariosObj.grupo2Obj = {};
                        ctrl.grupoUsuariosObj.grupo2Obj.GrupoIsAutorizated = true;
                    }
                }
                if (ctrl.grupoUsuariosObj.grupo3Obj != null) {
                    ctrl.grupoUsuariosObj.grupo3Obj.GrupoIsAutorizated = true;
                    if (ctrl.grupoUsuariosObj.grupo3Obj.gruposUsuariosRelacion != null ||
                        ctrl.grupoUsuariosObj.grupo3Obj.gruposUsuariosRelacion != undefined) {
                        if (ctrl.grupoUsuariosObj.grupo3Obj.gruposUsuariosRelacion.length > 0) {
                            ctrl.grupoUsuariosObj.grupo3Obj.GrupoIsAutorizated = false;
                        }
                    }
                } else {
                    if (ctrl.grupoUsuariosObj.grupo3Obj == null) {
                        ctrl.grupoUsuariosObj.grupo3Obj = {};
                        ctrl.grupoUsuariosObj.grupo3Obj.GrupoIsAutorizated = true;
                    }
                }

                angular.forEach(ctrl.listadoAutorizadasEtapa, function (value, key) {
                    var objAutorizacion = value;
                    checkIfUserhasAutorized(ctrl.grupoUsuariosObj.grupo1Obj, objAutorizacion);
                    checkIfUserhasAutorized(ctrl.grupoUsuariosObj.grupo2Obj, objAutorizacion);
                    checkIfUserhasAutorized(ctrl.grupoUsuariosObj.grupo3Obj, objAutorizacion);



                });
            }

            function checkIfUserhasAutorized(obj, objAutorizacion) {
                ctrl.active2 = 77;
                if (obj != null && obj.gruposUsuariosRelacion != null) {
                    angular.forEach(obj.gruposUsuariosRelacion, function (value, key) {
                        if (value.Usuario.Id == objAutorizacion.UsuarioId) {
                            if (value.Usuario.Id == authData.Id) {
                                ctrl.usuarioPuedeAutorizar = false; //No debe poder autorizar ya lo hizo..
                                ctrl.usuarioYaAutorizo = true;
                            }
                            obj.GrupoIsAutorizated = true;
                            value.hasAutorized = true;
                            value.Comentario = objAutorizacion.Comentario;
                            value.FechaAutorizacion = objAutorizacion.CreationDate;
                        }
                    });
                }

                if (ctrl.lProcesoIsDocumentalAutorizacionesV2) {
                    if (objAutorizacion.UsuarioId == authData.Id) {
                        ctrl.usuarioPuedeAutorizar = false; //No debe poder autorizar ya lo hizo..
                        ctrl.usuarioYaAutorizo = true;
                    } else {
                        ctrl.active2 = 77;
                    }
                }
            }

            function checkIfUserIsAllowedToAutorize(obj) {
                if (!ctrl.lProcesoIsDocumentalAutorizacionesV2) {
                    if (obj != null && obj.gruposUsuariosRelacion != null) {
                        angular.forEach(obj.gruposUsuariosRelacion, function (value, key) {
                            if (value.Usuario.Id == authData.Id) {
                                ctrl.usuarioPuedeAutorizar = true;
                            } else {
                            }
                        });
                    }
                }
            }

            function checkIfUserIsAllowedToAutorizeByEtapa(obj) {
                if (ctrl.lProcesoIsDocumentalAutorizacionesV2) {
                    angular.forEach(ctrl.listadoUsuariosAutorizanSolicitudEtapa, function (objPermiso, key) {
                        angular.forEach(objPermiso.gruposUsuariosRelacion, function (value, key) {
                            if (value.Usuario.Id == authData.Id) {
                                ctrl.usuarioPuedeAutorizar = true;
                            } else {
                            }
                        });
                    });
                }
            }

            function loadView(authData) {
                ctrl.puedeVerBtnQuitarPadre = sharedService.isSysAdminLoggedUser();

                if ($stateParams.id != "0") {
                    ctrl.title = 'Editar Datos de Carga del Proceso';
                    ctrl.buttonSaveCabeceraText = 'Guardar Cabecera';

                    dataService.getSolicitudById($stateParams.id)
                        .then(function (response) {
                            if (response.data.Success) {
                                ctrl.model = response.data.Value;
                                if (ctrl.model != null && ctrl.model.Id > 0) {
                                    ctrl.procesomcaOcultaAvanzarEtapa =  ctrl.model.Proceso.mcaOcultaAvanzarEtapa;
                                    ctrl.lProcesoIsDocumental = ctrl.model.Proceso.isDocumental;
                                    ctrl.lProcesoIsDocumentalAutorizacionesV2 = ctrl.model.Proceso.autorizacionesDocumental;
                                    ctrl.IdSolicitudEtapa = ctrl.model.Estado.Id;
                                    ctrl.lsuarioLogueadoIsSysAdmin = sharedService.isSysAdminLoggedUser();
                                    ctrl.motivoBloqueo = 'Cargando datos...';
                                    ctrl.showDelete = true;
                                    ctrl.fechaEtapa = ctrl.getFecha();
                                    ctrl.fechaEtapaForzarCierre = ctrl.getFecha();
                                    if (ctrl.model.SolicitudPadre != null && ctrl.model.SolicitudPadreId > 0)
                                        ctrl.solicitudesPadreList.push(ctrl.model.SolicitudPadre);

                                    //En la primer etapa no figura si aprueba o no en la vista. Aprueba por default
                                    if (ctrl.model.Estado.Codigo == 'ALTA') {
                                        ctrl.aceptadoEtapa = 1;
                                    }
                                    ctrl.puedeEditarSolicitud = puedeEditarSolicitud(ctrl.model, ctrl.rolProcesoList, authData.Id);
                                    ctrl.puedeEditarCampos = puedeEditarCampos(ctrl.model, ctrl.model.UsuarioCreacionId, authData.Id, ctrl.rolProcesoList);
                                    ctrl.puedeCargarTemplates = puedeCargarTemplates(ctrl.model, ctrl.rolProcesoList, authData.Id);
                                    ctrl.mostrarAprobacion = mostrarAprobacion(ctrl.model, authData.Id, ctrl.rolProcesoList);
                                    ctrl.anularVista = !sharedService.isSysAdminLoggedUser();
                                    onInitShowHideItemsModelSolicitud();

                                    dataService.getRolProcesoByProcesoUsuario(ctrl.model.Id, ctrl.model.ProcesoId, authData.Id)
                                        .then(function (response) {
                                            if (response.data.Success) {
                                                ctrl.rolProcesoList = response.data.Value;
                                                ctrl.showProcesosHijosEtapaActual = etapaActualProcesaHijos(ctrl.model, authData.Id, ctrl.rolProcesoList);
                                                ctrl.lsuarioLogueadoIsAdminProceso = usuariosLogueadoIsAdminProceso(ctrl.model, authData.Id, ctrl.rolProcesoList);
                                                ctrl.lsuarioLogueadoIsSupervisorProceso = userIsSupervisor(ctrl.model, ctrl.rolProcesoList, authData.Id);
                                                ctrl.lsuarioLogueadoIsEditorDocV2 = usuariosLogueadoIsEditor(ctrl.model, authData.Id, ctrl.rolProcesoList);
                                                if (sharedService.isSysAdminLoggedUser() ||
                                                    (ctrl.rolProcesoList != null && ctrl.rolProcesoList.length > 0)) {
                                                    ctrl.anularVista = false;
                                                    ctrl.puedeEditarSolicitud = puedeEditarSolicitud(ctrl.model, ctrl.rolProcesoList, authData.Id);
                                                    ctrl.puedeEditarCampos = puedeEditarCampos(ctrl.model, ctrl.model.UsuarioCreacionId, authData.Id, ctrl.rolProcesoList);
                                                    ctrl.puedeCargarTemplates = puedeCargarTemplates(ctrl.model, ctrl.rolProcesoList, authData.Id);
                                                    ctrl.mostrarAprobacion = mostrarAprobacion(ctrl.model, authData.Id, ctrl.rolProcesoList);
                                                    ctrl.fechaEtapa = ctrl.getFecha();
                                                    ctrl.isAdministradorProceso = puedeEditarSolicitud(ctrl.model, ctrl.rolProcesoList, authData.Id);
                                                    getSolicitudCampos();
                                                } else {
                                                    ctrl.showProcesosHijosEtapaActual = false;
                                                    ctrl.anularVista = true;
                                                    ctrl.motivoBloqueo = 'No tiene permisos para visualizar o realizar acciones sobre este proceso.';
                                                }
                                                ctrl.listaUsuariosDerivar(ctrl);
                                            } else {
                                                ctrl.showProcesosHijosEtapaActual = false;
                                                toastr.error(response.data.ErrorSummary);
                                            }
                                            ctrl.viewLoading = false;
                                        }, function (error) {
                                            toastr.error(error.data || sharedService.getGenericErrorMessage());
                                            ctrl.viewLoading = false;
                                        });

                                    ctrl.buscarSolicitudesHijo(true);
                                    ctrl.showForzarCierreEtapa = showForzarCierreEtapa(ctrl.model);
                                    if (sharedService.isSysAdminLoggedUser() || authData.Id == ctrl.model.UsuarioAprobadorId || ctrl.isAdministradorProceso) {
                                        if (ctrl.showForzarCierreEtapa) {
                                            ctrl.showForzarCierre = true;
                                        } else {
                                            ctrl.showForzarCierre = false;
                                        }
                                    } else {
                                        ctrl.showForzarCierre = false;
                                    }

                                    ctrl.isDatosSiguienteEstadoLoading = true;
                                    dataService.getSiguienteEstadoSolicitud($stateParams.id)
                                        .then(function (response) {
                                            if (response.data.Success) {
                                                ctrl.siguienteEstadoSolicitud = response.data.Value;

                                                if (ctrl.siguienteEstadoSolicitud != null && ctrl.siguienteEstadoSolicitud.Id > 0) {
                                                    dataService.getUsuarioListByProcesoEstado(ctrl.model.ProcesoId, $stateParams.id, ctrl.siguienteEstadoSolicitud.Id)
                                                        .then(function (response) {
                                                            if (response.data.Success) {
                                                                ctrl.siguienteEstadoUsuariosList = response.data.Value;
                                                                ctrl.siguienteEstadoUsuariosListTmp = response.data.Value;
                                                            } else {
                                                                toastr.error(response.data.ErrorSummary);
                                                            }
                                                            ctrl.isDatosSiguienteEstadoLoading = false;
                                                        }, function (error) {
                                                            toastr.error(error.data || sharedService.getGenericErrorMessage());
                                                            ctrl.isDatosSiguienteEstadoLoading = false;
                                                        });
                                                } else
                                                    ctrl.isDatosSiguienteEstadoLoading = false;
                                            } else {
                                                toastr.error(response.data.ErrorSummary);
                                                ctrl.isDatosSiguienteEstadoLoading = false;
                                            }
                                        }, function (error) {
                                            toastr.error(error.data || sharedService.getGenericErrorMessage());
                                            ctrl.isDatosSiguienteEstadoLoading = false;
                                        });

                                    ctrl.isDatosAnteriorEstadoLoading = true;
                                    dataService.getAnteriorEstadoSolicitud($stateParams.id)
                                        .then(function (response) {
                                            if (response.data.Success) {
                                                ctrl.anteriorEstadoSolicitud = response.data.Value;

                                                if (ctrl.anteriorEstadoSolicitud != null && ctrl.anteriorEstadoSolicitud.Id > 0) {
                                                    dataService.getUsuarioListByProcesoEstado(ctrl.model.ProcesoId, $stateParams.id, ctrl.anteriorEstadoSolicitud.Id)
                                                        .then(function (response) {
                                                            if (response.data.Success) {
                                                                ctrl.anteriorEstadoUsuariosList = response.data.Value;
                                                                ctrl.anteriorEstadoUsuariosListTmp = response.data.Value;
                                                            } else {
                                                                toastr.error(response.data.ErrorSummary);
                                                            }
                                                            ctrl.isDatosAnteriorEstadoLoading = false;
                                                        }, function (error) {
                                                            toastr.error(error.data || sharedService.getGenericErrorMessage());
                                                            ctrl.isDatosAnteriorEstadoLoading = false;
                                                        });
                                                } else
                                                    ctrl.isDatosAnteriorEstadoLoading = false;
                                            } else {
                                                toastr.error(response.data.ErrorSummary);
                                                ctrl.isDatosAnteriorEstadoLoading = false;
                                            }
                                        }, function (error) {
                                            toastr.error(error.data || sharedService.getGenericErrorMessage());
                                            ctrl.isDatosAnteriorEstadoLoading = false;
                                        });

                                    ctrl.historialIsSearching = true;
                                    dataService.getSolicitudEtapaBySolicitud($stateParams.id)
                                        .then(function (response) {
                                            if (response.data.Success) {
                                                ctrl.historialSolicitud = response.data.Value;
                                            } else {
                                                toastr.error(response.data.ErrorSummary);
                                            }
                                            ctrl.historialIsSearching = false;
                                        }, function (error) {
                                            toastr.error(error.data || sharedService.getGenericErrorMessage());
                                            ctrl.historialIsSearching = false;
                                        });
                                    ctrl.getHistorialTrazabilidadSolicitud();
                                    //if (ctrl.model.Estado.Codigo != 'APRO' && ctrl.model.Estado.Codigo != 'CERR') {
                                    if (ctrl.lProcesoIsDocumental || (ctrl.model.Estado.Codigo != 'APRO' && ctrl.model.Estado.Codigo != 'CERR')) {
                                        ctrl.templatePendientesIsSearching = true;
                                        dataService.getTemplatePendientesBySolicitudList($stateParams.id)
                                            .then(function (response) {
                                                if (response.data.Success) {
                                                    ctrl.templatesPendientesList = response.data.Value;
                                                    ctrl.mostrarTemplates = mostrarTemplates(ctrl.templatesPendientesList);
                                                    ctrl.templatesPendientesAccesoDirectoList = [];

                                                    if (ctrl.templatesPendientesList != null && ctrl.templatesPendientesList.length > 0) {
                                                        for (var i = 0; i < ctrl.templatesPendientesList.length; i++) {
                                                            if (ctrl.templatesPendientesList[i].EsAccesoDirecto)
                                                                ctrl.templatesPendientesAccesoDirectoList.push(ctrl.templatesPendientesList[i]);
                                                        }
                                                    }
                                                } else {
                                                    toastr.error(response.data.ErrorSummary);
                                                }
                                                ctrl.templatePendientesIsSearching = false;
                                            }, function (error) {
                                                toastr.error(error.data || sharedService.getGenericErrorMessage());
                                                ctrl.templatePendientesIsSearching = false;
                                            });
                                    }
                                    fillStepsEtapas();
                                    ctrl.isUserAbleToCreateDocumentFromSolicitud();
                                    ctrl.userTieneMarcaObsoleto();
                                    if (ctrl.model.Proceso.mcaOcultaAvanzarEtapa) {
                                        ctrl.active = 1;
                                    }
                                } else {
                                    ctrl.anularVista = true;
                                    ctrl.motivoBloqueo = 'No se encuentra la carga de proceso seleccionado.';
                                }
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }

                            ctrl.viewLoading = false;
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage());
                            ctrl.viewLoading = false;
                        });
                } else {
                    ctrl.active = 1;
                    ctrl.title = 'Crear Datos de Carga del Proceso';
                    ctrl.buttonSaveCabeceraText = 'Crear Proceso';
                    ctrl.isBusy = true;

                    var solicitudPadreId = 0;
                    if ($stateParams.solicitudPadreId != null)
                        solicitudPadreId = $stateParams.solicitudPadreId;

                    dataService.getSolicitudDefault($stateParams.proceso, solicitudPadreId)
                        .then(function (response) {
                            if (response.data.Success) {
                                ctrl.model = response.data.Value;
                                ctrl.isNew = true;
                                if (ctrl.model != null) {
                                    ctrl.lProcesoIsDocumental = ctrl.model.Proceso.isDocumental;
                                    ctrl.lProcesoIsDocumentalAutorizacionesV2 = ctrl.model.Proceso.autorizacionesDocumental;
                                    ctrl.IdSolicitudEtapa = ctrl.model.Estado.Id;
                                    ctrl.lsuarioLogueadoIsSysAdmin = sharedService.isSysAdminLoggedUser();
                                    ctrl.motivoBloqueo = 'Cargando datos...';
                                    ctrl.fechaEtapa = ctrl.getFecha();
                                    ctrl.puedeEditarSolicitud = puedeEditarSolicitud(ctrl.model, ctrl.rolProcesoList, authData.Id);
                                    ctrl.puedeEditarCampos = puedeEditarCampos(ctrl.model, ctrl.model.UsuarioCreacionId, authData.Id, ctrl.rolProcesoList);
                                    ctrl.puedeCargarTemplates = puedeCargarTemplates(ctrl.model, ctrl.rolProcesoList, authData.Id);
                                    ctrl.mostrarAprobacion = mostrarAprobacion(ctrl.model, authData.Id, ctrl.rolProcesoList);
                                    ctrl.anularVista = !sharedService.isSysAdminLoggedUser();
                                    onInitShowHideItemsModelSolicitud();

                                    if (ctrl.model.SolicitudPadre != null && ctrl.model.SolicitudPadreId > 0)
                                        ctrl.solicitudesPadreList.push(ctrl.model.SolicitudPadre);

                                    dataService.getRolProcesoByProcesoUsuario(ctrl.model.Id, ctrl.model.ProcesoId, authData.Id)
                                        .then(function (response) {
                                            if (response.data.Success) {
                                                ctrl.rolProcesoList = response.data.Value;
                                                ctrl.lsuarioLogueadoIsAdminProceso = usuariosLogueadoIsAdminProceso(ctrl.model, authData.Id, ctrl.rolProcesoList);
                                                if (sharedService.isSysAdminLoggedUser() ||
                                                    (ctrl.rolProcesoList != null && ctrl.rolProcesoList.length > 0)) {
                                                    ctrl.puedeEditarSolicitud = puedeEditarSolicitud(ctrl.model, ctrl.rolProcesoList, authData.Id);
                                                    ctrl.puedeEditarCampos = puedeEditarCampos(ctrl.model, ctrl.model.UsuarioCreacionId, authData.Id, ctrl.rolProcesoList);
                                                    ctrl.puedeCargarTemplates = puedeCargarTemplates(ctrl.model, ctrl.rolProcesoList, authData.Id);
                                                    ctrl.mostrarAprobacion = mostrarAprobacion(ctrl.model, authData.Id, ctrl.rolProcesoList);
                                                    ctrl.lsuarioLogueadoIsSupervisorProceso = userIsSupervisor(ctrl.model, ctrl.rolProcesoList, authData.Id);
                                                    ctrl.anularVista = !ctrl.puedeEditarSolicitud;
                                                } else {
                                                    ctrl.anularVista = true;
                                                    ctrl.motivoBloqueo = 'No tiene permisos para visualizar o realizar acciones sobre este proceso.';
                                                }
                                            } else {
                                                toastr.error(response.data.ErrorSummary);
                                            }
                                            ctrl.viewLoading = false;
                                        }, function (error) {
                                            toastr.error(error.data || sharedService.getGenericErrorMessage());
                                            ctrl.viewLoading = false;
                                        });

                                    ctrl.isCamposLoading = true;
                                    dataService.getSolicitudCampoValorDefault(ctrl.model)
                                        .then(function (response) {
                                            if (response.data.Success) {
                                                ctrl.camposList = response.data.Value;
                                                if (ctrl.camposList != null && ctrl.camposList.length > 0) {
                                                    ctrl.mostrarCamposBoton = true;
                                                    for (var i = 0; i < ctrl.camposList.length; i++) {
                                                        loadProcesoCampoData(ctrl.camposList, i, ctrl.camposList[i].Campo.CampoTipo);
                                                    }
                                                }
                                                ctrl.isBusy = false;
                                            } else {
                                                toastr.error(response.data.ErrorSummary);
                                            }
                                            ctrl.isCamposLoading = false;
                                            ctrl.runModal();
                                        }, function (error) {
                                            toastr.error(error.data || sharedService.getGenericErrorMessage());
                                            ctrl.isCamposLoading = false;
                                        });

                                    ctrl.historialIsSearching = true;
                                    dataService.getSolicitudEtapaBySolicitud($stateParams.id)
                                        .then(function (response) {
                                            if (response.data.Success) {
                                                ctrl.historialSolicitud = response.data.Value;
                                            } else {
                                                toastr.error(response.data.ErrorSummary);
                                            }
                                            ctrl.historialIsSearching = false;
                                        }, function (error) {
                                            toastr.error(error.data || sharedService.getGenericErrorMessage());
                                            ctrl.historialIsSearching = false;
                                        });
                                    ctrl.getHistorialTrazabilidadSolicitud();
                                    fillStepsEtapas();
                                } else {
                                    ctrl.anularVista = true;
                                    ctrl.motivoBloqueo = 'No se encuentra la carga de proceso seleccionado.';
                                }
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                            ctrl.viewLoading = false;
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage());
                            ctrl.viewLoading = false;
                        });
                } //Fin Load Datos Proceso View - Crear

            }

            ctrl.runModal = function () {
                if (ctrl.model != null && ctrl.model.Id == 0) {
                    if (ctrl.lProcesoIsDocumental && ctrl.lProcesoIsDocumentalAutorizacionesV2) {
                        ctrl.showModalDataContainer = true;
                        var htmlCode = document.getElementById("divContainerData");
                        Swal.fire({
                            title: '<strong>Parametros Iniciales</strong>',
                            onOpen: function () {
                                //Swal.disableButtons();
                            },
                            type: 'warning',
                            html: htmlCode,
                            showCloseButton: true,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            showCancelButton: true,
                            focusConfirm: false,
                            confirmButtonText: 'Aceptar',
                            confirmButtonAriaLabel: 'Aceptar',
                            cancelButtonText: 'Cancel',
                            cancelButtonColor: '#ff6a00c9',
                            heightAuto: false,
                            preConfirm: function () { }
                        }).then(function (result) {
                            if (result.dismiss != null && (result.dismiss == "cancel" || result.dismiss == "close")) {
                                ctrl.goListado();
                            }
                            if (result.value) {
                                validarDatosModal();
                            }
                        });
                    }
                }
            }

            function validarDatosModal() {
                var campoIdAutorizacion = ctrl.model.Proceso.campoIdAutorizacion;
                var jerarquiaIdValor = 0;
                angular.forEach(ctrl.camposList, function (value, key) {
                    if (value.CampoId == campoIdAutorizacion && value.Valor != "") {
                        jerarquiaIdValor = value.Valor;
                        ctrl.isUserAbleToCreateDocument(campoIdAutorizacion, jerarquiaIdValor);
                    }
                });
                if (jerarquiaIdValor == 0) {
                    ctrl.runModal();
                }
            }

            ctrl.getHistorialTrazabilidadSolicitud = function () {
                ctrl.TrazabilidadSolicitud = [];
                ctrl.historialIsSearchingTrazabilidad = true;
                dataService.getSolicitudTrazabilidad(ctrl.model.ProcesoId, ctrl.model.Id, ctrl.model.Numero)
                    .then(function (response) {
                        if (response.data.Success) {
                            ctrl.TrazabilidadSolicitud = response.data.Value;
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                        ctrl.historialIsSearchingTrazabilidad = false;
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage());
                        ctrl.historialIsSearchingTrazabilidad = false;
                    });

            }

            function getSolicitudCampos() {
                ctrl.isCamposLoading = true;

                if ($stateParams.id != undefined) {
                    if (ctrl.puedeEditarCampos) {
                        dataService.getSolicitudCampoValorCompleto($stateParams.id)
                            .then(function (response) {
                                if (response.data.Success) {
                                    ctrl.camposList = response.data.Value;
                                    if (ctrl.camposList != null && ctrl.camposList.length > 0) {
                                        ctrl.mostrarCamposBoton = true;
                                        for (var i = 0; i < ctrl.camposList.length; i++) {
                                            loadProcesoCampoData(ctrl.camposList, i, ctrl.camposList[i].Campo.CampoTipo);
                                        }
                                    }

                                    //TODO:HAVERJAN
                                    var campoIdAutorizacion = 0;
                                    campoIdAutorizacion = ctrl.model.Proceso.campoIdAutorizacion;
                                    console.log("ASAAAAA!!!!!********************");
                                    console.log(campoIdAutorizacion);
                                    var jerarquiaIdValor = 0;
                                    if (campoIdAutorizacion != 0) {
                                        console.log(ctrl.camposList);
                                        angular.forEach(ctrl.camposList, function (value, key) {
                                            if (value.CampoId == campoIdAutorizacion && value.Valor != "") {
                                                jerarquiaIdValor = value.Valor;
                                                console.log(jerarquiaIdValor);
                                                console.log("******");
                                                var jerarquiaItems = value.ValorObjeto;
                                                console.log(value.ValorObjeto);
                                                var jerarquiaTemp = null;
                                                angular.forEach(jerarquiaItems, function (value, key) {
                                                    if (value.Id == jerarquiaIdValor) {
                                                        jerarquiaTemp = value;
                                                    }
                                                });
                                                console.log("Jerarquia Temp ");
                                                console.log(jerarquiaTemp);
                                                if (jerarquiaTemp.TieneJerarquiaPermisosCampos) {
                                                    dataService.getJerarquiaProcesoCampos(ctrl.model.ProcesoId, jerarquiaIdValor)
                                                        .then(function (response) {
                                                            console.log(response);
                                                            if (response.data.Success) {
                                                                ctrl.procesoCamposListJerarquia = response.data.Value.Resultados;
                                                                ctrl.camposList = ctrl.camposList.filter(function (item) {
                                                                    return ctrl.procesoCamposListJerarquia.some(function (c) {
                                                                        return item.CampoId == c.campoId
                                                                    });
                                                                });
                                                            } else {
                                                                toastr.error(response.data.ErrorSummary);
                                                            }
                                                            ctrl.isSearching = false;
                                                        }, function (error) {
                                                            toastr.error(error.data || sharedService.getGenericErrorMessage());
                                                            ctrl.isSearching = false;
                                                        });
                                                }
                                            }
                                        });
                                    }

                                    //GET AUTORIZACIONES!!!
                                    getJerarquiaAutorizaciones();
                                } else {
                                    toastr.error(response.data.ErrorSummary);
                                }
                                ctrl.isCamposLoading = false;
                            }, function (error) {
                                toastr.error(error.data || sharedService.getGenericErrorMessage());
                                ctrl.isCamposLoading = false;
                            });
                    } else {
                        dataService.getSolicitudCampoValorTextosCompleto($stateParams.id)
                            .then(function (response) {
                                if (response.data.Success) {
                                    ctrl.camposList = response.data.Value;
                                    if (ctrl.camposList != null) {
                                        for (var i = 0; i < ctrl.camposList.length; i++) {
                                            loadProcesoCampoDataReadOnly(i, ctrl.camposList[i].Campo.CampoTipo);
                                        }
                                    }
                                    //GET AUTORIZACIONES!!!
                                    getJerarquiaAutorizaciones();
                                } else {
                                    toastr.error(response.data.ErrorSummary);
                                }
                                ctrl.isCamposLoading = false;
                            }, function (error) {
                                toastr.error(error.data || sharedService.getGenericErrorMessage());
                                ctrl.isCamposLoading = false;
                            });
                    }
                }

            }

            function usuariosLogueadoIsAdminProceso(model, loggedUserId, roles) {
                var response = false;
                if (roles != null && roles.length > 0) {
                    for (var i = 0; i < roles.length; i++) {
                        if (roles[i].Codigo == 'ADMIN') {
                            response = true;
                        }
                    }

                    var rolId = "6";
                    ctrl.lsuarioLogueadoIsLectorOnly = checkifUserhasOneRol(rolId, roles);
                    rolId = "7";
                    ctrl.lsuarioLogueadoIsNoCreateOnly = checkifUserhasOneRol(rolId, roles);

                }
                return response;
            }


            function usuariosLogueadoIsEditor(model, loggedUserId, roles) {
                var response = false;
                if (roles != null && roles.length > 0) {
                    for (var i = 0; i < roles.length; i++) {
                        if (roles[i].Codigo == 'Admin-Editor') {
                            response = true;
                        }
                    }
                }
                return response;
            }

            function checkifUserhasOneRol(rolId, roles) {
                if (roles != null && roles.length > 0) {
                    if (roles.length == 1) {
                        for (var i = 0; i < roles.length; i++) {
                            if (roles[i].Id == rolId) {
                                return true;
                            }
                        }
                    }
                }
                return false;
            }

            function etapaActualProcesaHijos(model, loggedUserId, roles) {
                var response = false;
                angular.forEach(model.Proceso.EtapasNombres, function (value, key) {
                    if (value.NombreEtapa == model.SolicitudEtapaNombre) {
                        response = value.procesoHijo;

                        if (response) {
                            if (sharedService.isSysAdminLoggedUser() || loggedUserId == model.UsuarioAprobadorId) {
                                response = true;
                            } else {
                                response = false;
                            }

                            if (roles != null && roles.length > 0) {
                                for (var i = 0; i < roles.length; i++) {
                                    if (roles[i].Codigo == 'ADMIN')
                                        response = true;
                                }
                            }

                        }

                    }
                });
                return response;
            };

            function showForzarCierreEtapa(model) {
                var response = false;
                angular.forEach(model.Proceso.EtapasNombres, function (value, key) {
                    if (value.NombreEtapa == model.SolicitudEtapaNombre) {
                        response = value.forzarCierre;
                    }
                });
                return response;
            };

            ctrl.agregarSolicitudHijo = function () {
                if (ctrl.model.Proceso.AceptaHijos == null || !ctrl.model.Proceso.AceptaHijos) {
                    toastr.error('No puede agregar hijos a un proceso que no acepta hijos');
                    return;
                }

                ctrl.isBusy = true;

                var confirmation = $uibModal.open({
                    animation: true,
                    component: "seleccionProceso",
                    resolve: {
                        title: function () {
                            return "Selección de Proceso para el Proceso Hijo"
                        },
                        aceptaHijos: function () {
                            return ctrl.model.Proceso.AceptaHijos
                        },
                        procesoPadreId: function () {
                            return ctrl.model.Proceso.Id
                        },
                    }
                });

                confirmation.result.then(function (returnValue) {
                    ctrl.isBusy = false;
                    var absHost = $location.absUrl();

                    //var urlTogo =  "http://localhost:3000/#/solicitud/edit/0/0/16/7282
                    var arrayHost = absHost.split("#");
                    absHost = arrayHost[0];

                    absHost = absHost + "#/solicitud/edit/0/0/" + returnValue.ProcesoSeleccionado.Id + "/" + ctrl.model.Id;
                    window.open(absHost, '_blank');
                    /*$state.go("pages.solicitud-edit", {
                        id: 0,
                        grupo: returnValue.GrupoSeleccionado.Id,
                        proceso: returnValue.ProcesoSeleccionado.Id,
                        solicitudPadreId: ctrl.model.Id
                    });*/
                }, function () {
                    ctrl.isBusy = false;
                });
            }

            ctrl.buscarSolicitudesHijo = function () {
                ctrl.solicitudesHijoIsSearching = true;
                dataService.getSolicitudesByPadre($stateParams.id, ctrl.verTodosProcesosAsociados)
                    .then(function (response) {
                        if (response.data.Success) {
                            ctrl.solicitudesHijoList = response.data.Value;
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                        ctrl.solicitudesHijoIsSearching = false;
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage());
                        ctrl.solicitudesHijoIsSearching = false;
                    });
            }

            ctrl.buscarTemplatesCargados = function buscarTemplatesCargados(tableState) {
                ctrl.templateCargadosIsSearching = true;
                var cargadosFilter = {};
                cargadosFilter.SolicitudId = $stateParams.id;

                if (tableState.search.predicateObject != null) {
                    cargadosFilter.Titulo = tableState.search.predicateObject.Resumen;
                    cargadosFilter.SolicitudEtapaNombre = tableState.search.predicateObject.SolicitudEtapaNombre;
                    cargadosFilter.Template = tableState.search.predicateObject.Template;
                    cargadosFilter.LastUpdate = tableState.search.predicateObject.LastUpdate;
                    cargadosFilter.UsuarioModificacion = tableState.search.predicateObject.UsuarioModificacion;
                }

                if (tableState.sort != null) {
                    cargadosFilter.OrderFieldName = tableState.sort.predicate;
                    cargadosFilter.OrderAscending = !tableState.sort.reverse;
                }

                dataService.getCargadosBySolicitudList(cargadosFilter)
                    .then(function (response) {
                        if (response.data.Success) {
                            ctrl.templatesCargadosList = response.data.Value;
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                        ctrl.templateCargadosIsSearching = false;
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage());
                        ctrl.templateCargadosIsSearching = false;
                    });
            }

            ctrl.totalProcesosHijo = function () {
                return (ctrl.solicitudesHijoList != null && Object.keys(ctrl.solicitudesHijoList).length > 1);
            }

            ctrl.borrarSolicitudPadre = function (solicitudSeleccionada) {
                if (solicitudSeleccionada == null || solicitudSeleccionada.Id <= 0) {
                    toastr.error('Debe seleccionar un proceso para poder eliminarlo');
                    return;
                }

                ctrl.model.SolicitudPadre = null;
                ctrl.model.SolicitudPadreId = null;

                ctrl.solicitudesPadreList = [];
            }

            ctrl.verSolicitudPadre = function (solicitudSeleccionada) {
                if (solicitudSeleccionada == null || solicitudSeleccionada.Id <= 0) {
                    toastr.error('Debe seleccionar un proceso para poder visualizarlo');
                    return;
                }

                $state.go("pages.solicitud-edit", {
                    id: solicitudSeleccionada.Id,
                    grupo: solicitudSeleccionada.Proceso.GrupoId,
                    proceso: solicitudSeleccionada.ProcesoId,
                    solicitudPadreId: 0
                });
            }

            ctrl.verSolicitudHijo = function (solicitudSeleccionada) {
                if (solicitudSeleccionada == null || solicitudSeleccionada.Id <= 0) {
                    toastr.error('Debe seleccionar un proceso para poder visualizarlo');
                    return;
                }

                $state.go("pages.solicitud-edit", {
                    id: solicitudSeleccionada.Id,
                    grupo: solicitudSeleccionada.Proceso.GrupoId,
                    proceso: solicitudSeleccionada.ProcesoId,
                    solicitudPadreId: 0
                });
            }

            function mostrarAprobacion(solicitud, loggedUserId, roles) {
                if (solicitud == null || solicitud.Id == 0)
                    return false;

                if (solicitud.Estado.Codigo == 'APRO' || solicitud.Estado.Codigo == 'CERR')
                    return false;

                if (sharedService.isSysAdminLoggedUser())
                    return true;

                if (solicitud.Estado.Codigo == 'ALTA' &&
                    loggedUserId != null && loggedUserId == solicitud.UsuarioCreacionId)
                    return true;

                // if (solicitud.UsuarioAprobadorId == null)
                //   return true;

                if (loggedUserId != null && loggedUserId == solicitud.UsuarioAprobadorId)
                    return true;

                if (roles != null && roles.length > 0) {
                    for (var i = 0; i < roles.length; i++) {
                        if (roles[i].Codigo == 'ADMIN')
                            return true;
                    }
                }

                return false;
            }

            ctrl.mostrarControlesAprobacion = function (solicitudEstadoCodigo) {
                return (solicitudEstadoCodigo == 'GENE' ||
                    solicitudEstadoCodigo == 'ACEP' ||
                    solicitudEstadoCodigo == 'VALI' ||
                    solicitudEstadoCodigo == 'VERI');
            }

            ctrl.mostrarComboSiguienteEstado = function (solicitudEstadoCodigo) {
                return (solicitudEstadoCodigo == 'GENE' ||
                    solicitudEstadoCodigo == 'ACEP' ||
                    solicitudEstadoCodigo == 'VALI' ||
                    solicitudEstadoCodigo == 'VERI');
            }

            ctrl.puedeEditarDescripcion = function (solicitud) {
                return (ctrl.puedeEditarSolicitud &&
                    !(solicitud.Proceso.ConfiguracionTitulo != null && solicitud.Proceso.ConfiguracionTitulo.length > 0));
            }

            ctrl.puedeRetrocederEstado = function (solicitud) {
                return (ctrl.mostrarAprobacion &&
                    !ctrl.anularVista &&
                    ctrl.anteriorEstadoSolicitud != null && ctrl.anteriorEstadoSolicitud.Id > 0 &&
                    solicitud != null && solicitud.Id > 0 &&
                    solicitud.Estado.Codigo != 'ALTA' &&
                    solicitud.Estado.Codigo != 'APRO' &&
                    solicitud.Estado.Codigo != 'CERR');
            }

            ctrl.puedeAvanzarEstado = function (solicitud) {
                return (ctrl.mostrarAprobacion &&
                    !ctrl.anularVista &&
                    ctrl.siguienteEstadoSolicitud != null && ctrl.siguienteEstadoSolicitud.Id > 0 &&
                    solicitud != null && solicitud.Id > 0 &&
                    solicitud.Estado.Codigo != 'APRO' &&
                    solicitud.Estado.Codigo != 'CERR');
            }


            function userIsSupervisor(solicitud, roles, loggedUserId) {
                if (roles != null && roles.length > 0) {
                    for (var i = 0; i < roles.length; i++) {
                        //if (roles[i].Codigo == 'ADMIN') {
                        //esAdmin = true;
                        //break;
                        //}
                        // if (roles[i].Codigo == 'LECTOR')
                        //   esLector = true;
                        if (roles[i].Codigo == 'SUPERV') {
                            return true;
                        }
                        // if (roles[i].Codigo == 'GESTOR' &&
                        //     solicitud.Estado.Codigo == 'ACEP')
                        //   esUsuarioAutorizador = true;

                        // if (roles[i].Codigo == 'VERIF' &&
                        //     solicitud.Estado.Codigo == 'VALI')
                        //   esUsuarioAutorizador = true;

                        // if (roles[i].Codigo == 'APROB' &&
                        //     solicitud.Estado.Codigo == 'VERI')
                        //   esUsuarioAutorizador = true;
                    }
                }

                //return true;
                return false;
            }

            function puedeEditarSolicitud(solicitud, roles, loggedUserId) {
                //Si la solicitud es nueva y tiene algun rol dentro del proceso, puede crearla
                if ((solicitud == null || solicitud.Id == 0) && (roles != null && roles.length > 0))
                    return true;

                //No puede hacer nada si la solicitud se aprobo o cerro
                if (solicitud != null && (solicitud.Estado.Codigo == 'APRO' || solicitud.Estado.Codigo == 'CERR'))
                    return false;

                if (sharedService.isSysAdminLoggedUser())
                    return true;

                //Si la solicitud esta en la primer etapa y el usuario logueado es el creador de la solicitud, puede editarla
                if (solicitud != null && solicitud.Id > 0 &&
                    solicitud.Estado.Codigo == 'ALTA' &&
                    loggedUserId == solicitud.UsuarioCreacionId)
                    return true;

                var esAdmin = false;
                // var esLector = false;
                // var esUsuarioAutorizador = false;

                if (roles != null && roles.length > 0) {
                    for (var i = 0; i < roles.length; i++) {
                        if (roles[i].Codigo == 'ADMIN') {
                            esAdmin = true;
                            break;
                        }

                        // if (roles[i].Codigo == 'LECTOR')
                        //   esLector = true;

                        // if (roles[i].Codigo == 'SUPERV' &&
                        //     solicitud.Estado.Codigo == 'GENE')
                        //   esUsuarioAutorizador = true;

                        // if (roles[i].Codigo == 'GESTOR' &&
                        //     solicitud.Estado.Codigo == 'ACEP')
                        //   esUsuarioAutorizador = true;

                        // if (roles[i].Codigo == 'VERIF' &&
                        //     solicitud.Estado.Codigo == 'VALI')
                        //   esUsuarioAutorizador = true;

                        // if (roles[i].Codigo == 'APROB' &&
                        //     solicitud.Estado.Codigo == 'VERI')
                        //   esUsuarioAutorizador = true;
                    }
                }

                //Si es admin, puede editarlo en cualquier momento
                if (esAdmin)
                    return true;

                // if (esUsuarioAutorizador)
                //   return true;                

                //return true;
                return false;
            }

            function puedeEditarCampos(solicitud, usuarioCreacionId, loggedUserId, roles) {
                //No puede hacer nada si la solicitud se aprobo o cerro
                if (solicitud != null && (solicitud.Estado.Codigo == 'APRO' || solicitud.Estado.Codigo == 'CERR'))
                    return false;

                if (sharedService.isSysAdminLoggedUser())
                    return true;

                if (roles != null && roles.length > 0) {
                    for (var i = 0; i < roles.length; i++) {
                        if (roles[i].Codigo == 'ADMIN')
                            return true;
                    }
                }

                //HAVERJAN..
                return (solicitud != null && solicitud.Estado.Codigo == 'ALTA' && usuarioCreacionId == loggedUserId);
            }

            function puedeCargarTemplates(solicitud, roles, loggedUserId) {
                //Si la solicitud es nueva y tiene algun rol dentro del proceso, puede crearla
                return true;
                if (solicitud == null || solicitud.Id == 0)
                    return false;

                //No puede hacer nada si la solicitud se aprobo o cerro
                if (solicitud != null && (solicitud.Estado.Codigo == 'APRO' || solicitud.Estado.Codigo == 'CERR'))
                    return false;

                if (sharedService.isSysAdminLoggedUser())
                    return true;

                return (roles != null && roles.length > 0);
            }

            function mostrarTemplates() {
                return true;
                return (ctrl.templatesPendientesList != null && ctrl.templatesPendientesList.length > 0);
            }

            ctrl.showConfirmar = function () {
                if (ctrl.model.Estado.Id > 0)
                    return true;
                else
                    return false;
            }

            ctrl.getFecha = function () {
                var fecha = new Date();

                var dd = fecha.getDate();
                var mm = fecha.getMonth() + 1;
                var yyyy = fecha.getFullYear();

                if (dd < 10) {
                    dd = '0' + dd
                }

                if (mm < 10) {
                    mm = '0' + mm
                }

                fecha = dd + '/' + mm + '/' + yyyy;
                return fecha;
            }

            function validateMandatoryFields() {
                if (ctrl.camposList != null) {
                    for (var i = 0; i < ctrl.camposList.length; i++) {
                        var nombre = ctrl.camposList[i].Campo.Nombre;
                        var lastCharacter = nombre.slice(-1);
                        if (lastCharacter == "*") {
                            var ValorObjeto = ctrl.camposList[i].ValorObjeto;
                            var Valor = ctrl.camposList[i].Valor;
                            if ((Valor == null || Valor == "") && (ValorObjeto == null || ValorObjeto == "")) {
                                return false;
                            }
                        }
                    }
                }
                return true;
            }

            ctrl.createSolicitud = function () {
                ctrl.isBusy = true;
                if (ctrl.camposList != null && ctrl.camposList.length > 0) {
                    ctrl.preSaveCamposSolicitud(); //Fix Error Constraint!
                }

                //funciton de validacion de campos obligatorios.
                if (!validateMandatoryFields()) {
                    ctrl.isBusy = false;
                    toastr.error("Hay Datos Obligatorios no cumplidos.");
                    return;
                }

                dataService.checkSolicitudCampoValor(ctrl.camposList)
                    .then(function (response) {
                        if (response.data.Success) {
                            if (response.data.Value == true) {
                                dataService.saveSolicitud(ctrl.model)
                                    .then(function (response) {
                                        if (response.data.Success) {
                                            ctrl.model = response.data.Value;
                                            if (ctrl.camposList != null && ctrl.camposList.length > 0) {
                                                ctrl.saveCamposSolicitud();
                                            } else {
                                                ctrl.isBusy = false;
                                                toastr.info("Operacion exitosa.");
                                                $state.go("pages.solicitud-edit", {
                                                    id: ctrl.model.Id,
                                                    grupo: $stateParams.grupo,
                                                    proceso: $stateParams.proceso,
                                                    solicitudPadreId: 0
                                                });
                                            }
                                        } else {
                                            toastr.error(response.data.ErrorSummary);
                                            ctrl.isBusy = false;
                                        }
                                    }, function (error) {
                                        toastr.error(error.data || sharedService.getGenericErrorMessage());
                                        ctrl.isBusy = false;
                                    });
                            } else {
                                ctrl.active = 1;
                                ctrl.isBusy = false;
                            }
                        } else {
                            ctrl.active = 1;
                            toastr.error(response.data.ErrorSummary);
                            ctrl.isBusy = false;
                        }
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage());
                        ctrl.isBusy = false;
                    });
                ctrl.active = 0;
            }

            ctrl.saveObsoleto = function () {
                ctrl.isBusy = true;
                dataService.saveObsoleto(ctrl.model)
                    .then(function (response) {
                        if (response.data.Success) {
                            ctrl.model = response.data.Value;
                            toastr.info("Operacion exitosa.");
                            ctrl.getHistorialTrazabilidadSolicitud();
                            $state.reload();
                            /*$state.go("pages.solicitud-edit", {
                                id: ctrl.model.Id,
                                grupo: $stateParams.grupo,
                                proceso: $stateParams.proceso,
                                solicitudPadreId: 0
                            });*/
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                        ctrl.isBusy = false;
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage());
                        ctrl.isBusy = false;
                    });
            }

            ctrl.saveSolicitud = function () {
                ctrl.isBusy = true;

                dataService.saveSolicitud(ctrl.model)
                    .then(function (response) {
                        if (response.data.Success) {
                            ctrl.model = response.data.Value;
                            toastr.info("Operacion exitosa.");

                            $state.go("pages.solicitud-edit", {
                                id: ctrl.model.Id,
                                grupo: $stateParams.grupo,
                                proceso: $stateParams.proceso,
                                solicitudPadreId: 0
                            });
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                        ctrl.isBusy = false;
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage());
                        ctrl.isBusy = false;
                    });
            }

            ctrl.saveSolicitudVersion = function () {
                ctrl.isBusy = true;
                ctrl.active = 0;
                dataService.saveSolicitudVersion(ctrl.model)
                    .then(function (response) {
                        if (response.data.Success) {
                            ctrl.model = response.data.Value;
                            ctrl.isBusy = false;
                            var respon = "Se ha creado la nueva version de la solicitud con numero: " + ctrl.model.NumeroCompleto;
                            toastr.info(respon);
                            ctrl.goListado();
                        } else {
                            toastr.error(response.data.ErrorSummary);
                            ctrl.isBusy = false;
                            $state.reload();
                        }
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage());
                        ctrl.isBusy = false;
                    });
            }

            ctrl.saveCrearCopia = function () {
                ctrl.isBusy = true;
                ctrl.active = 0;
                dataService.saveSolicitudCopia(ctrl.model)
                    .then(function (response) {
                        if (response.data.Success) {
                            ctrl.model = response.data.Value;
                            var respon = "Se ha creado la nueva solicitud con numero: " + ctrl.model.NumeroCompleto;
                            toastr.info(respon);
                            ctrl.isBusy = false;
                        } else {
                            toastr.error(response.data.ErrorSummary);
                            ctrl.isBusy = false;
                        }
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage());
                        ctrl.isBusy = false;
                    });
            }

            ctrl.preSaveCamposSolicitud = function () {
                ctrl.isBusy = true;
                if (ctrl.camposList != null) {
                    for (var i = 0; i < ctrl.camposList.length; i++) {
                        ctrl.camposList[i].SolicitudId = ctrl.model.Id;
                        ctrl.camposList[i].Solicitud = ctrl.model;
                        switch (ctrl.camposList[i].Campo.CampoTipo.Codigo) {
                            case 'TEXTENR':
                                var tmpValor = ctrl.camposList[i].ValorObjeto;
                                //tmpValor == '' ? ctrl.camposList[i].ValorObjeto:ctrl.camposList[i].Valor;
                                //tmpValor == '' || tmpValor ==  null ? ctrl.camposList[i].ValorObjeto:ctrl.camposList[i].Valor;
                                if (tmpValor != "" && tmpValor != null) {
                                    var colors = sharedService.getArrayColors(tmpValor);
                                    var lColor, lColorRGB;
                                    angular.forEach(colors, function (value, key) {
                                        lColorRGB = colors[key];
                                        if (!lColorRGB.startsWith('#')) {
                                            lColor = sharedService.RGB2Hex(colors[key]);
                                            //ctrl.camposList[i].Valor  = ctrl.camposList[i].Valor.replace(lColorRGB, lColor);
                                            ctrl.camposList[i].ValorObjeto = ctrl.camposList[i].ValorObjeto.replace(lColorRGB, lColor);
                                            /*if (ctrl.camposList[i].ValorObjeto != null && ctrl.camposList[i].ValorObjeto!= ""){
                                                ctrl.camposList[i].ValorObjeto  = ctrl.camposList[i].ValorObjeto.replace(lColorRGB, lColor);
                                            }*/
                                        }
                                    });
                                }
                                break;
                            case 'TABLE':
                                if (ctrl.camposList[i].TablaFilas != null) {
                                    var filaValor = "";
                                    for (var j = 0; j < ctrl.camposList[i].TablaFilas.length; j++) {
                                        if (j > 0)
                                            filaValor += "^";

                                        if (ctrl.camposList[i].TablaFilas[j].Valor != null) {
                                            var colValor = "";
                                            for (var k = 0; k < ctrl.camposList[i].TablaFilas[j].Valor.length; k++) {
                                                if (k > 0)
                                                    colValor += "~";

                                                colValor += ctrl.camposList[i].TablaFilas[j].Valor[k];
                                            }
                                            filaValor += colValor;
                                        }
                                    }
                                }
                                ctrl.camposList[i].Valor = filaValor;
                                ctrl.camposList[i].ValorObjeto = filaValor;
                                break;
                            case 'COND':
                                var tmpValorObjeto = ctrl.camposList[i].ValorObjeto;
                                try {
                                    var filaValor = "";
                                    if (ctrl.camposList[i].Campo.Columnas[0].ColumnaCampo.CampoTipo.Codigo == "ATTACH" ||
                                        ctrl.camposList[i].Campo.Columnas[0].ColumnaCampo.CampoTipo.Codigo == "IMG") {
                                        filaValor += ctrl.camposList[i].TablaFilas[0].Valor[0];
                                        filaValor += "~";
                                        filaValor += tmpValorObjeto;
                                    } else {
                                        if (ctrl.camposList[i].TablaFilas != null) {
                                            try {
                                                filaValor += ctrl.camposList[i].TablaFilas[0].Valor[0];
                                                filaValor += "~";
                                                filaValor += ctrl.camposList[i].TablaFilas[0].Valor[1];
                                            } catch (exception) {
                                                filaValor += "";
                                            }
                                        }
                                    }
                                } catch (ex) {
                                }
                                ctrl.camposList[i].Valor = filaValor;
                                ctrl.camposList[i].ValorObjeto = filaValor;
                                filaValor = "";
                                break;
                        }
                    }
                }
            }

            ctrl.saveCamposSolicitud = function () {
                ctrl.isBusy = true;
                if (ctrl.camposList != null) {
                    for (var i = 0; i < ctrl.camposList.length; i++) {
                        ctrl.camposList[i].SolicitudId = ctrl.model.Id;
                        ctrl.camposList[i].Solicitud = ctrl.model;

                        switch (ctrl.camposList[i].Campo.CampoTipo.Codigo) {
                            case 'TEXTENR':
                                var tmpValor = ctrl.camposList[i].ValorObjeto;
                                //tmpValor == '' || tmpValor ==  null ? ctrl.camposList[i].ValorObjeto:ctrl.camposList[i].Valor;
                                if (tmpValor != "" && tmpValor != null) {
                                    var colors = sharedService.getArrayColors(tmpValor);
                                    var lColor, lColorRGB;
                                    angular.forEach(colors, function (value, key) {
                                        lColorRGB = colors[key];
                                        if (!lColorRGB.startsWith('#')) {
                                            lColor = sharedService.RGB2Hex(colors[key]);
                                            ctrl.camposList[i].ValorObjeto = ctrl.camposList[i].ValorObjeto.replace(lColorRGB, lColor);
                                            if (ctrl.camposList[i].Valor != null && ctrl.camposList[i].Valor != "") {
                                                ctrl.camposList[i].Valor = ctrl.camposList[i].Valor.replace(lColorRGB, lColor);
                                            }
                                        }
                                    });
                                }
                                break;
                            case 'TABLE':

                                if (ctrl.camposList[i].TablaFilas != null) {
                                    var filaValor = "";

                                    for (var j = 0; j < ctrl.camposList[i].TablaFilas.length; j++) {
                                        if (j > 0)
                                            filaValor += "^";

                                        if (ctrl.camposList[i].TablaFilas[j].Valor != null) {
                                            var colValor = "";
                                            for (var k = 0; k < ctrl.camposList[i].TablaFilas[j].Valor.length; k++) {
                                                if (k > 0)
                                                    colValor += "~";

                                                colValor += ctrl.camposList[i].TablaFilas[j].Valor[k];
                                            }
                                            filaValor += colValor;
                                        }
                                    }
                                }
                                ctrl.camposList[i].Valor = filaValor;
                                ctrl.camposList[i].ValorObjeto = filaValor;
                                break;
                            case 'COND':
                                var tmpValorObjeto = ctrl.camposList[i].ValorObjeto;
                                try {
                                    var filaValor = "";
                                    if (ctrl.camposList[i].Campo.Columnas[0].ColumnaCampo.CampoTipo.Codigo == "ATTACH" ||
                                        ctrl.camposList[i].Campo.Columnas[0].ColumnaCampo.CampoTipo.Codigo == "IMG") {
                                        filaValor += ctrl.camposList[i].TablaFilas[0].Valor[0];
                                        filaValor += "~";
                                        filaValor += tmpValorObjeto;
                                    } else {
                                        if (ctrl.camposList[i].TablaFilas != null) {
                                            try {
                                                filaValor += ctrl.camposList[i].TablaFilas[0].Valor[0];
                                                filaValor += "~";
                                                filaValor += ctrl.camposList[i].TablaFilas[0].Valor[1];
                                            } catch (exception) {
                                                filaValor += "";
                                            }
                                        }
                                    }
                                } catch (ex) {
                                }
                                ctrl.camposList[i].Valor = filaValor;
                                ctrl.camposList[i].ValorObjeto = filaValor;
                                filaValor = "";
                                break;
                        }
                    }
                }

                /*
                 * Guadar la solicitud con sus campos y valores.
                 */
                dataService.saveSolicitudCampoValor(ctrl.camposList)
                    .then(function (response) {
                        if (response.data.Success) {
                            //ctrl.camposList = response.data.Value;
                            toastr.info("Operacion exitosa.");
                            if (ctrl.generaProcesoRelacionados) {
                                dataService.SaveSolicitudCampoValorGeneraProcesos(ctrl.camposList).then(function (data) {
                                    if (ctrl.isNew) {
                                        $state.go("pages.solicitud-edit", {
                                            id: ctrl.model.Id,
                                            grupo: $stateParams.grupo,
                                            proceso: $stateParams.proceso,
                                            solicitudPadreId: 0
                                        });
                                    } else {
                                        $state.reload();
                                    }
                                });
                            } else {
                                if (ctrl.isNew) {
                                    $state.go("pages.solicitud-edit", {
                                        id: ctrl.model.Id,
                                        grupo: $stateParams.grupo,
                                        proceso: $stateParams.proceso,
                                        solicitudPadreId: 0
                                    });
                                } else {
                                    $state.reload();
                                }
                            }
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                        ctrl.isBusy = false;
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage());
                        ctrl.isBusy = false;
                    });
            }

            ctrl.retrocederEtapa = function (form) {
                if (ctrl.model.Proceso.justificacionEsRequerida) {
                    if (ctrl.justificacionEtapa == "") {
                        toastr.error('Ingrese la justificación por favor');
                    }
                }

                if (ctrl.model.Id > 0) {
                    if (ctrl.aceptadoEtapa) {
                        toastr.error('No puede regresar a la etapa anterior si cierra el ciclo');
                        return;
                    }

                    if (ctrl.anteriorEstadoSolicitud == null) {
                        toastr.error('No hay etapa previa a la cual retroceder');
                        return;
                    }

                    if (ctrl.usuarioEtapaAnterior == null ||
                        !(ctrl.usuarioEtapaAnterior.Id > 0)) {
                        toastr.error('Seleccione un usuario para regresar a la etapa anterior');
                        return;
                    }

                    ctrl.isBusy = true;

                    ctrl.solicitudEtapaModel.SolicitudId = ctrl.model.Id;
                    ctrl.solicitudEtapaModel.SolicitudEstadoId = ctrl.model.EstadoId;
                    ctrl.solicitudEtapaModel.Comentarios = ctrl.justificacionEtapa;
                    ctrl.solicitudEtapaModel.Aprobado = ctrl.aceptadoEtapa;

                    if (ctrl.usuarioEtapaAnterior != null)
                        ctrl.solicitudEtapaModel.UsuarioAprobadorId = ctrl.usuarioEtapaAnterior.Id;

                    dataService.saveSolicitudEtapa(ctrl.solicitudEtapaModel)
                        .then(function (response) {
                            if (response.data.Success) {
                                toastr.info("Operacion exitosa.");
                                $state.reload();
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                            ctrl.isBusy = false;
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage());
                            ctrl.isBusy = false;
                        });

                    dataService.eliminarAutorizacionesEtapa(ctrl.solicitudEtapaModel.SolicitudId, ctrl.solicitudEtapaModel.SolicitudEstadoId)
                        .then(function (response) {
                            /*if (response.data.Success) {
                                //toastr.info("Operacion exitosa.");
                                //$state.reload();
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                            ctrl.isBusy = false;*/
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage());
                            ctrl.isBusy = false;
                        });
                } else {
                    toastr.error('Antes de retroceder de etapa, guarde la solicitud por favor');
                }
            }

            ctrl.avanzarEtapa = function (form) {

                if (!validateMandatoryFields()) {
                    ctrl.isBusy = false;
                    toastr.error("Hay Datos Obligatorios no cumplidos.");
                    return;
                }

                if (ctrl.model.Proceso.autorizaciones && (ctrl.model.EstadoId >= 2 && ctrl.model.EstadoId != 6)) {
                    if (ctrl.grupoUsuariosObj.grupo1Obj != null && ctrl.grupoUsuariosObj.grupo1Obj.GrupoIsAutorizated == false ||
                        ctrl.grupoUsuariosObj.grupo2Obj != null && ctrl.grupoUsuariosObj.grupo2Obj.GrupoIsAutorizated == false ||
                        ctrl.grupoUsuariosObj.grupo3Obj != null && ctrl.grupoUsuariosObj.grupo3Obj.GrupoIsAutorizated == false) {
                        toastr.error('La Solicitud no ha sido autorizada');
                        return;
                    }
                }

                if (ctrl.mostrarControlesAprobacion(ctrl.model.Estado.Codigo) && ctrl.model.Proceso.justificacionEsRequerida) {
                    if (ctrl.justificacionEtapa == "") {
                        toastr.error('Ingrese la justificación por favor');
                        return;
                    }
                }
                if (ctrl.model.Id > 0) {
                    if (!ctrl.aceptadoEtapa) {
                        toastr.error('No puede avanzar a la etapa siguiente si no cierra el ciclo');
                        return;
                    }

                    if (ctrl.siguienteEstadoSolicitud == null) {
                        toastr.error('No hay siguiente etapa a la cual avanzar');
                        return;
                    }

                    ctrl.isBusy = true;

                    ctrl.solicitudEtapaModel.SolicitudId = ctrl.model.Id;
                    ctrl.solicitudEtapaModel.SolicitudEstadoId = ctrl.model.EstadoId;
                    ctrl.solicitudEtapaModel.Comentarios = ctrl.justificacionEtapa;
                    ctrl.solicitudEtapaModel.Aprobado = ctrl.aceptadoEtapa;
                    ctrl.solicitudEtapaModel.forzarCierre = false;

                    if (ctrl.usuarioEtapaSiguiente != null)
                        ctrl.solicitudEtapaModel.UsuarioAprobadorId = ctrl.usuarioEtapaSiguiente.Id;

                    dataService.saveSolicitudEtapa(ctrl.solicitudEtapaModel)
                        .then(function (response) {
                            if (response.data.Success) {
                                toastr.info("Operacion exitosa.");
                                $state.reload();
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                            ctrl.isBusy = false;
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage());
                            ctrl.isBusy = false;
                        });
                } else {
                    toastr.error('Antes de avanzar de etapa, guarde la solicitud por favor');
                }
            }

            ctrl.forzarCierre = function (form) {
                if (ctrl.model.Id > 0) {
                    ctrl.isBusy = true;

                    ctrl.solicitudEtapaModel.SolicitudId = ctrl.model.Id;
                    ctrl.solicitudEtapaModel.SolicitudEstadoId = ctrl.model.EstadoId;
                    ctrl.solicitudEtapaModel.Comentarios = ctrl.justificacionEtapaForzarCierre;
                    ctrl.solicitudEtapaModel.Aprobado = true;
                    ctrl.solicitudEtapaModel.forzarCierre = true;

                    if (ctrl.usuarioEtapaSiguiente != null)
                        ctrl.solicitudEtapaModel.UsuarioAprobadorId = ctrl.usuarioEtapaSiguiente.Id;

                    dataService.saveSolicitudEtapa(ctrl.solicitudEtapaModel)
                        .then(function (response) {
                            if (response.data.Success) {
                                toastr.info("Operacion exitosa.");
                                $state.reload();
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                            ctrl.isBusy = false;
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage());
                            ctrl.isBusy = false;
                        });
                } else {
                    toastr.error('Antes de avanzar de etapa, guarde la solicitud por favor');
                }
            }

            ctrl.derivarEtapa = function (form) {
                if (ctrl.model.Id > 0) {
                    ctrl.isBusy = true;


                    ctrl.solicitudEtapaModel.SolicitudId = ctrl.model.Id;
                    ctrl.solicitudEtapaModel.SolicitudEstadoId = ctrl.model.EstadoId;
                    ctrl.solicitudEtapaModel.Comentarios = "Derivar Etapa a otro usuario";
                    ctrl.solicitudEtapaModel.Aprobado = ctrl.aceptadoEtapa;
                    ctrl.solicitudEtapaModel.forzarCierre = false;

                    if (ctrl.usuarioEtapaSiguienteDerivar != null)
                        ctrl.solicitudEtapaModel.UsuarioAprobadorId = ctrl.usuarioEtapaSiguienteDerivar.Id;

                    dataService.saveSolicitudEtapaDerivarRes(ctrl.solicitudEtapaModel)
                        .then(function (response) {
                            if (response.data.Success) {
                                toastr.info("Operacion exitosa.");
                                $state.reload();
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                            ctrl.isBusy = false;
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage());
                            ctrl.isBusy = false;
                        });
                } else {
                    toastr.error('Antes de avanzar de etapa, guarde la solicitud por favor');
                }
            }

            ctrl.goListado = function () {
                var grupoId = $stateParams.grupo;
                if (ctrl.model != null && ctrl.model.Proceso != null)
                    grupoId = ctrl.model.Proceso.GrupoId;

                $state.go("pages.solicitud", {
                    grupoId: grupoId,
                    procesoId: $stateParams.proceso
                });
            }

            ctrl.goBack = function () {
                $window.history.back();
            }
            ctrl.verDocumento = function (messageDestino) {
                //tipoDocumentoId
                //documentoPublicableId

                var tipoDocumentoId = ctrl.model.Proceso.tipoDocumentoId;
                var documentoPublicableId = ctrl.model.Proceso.documentoPublicableId;
                var linkDocumental = ctrl.model.Proceso.LinkDocumental;

                var campoForTipoDocumento, campoForDocumentoPublicable;

                angular.forEach(ctrl.camposList, function (value, key) {
                    if (value.CampoId == tipoDocumentoId && value.Valor != "") {
                        campoForTipoDocumento = value;
                    }
                    if (value.CampoId == documentoPublicableId && value.Valor != "") {
                        campoForDocumentoPublicable = value;
                    }
                });

                var tipoDocumentoOpcion;
                if (campoForTipoDocumento != null && campoForTipoDocumento.ValorObjeto != null && campoForTipoDocumento.ValorObjeto != undefined) {
                    var codigo = campoForTipoDocumento.ValorObjeto[0].Codigo;
                    if (codigo != null && codigo != undefined && codigo != "") {
                        if (codigo.toUpperCase() == "SKT-TIPOPUBLICACION-OP1") {
                            tipoDocumentoOpcion = 1;
                        }
                        if (codigo.toUpperCase() == "SKT-TIPOPUBLICACION-OP2") {
                            tipoDocumentoOpcion = 2;
                        }
                    }
                }
                if (tipoDocumentoOpcion == 1) {
                    if (campoForDocumentoPublicable != null && campoForDocumentoPublicable.Valor != null && campoForDocumentoPublicable.Valor != undefined && campoForDocumentoPublicable.Valor != "") {
                        ctrl.openAttachment(campoForDocumentoPublicable.Valor);
                    } else {
                        Swal.fire({
                            title: 'Debe configurar campo para documento publicable en el Proceso.',
                            type: 'warning',
                            showCancelButton: false,
                            confirmButtonColor: '#3085d6',
                            confirmButtonText: 'Aceptar',
                            cancelButtonText: 'Cancel',
                            heightAuto: false
                        })
                            .then(function (result) { });
                    }
                } else if (tipoDocumentoOpcion == 2) {
                    if (linkDocumental != null && linkDocumental != undefined && linkDocumental != "") {
                        linkDocumental = linkDocumental.replace("VarProcesoId", ctrl.model.ProcesoId);
                        linkDocumental = linkDocumental.replace("VarUsuarioId", authData.Id);
                        linkDocumental = linkDocumental.replace("varDestinoID", messageDestino);
                        linkDocumental = linkDocumental.replace("VarSolicitudId", ctrl.model.Id);
                        ctrl.generateImagesPdf(linkDocumental);
                    } else {
                        Swal.fire({
                            title: 'Debe configurar link en el Proceso.',
                            type: 'warning',
                            showCancelButton: false,
                            confirmButtonColor: '#3085d6',
                            confirmButtonText: 'Aceptar',
                            cancelButtonText: 'Cancel',
                            heightAuto: false
                        })
                            .then(function (result) { });
                    }
                }
            }

            ctrl.generateImagesPdf = function (linkDocumental) {
                Swal.fire({
                    title: 'Estamos trabajando para ti, Por favor espera.',
                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Aceptar',
                    cancelButtonText: 'Cancel',
                    showCloseButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    focusConfirm: false,
                    heightAuto: false,
                    onOpen: function () {
                        swal.showLoading();
                    }
                });

                dataService.generateImagesPdf(ctrl.model.Id)
                    .then(function (response) {
                        if (response.data.Success) {
                            swal.close();
                            window.open(linkDocumental, "_blank");
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                        ctrl.isBusy = false;
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage());
                        ctrl.isBusy = false;
                    });
            }

            ctrl.crearVersion = function () {
                ctrl.isBusy = true;
                var confirmation = $uibModal.open({
                    animation: true,
                    component: "confirmation",
                    resolve: {
                        title: function () {
                            return "Atención"
                        },
                        message: function () {
                            return "Esta seguro que desea crear una nueva Version?"
                        },
                    }
                });
                confirmation.result.then(function () {
                    ctrl.saveSolicitudVersion();
                }, function () {
                    ctrl.isBusy = false;
                });
            }

            ctrl.enviarObsoleto = function () {
                //ctrl.procesoIdObsoleto
                ctrl.isBusy = true;
                var confirmation = $uibModal.open({
                    animation: true,
                    component: "confirmation",
                    resolve: {
                        title: function () {
                            return "Atención"
                        },
                        message: function () {
                            return "Esta seguro que desea enviar el proceso a Obsoleto?"
                        },
                    }
                });

                confirmation.result.then(function () {
                    ctrl.model.ProcesoId = ctrl.model.Proceso.procesoIdObsoletos;
                    ctrl.saveObsoleto();
                }, function () {
                    ctrl.isBusy = false;
                });

            }
            ctrl.crearCopia = function () {
                ctrl.isBusy = true;
                var confirmation = $uibModal.open({
                    animation: true,
                    component: "confirmation",
                    resolve: {
                        title: function () {
                            return "Atención"
                        },
                        message: function () {
                            return "Esta seguro que desea crear una Copia?"
                        },
                    }
                });

                confirmation.result.then(function () {
                    ctrl.saveCrearCopia();
                }, function () {
                    ctrl.isBusy = false;
                });
            }

            ctrl.cargarAccesoDirectoTemplate = function (itemSeleccionado) {
                if (itemSeleccionado != null && itemSeleccionado.Id != null) {
                    ctrl.procesoTemplateSeleccionado = itemSeleccionado;
                    ctrl.cargarTemplate();
                }
            }

            ctrl.cargarTemplate = function () { //TODO:HAVERJAN => Cargar Template.
                if (ctrl.procesoTemplateSeleccionado != null && ctrl.procesoTemplateSeleccionado.Id != null) {
                    $state.go("pages.solicitud-template", {
                        solicitud: $stateParams.id,
                        solicitudEstado: ctrl.model.EstadoId,
                        procesoTemplate: ctrl.procesoTemplateSeleccionado.Id,
                        template: ctrl.procesoTemplateSeleccionado.TemplateId,
                        proceso: ctrl.procesoTemplateSeleccionado.ProcesoId,
                        solicitudProcesoTemplate: 0
                    });
                } else {
                    toastr.error('Debe seleccionar un template para iniciar su carga');
                }
            }

            ctrl.openTemplate = function (solicitudProcesoTemplate) {
                if (solicitudProcesoTemplate != null) {
                    $state.go("pages.solicitud-template", {
                        solicitud: solicitudProcesoTemplate.SolicitudId,
                        solicitudEstado: ctrl.model.EstadoId,
                        procesoTemplate: solicitudProcesoTemplate.ProcesoTemplateId,
                        template: solicitudProcesoTemplate.ProcesoTemplate.TemplateId,
                        proceso: solicitudProcesoTemplate.ProcesoTemplate.ProcesoId,
                        solicitudProcesoTemplate: solicitudProcesoTemplate.Id
                    });
                }
            }

            ctrl.openUrlLink = function (urlLink) {
                if (urlLink != undefined && urlLink != "") {
                    var urlLink = urlLink.replace("&solicitud", ctrl.model.Id);
                    urlLink = urlLink.replace("&SolicitudId", ctrl.model.Id);
                    window.open(urlLink, "_blank");
                }
            }
            ctrl.executeProcedure = function (item) {
                dataService.executeProcedure(item.UrlLink, ctrl.model.Id).then(function (response) {
                    Swal.fire({
                        title: "Procedimiento Ejecutado Correctamente",
                        type: "success",
                        showCancelButton: false,
                        confirmButtonColor: "#3085d6",
                        confirmButtonText: "Aceptar",
                        heightAuto: false,
                    }).then(function (result) {
                    });
                });
            }

            ctrl.delete = function () {
                ctrl.isBusy = true;
                var confirmation = $uibModal.open({
                    animation: true,
                    component: "confirmation",
                    resolve: {
                        title: function () {
                            return "Atención"
                        },
                        message: function () {
                            return "Confirma el borrado de la carga del proceso actual?"
                        },
                    }
                });

                confirmation.result.then(function (selectedItem) {
                    dataService.deleteSolicitud(ctrl.model.Id)
                        .then(function (response) {
                            if (response.data.Success) {
                                toastr.info("Operación exitosa.");

                                var grupoId = $stateParams.grupo;
                                if (ctrl.model != null && ctrl.model.Proceso != null)
                                    grupoId = ctrl.model.Proceso.GrupoId;

                                $state.go("pages.solicitud", {
                                    grupoId: grupoId,
                                    procesoId: $stateParams.proceso
                                });
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                            ctrl.isBusy = false;
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage());
                            ctrl.isBusy = false;
                        });
                }, function () {
                    ctrl.isBusy = false;
                });
            }

            ctrl.imprimirSolicitud = function () {
                window.open(appConfig.apiUrl + 'Solicitud/GenerarImpresion/' + ctrl.model.Id);
            }
            ctrl.imprimirCopiaControlada = function () {
                if (ctrl.copiaDestinadaA != undefined && ctrl.copiaDestinadaA != "") {
                    //window.open(appConfig.apiUrl + 'Solicitud/GenerarCopiaControlada/' + ctrl.model.Id + '/' + ctrl.lUsuarioLogeado.Id + '/' + ctrl.copiaDestinadaA);                    
                    ctrl.verDocumento(ctrl.copiaDestinadaA);
                } else {
                    toastr.error("Ingrese el destino de la copia");
                }
            }

            /******************* CAMPOS DEL PROCESO *******************/
            function loadProcesoCampoData(campoList, index, campoTipo) {
                if (campoTipo == null)
                    return;
                if (index < 0)
                    return;

                if (ctrl.camposList[index] == null)
                    return;

                switch (campoTipo.Codigo) {
                    case 'PROCEDURE':
                        ctrl.solicitudHasProceduresField = true;
                        ctrl.procesoGeneraProcesosRelacionados = ctrl.model.Proceso.generaProcesosRelacionados;
                        if (ctrl.procesoGeneraProcesosRelacionados) {
                            ctrl.generaProcesoRelacionados = true;//It will set the value.
                        }
                        break;
                    case 'VERSION':
                        ctrl.camposList[index].ValorObjeto = Number(ctrl.camposList[index].ValorObjeto);
                        break;
                    case 'INT':
                        ctrl.camposList[index].ValorObjeto = sharedService.addThousandSeparator(ctrl.camposList[index].ValorObjeto);
                        break;
                    case 'DECIMAL':
                        ctrl.camposList[index].ValorObjeto = sharedService.addThousandSeparator(ctrl.camposList[index].ValorObjeto);
                        break;
                    case 'DATE':
                        ctrl.camposList[index].ValorObjeto = sharedService.formatDate(ctrl.camposList[index].ValorObjeto);
                        break;
                    case 'JERARQ':
                        if (ctrl.camposList[index].ValorObjeto != null && ctrl.camposList[index].ValorObjeto.length > 0) {
                            for (var k = 0; k < ctrl.camposList[index].ValorObjeto.length; k++) {
                                if (ctrl.camposList[index].ValorObjeto[k] != null)
                                    ctrl.camposList[index].ValorObjeto[k].ValorInput = ctrl.camposList[index].ValorObjeto[k].Nombre;
                            }
                        } else {
                            if (ctrl.camposList[index].ValorObjeto == null)
                                ctrl.camposList[index].ValorObjeto = [];

                            ctrl.camposList[index].ValorObjeto.push({
                                JerarquiaPadreId: ctrl.camposList[index].Campo.JerarquiaId,
                                LoadingJerarquia: false,
                                NoResults: false,
                                Placeholder: 'Cargando...'
                            });
                            loadJerarquiaPlaceholder(ctrl.camposList[index].Campo.JerarquiaId, index, ctrl.camposList[index].ValorObjeto.length - 1);
                        }
                        break;
                    case 'TABLE':
                        loadTablaCampo(index);
                        break;
                    case 'COND':
                        loadTablaCampoCondicional(index);
                        break;
                } //switch
            }

            function loadProcesoCampoDataReadOnly(index, campoTipo) {
                if (campoTipo == null)
                    return;

                if (index < 0)
                    return;

                if (ctrl.camposList[index] == null)
                    return;
                switch (campoTipo.Codigo) {
                    case 'PROCEDURE':
                        ctrl.solicitudHasProceduresField = false;
                        break;
                    case 'VERSION':
                        ctrl.camposList[index].Valor = Number(ctrl.camposList[index].Valor);
                        break;
                    case 'INT':
                        ctrl.camposList[index].Valor = sharedService.addThousandSeparator(ctrl.camposList[index].Valor);
                        break;

                    case 'DECIMAL':
                        ctrl.camposList[index].Valor = sharedService.addThousandSeparator(ctrl.camposList[index].Valor);
                        break;

                    case 'TABLE':
                        loadTablaCampo(index);
                        break;

                    case 'JERARQ':
                        if (ctrl.camposList[index].ValorObjeto != null && ctrl.camposList[index].ValorObjeto.length > 0) {
                            for (var k = 0; k < ctrl.camposList[index].ValorObjeto.length; k++) {
                                if (ctrl.camposList[index].ValorObjeto[k] != null)
                                    ctrl.camposList[index].ValorObjeto[k].ValorInput = ctrl.camposList[index].ValorObjeto[k].Nombre;
                            }
                        } else {
                            if (ctrl.camposList[index].ValorObjeto == null)
                                ctrl.camposList[index].ValorObjeto = [];

                            ctrl.camposList[index].ValorObjeto.push({
                                JerarquiaPadreId: ctrl.camposList[index].Campo.JerarquiaId,
                                LoadingJerarquia: false,
                                NoResults: false,
                                Placeholder: 'Cargando...'
                            });

                            loadJerarquiaPlaceholder(ctrl.camposList[index].Campo.JerarquiaId, index, ctrl.camposList[index].ValorObjeto.length - 1);
                        }
                        break;

                    case 'COND':
                        loadTablaCampoCondicional(index);
                        break;
                } //switch
            }


            function loadTablaCampo(index) {
                if (ctrl.camposList[index].Valor != null && ctrl.camposList[index].Valor.length > 0) {
                    ctrl.camposList[index].TablaFilas = [];
                    var valorFilas = ctrl.camposList[index].Valor.split('^');
                    if (valorFilas != null && valorFilas.length > 0) {
                        for (var k = 0; k < valorFilas.length; k++) {
                            ctrl.camposList[index].TablaFilas.push({
                                Valor: []
                            });
                            var valorColumnas = valorFilas[k].split('~');
                            if (valorColumnas != null && valorColumnas.length > 0) {
                                ctrl.camposList[index].ValorObjeto = valorColumnas[0];

                                for (var h = 0; h < valorColumnas.length; h++) {
                                    try {
                                        switch (ctrl.camposList[index].Campo.Columnas[h].ColumnaCampo.CampoTipo.Codigo) {
                                            case 'INT':
                                                valorColumnas[h] = sharedService.addThousandSeparator(valorColumnas[h]);
                                                break;

                                            case 'DECIMAL':
                                                valorColumnas[h] = sharedService.addThousandSeparator(valorColumnas[h]);
                                                break;

                                            case 'BOOL':
                                                if (valorColumnas[h] == 'true' || valorColumnas[h] == '1')
                                                    valorColumnas[h] = true;
                                                else
                                                    valorColumnas[h] = false;
                                                break;

                                            case 'DATE':
                                                valorColumnas[h] = sharedService.formatDate(valorColumnas[h]);
                                                break;

                                            default:
                                                break;
                                        }
                                    } catch (ex) {

                                    }

                                    ctrl.camposList[index].TablaFilas[k].Valor.push(valorColumnas[h]);
                                }
                            }
                        }
                    }
                }
            }

            function loadTablaCampoCondicional(index) {
                if (ctrl.camposList[index].Valor != null && ctrl.camposList[index].Valor.length > 0) {
                    ctrl.camposList[index].TablaFilas = [];
                    var valorFilas = ctrl.camposList[index].Valor.split('^');
                    if (valorFilas != null && valorFilas.length > 0) {
                        for (var k = 0; k < valorFilas.length; k++) {
                            ctrl.camposList[index].TablaFilas.push({
                                Valor: []
                            });
                            var valorColumnas = valorFilas[k].split('~');

                            if (valorColumnas != null && valorColumnas.length > 0) {
                                ctrl.camposList[index].ValorObjeto = valorColumnas[0];
                                ctrl.camposList[index].TablaFilas[k].Valor.push(valorColumnas[0]);
                                for (var h = 0; h < valorColumnas.length; h++) {
                                    try {
                                        switch (ctrl.camposList[index].Campo.Columnas[h].ColumnaCampo.CampoTipo.Codigo) {
                                            case 'INT':
                                                valorColumnas[1] = sharedService.addThousandSeparator(valorColumnas[1]);
                                                break;
                                            case 'DECIMAL':
                                                valorColumnas[1] = sharedService.addThousandSeparator(valorColumnas[1]);
                                                break;
                                            case 'BOOL':
                                                if (valorColumnas[1] == 'true' || valorColumnas[1] == '1')
                                                    valorColumnas[1] = true;
                                                else
                                                    valorColumnas[1] = false;
                                                break;
                                            case 'DATE':
                                                valorColumnas[1] = sharedService.formatDate(valorColumnas[1]);
                                                break;
                                            case 'ATTACH':
                                                ctrl.camposList[index].ValorObjeto = valorColumnas[1];
                                                break;
                                            case 'IMG':
                                                ctrl.camposList[index].ValorObjeto = valorColumnas[1];
                                                break;
                                            default:
                                                break;
                                        }
                                    } catch (ex) {

                                    }
                                    ctrl.camposList[index].TablaFilas[k].Valor.push(valorColumnas[1]);
                                }
                            }
                        }
                    }
                }
            }

            /*function saveValorTablafilas(index,k,  input){
              ctrl.camposList[index].TablaFilas[k].Valor.push(input);
              //ctrl.camposList[index].TablaFilas[k].Valor.push("test");
            }*/

            function loadJerarquiaPlaceholder(jerarquiaPadreId, campoIndex, jerarquiaIndex) {
                dataService.getJerarquiaMuestra(jerarquiaPadreId, 2)
                    .then(function (response) {
                        if (response.data.Success) {
                            var ph = '';

                            if (response.data.Value != null) {
                                if (response.data.Value.length > 0)
                                    ph = 'Ejemplo: ' + response.data.Value[0].Nombre;

                                if (response.data.Value.length > 1)
                                    ph = ph + ', ' + response.data.Value[1].Nombre;
                            }

                            ctrl.camposList[campoIndex].ValorObjeto[jerarquiaIndex].Placeholder = ph;
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage());
                    });
            }

            ctrl.searchJerarquia = function (nombreJerarquia, padreId) {
                return dataService.searchJerarquiaByPadre(nombreJerarquia, padreId)
                    .then(function (response) {
                        if (response.data.Success) {
                            return response.data.Value;
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage());
                    });
            }

            ctrl.onSelectJerarquia = function (campoIndex, jerarquiaIndex, jerarquiaSeleccionada) {


                if (jerarquiaSeleccionada == null)
                    return;

                if (campoIndex >= 0) {
                    if (jerarquiaSeleccionada.Detalles != null && jerarquiaSeleccionada.Detalles.length > 0) {
                        jerarquiaSeleccionada.Detalles.sort(function (a, b) {
                            return (parseInt(a.Orden) > parseInt(b.Orden) ? 1 : (parseInt(b.Orden) > parseInt(a.Orden)) ? -1 : 0);
                        });
                    }

                    ctrl.camposList[campoIndex].ValorObjeto[jerarquiaIndex] = jerarquiaSeleccionada;
                    ctrl.camposList[campoIndex].ValorObjeto[jerarquiaIndex].ValorInput = jerarquiaSeleccionada.Nombre;

                    //Borrado de todas las jerarquias posteriores a la actual
                    ctrl.camposList[campoIndex].ValorObjeto.splice(jerarquiaIndex + 1, (ctrl.camposList[campoIndex].ValorObjeto.length - jerarquiaIndex - 1));
                    ctrl.camposList[campoIndex].Valor = jerarquiaSeleccionada.Id;

                }

                dataService.validarJerarquiaTienePadre(jerarquiaSeleccionada.Id)
                    .then(function (response) {
                        if (response.data.Success) {
                            if (response.data.Value == true) {
                                ctrl.camposList[campoIndex].ValorObjeto.push({
                                    ValorInput: null,
                                    JerarquiaPadreId: jerarquiaSeleccionada.Id,
                                    LoadingJerarquia: false,
                                    NoResults: false,
                                    Placeholder: 'Cargando...'
                                });

                                loadJerarquiaPlaceholder(jerarquiaSeleccionada.Id, campoIndex, ctrl.camposList[campoIndex].ValorObjeto.length - 1);
                            }
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage());
                    });
            }

            ctrl.searchCampoUsuario = function (nombreUsuario) {
                var filtroUsuario = {
                    Login: nombreUsuario,
                    PageSize: 20,
                    SkipNumber: 0
                };

                return dataService.searchUsuario(filtroUsuario)
                    .then(function (response) {
                        if (response.data.Success) {
                            return response.data.Value.Resultados;
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage());
                    });
            }

            ctrl.altaNuevaJerarquia = function (campoIndex, jerarquiaIndex) {
                ctrl.isBusy = true;
                var jerarquiaPadre = {};

                if (jerarquiaIndex > 0)
                    jerarquiaPadre = ctrl.camposList[campoIndex].ValorObjeto[jerarquiaIndex - 1];
                else
                    jerarquiaPadre = {
                        Id: ctrl.camposList[campoIndex].ValorObjeto[jerarquiaIndex].JerarquiaPadreId,
                        Nombre: ""
                    };

                var confirmation = $uibModal.open({
                    animation: true,
                    component: "altaJerarquia",
                    resolve: {
                        title: function () {
                            return "Alta de Nueva Jerarquía"
                        },
                        JerarquiaPadre: function () {
                            return jerarquiaPadre
                        },
                    }
                });

                confirmation.result.then(function (returnValue) {
                    ctrl.isBusy = false;
                    ctrl.onSelectJerarquia(campoIndex, jerarquiaIndex, returnValue);
                }, function () {
                    ctrl.isBusy = false;
                });
            }

            ctrl.onSelectUsuarioMultiList = function (campoIndex, usuarioSeleccionado) {
                if (usuarioSeleccionado == null)
                    return;

                if (campoIndex >= 0) {
                    if (ctrl.camposList[campoIndex].ValorObjeto == null)
                        ctrl.camposList[campoIndex].ValorObjeto = [];

                    for (var k = 0; k < ctrl.camposList[campoIndex].ValorObjeto.length; k++) {
                        if (ctrl.camposList[campoIndex].ValorObjeto[k].Id == usuarioSeleccionado.Id) {
                            ctrl.usuarioCargado = null;
                            return;
                        }
                    }

                    ctrl.camposList[campoIndex].ValorObjeto.push(usuarioSeleccionado);
                    // ctrl.camposList[campoIndex].Valor = ctrl.camposList[campoIndex].ValorObjeto.map(function(elem){
                    //                                                                                 return elem.Id;
                    //                                                                               }).join("|");
                    ctrl.usuarioCargado = null;
                }
            }

            ctrl.deleteCampoUsuario = function (campoIndex, usuarioId) {
                if (ctrl.camposList[campoIndex].ValorObjeto == null)
                    return;

                for (var k = 0; k < ctrl.camposList[campoIndex].ValorObjeto.length; k++) {
                    if (ctrl.camposList[campoIndex].ValorObjeto[k].Id == usuarioId) {
                        ctrl.camposList[campoIndex].ValorObjeto.splice(k, 1);
                        return;
                    }
                }

                // ctrl.camposList[campoIndex].Valor = ctrl.camposList[campoIndex].ValorObjeto.map(function(elem){
                //                                                                                   return elem.Id;
                //                                                                                 }).join("|");
            }
            ctrl.initListadoProcesos = function () {
                ctrl.isSearching = true;
                ctrl.filtros = {
                    PageSize: 1000,
                    SkipNumber: 0
                };
                dataService.searchProceso(ctrl.filtros)
                    .then(function (response) {
                        if (response.data.Success) {
                            ctrl.listadoDeProcesos = response.data.Value.Resultados;
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                        ctrl.isSearching = false;
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage());
                        ctrl.isSearching = false;
                    });

            }
            ctrl.initListadoProcesos_doc = function () {
                ctrl.isSearching = true;
                ctrl.filtros = {
                    PageSize: 1000,
                    SkipNumber: 0
                };
                dataService.searchProceso_doc(ctrl.filtros)
                    .then(function (response) {
                        if (response.data.Success) {
                            ctrl.listadoDeProcesos_doc = response.data.Value.Resultados;
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                        ctrl.isSearching = false;
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage());
                        ctrl.isSearching = false;
                    });

            }
            ctrl.onChangeSelectProcesoSeleccionado = function (procesoSeleccionado) {
            };
            ctrl.onChangeSelectProcesoSeleccionado_doc = function (procesoSeleccionado_doc) {
            };
            ctrl.searchCampoSolicitud = function (nombreUsuario) {
                var filtroUsuario = {
                    Login: nombreUsuario,
                    PageSize: 20,
                    SkipNumber: 0
                };

                if (ctrl.procesoSeleccionado != null && ctrl.procesoSeleccionado.Id != "") {

                    var filtrosSolicitud = {
                        ProcesoId: ctrl.procesoSeleccionado.Id,
                        Descripcion: nombreUsuario,
                        PageSize: 100,
                        SkipNumber: 0,
                        VerTodos: true,
                        VerProcesosPendientesOtrosUsuarios: false
                    };
                    //
                    return dataService.searchSolicitud(filtrosSolicitud)
                        .then(function (response) {
                            if (response.data.Success) {
                                //
                                ctrl.ListarSolicitudesProceso = response.data.Value.Resultados;
                                return response.data.Value.Resultados;
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage());
                        });
                } else {
                }


            }
            ctrl.searchCampoSolicitud_doc = function (nombreUsuario) {
                var filtroUsuario = {
                    Login: nombreUsuario,
                    PageSize: 20,
                    SkipNumber: 0
                };

                if (ctrl.procesoSeleccionado_doc != null && ctrl.procesoSeleccionado_doc.Id != "") {

                    var filtrosSolicitud = {
                        ProcesoId: ctrl.procesoSeleccionado_doc.Id,
                        Descripcion: nombreUsuario,
                        PageSize: 100,
                        SkipNumber: 0,
                        VerTodos: true,
                        VerProcesosPendientesOtrosUsuarios: false
                    };

                    return dataService.searchSolicitud_doc(filtrosSolicitud)
                        .then(function (response) {
                            if (response.data.Success) {

                                ctrl.ListarSolicitudesProceso_doc = response.data.Value.Resultados;
                                return response.data.Value.Resultados;
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage());
                        });
                } else {
                }
            }
            //MANTENER IGUAL
            ctrl.onSelectSolicitudMultiList = function (campoIndex, itemSeleccionado) {

                if (itemSeleccionado == null)
                    return;

                if (campoIndex >= 0) {
                    if (ctrl.camposList[campoIndex].ValorObjeto == null || ctrl.camposList[campoIndex].ValorObjeto == "")
                        ctrl.camposList[campoIndex].ValorObjeto = [];

                    for (var k = 0; k < ctrl.camposList[campoIndex].ValorObjeto.length; k++) {
                        if (ctrl.camposList[campoIndex].ValorObjeto[k].Id == itemSeleccionado.Id) {
                            ctrl.solicitudCargada = null;
                            return;
                        }
                    }

                    var obj = {
                        Id: itemSeleccionado.Id,
                        Numero: itemSeleccionado.Numero,
                        NumeroCompleto: itemSeleccionado.NumeroCompleto,
                        ProcesoId: itemSeleccionado.ProcesoId,
                        Descripcion: itemSeleccionado.Descripcion,
                        DescripcionResumida: itemSeleccionado.DescripcionResumida,
                        Proceso: {
                            Id: itemSeleccionado.ProcesoId,
                            Nombre: itemSeleccionado.Proceso.Nombre,
                            GrupoId: itemSeleccionado.Proceso.GrupoId
                        }
                    };

                    ctrl.camposList[campoIndex].ValorObjeto.push(obj);
                    ctrl.solicitudCargada = null;
                }
            }
            ctrl.onSelectSolicitudMultiList_doc = function (campoIndex, itemSeleccionado) {

                if (itemSeleccionado == null)
                    return;

                if (campoIndex >= 0) {
                    if (ctrl.camposList[campoIndex].ValorObjeto == null || ctrl.camposList[campoIndex].ValorObjeto == "")
                        ctrl.camposList[campoIndex].ValorObjeto = [];

                    for (var k = 0; k < ctrl.camposList[campoIndex].ValorObjeto.length; k++) {
                        if (ctrl.camposList[campoIndex].ValorObjeto[k].Id == itemSeleccionado.Id) {
                            ctrl.solicitudCargada_doc = null;
                            return;
                        }
                    }

                    var obj = {
                        Id: itemSeleccionado.Id,
                        Numero: itemSeleccionado.Numero,
                        NumeroCompleto: itemSeleccionado.NumeroCompleto,
                        ProcesoId: itemSeleccionado.ProcesoId,
                        Descripcion: itemSeleccionado.Descripcion,
                        DescripcionResumida: itemSeleccionado.DescripcionResumida,
                        Proceso: {
                            Id: itemSeleccionado.ProcesoId,
                            Nombre: itemSeleccionado.Proceso.Nombre,
                            GrupoId: itemSeleccionado.Proceso.GrupoId
                        },
                        NumeradorDocumental: itemSeleccionado.NumeradorDocumental
                    };

                    ctrl.camposList[campoIndex].ValorObjeto.push(obj);
                    ctrl.solicitudCargada_doc = null;
                }
            }

            ctrl.deleteCampoSolicitud = function (campoIndex, usuarioId) {
                if (ctrl.camposList[campoIndex].ValorObjeto == null)
                    return;

                for (var k = 0; k < ctrl.camposList[campoIndex].ValorObjeto.length; k++) {
                    if (ctrl.camposList[campoIndex].ValorObjeto[k].Id == usuarioId) {
                        ctrl.camposList[campoIndex].ValorObjeto.splice(k, 1);
                        return;
                    }
                }
            }


            ctrl.openAttachment = function (fileName) {
                window.open(appConfig.uploadUrl + fileName);
            }

            ctrl.uploadAttachment = function (file, item) {
                if (file == null)
                    return;

                ctrl.isBusy = true;
                item.isLoading = true;

                dataService.updateFileSolicitudCampoValor(file)
                    .then(function (response) {
                        $timeout(function () {
                            if (response.data.Success) {
                                item.ValorObjeto = response.data.Value; //{ fileName: file.name, serverFileName: response.data.Value };
                            } else {
                                item.ValorObjeto = null;
                            }
                        });
                        ctrl.isBusy = false;
                        item.isLoading = false;
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage());
                        ctrl.isBusy = false;
                        item.isLoading = false;
                    });
            }

            ctrl.evaluatenumber = function (event) {
                var charCode = (event.which) ? event.which : event.keyCode;
                if (charCode == 8 || charCode == 35 || charCode == 36 || charCode == 37 || charCode == 39 || charCode == 45 || charCode == 46 || charCode == 96 || charCode == 109) {
                    return true;
                } else if (charCode >= 97 && charCode <= 105) {
                    return true;
                } else if (charCode < 48 || charCode > 57) {
                    event.preventDefault();
                    return false;
                } else {
                    return true;
                }
            }

            ctrl.evaluatenumberDigit = function (event) {
                var charCode = (event.which) ? event.which : event.keyCode;
                if (charCode == 8 || charCode == 35 || charCode == 36 || charCode == 37 || charCode == 39 || charCode == 45 || charCode == 46 || charCode == 96 || charCode == 109) {
                    return true;
                } else if (charCode >= 97 && charCode <= 105) {
                    return true;
                } else if (charCode < 48 || charCode > 57) {
                    event.preventDefault();
                    return false;
                } else {
                    return true;
                }
            }

            ctrl.evaluatenumberDecimal = function (event) {
                var charCode = (event.which) ? event.which : event.keyCode;
                if (charCode == 8 || charCode == 35 || charCode == 36 || charCode == 37 || charCode == 39 || charCode == 45 || charCode == 46 || charCode == 96 || charCode == 190 || charCode == 109 || charCode == 110) {
                    return true;
                } else if (charCode >= 97 && charCode <= 105) {
                    return true;
                } else if (charCode < 48 || charCode > 57) {
                    event.preventDefault();
                    return false;
                } else {
                    return true;
                }
            }

            ctrl.removeAttachment = function (item) {
                item.ValorObjeto = null;
            }

            ctrl.onChangeInputTable = function (indexCampo, indexFila, indexColumna, valor) {
                ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[indexColumna] = valor;
            }

            ctrl.onChangeInputTableCond = function (indexCampo, indexFila, indexColumna, valor) {
                ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[indexColumna] = valor;
            }

            ctrl.onChangeInputcond = function (item) {
                item.Valor[1] = "";
            }

            ctrl.onNumericInputGotFocus = function (nStr) {
                return sharedService.replaceAll(nStr, ",", "");
            }

            ctrl.onNumericInputLostFocus = function (nStr) {
                return sharedService.addThousandSeparator(nStr);
            }


            ctrl.onChangeInputUsuarioAnterior = function (nStr) {
                if (nStr.length > 1) {
                    var result = sharedService.contains(ctrl.anteriorEstadoUsuariosList, "Login", nStr);
                    if (result != null && result != undefined) {
                        ctrl.anteriorEstadoUsuariosList = result;
                    } else {
                        ctrl.anteriorEstadoUsuariosList = ctrl.anteriorEstadoUsuariosListTmp;
                    }
                } else if (nStr.length == 0) {
                    ctrl.anteriorEstadoUsuariosList = ctrl.anteriorEstadoUsuariosListTmp;
                }
            }

            ctrl.onChangeInputCampostList = function (textoBusqueda, item) {
                //ctrl.TextoBusqueda = item.TextoBusqueda;
                if (!item.SourceObjetoTemp) {
                    item.SourceObjetoTemp = item.SourceObjeto;
                }
                if (textoBusqueda.length >= 1) {
                    var result = sharedService.contains(item.SourceObjetoTemp, "Nombre", textoBusqueda);
                    if (result != null && result != undefined && result.length > 0) {
                        item.SourceObjeto = result;
                    } else {
                        item.SourceObjeto = [];// item.SourceObjetoTemp;
                    }
                } else if (textoBusqueda.length == 0) {
                    item.SourceObjeto = item.SourceObjetoTemp;
                }
            }
            ctrl.onChangeInputUsuarioSiguiente = function (nStr) {
                if (nStr.length > 1) {
                    var result = sharedService.contains(ctrl.siguienteEstadoUsuariosList, "Login", nStr);
                    if (result != null && result != undefined) {
                        ctrl.siguienteEstadoUsuariosList = result;
                    } else {
                        ctrl.siguienteEstadoUsuariosList = ctrl.siguienteEstadoUsuariosListTmp;
                    }
                } else if (nStr.length == 0) {
                    ctrl.siguienteEstadoUsuariosList = ctrl.siguienteEstadoUsuariosListTmp;
                }
            }

            ctrl.onChangeInputUsuarioSiguienteDerivar = function (nStr) {
                if (nStr.length > 1) {
                    var result = sharedService.contains(ctrl.listaUsuariosDerivarResponsabilidad, "Login", nStr);
                    if (result != null && result != undefined) {
                        ctrl.listaUsuariosDerivarResponsabilidad = result;
                    } else {
                        ctrl.listaUsuariosDerivarResponsabilidad = ctrl.listaUsuariosDerivarResponsabilidadTmp;
                    }
                } else if (nStr.length == 0) {
                    ctrl.listaUsuariosDerivarResponsabilidad = ctrl.listaUsuariosDerivarResponsabilidadTmp;
                }
            }

            ctrl.listaUsuariosDerivar = function () {
                //Si el proceso permite derivar responsabilidad hacer esto:
                if (
                    (ctrl.model.Id != 0 && ctrl.model.Proceso.PermiteDerivarRes == 1) &&
                    (ctrl.lsuarioLogueadoIsAdminProceso || ctrl.model.UsuarioAprobadorId == ctrl.lUsuarioLogeado.Id) &&
                    (ctrl.model.EstadoId != 6)
                ) {
                    try {
                        dataService.getUsuarioListByProcesoEstado(ctrl.model.ProcesoId, ctrl.model.Id, ctrl.model.EstadoId).then(function (response) {
                            if (response.data.Success) {
                                ctrl.listaUsuariosDerivarResponsabilidad = response.data.Value;
                                ctrl.listaUsuariosDerivarResponsabilidadTmp = ctrl.listaUsuariosDerivarResponsabilidad;
                            } else {
                                ctrl.listaUsuariosDerivarResponsabilidad = [];
                                ctrl.listaUsuariosDerivarResponsabilidadTmp = [];
                            }
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage());
                        });
                    } catch (ex) {
                        ctrl.listaUsuariosDerivarResponsabilidad = [];
                        ctrl.listaUsuariosDerivarResponsabilidadTmp = [];
                    }
                }
            }

            /**
             * Permite Mostrar u ocultar items dependiendo de los datos de la solicitud ctrl.model
             */
            function onInitShowHideItemsModelSolicitud() {
                ctrl.showCopiaControlada = ctrl.model.Proceso.isDocumental;
            }

        }
    });
})(window.angular);
(function (angular) {
    'use strict';
    angular.module('Kahuna.pages.solicitud').component('solicitudList', {
        templateUrl: 'app/pages/solicitud/list.template.html',
        controller: function ($scope, $state, $uibModal, dataService, sharedService, toastr) {
            var ctrl = this;
            ctrl.anularVista = true;
            ctrl.filtrosProceso = {};
            ctrl.filtrosSolicitud = {};
            ctrl.procesosList = [];
            ctrl.solicitudesList = [];
            ctrl.procesoSeleccionado = {};
            ctrl.solicitudSeleccionada = {};
            ctrl.solicitudTableState = {};
            ctrl.isSysAdmin = false;
            ctrl.primeraVez = true;
            ctrl.filtrosKey = "";
            ctrl.puedeCrearSolicitud = true;
            ctrl.showCheckProcesosCerrados = true;
            ctrl.verTodos = false;
            ctrl.itemsByPage = 10;
            ctrl.currentPage = 1;
            ctrl.lProcesoIsDocumentalAutorizacionesV2 = false;
            ctrl.documentalGetCerrados = true;
            ctrl.values = [];
            var authData = {};

            this.$onInit = function () {
                loadView();
                authData = sharedService.getLoggedUser();
                ctrl.filtrosKey = "BUSQUEDA_SOLICITUDES_" + authData.Id;
            };

            function puedeCrearSolicitud(usuarios, authData) {/*este se agrego*/
                var response = true;
                angular.forEach(usuarios, function (usuario, key) {
                    if (usuario.UsuarioId == authData.Id && usuario.RolProcesoId == 7) {
                        response = false;
                    }
                });
                return response;
            }

            function loadView() {
                console.log("LOAD VIEW LIST COMPONENET");
                ctrl.itemsByPage = 10;
                if ($state != null && $state.params != null &&
                    $state.params.grupoId != null && $state.params.grupoId > 0 &&
                    $state.params.procesoId != null && $state.params.procesoId > 0) {
                    ctrl.anularVista = false;
                    ctrl.isSysAdmin = sharedService.isSysAdminLoggedUser();
                    var authData = sharedService.getLoggedUser();
                    dataService.getProcesoSolicitudGrid($state.params.procesoId)
                        .then(function (response) {
                            if (response.data.Success) {
                                ctrl.procesoSeleccionado = response.data.Value;
                                console.log(ctrl.procesoSeleccionado);
                                if (ctrl.procesoSeleccionado == null || ctrl.procesoSeleccionado.Id <= 0) {
                                    ctrl.anularVista = true;
                                    return;
                                }
                                if (ctrl.procesoSeleccionado.verProcesosCerrados) {
                                    ctrl.showCheckProcesosCerrados = false;
                                    ctrl.verTodos = false;
                                }
                                /*else {
                                                                   console.log("**************************Updating VER TODOS*********************************************************2.2");
                                                                   ctrl.showCheckProcesosCerrados = true;
                                                                   ctrl.verTodos = true;
                                                               }*/
                                //console.log(ctrl.verTodos);
                                ctrl.puedeCrearSolicitud = puedeCrearSolicitud(ctrl.procesoSeleccionado.Usuarios, authData);
                                ctrl.lProcesoIsDocumentalAutorizacionesV2 = ctrl.procesoSeleccionado.autorizacionesDocumental;

                                console.log("LLEGO LA informacion al cargar la data del proceso  seleccionado...");

                                llenarArrayFiltro();

                                
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage());
                        });                        
                }
            }

            ctrl.buscarSolicitud = function buscarSolicitud(tableState) {
                console.log("********BUSCVAR SOLICITUD LOAD VIEW!!!*************");
                console.log(ctrl.filtrosSolicitud);
                tableState == null || tableState == undefined ? ctrl.solicitudTableState : tableState;
                console.log(tableState);
                ctrl.solicitudTableState = tableState;
                if ($state != null && $state.params != null &&
                    $state.params.grupoId != null && $state.params.grupoId > 0 &&
                    $state.params.procesoId != null && $state.params.procesoId > 0) {
                    if (ctrl.primeraVez) {
                        ctrl.primeraVez = false;
                        ctrl.solicitudTableState = setTableFilters(tableState);
                    }
                    ctrl.isSolicitudSearching = true;
                    console.log("TABLE STATE PAGINATION..   * ** * ") ;
                    console.log(tableState.pagination);
                    var pagination = tableState.pagination;
                    var start = pagination.start || 0; // This is NOT the page number, but the index of item in the list that you want to use to display the table.
                    var number = pagination.number || 10; // Number of entries showed per page.                   


                    console.log(tableState);
                    ctrl.itemsByPage= number;
                    console.log(ctrl.filtrosSolicitud);                                                           
                    console.log("ctrl.filtrosSolicitud");

                    ctrl.filtrosSolicitud.ProcesoId = $state.params.procesoId;
                    ctrl.filtrosSolicitud.PageSize = number; 
                    ctrl.filtrosSolicitud.SkipNumber = start; 
                    ctrl.filtrosSolicitud.VerTodos = ctrl.verTodos;
                    ctrl.filtrosSolicitud.documentalGetCerrados = ctrl.documentalGetCerrados;
                    ctrl.filtrosSolicitud.lProcesoIsDocumentalAutorizacionesV2 = ctrl.lProcesoIsDocumentalAutorizacionesV2;
                    ctrl.filtrosSolicitud.currentPage = ctrl.currentPage;
                    ctrl.filtrosSolicitud.VerProcesosPendientesOtrosUsuarios = ctrl.verProcesosPendientesOtrosUsuarios;

                    

                    if (tableState.sort != null) {
                        ctrl.filtrosSolicitud.OrderFieldName = sharedService.replaceAll(tableState.sort.predicate, "C_", "");
                        ctrl.filtrosSolicitud.OrderAscending = !tableState.sort.reverse;
                    }
                    saveTableFilters();

                    dataService.searchSolicitud(ctrl.filtrosSolicitud)
                        .then(function (response) {
                            if (response.data.Success) {
                                ctrl.solicitudesList = response.data.Value.Resultados;
                                console.log("Resultado con todas las solicitudes.");
                                console.log(ctrl.solicitudesList);
                                //ctrl.totalResultados = response.data.Value.TotalResultados;
                                tableState.pagination.numberOfPages = Math.ceil(response.data.Value.TotalResultados / number); //result.numberOfPages;//set the number of pages so the pagination can update
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                            ctrl.isSolicitudSearching = false;
                            ctrl.solicitudTableState = tableState;
                            console.log(tableState);
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage());
                            ctrl.isSolicitudSearching = false;
                        });
                }
            };

         function llenarArrayFiltro(){
            angular.forEach(ctrl.procesoSeleccionado.CamposListado, function (campoProceso, keyListado) {
                if (campoProceso.Campo != null) {
                    angular.forEach(ctrl.filtrosSolicitud.CamposList, function (campoCache, key) {
                        if(campoCache.CampoId == campoProceso.CampoId){
                            ctrl.values[keyListado] = ctrl.filtrosSolicitud.CamposList[key].Valor;                        
                       }
                    });                        
                }
                if (campoProceso.SolicitudColumna != null) {
                    var codigo = campoProceso.SolicitudColumna.Codigo;
                    switch (codigo) {
                        case "Id":
                            ctrl.values[keyListado] = ctrl.filtrosSolicitud.Id;
                            break;
                        case "NumeroCompleto":
                            ctrl.values[keyListado] = ctrl.filtrosSolicitud.NumeroCompleto;
                            break;
                        case "Descripcion":
                            ctrl.values[keyListado] =  ctrl.filtrosSolicitud.Descripcion;
                            break;
                        case "DescripcionResumida":
                            ctrl.values[keyListado] = ctrl.filtrosSolicitud.DescripcionResumida;
                            break;
                        case "FechaCierre":
                            ctrl.values[keyListado] = ctrl.filtrosSolicitud.FechaCierre;
                            break;
                        case "Estado":
                            ctrl.values[keyListado] = ctrl.filtrosSolicitud.Estado;
                            break;
                        case "UsuarioAprobador":
                            ctrl.values[keyListado] =ctrl.filtrosSolicitud.UsuarioAprobador;
                            break;
                        case "Proceso":
                            ctrl.values[keyListado] = ctrl.filtrosSolicitud.ProcesoNombre;
                            break;
                        case "Activo":
                            ctrl.values[keyListado] =ctrl.filtrosSolicitud.Activo;
                            break;
                        case "UsuarioCreacion":
                            ctrl.values[keyListado] =  ctrl.filtrosSolicitud.UsuarioCreacion;
                            break;
                        case "CreationDate":
                            ctrl.values[keyListado] = ctrl.filtrosSolicitud.CreationDate;
                            break;
                        case "LastUpdate":
                            ctrl.values[keyListado] = ctrl.filtrosSolicitud.LastUpdate;
                            break;
                    }
                }
 
            });
            //console.log(ctrl.values)
         }

            //Delete..
            ctrl.buscarSolicitudOldBk = function buscarSolicitud(tableState) {
                console.log("********BUSCVAR SOLICITUD*************");
                console.log(ctrl.filtrosSolicitud);
                ctrl.solicitudTableState = tableState;
                if ($state != null && $state.params != null &&
                    $state.params.grupoId != null && $state.params.grupoId > 0 &&
                    $state.params.procesoId != null && $state.params.procesoId > 0) {
                    console.log("PRIMA VEZ ! " + ctrl.primeraVez);
                    if (ctrl.primeraVez) {
                        ctrl.primeraVez = false;
                        ctrl.solicitudTableState = setTableFilters(tableState);
                    }

                    ctrl.isSolicitudSearching = true;
                    var pagination = tableState.pagination;
                    var start = pagination.start || 0; // This is NOT the page number, but the index of item in the list that you want to use to display the table.
                    var number = pagination.number || 10; // Number of entries showed per page.

                    ctrl.filtrosSolicitud = {
                        ProcesoId: $state.params.procesoId,
                        PageSize: number,
                        SkipNumber: start,
                        VerTodos: ctrl.verTodos,
                        documentalGetCerrados: ctrl.documentalGetCerrados,
                        lProcesoIsDocumentalAutorizacionesV2: ctrl.lProcesoIsDocumentalAutorizacionesV2,
                        currentPage: ctrl.currentPage,
                        VerProcesosPendientesOtrosUsuarios: ctrl.verProcesosPendientesOtrosUsuarios
                    };
                    console.log(ctrl.filtrosSolicitud);
                    if (tableState.search != null && tableState.search.predicateObject != null) {
                        for (var property in tableState.search.predicateObject) {
                            switch (property) {
                                case "Id":
                                    ctrl.filtrosSolicitud.Id = tableState.search.predicateObject[property];
                                    break;

                                case "NumeroCompleto":
                                    ctrl.filtrosSolicitud.NumeroCompleto = tableState.search.predicateObject[property];
                                    break;

                                case "Descripcion":
                                    ctrl.filtrosSolicitud.Descripcion = tableState.search.predicateObject[property];
                                    break;

                                case "DescripcionResumida":
                                    ctrl.filtrosSolicitud.DescripcionResumida = tableState.search.predicateObject[property];
                                    break;

                                case "FechaCierre":
                                    ctrl.filtrosSolicitud.FechaCierre = sharedService.convertDate(tableState.search.predicateObject[property]);
                                    break;

                                case "Estado":
                                    ctrl.filtrosSolicitud.Estado = tableState.search.predicateObject[property];
                                    break;

                                case "UsuarioAprobador":
                                    ctrl.filtrosSolicitud.UsuarioAprobador = tableState.search.predicateObject[property];
                                    break;

                                case "Proceso":
                                    ctrl.filtrosSolicitud.ProcesoNombre = tableState.search.predicateObject[property];
                                    break;

                                case "Activo":
                                    ctrl.filtrosSolicitud.Activo = tableState.search.predicateObject[property];
                                    break;

                                case "UsuarioCreacion":
                                    ctrl.filtrosSolicitud.UsuarioCreacion = tableState.search.predicateObject[property];
                                    break;

                                case "CreationDate":
                                    ctrl.filtrosSolicitud.CreationDate = sharedService.convertDate(tableState.search.predicateObject[property]);
                                    break;

                                case "LastUpdate":
                                    ctrl.filtrosSolicitud.LastUpdate = sharedService.convertDate(tableState.search.predicateObject[property]);
                                    break;

                                default:

                                    if (ctrl.filtrosSolicitud.CamposList == null)
                                        ctrl.filtrosSolicitud.CamposList = [];

                                    ctrl.filtrosSolicitud.CamposList.push({
                                        CampoId: sharedService.replaceAll(property, "C_", ""),
                                        Valor: tableState.search.predicateObject[property]
                                    });

                                    break;
                            }
                        } //for
                    }
                    if (tableState.sort != null) {
                        ctrl.filtrosSolicitud.OrderFieldName = sharedService.replaceAll(tableState.sort.predicate, "C_", "");
                        ctrl.filtrosSolicitud.OrderAscending = !tableState.sort.reverse;
                    }
                    saveTableFilters();
                    dataService.searchSolicitud(ctrl.filtrosSolicitud)
                        .then(function (response) {
                            if (response.data.Success) {
                                ctrl.solicitudesList = response.data.Value.Resultados;
                                console.log("Resultado con todas las solicitudes.");
                                console.log(ctrl.solicitudesList);
                                //ctrl.totalResultados = response.data.Value.TotalResultados;
                                tableState.pagination.numberOfPages = Math.ceil(response.data.Value.TotalResultados / number); //result.numberOfPages;//set the number of pages so the pagination can update
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                            ctrl.isSolicitudSearching = false;
                            ctrl.solicitudTableState = tableState;
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage());
                            ctrl.isSolicitudSearching = false;
                        });
                }
            };

            function setTableFilters(tableState) {
                console.log("leyendo desde  cache...!");
                var authData = sharedService.getLoggedUser();
                ctrl.filtrosKey = "BUSQUEDA_SOLICITUDES_" + authData.Id;
                var filtros = sharedService.getLocalData(ctrl.filtrosKey);

                if (filtros != null && filtros.length > 0) {
                    for (var i = 0; i < filtros.length; i++) {
                        if (filtros[i].ProcesoId == $state.params.procesoId)
                            ctrl.filtrosSolicitud = filtros[i].Filtros;
                    }
                }

                if (ctrl.filtrosSolicitud == null)
                    ctrl.filtrosSolicitud = {};

                if (ctrl.filtrosSolicitud.SkipNumber == null)
                    ctrl.filtrosSolicitud.SkipNumber = 0;

                if (ctrl.filtrosSolicitud.documentalGetCerrados == null) {
                    ctrl.filtrosSolicitud.documentalGetCerrados = ctrl.documentalGetCerrados!=null?ctrl.documentalGetCerrados:true;
                } else {
                    ctrl.documentalGetCerrados = ctrl.filtrosSolicitud.documentalGetCerrados;
                }

                if (ctrl.filtrosSolicitud.lProcesoIsDocumentalAutorizacionesV2 == null) {
                    ctrl.filtrosSolicitud.lProcesoIsDocumentalAutorizacionesV2 = ctrl.lProcesoIsDocumentalAutorizacionesV2;
                } else {
                    ctrl.lProcesoIsDocumentalAutorizacionesV2 = ctrl.filtrosSolicitud.lProcesoIsDocumentalAutorizacionesV2;
                }

                if (ctrl.filtrosSolicitud.currentPage == null) {
                    ctrl.filtrosSolicitud.currentPage = ctrl.currentPage;
                } else {
                    ctrl.currentPage = ctrl.filtrosSolicitud.currentPage;
                }

                if (ctrl.filtrosSolicitud.PageSize == null){
                    ctrl.filtrosSolicitud.PageSize = 10;
                }

                if (tableState.pagination == null)
                    tableState.pagination = {};

                tableState.pagination.start = ctrl.filtrosSolicitud.SkipNumber;
                tableState.pagination.number = ctrl.filtrosSolicitud.PageSize;
                ctrl.itemsByPage = ctrl.filtrosSolicitud.PageSize;

                ctrl.verProcesosPendientesOtrosUsuarios = ctrl.filtrosSolicitud.VerProcesosPendientesOtrosUsuarios;

                if (tableState.search == null)
                    tableState.search = {};

                tableState.search.predicateObject = {};

                tableState.search.predicateObject.Id = ctrl.filtrosSolicitud.Id;
                tableState.search.predicateObject.NumeroCompleto = ctrl.filtrosSolicitud.NumeroCompleto;
                tableState.search.predicateObject.Descripcion = ctrl.filtrosSolicitud.Descripcion;
                tableState.search.predicateObject.DescripcionResumida = ctrl.filtrosSolicitud.DescripcionResumida;
                tableState.search.predicateObject.FechaCierre = sharedService.formatDateForGetUrl(ctrl.filtrosSolicitud.FechaCierre);
                tableState.search.predicateObject.Estado = ctrl.filtrosSolicitud.Estado;
                tableState.search.predicateObject.UsuarioAprobador = ctrl.filtrosSolicitud.UsuarioAprobador;
                tableState.search.predicateObject.Proceso = ctrl.filtrosSolicitud.ProcesoNombre;
                tableState.search.predicateObject.Activo = ctrl.filtrosSolicitud.Activo;
                tableState.search.predicateObject.UsuarioCreacion = ctrl.filtrosSolicitud.UsuarioCreacion;
                tableState.search.predicateObject.CreationDate = sharedService.formatDateForGetUrl(ctrl.filtrosSolicitud.CreationDate);
                tableState.search.predicateObject.LastUpdate = sharedService.formatDateForGetUrl(ctrl.filtrosSolicitud.LastUpdate);

                if (ctrl.filtrosSolicitud.CamposList != null && ctrl.filtrosSolicitud.CamposList.length > 0) {
                    for (var i = 0; i < ctrl.filtrosSolicitud.CamposList.length; i++) {
                        var property = "C_" + ctrl.filtrosSolicitud.CamposList[i].CampoId;
                        tableState.search.predicateObject[property] = ctrl.filtrosSolicitud.CamposList[i].Valor;
                    }
                }

                tableState.sort = {};
                tableState.sort.predicate = ctrl.filtrosSolicitud.OrderFieldName;
                tableState.sort.reverse = !ctrl.filtrosSolicitud.OrderAscending;

                //llenarArrayFiltro();
                return tableState;
            }

            function saveTableFilters() {
                console.log("****SAVE FILTER!");
                var index = -1;
                var filtros = sharedService.getLocalData(ctrl.filtrosKey);

                if (filtros != null && filtros.length > 0) {
                    for (var i = 0; i < filtros.length; i++) {
                        if (filtros[i].ProcesoId == $state.params.procesoId) {
                            index = i;
                            break;
                        }
                    }
                } else
                    filtros = [];

                if (index > -1)
                    filtros[i] = {
                        ProcesoId: $state.params.procesoId,
                        Filtros: ctrl.filtrosSolicitud
                    };
                else
                    filtros.push({
                        ProcesoId: $state.params.procesoId,
                        Filtros: ctrl.filtrosSolicitud
                    });

                console.log(ctrl.filtrosKey);
                console.log(filtros);
                sharedService.setLocalData(ctrl.filtrosKey, filtros);
            }

            ctrl.add = function () {
                if (ctrl.procesoSeleccionado == null || ctrl.procesoSeleccionado.Id == null || ctrl.procesoSeleccionado.Id <= 0) {
                    toastr.error('Seleccione un proceso para poder continuar con la operación');
                    return;
                }

                $state.go("pages.solicitud-edit", {
                    id: 0,
                    grupo: $state.params.grupoId,
                    proceso: ctrl.procesoSeleccionado.Id,
                    solicitudPadreId: 0
                });
            }

            ctrl.edit = function (id) {
                ctrl.model = {};
                ctrl.model.Id = id;
                ctrl.model.ProcesoId = ctrl.procesoSeleccionado.Id;
                console.log(ctrl.model);

                if (sharedService.isSysAdminLoggedUser() ||
                    (ctrl.rolProcesoList != null && ctrl.rolProcesoList.length > 0)) {

                } else {
                    ctrl.anularVista = true;
                    ctrl.motivoBloqueo = 'No tiene permisos para visualizar o realizar acciones sobre este proceso.';
                }

                if (ctrl.procesoSeleccionado == null || ctrl.procesoSeleccionado.Id == null || ctrl.procesoSeleccionado.Id <= 0) {
                    toastr.error('Seleccione un proceso para poder continuar con la operación');
                    return;
                }

                dataService.getRolProcesoByProcesoUsuario(ctrl.model.Id, ctrl.model.ProcesoId, authData.Id)
                    .then(function (response) {
                        if (response.data.Success) {
                            ctrl.rolProcesoList = response.data.Value;
                            if (sharedService.isSysAdminLoggedUser() ||
                                (ctrl.rolProcesoList != null && ctrl.rolProcesoList.length > 0)) {
                                console.log("IS OK CAN CONTINUE");
                                $state.go("pages.solicitud-edit", {
                                    id: id,
                                    grupo: $state.params.grupoId,
                                    proceso: ctrl.procesoSeleccionado.Id,
                                    solicitudPadreId: 0
                                });
                            } else {
                                toastr.error('No tiene permisos para visualizar o realizar acciones sobre esta solicitud.');
                                return;
                            }
                        } else {
                            toastr.error('No tiene permisos para visualizar o realizar acciones sobre esta solicitud.');
                            return;
                        }
                        return false;
                    }, function (error) {
                        toastr.error('No tiene permisos para visualizar o realizar acciones sobre esta solicitud.');
                        return;
                    });

            }

            ctrl.deleteAll = function (id) {
                if (ctrl.procesoSeleccionado == null || ctrl.procesoSeleccionado.Id == null || ctrl.procesoSeleccionado.Id <= 0) {
                    toastr.error('Seleccione un proceso para poder continuar con la operación');
                    return;
                }

                ctrl.isBusy = true;
                var confirmation = $uibModal.open({
                    animation: true,
                    component: "confirmation",
                    resolve: {
                        title: function () {
                            return "Atención"
                        },
                        message: function () {
                            return "Confirma el borrado de todos los elementos pertenecientes al proceso " + ctrl.procesoSeleccionado.Nombre + "?"
                        },
                    }
                });

                confirmation.result.then(function (selectedItem) {
                    dataService.deleteSolicitudesByProceso(ctrl.procesoSeleccionado.Id)
                        .then(function (response) {
                            if (response.data.Success) {
                                toastr.info("Operacion exitosa.");
                                $state.reload();
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                            ctrl.isBusy = false;
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage());
                            ctrl.isBusy = false;
                        });
                }, function () {
                    ctrl.isBusy = false;
                });
            }

            ctrl.openNewTab = function (fila) {
                ctrl.model = {};
                ctrl.model.Id = fila.Id;
                ctrl.model.ProcesoId = ctrl.procesoSeleccionado.Id;
                console.log(ctrl.model);
                console.log(fila);
                dataService.getRolProcesoByProcesoUsuario(ctrl.model.Id, ctrl.model.ProcesoId, authData.Id)
                    .then(function (response) {
                        if (response.data.Success) {
                            ctrl.rolProcesoList = response.data.Value;
                            if (sharedService.isSysAdminLoggedUser() ||
                                (ctrl.rolProcesoList != null && ctrl.rolProcesoList.length > 0)) {
                                console.log("IS OK CAN CONTINUE");
                                var url = fila.UrlLink;
                                if (url != null && url.length > 0) {
                                    window.open(url);
                                }
                            } else {
                                toastr.error('No tiene permisos para visualizar o realizar acciones sobre esta solicitud.');
                                return;
                            }
                        } else {
                            toastr.error('No tiene permisos para visualizar o realizar acciones sobre esta solicitud.');
                            return;
                        }
                        return false;
                    }, function (error) {
                        toastr.error('No tiene permisos para visualizar o realizar acciones sobre esta solicitud.');
                        return;
                    });
            }

            ctrl.cancel = function () {
                ctrl.filtrosSolicitud.documentalGetCerrados = true;
                saveTableFilters();
                $state.go("pages.solicitud-procesos", {
                    grupoId: $state.params.grupoId
                });
            }

            ctrl.goHome = function () {
                $state.go("pages.home");
            }

            ctrl.openUrl = function (url) {
                if (url != null && url.length > 0)
                    window.open(url);
            }

            ctrl.verDocPendientes = function () {
                ctrl.documentalGetCerrados = !ctrl.documentalGetCerrados;
                console.log(ctrl.solicitudTableState);
                ctrl.currentPage = 1;
                if (ctrl.solicitudTableState!= null &&  ctrl.solicitudTableState.pagination!= null) {
                    ctrl.solicitudTableState.pagination.start = 0;
                }else{
                    ctrl.solicitudTableState.pagination = {};
                    ctrl.solicitudTableState.pagination.start = 0;
                }
                ctrl.buscarSolicitud(ctrl.solicitudTableState);
                //saveTableFilters();
            }

            ctrl.cleanFilters = function () {                
                angular.forEach(ctrl.values, function (value, key) {
                    console.log(value);
                    ctrl.values[key] = "";
                });
                ctrl.triggerFind();
            } 

            ctrl.triggerFind = function () {
                  
                ctrl.filtrosSolicitud.CamposList = [];
                    angular.forEach(ctrl.values, function (value, key) {
                        console.log(value);
                        if (ctrl.procesoSeleccionado.CamposListado[key].Campo != null) {
                            console.log(" Es para un campo...");
                            ctrl.filtrosSolicitud.CamposList.push({
                                CampoId: ctrl.procesoSeleccionado.CamposListado[key].Campo.Id,
                                Valor: value
                            });
                        }

                        if (ctrl.procesoSeleccionado.CamposListado[key].SolicitudColumna != null) {
                            console.log(" Es para un SolicitudColumna...");
                            console.log(ctrl.procesoSeleccionado.CamposListado[key].SolicitudColumna);
                            var codigo = ctrl.procesoSeleccionado.CamposListado[key].SolicitudColumna.Codigo;

                            switch (codigo) {
                                case "Id":
                                    ctrl.filtrosSolicitud.Id = value;
                                    break;

                                case "NumeroCompleto":
                                    ctrl.filtrosSolicitud.NumeroCompleto = value;
                                    break;

                                case "Descripcion":
                                    ctrl.filtrosSolicitud.Descripcion = value;
                                    break;

                                case "DescripcionResumida":
                                    ctrl.filtrosSolicitud.DescripcionResumida = value;
                                    break;

                                case "FechaCierre":
                                    ctrl.filtrosSolicitud.FechaCierre = sharedService.convertDate(value);
                                    break;

                                case "Estado":
                                    ctrl.filtrosSolicitud.Estado = value;
                                    break;

                                case "UsuarioAprobador":
                                    ctrl.filtrosSolicitud.UsuarioAprobador = value;
                                    break;

                                case "Proceso":
                                    ctrl.filtrosSolicitud.ProcesoNombre = value;
                                    break;

                                case "Activo":
                                    ctrl.filtrosSolicitud.Activo = value;
                                    break;

                                case "UsuarioCreacion":
                                    ctrl.filtrosSolicitud.UsuarioCreacion = value;
                                    break;

                                case "CreationDate":
                                    ctrl.filtrosSolicitud.CreationDate = sharedService.convertDate(value);
                                    break;

                                case "LastUpdate":
                                    ctrl.filtrosSolicitud.LastUpdate = sharedService.convertDate(value);
                                    break;

                                default:
                                    if (ctrl.filtrosSolicitud.CamposList == null)
                                        ctrl.filtrosSolicitud.CamposList = [];

                                    ctrl.filtrosSolicitud.CamposList.push({
                                        CampoId: sharedService.replaceAll(property, "C_", ""),
                                        Valor: value
                                    });
                                    break;
                            }
                        }
                    });
                saveTableFilters();
                ctrl.solicitudTableState.pagination.start = 0;
                ctrl.buscarSolicitud(ctrl.solicitudTableState);
            } 

        }
    });
})(window.angular);
(function (angular) {
    'use strict';
    angular.module('Kahuna.pages.solicitud').component('solicitudProcesos', {
      templateUrl: 'app/pages/solicitud/procesolist.template.html',
      controller: function ($scope,$state,$window,dataService, sharedService,toastr) {
        var ctrl = this;
        ctrl.anularVista = true;
        ctrl.procesosList = [];
        ctrl.grupoSeleccionado = {};
        this.$onInit = function () 
        {
          if ($state != null && $state.params != null && $state.params.grupoId != null && $state.params.grupoId > 0)
          {
            ctrl.anularVista = false;
            ctrl.isProcesoSearching = true;

            dataService.getGrupoById($state.params.grupoId)
              .then(function (response) 
              {
                if (response.data.Success) 
                {
                  ctrl.grupoSeleccionado = response.data.Value;
                } 
                else 
                {
                  toastr.error(response.data.ErrorSummary);
                }
              }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage());
            });

            dataService.getProcesoByGrupo($state.params.grupoId)
              .then(function (response) 
              {
                if (response.data.Success) 
                {
                  ctrl.procesosList = response.data.Value;
                }
                else 
                {
                  toastr.error(response.data.ErrorSummary);
                }
                ctrl.isProcesoSearching = false;
              }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage());
              ctrl.isProcesoSearching = false;
            });
          }
          else
          {
            ctrl.goHome();
            return;
          }
        };

        ctrl.setProcesoSeleccionado = function (procesoSeleccionado)
        {
          //Si tiene seteado un link, navego a ese link
          if (procesoSeleccionado.UrlLink != null && procesoSeleccionado.UrlLink.length > 0)
            $window.open(procesoSeleccionado.UrlLink, '_blank');

          $state.go('pages.solicitud',{grupoId:$state.params.grupoId,procesoId:procesoSeleccionado.Id});
        };

        ctrl.goHome = function ()
        {
          $state.go("pages.home");
        }
      }
    });
  })(window.angular);
(function () {
    'use strict';
    angular.module('Kahuna.pages.solicitud').config(routeConfig);
    function routeConfig($stateProvider) {
      $stateProvider
        .state('pages.solicitud', {
          url: '/solicitud/:grupoId/:procesoId',
          title: 'Gestión de Carga de Procesos',
          template : '<solicitud-list></solicitud-list>',
          authenticate: true,
        })
        .state('pages.solicitud-edit', {
          url: '/solicitud/edit/:id/:grupo/:proceso/:solicitudPadreId',
          title: 'Carga de Proceso',
          template : '<solicitud-edit></solicitud-edit>',
          params: {id:null},
          authenticate: true,
        })
        .state('pages.solicitud-template', {
          url: '/solicitud/template/edit/:solicitud/:solicitudEstado/:procesoTemplate/:template/:proceso/:solicitudProcesoTemplate',
          title: 'Carga de Proceso',
          template : '<solicitud-template></solicitud-template>',
          params: {id:null},
          authenticate: true,
        })
        .state('pages.solicitud-procesos', {
          url: '/solicitudes/procesos/:grupoId',
          title: 'Selección de Proceso',
          template : '<solicitud-procesos></solicitud-procesos>',
          params: {id:null},
          authenticate: true,
        });
    }
  })();
(function (angular) {
  "use strict";
  angular.module("Kahuna.pages.solicitud").component("solicitudTemplate", {
    templateUrl: "app/pages/solicitud/template.template.html",
    controller: function (
      $scope,
      $state,
      dataService,
      sharedService,
      appConfig,
      toastr,
      toastrConfig,
      $stateParams,
      $uibModal,
      $timeout
    ) {
      console.log("Template.componmente.js");
      var ctrl = this;
      ctrl.imgFile = appConfig.uploadUrl;
      ctrl.model = {};
      ctrl.LinkTemplate = {
        UrlDocumentos: "",
        TipoCampo: "",
      };
      ctrl.solicitudProcesoTemplateId = 0;
      ctrl.isBusy = false;
      ctrl.showDelete = false;
      ctrl.anularVista = true;
      ctrl.viewLoading = true;
      ctrl.motivoBloqueo = "";
      ctrl.soloLectura = 1;
      ctrl.puedeBorrarTemplate = false;
      ctrl.tituloCampoValor = "";
      ctrl.title = "Carga de Gestión";
      ctrl.mensajeNotificacion = "";
      ctrl.mailsAdicionales = "";
      ctrl.solicitudHasProceduresField = false;
      ctrl.generaProcesoRelacionados = false;
      ctrl.allowToAutoriceA = false;
      ctrl.allowToAutoriceB = false;
      ctrl.styleFontTitle = {};
      ctrl.solicitud = {};
      ctrl.template = {};

      ctrl.camposList = [];
      ctrl.jerarquia = [];
      ctrl.usuarios = [];

      ctrl.valoresCampoSolicitudList = [];
      ctrl.procesoUsuariosList = [];
      ctrl.procesoUsuariosDS = [];
      ctrl.procesoUsuariosNotificarList = [];
      ctrl.procesoUsuariosNotificarDS = [];
      ctrl.showBtnLink = false;

      ctrl.listadoDeProcesos = [];
      ctrl.listadoDeProcesos_doc = [];
      ctrl.listaUsuariosDerivarResponsabilidad = [];

      ctrl.templates = [];
      ctrl.rolTemplateList = [];
      var authData = {};

      this.$onInit = function () {
        console.log("*********************");
        console.log($stateParams.solicitudProcesoTemplate);
        console.log($stateParams);
        console.log("*********************");
        authData = sharedService.getLoggedUser();
        var applicationProperties = sharedService.getLocalData(
          "ApplicationProperties"
        );
        if (
          applicationProperties != null &&
          applicationProperties != undefined &&
          applicationProperties.hasOwnProperty("HEADCOLOR")
        ) {
          ctrl.styleFontTitle = {
            color: applicationProperties.HEADCOLOR,
          };
        }

        if (authData != null && authData.Id > 0) {
          loadView(authData);
        } else {
          $state.go("auth");
          return;
        }
      };

      ctrl.openLink = function (url) {
        console.log("OPEN LINK" + url);
        window.open(url, "_blank");
      };

      ctrl.openLinkTemplate = function () {
        console.log("OPEN LINK TEMPLATE...");
        console.log(ctrl.LinkTemplate);
        console.log($stateParams.solicitud);
        console.log($stateParams.template);
        console.log($stateParams.procesoTemplate);
        ctrl.solicitudProcesoTemplateId = $stateParams.solicitudProcesoTemplate;
        console.log(ctrl.solicitudProcesoTemplateId);

        if (
          ctrl.LinkTemplate != undefined &&
          ctrl.LinkTemplate != null &&
          ctrl.LinkTemplate.UrlDocumentos != ""
        ) {
          console.log(ctrl.LinkTemplate);
          var urlLink = ctrl.LinkTemplate.UrlDocumentos.replace("&solicitud", ctrl.solicitud.Id);
          urlLink = urlLink.replace("&SolicitudId", ctrl.solicitud.Id);
          urlLink = urlLink.replace("&IdProcesoTemplate", ctrl.solicitudProcesoTemplateId);
          if ($stateParams.procesoTemplate != 0) {
            window.open(urlLink, "_blank");
          }
        }
      };

      ctrl.userInGroup = function (grupoId, userId, callbackFunction) {
        try {
          console.log("ingreso a userInGrup********");
          dataService.userInGroup(grupoId, userId).then(
            function (response) {
              if (response.data.Success) {
                console.log("value ", response.data.Value);
                callbackFunction(response.data.Value);
              } else {
                callbackFunction(false);
              }
            },
            function (error) {
              toastr.error(
                error.data || sharedService.getGenericErrorMessage()
              );
            }
          );
        } catch (ex) {
          console.log("error.");
        }
      };

      ctrl.listaUsuariosDerivar = function () {
        console.log(ctrl.solicitud);
        try {
          dataService
            .getUsuarioListByProcesoEstado(
              ctrl.solicitud.ProcesoId,
              ctrl.solicitud.Id,
              ctrl.solicitud.EstadoId
            )
            .then(
              function (response) {
                if (response.data.Success) {
                  ctrl.listaUsuariosDerivarResponsabilidad =
                    response.data.Value;
                  console.log("LISTAO ");
                  console.log(ctrl.listaUsuariosDerivarResponsabilidad);
                  ctrl.verificarUsuarioListado(authData.Id);
                }
              },
              function (error) {
                toastr.error(
                  error.data || sharedService.getGenericErrorMessage()
                );
              }
            );
        } catch (ex) {
          console.log("error.");
          ctrl.listaUsuariosDerivarResponsabilidad = [];
        }
      };

      ctrl.verificarUsuarioListado = function (stringFind) {
        console.log(stringFind);
        //stringFind = 3;
        if (stringFind != "") {
          var userExist = sharedService.uniqById(
            ctrl.listaUsuariosDerivarResponsabilidad,
            "Id",
            stringFind
          );
          /*if ( userExist != null && userExist != undefined && userExist.length > 0) {
            console.log(userExist);
            ctrl.allowToAutoriceA = true;
          } else {
            ctrl.allowToAutoriceA = false;
          }
          console.log(ctrl.allowToAutoriceA);*/
        }
      };

      // ctrl.init = function (item) {
      //   console.log('ITEM.VALOROBJETO',item.ValorObjeto);
      //   console.log('ITEM.SOURCEOBJETO',item.SourceObjeto);
      //   console.log("ENTRÓ AL INIT");

      //   if (item.ValorObjeto === null) {
      //     console.log("LLEGÓ NULL");
      //     item.ValorObjeto = [];
      //   }
      //   for (let i = 0 ;i < item.SourceObjeto.length; i++) {
      //     for (let j = 0; j < item.ValorObjeto.length; j++) {
      //       if (item.SourceObjeto[i].Id == item.ValorObjeto[j].Id) {
      //         item.SourceObjeto.splice(i, 1);
      //       }
      //     }
      //   }
      //   // item.SourceObjeto = item.SourceObjeto.filter(function(obj){
      //   //   return  item.ValorObjeto.indexOf(obj) == -1;
      //   // });
      //   console.log(item.SourceObjeto)
      // };
      ctrl.onChangeInputCampostList = function (textoBusqueda, item) {
        ctrl.TextoBusqueda = item.TextoBusqueda;

        if (!item.SourceObjetoTemp) {
          item.SourceObjetoTemp = item.SourceObjeto;
        }

        console.log(ctrl.SourceObjetoTemp);
        if (textoBusqueda.length >= 1) {
          var result = sharedService.contains(item.SourceObjetoTemp, "Nombre", textoBusqueda);
          if (result != null && result != undefined && result.length > 0) {
            item.SourceObjeto = result;
          } else {
            item.SourceObjeto = [];
          }
        } else if (textoBusqueda.length == 0) {
          console.log("ESTÁ VACÍO EL INPUT");
          item.SourceObjeto = item.SourceObjetoTemp;
        }
      }
      ctrl.actionAddOnClick = function (j, item) {
        item.SourceObjetoTemp = item.SourceObjetoTemp.filter(function (item) {
          return item.Id != j.Id;
        });
        item.SourceObjeto = item.SourceObjetoTemp;
        if (item.ValorObjeto === null) {
          console.log("LLEGÓ NULL");
          item.ValorObjeto = [];
        }
        item.ValorObjeto.push(j);
        item.TextoBusqueda = "";
      };

      ctrl.actionRemoveOnClick = function (j, item) {
        item.ValorObjeto = item.ValorObjeto.filter(function (item) {
          return item.Id != j.Id;
        });
        item.SourceObjeto.push(j);
        item.SourceObjetoTemp = item.SourceObjeto;
        item.TextoBusqueda = "";
      };

      function loadView(authData) {
        ctrl.isProcesoUsuarioSearching = true;
        ctrl.getParametrosByIdent($stateParams.template);
        dataService.getProcesoUsuarioListByProceso($stateParams.proceso).then(
          function (response) {
            if (response.data.Success) {
              //console.log(56);
              //console.log(response.data);
              var usuarios = response.data.Value;
              ctrl.procesoUsuariosList = [];

              //Carga de usuarios del proceso
              if (usuarios != null && usuarios.length > 0) {
                var index;

                for (var i = 0; i < usuarios.length; i++) {
                  index = -1;

                  for (var x = 0; x < ctrl.procesoUsuariosList.length; x++) {
                    if (
                      ctrl.procesoUsuariosList[x].Usuario.Id ==
                      usuarios[i].Usuario.Id
                    ) {
                      index = x;
                      break;
                    }
                  }

                  if (index < 0) {
                    ctrl.procesoUsuariosList.push({
                      Usuario: usuarios[i].Usuario,
                      RolProcesoList: [],
                    });
                    index = ctrl.procesoUsuariosList.length - 1;
                  }

                  //Existe el usuario
                  ctrl.procesoUsuariosList[index].RolProcesoList.push(
                    usuarios[i].RolProceso
                  );
                }
              }
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isProcesoUsuarioSearching = false;
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
            ctrl.isProcesoUsuarioSearching = false;
          }
        );

        dataService
          .getRolTemplateByProcesoTemplateUsuario(
            $stateParams.solicitud,
            $stateParams.procesoTemplate,
            authData.Id
          )
          .then(
            function (response) {
              if (response.data.Success) {
                ctrl.rolTemplateList = response.data.Value;

                //Si tiene roles en el template, puede continuar con la carga
                if (
                  ctrl.rolTemplateList != null &&
                  ctrl.rolTemplateList.length > 0
                ) {
                  ctrl.anularVista = false;
                } else {
                  //Si no tiene roles asignados en el template, solo el sysadmin puede hacer algo
                  ctrl.anularVista = !sharedService.isSysAdminLoggedUser();
                }

                console.log(ctrl.anularVista);
                if (ctrl.anularVista) {
                  console.log("Entro aca.. 2");
                  ctrl.viewLoading = false;
                  ctrl.motivoBloqueo =
                    "No tiene permisos para visualizar o realizar acciones sobre esta gestión.";
                  return;
                }

                ctrl.isCamposLoading = true;
                ctrl.soloLectura = 1;

                dataService
                  .getSolicitudCampoValorProcesoTemplate(
                    $stateParams.solicitud,
                    $stateParams.procesoTemplate
                  )
                  .then(
                    function (response) {
                      if (response.data.Success) {
                        //console.log("getSolicitudCampoValorProcesoTemplate***");
                        //console.log(response.data);
                        ctrl.valoresCampoSolicitudList = response.data.Value;
                        // console.log(ctrl.valoresCampoSolicitudList);
                        if (ctrl.valoresCampoSolicitudList != null) {
                          for (
                            var i = 0;
                            i < ctrl.valoresCampoSolicitudList.length;
                            i++
                          ) {
                            loadCampoDataSolicitudList(
                              ctrl.valoresCampoSolicitudList[i],
                              i
                            );
                          }
                        }
                      } else {
                        toastr.error(response.data.ErrorSummary);
                      }
                    },
                    function (error) {
                      toastr.error(
                        error.data || sharedService.getGenericErrorMessage()
                      );
                    }
                  );

                //Verificar los permisos
                if ($stateParams.solicitudProcesoTemplate > 0) {
                  //console.log("solicitudProcesoTemplate***");
                  //Si es una edicion, verificar que tenga permisos de edicion
                  ctrl.solicitudProcesoTemplateId =
                    $stateParams.solicitudProcesoTemplate;
                  dataService
                    .getSolicitudProcesoTemplateById(
                      $stateParams.solicitudProcesoTemplate
                    )
                    .then(
                      function (response) {
                        if (response.data.Success) {
                          var solicitudProcesoTemplate = response.data.Value;
                          console.log(solicitudProcesoTemplate);
                          ctrl.template =
                            solicitudProcesoTemplate.ProcesoTemplate.Template;
                          ctrl.puedeBorrarTemplate = puedeBorrarTemplate(
                            solicitudProcesoTemplate.Solicitud,
                            ctrl.rolTemplateList
                          );
                          ctrl.verTemplate = puedeverTemplate(
                            solicitudProcesoTemplate.Solicitud,
                            solicitudProcesoTemplate.SolicitudEstado,
                            ctrl.rolTemplateList,
                            solicitudProcesoTemplate.UsuarioCreacionId,
                            authData.Id
                          );
                          ctrl.solicitud = solicitudProcesoTemplate.Solicitud;
                          ctrl.soloLectura = !puedeEditarTemplate(
                            solicitudProcesoTemplate.Solicitud,
                            solicitudProcesoTemplate.SolicitudEstado,
                            ctrl.rolTemplateList,
                            solicitudProcesoTemplate.UsuarioCreacionId,
                            authData.Id,
                            solicitudProcesoTemplate
                          );
                          if (ctrl.solicitudProcesoTemplateId != 0) {
                            ctrl.listaUsuariosDerivar();
                            ctrl.userInGroup(
                              ctrl.template.gUsuariosAutorizaA,
                              authData.Id,
                              function (resultado) {
                                console.log("ingreso a la funcion A");
                                console.log("resultado ", resultado);
                                ctrl.allowToAutoriceA = resultado;
                                console.log(ctrl.allowToAutoriceA);
                              }
                            );
                            ctrl.userInGroup(
                              ctrl.template.gUsuariosAutorizaB,
                              authData.Id,
                              function (resultado) {
                                console.log("ingreso a la funcion B");
                                console.log("resultado ", resultado);
                                ctrl.allowToAutoriceB = resultado;
                                console.log(ctrl.allowToAutoriceB);
                              }
                            );
                          }
                          getCamposData(authData);
                        } else {
                          toastr.error(response.data.ErrorSummary);
                        }
                      },
                      function (error) {
                        toastr.error(
                          error.data || sharedService.getGenericErrorMessage()
                        );
                      }
                    );
                } else {
                  //Si es una carga nueva, verificar que tenga permisos de creacion
                  dataService.getSolicitudById($stateParams.solicitud).then(
                    function (response) {
                      if (response.data.Success) {
                        ctrl.solicitud = response.data.Value;
                        //Si tiene roles y el template es nuevo, verifico si puede crearlo
                        if (
                          puedeCrearTemplate(
                            ctrl.solicitud,
                            ctrl.rolTemplateList
                          )
                        ) {
                          ctrl.soloLectura = 0;
                          getCamposData(authData);
                        } else {
                          console.log("entro a este.. ");
                          ctrl.soloLectura = 1;
                          ctrl.anularVista = true;
                          ctrl.viewLoading = false;
                          ctrl.motivoBloqueo =
                            "No tiene permisos para visualizar o realizar acciones sobre esta gestión.";
                          return;
                        }
                      } else {
                        toastr.error(response.data.ErrorSummary);
                      }
                    },
                    function (error) {
                      toastr.error(
                        error.data || sharedService.getGenericErrorMessage()
                      );
                    }
                  );
                }
              } else {
                toastr.error(response.data.ErrorSummary);
              }
            },
            function (error) {
              toastr.error(
                error.data || sharedService.getGenericErrorMessage()
              );
            }
          );
      }

      function getCamposData(authData) {
        if (ctrl.soloLectura == 0) {
          dataService
            .getCampoValorCompleto(
              $stateParams.solicitudProcesoTemplate,
              $stateParams.solicitud,
              $stateParams.solicitudEstado,
              $stateParams.procesoTemplate,
              $stateParams.template
            )
            .then(
              function (response) {
                if (response.data.Success) {
                  // console.log("getCampoValorCompleto***");
                  ctrl.camposList = response.data.Value;
                  ctrl.title =
                    "Carga de Gestión: " +
                    ctrl.camposList[0].SolicitudProcesoTemplate.ProcesoTemplate
                      .Template.Nombre;
                  ctrl.tituloCampoValor =
                    ctrl.camposList[0].SolicitudProcesoTemplate.Resumen;
                  // console.log(ctrl.camposList);
                  for (var i = 0; i < ctrl.camposList.length; i++) {
                    loadCampoData(ctrl.camposList[i], i);
                  } //for
                } else {
                  toastr.error(response.data.ErrorSummary);
                }
                ctrl.isCamposLoading = false;
                ctrl.viewLoading = false;
              },
              function (error) {
                toastr.error(
                  error.data || sharedService.getGenericErrorMessage()
                );
                ctrl.isCamposLoading = false;
                ctrl.viewLoading = false;
              }
            );
        } else {
          //Datos de solo lectura
          dataService
            .getCampoValorTextosCompleto(
              $stateParams.solicitudProcesoTemplate,
              $stateParams.solicitud,
              $stateParams.solicitudEstado,
              $stateParams.procesoTemplate,
              $stateParams.template
            )
            .then(
              function (response) {
                if (response.data.Success) {
                  ctrl.camposList = response.data.Value;
                  //console.log("getCampoValorTextosCompleto");
                  //console.log(ctrl.camposList);

                  ctrl.title =
                    "Carga de Gestión: " +
                    ctrl.camposList[0].SolicitudProcesoTemplate.ProcesoTemplate
                      .Template.Nombre;
                  ctrl.tituloCampoValor =
                    ctrl.camposList[0].SolicitudProcesoTemplate.Resumen;

                  for (var i = 0; i < ctrl.camposList.length; i++) {
                    loadCampoDataReadOnly(
                      i,
                      ctrl.camposList[i].Campo.CampoTipo
                    );
                  } //for
                } else {
                  toastr.error(response.data.ErrorSummary);
                }
                ctrl.isCamposLoading = false;
                ctrl.viewLoading = false;
              },
              function (error) {
                toastr.error(
                  error.data || sharedService.getGenericErrorMessage()
                );
                ctrl.isCamposLoading = false;
                ctrl.viewLoading = false;
              }
            );
        }
      }

      ctrl.AutorizarActionTemplate = function (tipoAutorizacion) {
        var authData = sharedService.getLoggedUser();
        console.log("FUNCION DE AUTORIAZAR");
        console.log(ctrl.AutorizarMsg);
        console.log(ctrl.model);
        if (ctrl.AutorizarMsg == undefined || ctrl.AutorizarMsg == "") {
          console.log("MNENSAJE ES NULL");
          Swal.fire({
            title: "Debe ingresar comentario.",
            type: "warning",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Aceptar",
            heightAuto: false,
          }).then(function (result) { });
          return;
        }
        var obj = {
          UsuarioId: authData.Id,
          SolicitudId: ctrl.solicitud.Id,
          EtapaId: ctrl.model.EstadoId,
          Comentario: ctrl.AutorizarMsg,
          EtapaNombre: ctrl.model.SolicitudEtapaNombre,
          TipoAutorizacion: tipoAutorizacion,
        };
        sharedService.showLoading();
        dataService.guardarAutorizacionTemplate(obj).then(
          function (response) {
            if (response.data.Success) {
              Swal.fire({
                title: "Autorización Guardada Correctamente.",
                type: "success",
                showCancelButton: false,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                heightAuto: false,
              }).then(function (result) {
                //.then((result) => {
                sharedService.closeLoading();
                $state.reload();
                //listarAutorizadasEtapa();
              });
              console.log("RESPONSE WEBSERVICE OK");
            } else {
              console.log("USUARIO YA AUTORIZCO O ES FALSEE");
              sharedService.closeLoading();
              toastr.error(response.data.ErrorSummary);
            }
          },
          function (error) {
            sharedService.closeLoading();
            toastr.error(error.data || sharedService.getGenericErrorMessage());
          }
        );
      };

      function loadCampoDataSolicitudList(item, i) {
        if (item == null || item.Campo == null || item.Campo.CampoTipo == null)
          return;

        switch (item.Campo.CampoTipo.Codigo) {
          case "PROCEDURE":
            ctrl.solicitudHasProceduresField = true;
            break;
          case "INT":
            ctrl.valoresCampoSolicitudList[
              i
            ].ValorObjeto = sharedService.addThousandSeparator(
              ctrl.valoresCampoSolicitudList[i].ValorObjeto
            );
            break;

          case "DECIMAL":
            ctrl.valoresCampoSolicitudList[
              i
            ].ValorObjeto = sharedService.addThousandSeparator(
              ctrl.valoresCampoSolicitudList[i].ValorObjeto
            );
            break;

          case "DATE":
            ctrl.valoresCampoSolicitudList[
              i
            ].ValorObjeto = sharedService.formatDate(
              ctrl.valoresCampoSolicitudList[i].ValorObjeto
            );
            break;

          case "JERARQ":
            if (
              ctrl.valoresCampoSolicitudList[i].ValorObjeto != null &&
              ctrl.valoresCampoSolicitudList[i].ValorObjeto.length > 0
            ) {
              for (
                var k = 0;
                k < ctrl.valoresCampoSolicitudList[i].ValorObjeto.length;
                k++
              ) {
                if (ctrl.valoresCampoSolicitudList[i].ValorObjeto[k] != null)
                  ctrl.valoresCampoSolicitudList[i].ValorObjeto[k].ValorInput =
                    ctrl.valoresCampoSolicitudList[i].ValorObjeto[k].Nombre;
              }
            } else {
              if (ctrl.valoresCampoSolicitudList[i].ValorObjeto == null)
                ctrl.valoresCampoSolicitudList[i].ValorObjeto = [];

              ctrl.valoresCampoSolicitudList[i].ValorObjeto.push({
                JerarquiaPadreId:
                  ctrl.valoresCampoSolicitudList[i].Campo.JerarquiaId,
                LoadingJerarquia: false,
                NoResults: false,
                Placeholder: "Cargando...",
              });
              loadJerarquiaPlaceholder(
                ctrl.valoresCampoSolicitudList[i].Campo.JerarquiaId,
                i,
                ctrl.valoresCampoSolicitudList[i].ValorObjeto.length - 1
              );
            }
            break;
          case "TABLE":
            loadTablaCampoSolicitud(i);
            break;
          case "COND":
            loadTablaCampoSolicitud(i);
            break;
        }
      }

      function loadCampoData(item, i) {
        if (item == null || item.Campo == null || item.Campo.CampoTipo == null)
          return;

        switch (item.Campo.CampoTipo.Codigo) {
          case "PROCEDURE":
            ctrl.solicitudHasProceduresField = true;
            break;
          case "INT":
            ctrl.camposList[i].ValorObjeto = sharedService.addThousandSeparator(
              ctrl.camposList[i].ValorObjeto
            );
            break;

          case "DECIMAL":
            ctrl.camposList[i].ValorObjeto = sharedService.addThousandSeparator(
              ctrl.camposList[i].ValorObjeto
            );
            break;

          case "DATE":
            ctrl.camposList[i].ValorObjeto = sharedService.formatDate(
              ctrl.camposList[i].ValorObjeto
            );
            break;

          case "JERARQ":
            if (
              ctrl.camposList[i].ValorObjeto != null &&
              ctrl.camposList[i].ValorObjeto.length > 0
            ) {
              for (var k = 0; k < ctrl.camposList[i].ValorObjeto.length; k++) {
                if (ctrl.camposList[i].ValorObjeto[k] != null)
                  ctrl.camposList[i].ValorObjeto[k].ValorInput =
                    ctrl.camposList[i].ValorObjeto[k].Nombre;
              }
            } else {
              if (ctrl.camposList[i].ValorObjeto == null)
                ctrl.camposList[i].ValorObjeto = [];

              ctrl.camposList[i].ValorObjeto.push({
                JerarquiaPadreId: ctrl.camposList[i].Campo.JerarquiaId,
                LoadingJerarquia: false,
                NoResults: false,
                Placeholder: "Cargando...",
              });
              loadJerarquiaPlaceholder(
                ctrl.camposList[i].Campo.JerarquiaId,
                i,
                ctrl.camposList[i].ValorObjeto.length - 1
              );
            }
            break;
          case "TABLE":
            loadTablaCampo(i);
            break;
          case "COND":
            loadTablaCampo(i);
            break;
        }
      }

      function loadTablaCampoSolicitud(index) {
        if (
          ctrl.valoresCampoSolicitudList[index].Valor != null &&
          ctrl.valoresCampoSolicitudList[index].Valor.length > 0
        ) {
          ctrl.valoresCampoSolicitudList[index].TablaFilas = [];
          var valorFilas = ctrl.valoresCampoSolicitudList[index].Valor.split(
            "^"
          );

          if (valorFilas != null && valorFilas.length > 0) {
            for (var k = 0; k < valorFilas.length; k++) {
              ctrl.valoresCampoSolicitudList[index].TablaFilas.push({
                Valor: [],
              });
              var valorColumnas = valorFilas[k].split("~");

              if (valorColumnas != null && valorColumnas.length > 0) {
                for (var h = 0; h < valorColumnas.length; h++) {
                  switch (
                  ctrl.valoresCampoSolicitudList[index].Campo.Columnas[h]
                    .ColumnaCampo.CampoTipo.Codigo
                  ) {
                    case "INT":
                      valorColumnas[h] = sharedService.addThousandSeparator(
                        valorColumnas[h]
                      );
                      break;
                    case "DECIMAL":
                      valorColumnas[h] = sharedService.addThousandSeparator(
                        valorColumnas[h]
                      );
                      break;
                    case "BOOL":
                      if (valorColumnas[h] == "true" || valorColumnas[h] == "1")
                        valorColumnas[h] = true;
                      else valorColumnas[h] = false;
                      break;
                    case "DATE":
                      valorColumnas[h] = sharedService.formatDate(
                        valorColumnas[h]
                      );
                      break;
                    default:
                      break;
                  }
                  ctrl.valoresCampoSolicitudList[index].TablaFilas[
                    k
                  ].Valor.push(valorColumnas[h]);
                }
              }
            }
          }
        }
      }

      function loadCampoDataReadOnly(index, campoTipo) {
        if (campoTipo == null || campoTipo.Codigo == null) return;

        if (index < 0) return;

        if (ctrl.camposList[index] == null) return;

        switch (campoTipo.Codigo) {
          case "INT":
            ctrl.camposList[index].Valor = sharedService.addThousandSeparator(
              ctrl.camposList[index].Valor
            );
            break;

          case "DECIMAL":
            ctrl.camposList[index].Valor = sharedService.addThousandSeparator(
              ctrl.camposList[index].Valor
            );
            break;

          case "TABLE":
            loadTablaCampo(index);
            break;

          case "JERARQ":
            if (
              ctrl.camposList[index].ValorObjeto != null &&
              ctrl.camposList[index].ValorObjeto.length > 0
            ) {
              for (
                var k = 0;
                k < ctrl.camposList[index].ValorObjeto.length;
                k++
              ) {
                if (ctrl.camposList[index].ValorObjeto[k] != null)
                  ctrl.camposList[index].ValorObjeto[k].ValorInput =
                    ctrl.camposList[index].ValorObjeto[k].Nombre;
              }
            } else {
              if (ctrl.camposList[index].ValorObjeto == null)
                ctrl.camposList[index].ValorObjeto = [];

              ctrl.camposList[index].ValorObjeto.push({
                JerarquiaPadreId: ctrl.camposList[index].Campo.JerarquiaId,
                LoadingJerarquia: false,
                NoResults: false,
                Placeholder: "Cargando...",
              });
              loadJerarquiaPlaceholder(
                ctrl.camposList[index].Campo.JerarquiaId,
                index,
                ctrl.camposList[index].ValorObjeto.length - 1
              );
            }
            break;

          case "COND":
            loadTablaCampo(index);
            break;
        } //switch
      }

      ctrl.concatRolesString = function (values) {
        return values
          .map(function (elem) {
            if (elem != null) return elem.Nombre;
            return "";
          })
          .join(", ");
      };

      function puedeverTemplate(
        solicitud,
        estadoCargaTemplate,
        rolesList,
        usuarioCreacionId,
        loggedUserId
      ) {
        if (sharedService.isSysAdminLoggedUser()) return true;
        var puedeVerTem = true;
        for (var i = 0; i < rolesList.length; i++) {
          if (rolesList[i].Codigo == "NONE") {
            puedeVerTem = false;
            break;
          }
        }
        return puedeVerTem;
      }

      function puedeEditarTemplate(
        solicitud,
        estadoCargaTemplate,
        rolesList,
        usuarioCreacionId,
        loggedUserId,
        solicitudProcesoTemplate
      ) {
        console.log("ingreso a puedeEditarTemplate");
        console.log("ASA!!!!");
        console.log(solicitud);
        console.log($stateParams.procesoTemplate);
        console.log(
          solicitudProcesoTemplate.ProcesoTemplate.Template
            .PermiteEditarTemplate
        );
        //PermiteEditarTemplate

        //No puede hacer nada si la solicitud se aprobo o cerro
        if (
          solicitud != null &&
          (solicitud.Estado.Codigo == "APRO" ||
            solicitud.Estado.Codigo == "CERR")
        )
          return false;

        if (sharedService.isSysAdminLoggedUser()) return true;

        var puedeEditar = false;

        for (var i = 0; i < rolesList.length; i++) {
          if (
            rolesList[i].Codigo == "ADMIN" ||
            rolesList[i].Codigo == "SUPERV"
          ) {
            puedeEditar = true;
            break;
          }

          //Si es creador, puede editar solo cuando no se haya avanzado la solicitud
          if (
            rolesList[i].Codigo == "CREADOR" &&
            usuarioCreacionId == loggedUserId
          ) {
            if (estadoCargaTemplate == null) {
              puedeEditar = true;
              break;
            } else {
              if (estadoCargaTemplate.Id == solicitud.Estado.Id) {
                puedeEditar = true;
                break;
              }
            }
          }
        }

        if (
          puedeEditar &&
          solicitudProcesoTemplate.ProcesoTemplate.Template
            .PermiteEditarTemplate
        ) {
          puedeEditar = true;
        } else {
          puedeEditar = false;
        }
        return puedeEditar;
      }

      function puedeCrearTemplate(solicitud, rolesList) {
        console.log(solicitud);
        if (solicitud != null) {
          ctrl.lProcesoIsDocumental = solicitud.Proceso.isDocumental;
        }
        //No puede hacer nada si la solicitud se aprobo o cerro
        if (
          solicitud != null &&
          (solicitud.Estado.Codigo == "APRO" ||
            solicitud.Estado.Codigo == "CERR") &&
          !ctrl.lProcesoIsDocumental
        ) {
          console.log("entro..");
          return false;
        }

        if (sharedService.isSysAdminLoggedUser()) return true;

        var puedeCrear = false;

        for (var i = 0; i < rolesList.length; i++) {
          if (
            rolesList[i].Codigo == "CREADOR" ||
            rolesList[i].Codigo == "ADMIN" ||
            rolesList[i].Codigo == "SUPERV"
          ) {
            puedeCrear = true;
            break;
          }
        }

        return puedeCrear;
      }

      function puedeBorrarTemplate(solicitud, rolesList) {
        //No puede hacer nada si la solicitud se aprobo o cerro
        if (
          solicitud != null &&
          (solicitud.Estado.Codigo == "APRO" ||
            solicitud.Estado.Codigo == "CERR")
        )
          return false;

        if (sharedService.isSysAdminLoggedUser()) return true;

        var puedeBorrar = false;

        for (var i = 0; i < rolesList.length; i++) {
          if (rolesList[i].Codigo == "ADMIN") {
            puedeBorrar = true;
            break;
          }
        }

        return puedeBorrar;
      }

      function loadTablaCampo(index) {
        if (
          ctrl.camposList[index].Valor != null &&
          ctrl.camposList[index].Valor.length > 0
        ) {
          ctrl.camposList[index].TablaFilas = [];
          var valorFilas = ctrl.camposList[index].Valor.split("^");

          if (valorFilas != null && valorFilas.length > 0) {
            for (var k = 0; k < valorFilas.length; k++) {
              ctrl.camposList[index].TablaFilas.push({
                Valor: [],
              });
              var valorColumnas = valorFilas[k].split("~");

              if (valorColumnas != null && valorColumnas.length > 0) {
                for (var h = 0; h < valorColumnas.length; h++) {
                  switch (
                  ctrl.camposList[index].Campo.Columnas[h].ColumnaCampo
                    .CampoTipo.Codigo
                  ) {
                    case "INT":
                      valorColumnas[h] = sharedService.addThousandSeparator(
                        valorColumnas[h]
                      );
                      break;

                    case "DECIMAL":
                      valorColumnas[h] = sharedService.addThousandSeparator(
                        valorColumnas[h]
                      );
                      break;
                    case "BOOL":
                      if (valorColumnas[h] == "true" || valorColumnas[h] == "1")
                        valorColumnas[h] = true;
                      else valorColumnas[h] = false;
                      break;

                    case "DATE":
                      valorColumnas[h] = sharedService.formatDate(
                        valorColumnas[h]
                      );
                      break;

                    default:
                      break;
                  }
                  ctrl.camposList[index].TablaFilas[k].Valor.push(
                    valorColumnas[h]
                  );
                }
              }
            }
          }
        }
      }

      function loadJerarquiaPlaceholder(
        jerarquiaPadreId,
        campoIndex,
        jerarquiaIndex
      ) {
        dataService.getJerarquiaMuestra(jerarquiaPadreId, 2).then(
          function (response) {
            if (response.data.Success) {
              var ph = "";

              if (response.data.Value != null) {
                if (response.data.Value.length > 0)
                  ph = "Ejemplo: " + response.data.Value[0].Nombre;

                if (response.data.Value.length > 1)
                  ph = ph + ", " + response.data.Value[1].Nombre;
              }

              ctrl.camposList[campoIndex].ValorObjeto[
                jerarquiaIndex
              ].Placeholder = ph;
            } else {
              toastr.error(response.data.ErrorSummary);
            }
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
          }
        );
      }

      ctrl.searchJerarquia = function (nombreJerarquia, padreId) {
        return dataService
          .searchJerarquiaByPadre(nombreJerarquia, padreId)
          .then(
            function (response) {
              if (response.data.Success) {
                return response.data.Value;
              } else {
                toastr.error(response.data.ErrorSummary);
              }
            },
            function (error) {
              toastr.error(
                error.data || sharedService.getGenericErrorMessage()
              );
            }
          );
      };

      ctrl.altaNuevaJerarquia = function (campoIndex, jerarquiaIndex) {
        ctrl.isBusy = true;
        var jerarquiaPadre = {};

        if (jerarquiaIndex > 0)
          jerarquiaPadre =
            ctrl.camposList[campoIndex].ValorObjeto[jerarquiaIndex - 1];
        else
          jerarquiaPadre = {
            Id:
              ctrl.camposList[campoIndex].ValorObjeto[jerarquiaIndex]
                .JerarquiaPadreId,
            Nombre: "",
          };

        var confirmation = $uibModal.open({
          animation: true,
          component: "altaJerarquia",
          resolve: {
            title: function () {
              return "Alta de Nueva Jerarquía";
            },
            JerarquiaPadre: function () {
              return jerarquiaPadre;
            },
          },
        });

        confirmation.result.then(
          function (returnValue) {
            ctrl.isBusy = false;
            ctrl.onSelectJerarquia(campoIndex, jerarquiaIndex, returnValue);
          },
          function () {
            ctrl.isBusy = false;
          }
        );
      };

      ctrl.onSelectJerarquia = function (
        campoIndex,
        jerarquiaIndex,
        jerarquiaSeleccionada
      ) {
        if (jerarquiaSeleccionada == null) return;

        if (campoIndex >= 0) {
          if (
            jerarquiaSeleccionada.Detalles != null &&
            jerarquiaSeleccionada.Detalles.length > 0
          )
            jerarquiaSeleccionada.Detalles.sort(function (a, b) {
              return parseInt(a.Orden) > parseInt(b.Orden)
                ? 1
                : parseInt(b.Orden) > parseInt(a.Orden)
                  ? -1
                  : 0;
            });

          ctrl.camposList[campoIndex].ValorObjeto[
            jerarquiaIndex
          ] = jerarquiaSeleccionada;
          ctrl.camposList[campoIndex].ValorObjeto[jerarquiaIndex].ValorInput =
            jerarquiaSeleccionada.Nombre;

          //Borrado de todas las jerarquias posteriores a la actual
          ctrl.camposList[campoIndex].ValorObjeto.splice(
            jerarquiaIndex + 1,
            ctrl.camposList[campoIndex].ValorObjeto.length - jerarquiaIndex - 1
          );
          ctrl.camposList[campoIndex].Valor = jerarquiaSeleccionada.Id; //Fixin jerarquia Templates.
        }

        dataService.validarJerarquiaTienePadre(jerarquiaSeleccionada.Id).then(
          function (response) {
            if (response.data.Success) {
              if (response.data.Value == true) {
                ctrl.camposList[campoIndex].ValorObjeto.push({
                  ValorInput: null,
                  JerarquiaPadreId: jerarquiaSeleccionada.Id,
                  LoadingJerarquia: false,
                  NoResults: false,
                  Placeholder: "Cargando...",
                });

                loadJerarquiaPlaceholder(
                  jerarquiaSeleccionada.Id,
                  campoIndex,
                  ctrl.camposList[campoIndex].ValorObjeto.length - 1
                );
              }
            } else {
              toastr.error(response.data.ErrorSummary);
            }
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
          }
        );
      };

      ctrl.searchCampoUsuario = function (nombreUsuario) {
        var filtroUsuario = {
          Login: nombreUsuario,
          PageSize: 20,
          SkipNumber: 0,
        };

        return dataService.searchUsuario(filtroUsuario).then(
          function (response) {
            if (response.data.Success) {
              return response.data.Value.Resultados;
            } else {
              toastr.error(response.data.ErrorSummary);
            }
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
          }
        );
      };

      ctrl.onSelectUsuarioMultiList = function (
        campoIndex,
        usuarioSeleccionado
      ) {
        if (usuarioSeleccionado == null) return;

        if (campoIndex >= 0) {
          if (ctrl.camposList[campoIndex].ValorObjeto == null)
            ctrl.camposList[campoIndex].ValorObjeto = [];

          for (
            var k = 0;
            k < ctrl.camposList[campoIndex].ValorObjeto.length;
            k++
          ) {
            if (
              ctrl.camposList[campoIndex].ValorObjeto[k].Id ==
              usuarioSeleccionado.Id
            ) {
              ctrl.usuarioCargado = null;
              return;
            }
          }

          ctrl.camposList[campoIndex].ValorObjeto.push(usuarioSeleccionado);
          // ctrl.camposList[campoIndex].Valor = ctrl.camposList[campoIndex].ValorObjeto.map(function(elem){
          //                                                                                 return elem.Id;
          //                                                                               }).join("|");
          ctrl.usuarioCargado = null;
        }
      };

      ctrl.deleteCampoUsuario = function (campoIndex, usuarioId) {
        if (ctrl.camposList[campoIndex].ValorObjeto == null) return;

        for (
          var k = 0;
          k < ctrl.camposList[campoIndex].ValorObjeto.length;
          k++
        ) {
          if (ctrl.camposList[campoIndex].ValorObjeto[k].Id == usuarioId) {
            ctrl.camposList[campoIndex].ValorObjeto.splice(k, 1);
            return;
          }
        }

        // ctrl.camposList[campoIndex].Valor = ctrl.camposList[campoIndex].ValorObjeto.map(function(elem){
        //                                                                                   return elem.Id;
        //                                                                                 }).join("|");
      };

      ctrl.onChangeInputTable = function (
        indexCampo,
        indexFila,
        indexColumna,
        valor
      ) {
        ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[
          indexColumna
        ] = valor;
      };

      ctrl.openAttachment = function (fileName) {
        window.open(appConfig.uploadUrl + fileName);
      };

      ctrl.getParametrosByIdent = function (Ident) {
        if (Ident != "") {
          dataService.obtenerParametrosByIdent(Ident).then(function (response) {
            if (response.data.Success && response.data.Value != null) {
              ctrl.LinkTemplate = response.data.Value;
              ctrl.showBtnLink = true;
            }
          });
        }
      };

      ctrl.uploadAttachment = function (file, item) {
        if (file == null) return;

        ctrl.isBusy = true;
        item.isLoading = true;

        dataService.updateFileCampoValor(file).then(
          function (response) {
            $timeout(function () {
              //console.log(response);
              if (response.data.Success) {
                //console.log('uploadFileAttachment: ' + response.data.Value);
                item.ValorObjeto = response.data.Value; //{ fileName: file.name, serverFileName: response.data.Value };
              } else {
                item.ValorObjeto = null;
              }
            });
            ctrl.isBusy = false;
            item.isLoading = false;
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
            ctrl.isBusy = false;
            item.isLoading = false;
          }
        );
      };

      ctrl.removeAttachment = function (item) {
        item.ValorObjeto = null;
      };

      ctrl.addUsuarioNotificar = function (item) {
        if (ctrl.procesoUsuariosNotificarList == null)
          ctrl.procesoUsuariosNotificarList = [];

        for (var i = 0; i < ctrl.procesoUsuariosNotificarList.length; i++) {
          if (
            ctrl.procesoUsuariosNotificarList[i].Usuario.Id == item.Usuario.Id
          )
            return;
        }

        ctrl.procesoUsuariosNotificarList.push(item);
        ctrl.procesoUsuariosNotificarDS = ctrl.procesoUsuariosNotificarList;
      };

      ctrl.removeUsuarioNotificar = function (index) {
        if (ctrl.procesoUsuariosNotificarList == null)
          ctrl.procesoUsuariosNotificarList = [];

        if (ctrl.procesoUsuariosNotificarList.length > 0)
          ctrl.procesoUsuariosNotificarList.splice(index, 1);

        ctrl.procesoUsuariosNotificarDS = ctrl.procesoUsuariosNotificarList;
      };

      ctrl.onNumericInputGotFocus = function (nStr) {
        return sharedService.replaceAll(nStr, ",", "");
      };

      ctrl.onNumericInputLostFocus = function (nStr) {
        return sharedService.addThousandSeparator(nStr);
      };

      ctrl.save = function (form) {

        /*if (
          ((ctrl.procesoUsuariosNotificarList != null &&
            ctrl.procesoUsuariosNotificarList.length > 0) ||
            (ctrl.mailsAdicionales != null &&
              ctrl.mailsAdicionales.length > 0)) &&
          (ctrl.mensajeNotificacion == null ||
            ctrl.mensajeNotificacion.length == 0)
        ) {
          toastr.error(
            "Debe ingresar un mensaje para enviar las notificaciones a los usuarios seleccionados"
          );
          return;
        }*/

        if (
          ctrl.mensajeNotificacion != null &&
          ctrl.mensajeNotificacion.length > 0 &&
          (ctrl.procesoUsuariosNotificarList == null ||
            ctrl.procesoUsuariosNotificarList.length <= 0) &&
          (ctrl.mailsAdicionales == null || ctrl.mailsAdicionales.length <= 0)
        ) {
          toastr.error(
            "Debe seleccionar usuarios para enviar el mensaje a notificar o ingresar mails externos"
          );
          return;
        }

        ctrl.isBusy = true;

        if (ctrl.camposList != null) {
          for (var i = 0; i < ctrl.camposList.length; i++) {
            ctrl.camposList[i].SolicitudProcesoTemplate.Resumen =
              ctrl.tituloCampoValor;

            if (ctrl.camposList[i].Campo.CampoTipo.Codigo == "TABLE") {
              if (ctrl.camposList[i].TablaFilas != null) {
                var filaValor = "";

                for (var j = 0; j < ctrl.camposList[i].TablaFilas.length; j++) {
                  if (j > 0) filaValor += "^";

                  if (ctrl.camposList[i].TablaFilas[j].Valor != null) {
                    var colValor = "";

                    for (
                      var k = 0;
                      k < ctrl.camposList[i].TablaFilas[j].Valor.length;
                      k++
                    ) {
                      if (k > 0) colValor += "~";

                      colValor += ctrl.camposList[i].TablaFilas[j].Valor[k];
                    }

                    filaValor += colValor;
                  }
                }
              }
              ctrl.camposList[i].Valor = filaValor;
              ctrl.camposList[i].ValorObjeto = filaValor;
            }
            if (ctrl.camposList[i].Campo.CampoTipo.Codigo == "COND") {
              if (ctrl.camposList[i].TablaFilas != null) {
                var filaValor = "";
                //console.log(ctrl.camposList[i].TablaFilas[0].Valor);
                try {
                  filaValor += ctrl.camposList[i].TablaFilas[0].Valor[0];
                  filaValor += "~";

                  filaValor += ctrl.camposList[i].TablaFilas[0].Valor[1];
                } catch (exception) {
                  filaValor += "";
                }
              }
              ctrl.camposList[i].Valor = filaValor;
              ctrl.camposList[i].ValorObjeto = filaValor;
            }
          }
        }
        console.log("saveCampoValor *****");
        console.log(ctrl.camposList);
        var camposListTemp = ctrl.camposList;

        dataService.saveCampoValor(ctrl.camposList).then(
          function (response) {
            if (response.data.Success) {
              ctrl.camposList = response.data.Value;
              //Enviar notificaciones
              if (
                (ctrl.procesoUsuariosNotificarList != null &&
                  ctrl.procesoUsuariosNotificarList.length > 0) ||
                (ctrl.mailsAdicionales != null &&
                  ctrl.mailsAdicionales.length > 0)
              ) {
                var notificacion = {
                  Usuarios: [],
                  Asunto: "Kahuna | " + ctrl.title,
                  Mensaje: ctrl.mensajeNotificacion,
                  Valores: ctrl.camposList,
                  MailsAdicionales: ctrl.mailsAdicionales,
                };

                for (
                  var i = 0;
                  i < ctrl.procesoUsuariosNotificarList.length;
                  i++
                )
                  notificacion.Usuarios.push(
                    ctrl.procesoUsuariosNotificarList[i].Usuario
                  );

                dataService.notificacionesCampoValor(notificacion).then(
                  function (response) {
                    if (response.data.Success) {
                      $state.reload();
                      /*$state.go("pages.solicitud-edit", {
                        id: $stateParams.solicitud,
                        // grupo: $state.params.grupoId, 
                        proceso: $stateParams.proceso,
                        solicitudPadreId: 0
                      });*/
                    } else {
                      toastr.error(response.data.ErrorSummary);
                    }
                  },
                  function (error) {
                    toastr.error(
                      error.data || sharedService.getGenericErrorMessage()
                    );
                  }
                );
              }

              console.log("saveSolicitudCampoValor");
              if (ctrl.generaProcesoRelacionados) {
                console.log("genera procesos RElacionados es TRUE!!!!");
                console.log(camposListTemp);
                console.log(ctrl.camposList[0].SolicitudProcesoTemplateId);

                angular.forEach(camposListTemp, function (value, key) {
                  camposListTemp[key].SolicitudProcesoTemplateId =
                    ctrl.camposList[0].SolicitudProcesoTemplateId;
                });

                dataService
                  .SaveSolicitudCampoValorGeneraProcesosTemplates(
                    camposListTemp
                  )
                  .then(function (data) {
                    toastr.info("Operacion exitosa.");
                    $state.go("pages.solicitud-edit", {
                      id: $stateParams.solicitud,
                      // grupo: $state.params.grupoId,
                      proceso: $stateParams.proceso,
                      solicitudPadreId: 0,
                    });
                  });
              } else {
                console.log("genera procesos Relacionados es FALSE!!!!");
                toastr.info("Operacion exitosa.");
                $state.go("pages.solicitud-edit", {
                  id: $stateParams.solicitud,
                  // grupo: $state.params.grupoId,
                  proceso: $stateParams.proceso,
                  solicitudPadreId: 0,
                });
              }
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
            ctrl.isBusy = false;
          }
        );
      };

      ctrl.delete = function () {
        ctrl.isBusy = true;
        var confirmation = $uibModal.open({
          animation: true,
          component: "confirmation",
          resolve: {
            title: function () {
              return "Atención";
            },
            message: function () {
              return "Confirma el borrado de la gestión actual?";
            },
          },
        });

        confirmation.result.then(
          function (selectedItem) {
            dataService
              .deleteCampoValor($stateParams.solicitudProcesoTemplate)
              .then(
                function (response) {
                  if (response.data.Success) {
                    toastr.info("Operación exitosa.");
                    ctrl.cancel();
                  } else {
                    toastr.error(response.data.ErrorSummary);
                  }
                  ctrl.isBusy = false;
                },
                function (error) {
                  toastr.error(
                    error.data || sharedService.getGenericErrorMessage()
                  );
                  ctrl.isBusy = false;
                }
              );
          },
          function () {
            ctrl.isBusy = false;
          }
        );
      };
      ctrl.evaluatenumber = function (event) {
        var charCode = event.which ? event.which : event.keyCode;
        if (
          charCode == 8 ||
          charCode == 35 ||
          charCode == 36 ||
          charCode == 37 ||
          charCode == 39 ||
          charCode == 45 ||
          charCode == 46 ||
          charCode == 96 ||
          charCode == 109
        ) {
          return true;
        } else if (charCode >= 97 && charCode <= 105) {
          return true;
        } else if (charCode < 48 || charCode > 57) {
          event.preventDefault();
          return false;
        } else {
          return true;
        }
      };

      //Previene que se ingresen separadores de miles, la coma o el punto
      ctrl.evaluatenumberDigit = function (event) {
        var charCode = event.which ? event.which : event.keyCode;
        console.log(charCode);
        if (
          charCode == 8 ||
          charCode == 35 ||
          charCode == 36 ||
          charCode == 37 ||
          charCode == 39 ||
          charCode == 45 ||
          charCode == 46 ||
          charCode == 96 ||
          charCode == 109
        ) {
          return true;
        } else if (charCode >= 97 && charCode <= 105) {
          return true;
        } else if (charCode < 48 || charCode > 57) {
          event.preventDefault();
          return false;
        } else {
          return true;
        }
      };

      ctrl.evaluatenumberDecimal = function (event) {
        var charCode = event.which ? event.which : event.keyCode;
        if (
          charCode == 8 ||
          charCode == 35 ||
          charCode == 36 ||
          charCode == 37 ||
          charCode == 39 ||
          charCode == 45 ||
          charCode == 46 ||
          charCode == 96 ||
          charCode == 190 ||
          charCode == 109 ||
          charCode == 110
        ) {
          return true;
        } else if (charCode >= 97 && charCode <= 105) {
          return true;
        } else if (charCode < 48 || charCode > 57) {
          event.preventDefault();
          return false;
        } else {
          return true;
        }
      };

      ctrl.onChangeInputTableCond = function (
        indexCampo,
        indexFila,
        indexColumna,
        valor
      ) {
        ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[
          indexColumna
        ] = valor;
      };

      ctrl.onChangeInputcond = function (item) {
        console.log((item.Valor[1] = ""));
      };

      ctrl.cancel = function () {
        if ($stateParams.solicitud == 0) {
          $state.transitionTo("pages.solicitud");
        } else {
          $state.go("pages.solicitud-edit", {
            id: $stateParams.solicitud,
            //grupo: $state.params.grupoId,
            proceso: $stateParams.proceso,
            solicitudPadreId: 0,
          });
        }
      };

      ctrl.initListadoProcesos = function () {
        console.log("INICIALÑIOZANDO EL LISTADO DE LOS POROCESOSS::!!!");
        ctrl.isSearching = true;
        ctrl.filtros = {
          PageSize: 1000,
          SkipNumber: 0,
        };
        dataService.searchProceso(ctrl.filtros).then(
          function (response) {
            if (response.data.Success) {
              ctrl.listadoDeProcesos = response.data.Value.Resultados;
              console.log(ctrl.listadoDeProcesos);
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isSearching = false;
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
            ctrl.isSearching = false;
          }
        );
      };
      ctrl.initListadoProcesos_doc = function () {
        console.log("INICIALÑIOZANDO EL LISTADO DE LOS POROCESOSS::!!!");
        ctrl.isSearching = true;
        ctrl.filtros = {
          PageSize: 1000,
          SkipNumber: 0,
        };
        dataService.searchProceso_doc(ctrl.filtros).then(
          function (response) {
            if (response.data.Success) {
              ctrl.listadoDeProcesos_doc = response.data.Value.Resultados;
              console.log(ctrl.listadoDeProcesos_doc);
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isSearching = false;
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
            ctrl.isSearching = false;
          }
        );
      };
      ctrl.onChangeSelectProcesoSeleccionado = function (procesoSeleccionado) {
        console.log(procesoSeleccionado);
      };
      ctrl.onChangeSelectProcesoSeleccionado_doc = function (
        procesoSeleccionado_doc
      ) {
        console.log(procesoSeleccionado_doc);
      };
      ctrl.searchCampoSolicitud = function (nombreUsuario) {
        var filtroUsuario = {
          Login: nombreUsuario,
          PageSize: 20,
          SkipNumber: 0,
        };

        if (
          ctrl.procesoSeleccionado != null &&
          ctrl.procesoSeleccionado.Id != ""
        ) {
          var filtrosSolicitud = {
            ProcesoId: ctrl.procesoSeleccionado.Id,
            Descripcion: nombreUsuario,
            PageSize: 100,
            SkipNumber: 0,
            VerTodos: true,
            VerProcesosPendientesOtrosUsuarios: false,
          };

          return dataService.searchSolicitud(filtrosSolicitud).then(
            function (response) {
              if (response.data.Success) {
                console.log(response);
                ctrl.ListarSolicitudesProceso = response.data.Value.Resultados;
                return response.data.Value.Resultados;
              } else {
                toastr.error(response.data.ErrorSummary);
              }
            },
            function (error) {
              toastr.error(
                error.data || sharedService.getGenericErrorMessage()
              );
            }
          );
        } else {
          console.log("seleccione el proceso.");
        }
      };
      ctrl.searchCampoSolicitud_doc = function (nombreUsuario) {
        var filtroUsuario = {
          Login: nombreUsuario,
          PageSize: 20,
          SkipNumber: 0,
        };

        if (
          ctrl.procesoSeleccionado_doc != null &&
          ctrl.procesoSeleccionado_doc.Id != ""
        ) {
          var filtrosSolicitud = {
            ProcesoId: ctrl.procesoSeleccionado_doc.Id,
            Descripcion: nombreUsuario,
            PageSize: 100,
            SkipNumber: 0,
            VerTodos: true,
            VerProcesosPendientesOtrosUsuarios: false,
          };

          return dataService.searchSolicitud_doc(filtrosSolicitud).then(
            function (response) {
              if (response.data.Success) {
                console.log(response);
                ctrl.ListarSolicitudesProceso_doc =
                  response.data.Value.Resultados;
                return response.data.Value.Resultados;
              } else {
                toastr.error(response.data.ErrorSummary);
              }
            },
            function (error) {
              toastr.error(
                error.data || sharedService.getGenericErrorMessage()
              );
            }
          );
        } else {
          console.log("seleccione el proceso.");
        }
      };

      ctrl.onSelectSolicitudMultiList = function (
        campoIndex,
        itemSeleccionado
      ) {
        console.log(itemSeleccionado);

        if (itemSeleccionado == null) return;

        if (campoIndex >= 0) {
          if (
            ctrl.camposList[campoIndex].ValorObjeto == null ||
            ctrl.camposList[campoIndex].ValorObjeto == ""
          )
            ctrl.camposList[campoIndex].ValorObjeto = [];

          for (
            var k = 0;
            k < ctrl.camposList[campoIndex].ValorObjeto.length;
            k++
          ) {
            if (
              ctrl.camposList[campoIndex].ValorObjeto[k].Id ==
              itemSeleccionado.Id
            ) {
              ctrl.solicitudCargada = null;
              return;
            }
          }

          var obj = {
            Id: itemSeleccionado.Id,
            Numero: itemSeleccionado.Numero,
            NumeroCompleto: itemSeleccionado.NumeroCompleto,
            ProcesoId: itemSeleccionado.ProcesoId,
            Descripcion: itemSeleccionado.Descripcion,
            DescripcionResumida: itemSeleccionado.DescripcionResumida,
            Proceso: {
              Id: itemSeleccionado.Proceso.Id,
              Nombre: itemSeleccionado.Proceso.Nombre,
              GrupoId: itemSeleccionado.Proceso.GrupoId,
            },
          };

          ctrl.camposList[campoIndex].ValorObjeto.push(obj);
          ctrl.solicitudCargada = null;
        }
      };
      ctrl.onSelectSolicitudMultiList_doc = function (
        campoIndex,
        itemSeleccionado
      ) {
        console.log(itemSeleccionado);

        if (itemSeleccionado == null) return;

        if (campoIndex >= 0) {
          if (
            ctrl.camposList[campoIndex].ValorObjeto == null ||
            ctrl.camposList[campoIndex].ValorObjeto == ""
          )
            ctrl.camposList[campoIndex].ValorObjeto = [];

          for (
            var k = 0;
            k < ctrl.camposList[campoIndex].ValorObjeto.length;
            k++
          ) {
            if (
              ctrl.camposList[campoIndex].ValorObjeto[k].Id ==
              itemSeleccionado.Id
            ) {
              ctrl.solicitudCargada_doc = null;
              return;
            }
          }

          var obj = {
            Id: itemSeleccionado.Id,
            Numero: itemSeleccionado.Numero,
            NumeroCompleto: itemSeleccionado.NumeroCompleto,
            ProcesoId: itemSeleccionado.ProcesoId,
            Descripcion: itemSeleccionado.Descripcion,
            DescripcionResumida: itemSeleccionado.DescripcionResumida,
            Proceso: {
              Id: itemSeleccionado.Proceso.Id,
              Nombre: itemSeleccionado.Proceso.Nombre,
              GrupoId: itemSeleccionado.Proceso.GrupoId,
            },
          };

          ctrl.camposList[campoIndex].ValorObjeto.push(obj);
          ctrl.solicitudCargada_doc = null;
        }
      };

      ctrl.deleteCampoSolicitud = function (campoIndex, usuarioId) {
        if (ctrl.camposList[campoIndex].ValorObjeto == null) return;

        for (
          var k = 0;
          k < ctrl.camposList[campoIndex].ValorObjeto.length;
          k++
        ) {
          if (ctrl.camposList[campoIndex].ValorObjeto[k].Id == usuarioId) {
            ctrl.camposList[campoIndex].ValorObjeto.splice(k, 1);
            return;
          }
        }
      };
    },
  });
})(window.angular);

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Kahuna.pages.template').component('tablesPageCtrl', {
    templateUrl: 'app/pages/tables/editableRowTable.html',
    controller: function ($scope, $state, $filter, dataService, toastr, toastrConfig, $stateParams, $uibModal, editableOptions, editableThemes) {
  /** @ngInject */
  
  $scope.smartTablePageSize = 10;

    $scope.smartTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45'
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18'
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20'
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30'
      },
      {
        id: 6,
        firstName: 'Ann',
        lastName: 'Smith',
        username: '@ann',
        email: 'ann@gmail.com',
        age: '21'
      },
      {
        id: 7,
        firstName: 'Barbara',
        lastName: 'Black',
        username: '@barbara',
        email: 'barbara@yandex.ru',
        age: '43'
      },
      {
        id: 8,
        firstName: 'Sevan',
        lastName: 'Bagrat',
        username: '@sevan',
        email: 'sevan@outlook.com',
        age: '13'
      },
      {
        id: 9,
        firstName: 'Ruben',
        lastName: 'Vardan',
        username: '@ruben',
        email: 'ruben@gmail.com',
        age: '22'
      },
      {
        id: 10,
        firstName: 'Karen',
        lastName: 'Sevan',
        username: '@karen',
        email: 'karen@yandex.ru',
        age: '33'
      },
      {
        id: 11,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mark',
        email: 'mark@gmail.com',
        age: '38'
      },
      {
        id: 12,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@jacob',
        email: 'jacob@yandex.ru',
        age: '48'
      },
      {
        id: 13,
        firstName: 'Haik',
        lastName: 'Hakob',
        username: '@haik',
        email: 'haik@outlook.com',
        age: '48'
      },
      {
        id: 14,
        firstName: 'Garegin',
        lastName: 'Jirair',
        username: '@garegin',
        email: 'garegin@gmail.com',
        age: '40'
      },
      {
        id: 15,
        firstName: 'Krikor',
        lastName: 'Bedros',
        username: '@krikor',
        email: 'krikor@yandex.ru',
        age: '32'
      },
      {
        "id": 16,
        "firstName": "Francisca",
        "lastName": "Brady",
        "username": "@Gibson",
        "email": "franciscagibson@comtours.com",
        "age": 11
      },
      {
        "id": 17,
        "firstName": "Tillman",
        "lastName": "Figueroa",
        "username": "@Snow",
        "email": "tillmansnow@comtours.com",
        "age": 34
      },
      {
        "id": 18,
        "firstName": "Jimenez",
        "lastName": "Morris",
        "username": "@Bryant",
        "email": "jimenezbryant@comtours.com",
        "age": 45
      },
      {
        "id": 19,
        "firstName": "Sandoval",
        "lastName": "Jacobson",
        "username": "@Mcbride",
        "email": "sandovalmcbride@comtours.com",
        "age": 32
      },
      {
        "id": 20,
        "firstName": "Griffin",
        "lastName": "Torres",
        "username": "@Charles",
        "email": "griffincharles@comtours.com",
        "age": 19
      },
      {
        "id": 21,
        "firstName": "Cora",
        "lastName": "Parker",
        "username": "@Caldwell",
        "email": "coracaldwell@comtours.com",
        "age": 27
      },
      {
        "id": 22,
        "firstName": "Cindy",
        "lastName": "Bond",
        "username": "@Velez",
        "email": "cindyvelez@comtours.com",
        "age": 24
      },
      {
        "id": 23,
        "firstName": "Frieda",
        "lastName": "Tyson",
        "username": "@Craig",
        "email": "friedacraig@comtours.com",
        "age": 45
      },
      {
        "id": 24,
        "firstName": "Cote",
        "lastName": "Holcomb",
        "username": "@Rowe",
        "email": "coterowe@comtours.com",
        "age": 20
      },
      {
        "id": 25,
        "firstName": "Trujillo",
        "lastName": "Mejia",
        "username": "@Valenzuela",
        "email": "trujillovalenzuela@comtours.com",
        "age": 16
      },
      {
        "id": 26,
        "firstName": "Pruitt",
        "lastName": "Shepard",
        "username": "@Sloan",
        "email": "pruittsloan@comtours.com",
        "age": 44
      },
      {
        "id": 27,
        "firstName": "Sutton",
        "lastName": "Ortega",
        "username": "@Black",
        "email": "suttonblack@comtours.com",
        "age": 42
      },
      {
        "id": 28,
        "firstName": "Marion",
        "lastName": "Heath",
        "username": "@Espinoza",
        "email": "marionespinoza@comtours.com",
        "age": 47
      },
      {
        "id": 29,
        "firstName": "Newman",
        "lastName": "Hicks",
        "username": "@Keith",
        "email": "newmankeith@comtours.com",
        "age": 15
      },
      {
        "id": 30,
        "firstName": "Boyle",
        "lastName": "Larson",
        "username": "@Summers",
        "email": "boylesummers@comtours.com",
        "age": 32
      },
      {
        "id": 31,
        "firstName": "Haynes",
        "lastName": "Vinson",
        "username": "@Mckenzie",
        "email": "haynesmckenzie@comtours.com",
        "age": 15
      },
      {
        "id": 32,
        "firstName": "Miller",
        "lastName": "Acosta",
        "username": "@Young",
        "email": "milleryoung@comtours.com",
        "age": 55
      },
      {
        "id": 33,
        "firstName": "Johnston",
        "lastName": "Brown",
        "username": "@Knight",
        "email": "johnstonknight@comtours.com",
        "age": 29
      },
      {
        "id": 34,
        "firstName": "Lena",
        "lastName": "Pitts",
        "username": "@Forbes",
        "email": "lenaforbes@comtours.com",
        "age": 25
      },
      {
        "id": 35,
        "firstName": "Terrie",
        "lastName": "Kennedy",
        "username": "@Branch",
        "email": "terriebranch@comtours.com",
        "age": 37
      },
      {
        "id": 36,
        "firstName": "Louise",
        "lastName": "Aguirre",
        "username": "@Kirby",
        "email": "louisekirby@comtours.com",
        "age": 44
      },
      {
        "id": 37,
        "firstName": "David",
        "lastName": "Patton",
        "username": "@Sanders",
        "email": "davidsanders@comtours.com",
        "age": 26
      },
      {
        "id": 38,
        "firstName": "Holden",
        "lastName": "Barlow",
        "username": "@Mckinney",
        "email": "holdenmckinney@comtours.com",
        "age": 11
      },
      {
        "id": 39,
        "firstName": "Baker",
        "lastName": "Rivera",
        "username": "@Montoya",
        "email": "bakermontoya@comtours.com",
        "age": 47
      },
      {
        "id": 40,
        "firstName": "Belinda",
        "lastName": "Lloyd",
        "username": "@Calderon",
        "email": "belindacalderon@comtours.com",
        "age": 21
      },
      {
        "id": 41,
        "firstName": "Pearson",
        "lastName": "Patrick",
        "username": "@Clements",
        "email": "pearsonclements@comtours.com",
        "age": 42
      },
      {
        "id": 42,
        "firstName": "Alyce",
        "lastName": "Mckee",
        "username": "@Daugherty",
        "email": "alycedaugherty@comtours.com",
        "age": 55
      },
      {
        "id": 43,
        "firstName": "Valencia",
        "lastName": "Spence",
        "username": "@Olsen",
        "email": "valenciaolsen@comtours.com",
        "age": 20
      },
      {
        "id": 44,
        "firstName": "Leach",
        "lastName": "Holcomb",
        "username": "@Humphrey",
        "email": "leachhumphrey@comtours.com",
        "age": 28
      },
      {
        "id": 45,
        "firstName": "Moss",
        "lastName": "Baxter",
        "username": "@Fitzpatrick",
        "email": "mossfitzpatrick@comtours.com",
        "age": 51
      },
      {
        "id": 46,
        "firstName": "Jeanne",
        "lastName": "Cooke",
        "username": "@Ward",
        "email": "jeanneward@comtours.com",
        "age": 59
      },
      {
        "id": 47,
        "firstName": "Wilma",
        "lastName": "Briggs",
        "username": "@Kidd",
        "email": "wilmakidd@comtours.com",
        "age": 53
      },
      {
        "id": 48,
        "firstName": "Beatrice",
        "lastName": "Perry",
        "username": "@Gilbert",
        "email": "beatricegilbert@comtours.com",
        "age": 39
      },
      {
        "id": 49,
        "firstName": "Whitaker",
        "lastName": "Hyde",
        "username": "@Mcdonald",
        "email": "whitakermcdonald@comtours.com",
        "age": 35
      },
      {
        "id": 50,
        "firstName": "Rebekah",
        "lastName": "Duran",
        "username": "@Gross",
        "email": "rebekahgross@comtours.com",
        "age": 40
      },
      {
        "id": 51,
        "firstName": "Earline",
        "lastName": "Mayer",
        "username": "@Woodward",
        "email": "earlinewoodward@comtours.com",
        "age": 52
      },
      {
        "id": 52,
        "firstName": "Moran",
        "lastName": "Baxter",
        "username": "@Johns",
        "email": "moranjohns@comtours.com",
        "age": 20
      },
      {
        "id": 53,
        "firstName": "Nanette",
        "lastName": "Hubbard",
        "username": "@Cooke",
        "email": "nanettecooke@comtours.com",
        "age": 55
      },
      {
        "id": 54,
        "firstName": "Dalton",
        "lastName": "Walker",
        "username": "@Hendricks",
        "email": "daltonhendricks@comtours.com",
        "age": 25
      },
      {
        "id": 55,
        "firstName": "Bennett",
        "lastName": "Blake",
        "username": "@Pena",
        "email": "bennettpena@comtours.com",
        "age": 13
      },
      {
        "id": 56,
        "firstName": "Kellie",
        "lastName": "Horton",
        "username": "@Weiss",
        "email": "kellieweiss@comtours.com",
        "age": 48
      },
      {
        "id": 57,
        "firstName": "Hobbs",
        "lastName": "Talley",
        "username": "@Sanford",
        "email": "hobbssanford@comtours.com",
        "age": 28
      },
      {
        "id": 58,
        "firstName": "Mcguire",
        "lastName": "Donaldson",
        "username": "@Roman",
        "email": "mcguireroman@comtours.com",
        "age": 38
      },
      {
        "id": 59,
        "firstName": "Rodriquez",
        "lastName": "Saunders",
        "username": "@Harper",
        "email": "rodriquezharper@comtours.com",
        "age": 20
      },
      {
        "id": 60,
        "firstName": "Lou",
        "lastName": "Conner",
        "username": "@Sanchez",
        "email": "lousanchez@comtours.com",
        "age": 16
      }
    ];

    $scope.editableTableData = $scope.smartTableData.slice(0, 36);

    $scope.peopleTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28',
        status: 'info'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45',
        status: 'primary'
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18',
        status: 'success'
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20',
        status: 'danger'
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30',
        status: 'warning'
      }
    ];

    $scope.metricsTableData = [
      {
        image: 'app/browsers/chrome.svg',
        browser: 'Google Chrome',
        visits: '10,392',
        isVisitsUp: true,
        purchases: '4,214',
        isPurchasesUp: true,
        percent: '45%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/firefox.svg',
        browser: 'Mozilla Firefox',
        visits: '7,873',
        isVisitsUp: true,
        purchases: '3,031',
        isPurchasesUp: false,
        percent: '28%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/ie.svg',
        browser: 'Internet Explorer',
        visits: '5,890',
        isVisitsUp: false,
        purchases: '2,102',
        isPurchasesUp: false,
        percent: '17%',
        isPercentUp: false
      },
      {
        image: 'app/browsers/safari.svg',
        browser: 'Safari',
        visits: '4,001',
        isVisitsUp: false,
        purchases: '1,001',
        isPurchasesUp: false,
        percent: '14%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/opera.svg',
        browser: 'Opera',
        visits: '1,833',
        isVisitsUp: true,
        purchases: '83',
        isPurchasesUp: true,
        percent: '5%',
        isPercentUp: false
      }
    ];

    $scope.users = [
      {
        "id": 1,
        "name": "Esther Vang",
        "status": 4,
        "group": 3
      },
      {
        "id": 2,
        "name": "Leah Freeman",
        "status": 3,
        "group": 1
      },
      {
        "id": 3,
        "name": "Mathews Simpson",
        "status": 3,
        "group": 2
      },
      {
        "id": 4,
        "name": "Buckley Hopkins",
        "group": 4
      },
      {
        "id": 5,
        "name": "Buckley Schwartz",
        "status": 1,
        "group": 1
      },
      {
        "id": 6,
        "name": "Mathews Hopkins",
        "status": 4,
        "group": 2
      },
      {
        "id": 7,
        "name": "Leah Vang",
        "status": 4,
        "group": 1
      },
      {
        "id": 8,
        "name": "Vang Schwartz",
        "status": 4,
        "group": 2
      },
      {
        "id": 9,
        "name": "Hopkin Esther",
        "status": 1,
        "group": 2
      },
      {
        "id": 10,
        "name": "Mathews Schwartz",
        "status": 1,
        "group": 3
      }
    ];

    $scope.statuses = [
      {value: 1, text: 'Good'},
      {value: 2, text: 'Awesome'},
      {value: 3, text: 'Excellent'},
    ];

    $scope.groups = [
      {id: 1, text: 'user'},
      {id: 2, text: 'customer'},
      {id: 3, text: 'vip'},
      {id: 4, text: 'admin'}
    ];

    $scope.showGroup = function(user) {
      if(user.group && $scope.groups.length) {
        var selected = $filter('filter')($scope.groups, {id: user.group});
        return selected.length ? selected[0].text : 'Not set';
      } else return 'Not set'
    };

    $scope.showStatus = function(user) {
      var selected = [];
      if(user.status) {
        selected = $filter('filter')($scope.statuses, {value: user.status});
      }
      return selected.length ? selected[0].text : 'Not set';
    };


    $scope.removeUser = function(index) {
      $scope.users.splice(index, 1);
    };

    $scope.addUser = function() {
      $scope.inserted = {
        id: $scope.users.length+1,
        name: '',
        status: null,
        group: null
      };
      $scope.users.push($scope.inserted);
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }
});
})(window.angular);

(function (angular) {
  'use strict';
  angular.module('Kahuna.pages.usuario').component('usuarioEdit', {
    templateUrl: 'app/pages/usuario/edit.template.html',
    controller: function ($scope, $state, dataService, sharedService, toastr, toastrConfig, $stateParams, $uibModal) {
      var ctrl = this;
      var authData = {};
      ctrl.model = {};
      ctrl.isBusy = false;
      ctrl.showDelete = false;
      ctrl.title = 'Datos del Usuario';
      ctrl.rolesList = {};
      ctrl.rolesSeleccionados = null;
      ctrl.mailIngresado = null;
      ctrl.model.CanCreateProcess = true;
      ctrl.lUsuarioLogeado = {};
      ctrl.lsuarioLogueadoIsSysAdmin = false;

      this.$onInit = function () {
        ctrl.lsuarioLogueadoIsSysAdmin = sharedService.isSuperAdminLoggedUser();
        console.log(ctrl.lsuarioLogueadoIsSysAdmin);
        authData = sharedService.getLoggedUser();
        if (authData != null && authData.Id > 0) {
          ctrl.lUsuarioLogeado = authData;
          console.log(ctrl.lUsuarioLogeado);
        } else {
          $state.go('auth');
        }

        dataService.getRolesList()
          .then(function (response) {
            if (response.data.Success) {
              ctrl.rolesList = response.data.Value;
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
          });

        if ($stateParams.id != "0") {
          ctrl.title = 'Editar Usuario';

          dataService.getUsuarioById($stateParams.id)
            .then(function (response) {
              if (response.data.Success) {
                ctrl.showDelete = true;
                ctrl.model = response.data.Value;

                ctrl.model.ConfirmaClave = ctrl.model.Clave;
                ctrl.rolesSeleccionados = [];

                if (ctrl.model.Roles != null && ctrl.model.Roles.length > 0) {
                  for (var i = 0; i < ctrl.model.Roles.length; i++)
                    ctrl.rolesSeleccionados.push(ctrl.model.Roles[i].Rol);
                }
              }
              else {
                toastr.error(response.data.ErrorSummary);
              }
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage());
            });
        }
        else {
          ctrl.title = 'Crear Usuario';
        }
      };


     
      ctrl.save = function (form) {
        if (ctrl.model.Login == null ||
          ctrl.model.Login == '' ||
          ctrl.model.Clave == null ||
          ctrl.model.Clave == '') {
          toastr.error('Por favor complete todos los campos obligatorios');
          return;
        }

        if (ctrl.model.Clave != ctrl.model.ConfirmaClave) {
          toastr.error('Por favor verifique que la contraseña ingresada y su confirmación sean iguales');
          return;
        }

        if (!dataService.checkpassword(ctrl.model.Clave)){
          toastr.error('Por favor verifique que la contraseña debe contener una letra, un numero y un caracter especial. Longitud [3-6]');
          return;
        }
                  
        if (ctrl.rolesSeleccionados == null || ctrl.rolesSeleccionados.length <= 0) {
          toastr.error("Debe seleccionar al menos un rol");
          return;
        }

        ctrl.model.Roles = [];
        ctrl.model.Activo = 1;

        for (var i = 0; i < ctrl.rolesSeleccionados.length; i++) {
          ctrl.model.Roles.push({
            RolId: ctrl.rolesSeleccionados[i].Id,
            Rol: ctrl.rolesSeleccionados[i],
            UsuarioId: ctrl.model.Id
          });
        }

        ctrl.isBusy = true;

        dataService.saveUsuario(ctrl.model)
          .then(function (response) {
            if (response.data.Success) {
              toastr.info("Operacion exitosa.");
              $state.transitionTo("pages.usuario");
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
            ctrl.isBusy = false;
          });
      }

      ctrl.cancel = function () {
        $state.transitionTo("pages.usuario");
      }

      ctrl.delete = function () {
        ctrl.isBusy = true;
        var confirmation = $uibModal.open({
          animation: true,
          component: "confirmation",
          resolve: {
            title: function () { return "Atención" },
            message: function () { return "Confirma el borrado del usuario?" },
          }
        });

        confirmation.result.then(function (selectedItem) {
          dataService.deleteUsuario(ctrl.model.Id).then(function (response) {
            if (response.data.Success) {
              toastr.info("Operacion exitosa.");
              $state.transitionTo("pages.usuario");
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
            ctrl.isBusy = false;
          });
        }, function () {
          ctrl.isBusy = false;
        });
      }

      ctrl.addMail = function () {
        if (ctrl.mailIngresado == null || ctrl.mailIngresado.length <= 0) {
          toastr.error('Por favor ingrese un correo electrónico');
          return;
        }

        if (!sharedService.checkEmailFormat(ctrl.mailIngresado)) {
          toastr.error('El formato del correo electrónico es inválido');
          return;
        }

        if (ctrl.model.Mails == null)
          ctrl.model.Mails = [];

        for (var i = 0; i < ctrl.model.Mails.length; i++) {
          if (ctrl.model.Mails[i].Mail == ctrl.mailIngresado) {
            toastr.error('El correo electrónico ya fue ingresado');
            return;
          }
        }

        ctrl.model.Mails.push({ UsuarioId: ctrl.model.Id, Mail: ctrl.mailIngresado });
        ctrl.mailIngresado = '';
      }

      ctrl.eliminarMail = function (index) {
        if (ctrl.model.Mails != null && ctrl.model.Mails.length > 0) {
          ctrl.model.Mails.splice(index, 1);
        }
      }
    }
  });
})(window.angular);
(function (angular) {
  'use strict';
  angular.module('Kahuna.pages.usuario').component('usuarioList', {
    templateUrl: 'app/pages/usuario/list.template.html',
    controller: function ($scope, $state, dataService, sharedService, toastr) {
      var ctrl = this;
      ctrl.filtros = {};
      ctrl.lsuarioLogueadoIsSysAdmin = false;

      this.$onInit = function () {
        var authData = sharedService.getLoggedUser();
        if (authData != null && authData.Id > 0) {
          ctrl.lsuarioLogueadoIsSysAdmin = sharedService.isSysAdminLoggedUser();
        } else {
          $state.go('auth');
        }
      };

      ctrl.buscar = function buscar(tableState) {
        ctrl.isSearching = true;

        var pagination = tableState.pagination;

        var start = pagination.start || 0; // This is NOT the page number, but the index of item in the list that you want to use to display the table.
        var number = pagination.number || 10; // Number of entries showed per page.

        ctrl.filtros = {
          PageSize: number,
          SkipNumber: start
        };

        if (tableState.search.predicateObject != null) {
          ctrl.filtros.Login = tableState.search.predicateObject.Login;
          ctrl.filtros.Nombre = tableState.search.predicateObject.Nombre;
          ctrl.filtros.Apellido = tableState.search.predicateObject.Apellido;
          ctrl.filtros.Mail = tableState.search.predicateObject.Mail;
        }

        if (tableState.sort != null) {
          ctrl.filtros.OrderFieldName = tableState.sort.predicate;
          ctrl.filtros.OrderAscending = !tableState.sort.reverse;
        }

        dataService.searchUsuario(ctrl.filtros)
          .then(function (response) {
            if (response.data.Success) {
              ctrl.resultList = response.data.Value.Resultados;
              //ctrl.totalResultados = response.data.Value.TotalResultados;

              tableState.pagination.numberOfPages = Math.ceil(response.data.Value.TotalResultados / number); //result.numberOfPages;//set the number of pages so the pagination can update
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isSearching = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage());
            ctrl.isSearching = false;
          });
      };

      ctrl.add = function () {
        $state.go("pages.usuario-edit", {
          id: 0
        });
      }

      ctrl.edit = function (id) {
        $state.go("pages.usuario-edit", {
          id: id
        });
      }
    }
  });
})(window.angular);
(function () {
    'use strict';
    angular.module('Kahuna.pages.usuario').config(routeConfig);
    function routeConfig($stateProvider) {
      $stateProvider
        .state('pages.usuario', {
          url: '/usuario',
          title: 'Usuario',
          template : '<usuario-list></usuario-list>',
          authenticate: true,
        })
        .state('pages.usuario-edit', {
          url: '/usuario/edit/:id',
          title: 'Usuario',
          template : '<usuario-edit></usuario-edit>',
          params: {id:null},
          authenticate: true,
        });
    }
  })();
/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 7500,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-center',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';
  angular.module('BlurAdmin.theme')
      .directive('listadoHistorialAutorizacion', listadoHistorialAutorizacion);

  /** @ngInject */
  function listadoHistorialAutorizacion($timeout, $rootScope) {
    console.log("entro al modal Directiva listadoHistorialAutorizacion");
    return {
      templateUrl: 'app/theme/directives/templateshtml/listHistorialAutorizacion.html'
    };
  }
})();
(function () {
  'use strict';
  angular.module('BlurAdmin.theme')
      .directive('listadoUsuariosAutorizacion', listadoUsuariosAutorizacion);

  /** @ngInject */
  function listadoUsuariosAutorizacion($timeout, $rootScope) {
    console.log("entro al modal Directiva listadoUsuariosAutorizacion");
    return {
      templateUrl: 'app/theme/directives/templateshtml/listUsuariosAutorizacion.html'
    };
  }
})();

(function () {
  'use strict';
  angular.module('BlurAdmin.theme')
      .directive('modalDirective', modalDirective);

  /** @ngInject */
  function modalDirective($timeout, $rootScope) {
    console.log("entro al modal Diurectiva");
    return {
      templateUrl: 'app/theme/directives/templateshtml/modal.html'
    };
  }
})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          //elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebar2', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0;
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
              .filter(function(s) {
                return s.sidebarMeta;
              })
              .map(function(s) {
                var meta = s.sidebarMeta;
                return {
                  name: s.name,
                  title: s.title,
                  level: (s.name.match(/\./g) || []).length,
                  order: meta.order,
                  icon: meta.icon,
                  stateRef: s.name,
                };
              })
              .sort(function(a, b) {
                return (a.level - b.level) * 100 + a.order - b.order;
              });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, baSidebarService) {

    $scope.menuItems = baSidebarService.getMenuItems();
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h5 class="panel-title">' + attrs.baPanelTitle + '</h5></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl',
    }
  }
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
    $scope.users = {
      0: {
        name: 'Vlad',
      },
      1: {
        name: 'Kostya',
      },
      2: {
        name: 'Andrey',
      },
      3: {
        name: 'Nasta',
      }
    };

    $scope.notifications = [
      {
        userId: 0,
        template: '&name posted a new article.',
        time: '1 min ago'
      },
      {
        userId: 1,
        template: '&name changed his contact information.',
        time: '2 hrs ago'
      },
      {
        image: 'assets/img/shopping-cart.svg',
        template: 'New orders received.',
        time: '5 hrs ago'
      },
      {
        userId: 2,
        template: '&name replied to your comment.',
        time: '1 day ago'
      },
      {
        userId: 3,
        template: 'Today is &name\'s birthday.',
        time: '2 days ago'
      },
      {
        image: 'assets/img/comments.svg',
        template: 'New comments on your post.',
        time: '3 days ago'
      },
      {
        userId: 1,
        template: '&name invited you to join the event.',
        time: '1 week ago'
      }
    ];

    $scope.messages = [
      {
        userId: 3,
        text: 'After you get up and running, you can place Font Awesome icons just about...',
        time: '1 min ago'
      },
      {
        userId: 0,
        text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
        time: '2 hrs ago'
      },
      {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
      },
      {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
      },
      {
        userId: 3,
        text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
        time: '1 day ago'
      },
      {
        userId: 1,
        text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
        time: '2 days ago'
      },
      {
        userId: 0,
        text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
        time: '1 week ago'
      }
    ];

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('pageTop2', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html'
    };
  }

})();
/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '='
      }
    };
  }

})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
angular.module('Kahuna').run(['$templateCache', function($templateCache) {$templateCache.put('app/auth/auth.html','<main class="auth-main"><div class="auth-block"><div ba-panel="" ba-panel-title="Inicio de Sesi\xF3n - Versi\xF3n {{$ctrl.appVersion}}" ba-panel-class="with-scroll" class="col-sm-offset-3 col-sm-6" style="padding-top:90px; opacity:0.95"><div class="col-md-12 al-login-logo-rodio"><img src="{{$ctrl.logoIcon}}"></div><div class="col-sm-12 col-md-12" style="padding-top:40px"><form class="form-horizontal"><div class="form-group"><label for="inputUser3" class="col-sm-3 control-label">Usuario</label><div class="col-sm-7"><input class="form-control" ng-model="$ctrl.model.Usuario" id="inputUser3"></div></div><div class="form-group"><label for="inputPassword3" class="col-sm-3 control-label">Contrase\xF1a</label><div class="col-sm-7"><input type="password" ng-model="$ctrl.model.Password" class="form-control" id="inputPassword3"></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-5"><button ng-click="$ctrl.login();" class="btn btn-default btn-auth pull-right" ng-disabled="$ctrl.isBusy">{{$ctrl.buttonLoginText}}</button></div></div></form></div></div></div></main>');
$templateCache.put('app/components/altaJerarquia.template.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-android-warning modal-icon"></i><span>{{$ctrl.resolve.title}}</span></div><div class="modal-body text-center add-top-space"><label class="col-md-3 center-label" ng-if="$ctrl.model.JerarquiaPadre.Nombre.length > 0">Jerarqu\xEDa Padre:</label> <label class="col-md-9" style="text-align: left" ng-if="$ctrl.model.JerarquiaPadre.Nombre.length > 0">{{$ctrl.model.JerarquiaPadre.Nombre}}</label> <label class="col-md-3 center-label">Nombre*:</label><div class="col-md-9"><input type="text" class="form-control" name="" ng-model="$ctrl.model.Nombre" ng-keydown="$ctrl.checkKey($event)"></div></div><div class="modal-footer add-top-space"><button type="button" class="btn btn-success" ng-click="$ctrl.save()" ng-disabled="$ctrl.isBusy">Guardar</button> <button type="button" class="btn btn-danger" ng-click="$ctrl.cancel()" ng-disabled="$ctrl.isBusy">Cancelar</button></div></div>');
$templateCache.put('app/components/baSidebar.template.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li class="al-sidebar-list-item" ui-sref-active="selected" ba-sidebar-toggling-item="item"><img class="col-md-5 home-app-logo-side-bar" src="{{$ctrl.appLogoIcon}}" ng-if="$ctrl.appLogoIcon!=\'\'"> <span class="version">{{appVersion}}</span></li></ul><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link">{{ ::subSubitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">{{ ::subitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/components/cambioClave.template.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-android-warning modal-icon"></i><span>{{$ctrl.resolve.title}}</span></div><div class="modal-body text-center add-top-space"><div class="col-md-12"><label class="col-md-4 center-label">Clave Actual:</label><div class="col-md-8"><input type="password" class="form-control" ng-model="$ctrl.model.ClaveActual" name="" placeholder="" ng-keydown="$ctrl.checkKey($event)"></div></div><div class="col-md-12"><label class="col-md-4 center-label">Nueva Clave:</label><div class="col-md-8"><input type="password" class="form-control" ng-model="$ctrl.model.ClaveNueva" name="" placeholder="" ng-keydown="$ctrl.checkKey($event)"></div></div><div class="col-md-12"><label class="col-md-4 center-label">Confirmar Clave:</label><div class="col-md-8"><input type="password" class="form-control" ng-model="$ctrl.model.ClaveNuevaConfirmacion" name="" placeholder="" ng-keydown="$ctrl.checkKey($event)"></div></div></div><div class="modal-footer add-top-space"><button type="button" class="btn btn-success" ng-click="$ctrl.save()" ng-disabled="$ctrl.isBusy">Guardar</button> <button type="button" class="btn btn-danger" ng-click="$ctrl.cancel()" ng-disabled="$ctrl.isBusy">Cancelar</button></div></div>');
$templateCache.put('app/components/confirmation.template.html','<div class="modal-content"><div class="modal-header bg-warning"><i class="ion-android-warning modal-icon"></i><span>{{$ctrl.resolve.title}}</span></div><div class="modal-body text-center">{{$ctrl.resolve.message}}</div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="$ctrl.confirm()">Si</button> <button type="button" class="btn btn-danger" ng-click="$ctrl.cancel()">No</button></div></div>');
$templateCache.put('app/components/pageTop.template.html','<div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}" ng-style="$ctrl.myStyle"><a href="#/dashboard" class="al-logo clearfix"><span></span></a> <a href="" class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu=""></a><div class="user-profile clearfix"><div class="user-text"><label class="pull-right">{{$ctrl.userMessage}}</label><div class="application-text pull-right">{{$ctrl.applicationProperties.HEADLINEA1}}</div><div class="application-text pull-right">{{$ctrl.applicationProperties.HEADLINEA2}}</div></div><div class="al-user-profile" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link"><img ng-src="{{::( \'generic-user-profile\' | profilePicture )}}"></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li style="line-height:1.42857143;padding:4px 16px 4px 20px"><i style="margin-right:10px" class="fa fa-info"></i>Versi\xF3n: {{$ctrl.appVersion}}</li><li><a href="" ng-click="$ctrl.cambioClave()"><i class="fa fa-user"></i>Cambio Clave</a></li><li><a href="" ng-click="$ctrl.logout()" class="signout"><i class="fa fa-power-off"></i>Cerrar Sesi\xF3n</a></li></ul></div><msg-center></msg-center></div></div>');
$templateCache.put('app/components/seleccionProceso.template.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-android-warning modal-icon"></i><span>{{$ctrl.resolve.title}}</span></div><div class="modal-body text-center add-top-space"><div class="col-md-12"><label class="col-md-2 center-label">Proceso:</label> <label class="col-md-10 center-label" ng-show="$ctrl.procesoLoading" style="font-weight:normal">Cargando...</label><div class="col-md-10" ng-show="!$ctrl.procesoLoading"><select name="" class="form-control" ng-model="$ctrl.model.ProcesoSeleccionado" ng-options="item as item.Nombre for item in $ctrl.procesosList track by item.Id"></select></div></div></div><div class="modal-footer add-top-space"><button type="button" class="btn btn-success" ng-click="$ctrl.save()" ng-disabled="$ctrl.isBusy">Aceptar</button> <button type="button" class="btn btn-danger" ng-click="$ctrl.cancel()" ng-disabled="$ctrl.isBusy">Cancelar</button></div></div>');
$templateCache.put('app/pages/shell.html','<ba-sidebar></ba-sidebar><page-top></page-top><div class="al-main"><div class="al-content"><content-top></content-top><div ui-view="" autoscroll="true" autoscroll-body-top=""></div></div></div>');
$templateCache.put('app/pages/autosolicitud/edit.template.html','<div ba-panel="" ba-panel-title="{{$ctrl.title}}" ba-panel-class="with-scroll"><uib-tabset active="$ctrl.active"><uib-tab index="0" heading="Datos del Proceso" ng-disabled="true"><div ba-panel="" ba-panel-class="with-scroll" class="add-top-space"><form name="$ctrl.form" novalidate=""><div class="form-group" ng-class="{ \'has-error\': form.name.$invalid && (form.name.$dirty || $ctrl.showError) }"><label class="col-md-2 center-label">Auto Id*:</label><div class="col-md-4" style="margin-bottom: 5px"><input tooltip-placement="bottom" type="text" uib-tooltip="{{$ctrl.returnDescription(\'AutoId\')}}" tooltip-class="customClass" class="form-control" ng-model="$ctrl.model.AutoId" name="codigo" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el AutoId.</span></div></div><label class="col-md-2 center-label">DetalleAcciones*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'DetalleAcciones\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.model.DetalleAcciones" name="name" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el DetalleAcciones.</span></div></div><label class="col-md-2 center-label">OrigenSP*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'OrigenSP\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.model.OrigenSP" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de OrigenSP</span></div></div><label class="col-md-2 center-label">IdProcesoDestino*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'IdProcesoDestino\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.model.IdProcesoDestino" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de IdProcesoDestino</span></div></div><label class="col-md-2 center-label">OrigenDiasdeCierre*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'OrigenDiasdeCierre\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.model.OrigenDiasdeCierre" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de OrigenDiasdeCierre</span></div></div><label class="col-md-2 center-label">OrigenJerarquiaDiasCierre*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'OrigenJerarquiaDiasCierre\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.model.OrigenJerarquiaDiasCierre" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de OrigenJerarquiaDiasCierre</span></div></div><label class="col-md-2 center-label">IdCampoJerarquiaDiasCierre*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'IdCampoJerarquiaDiasCierre\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.model.IdCampoJerarquiaDiasCierre" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de IdCampoJerarquiaDiasCierre</span></div></div><label class="col-md-2 center-label">DiasCierre*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'DiasCierre\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.model.DiasCierre" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de DiasCierre</span></div></div><label class="col-md-2 center-label">AquienMando*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'AquienMando\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.model.AQuienMando" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de DiasCierre</span></div></div><label class="col-md-2 center-label">UsuarioCreadorDestino*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'UsuarioCreadorDestino\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.model.UsuarioCreadorDestino" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de UsuarioCreadorDestino</span></div></div><label class="col-md-2 center-label">OrigenUsuarioCreadorDestino*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'OrigenUsuarioCreadorDestino\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.model.OrigenUsuarioCreadorDestino" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de OrigenUsuarioCreadorDestino</span></div></div><label class="col-md-2 center-label">IdCampoUsuarioCreadorDestino*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'IdCampoUsuarioCreadorDestino\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.model.IdCampoUsuarioCreadorDestino" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de IdCampoUsuarioCreadorDestino</span></div></div><label class="col-md-2 center-label">OrigenCabezaDescripcion*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'OrigenCabezaDescripcion\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.model.OrigenCabezaDescripcion" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de OrigenCabezaDescripcion</span></div></div><label class="col-md-2 center-label">IdCampoCabezaDescripcion*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'IdCampoCabezaDescripcion\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.model.IdCampoCabezaDescripcion" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de IdCampoCabezaDescripcion</span></div></div><label class="col-md-2 center-label">MensajeDescripcion*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'MensajeDescripcion\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.model.MensajeDescripcion" name="name" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar MensajeDescripcion</span></div></div><label class="col-md-2 center-label">OrigenFinalDescripcion1*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'OrigenFinalDescripcion1\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.model.OrigenFinalDescripcion1" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de OrigenFinalDescripcion1</span></div></div><label class="col-md-2 center-label">IdCampoFinalDescripcion1*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'IdCampoFinalDescripcion1\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.model.IdCampoFinalDescripcion1" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de IdCampoFinalDescripcion1</span></div></div><label class="col-md-2 center-label">OrigenFinalDescripcion2*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'OrigenFinalDescripcion2\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.model.OrigenFinalDescripcion2" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de OrigenFinalDescripcion2</span></div></div><label class="col-md-2 center-label">IdCampoFinalDescripcion2*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'IdCampoFinalDescripcion2\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.model.IdCampoFinalDescripcion2" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de IdCampoFinalDescripcion2</span></div></div><label class="col-md-2 center-label">IdEstadoFinal*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'IdEstadoFinal\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.model.IdEstadoFinal" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de IdEstadoFinal</span></div></div><label class="col-md-2 center-label">UsuarioAprobador*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'UsuarioAprobador\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.model.UsuarioAprobador" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de UsuarioAprobador</span></div></div><label class="col-md-2 center-label">OrigenCampoIdAprobador*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'OrigenCampoIdAprobador\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.model.OrigenCampoIdAprobador" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de OrigenCampoIdAprobador</span></div></div><label class="col-md-2 center-label">IdCampoIdAprobador*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'IdCampoIdAprobador\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.model.IdCampoIdAprobador" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de IdCampoIdAprobador</span></div></div><label class="col-md-2 center-label">SubjectCorreo*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'SubjectCorreo\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.model.SubjectCorreo" name="name" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar subject del correo.</span></div></div><label class="col-md-2 center-label">CuerpoCorreo*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'CuerpoCorreo\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.model.CuerpoCorreo" name="name" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar Cuerpo Correo</span></div></div><label class="col-md-2 center-label">UrlAddCorreo*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'UrlAddCorreo\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.model.UrlAddCorreo" name="name" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la UrlAddCorreo</span></div></div><label class="col-md-2 center-label">EnviaCorreo*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'EnviaCorreo\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.model.EnviaCorreo" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de EnviaCorreo</span></div></div><label class="col-md-2 center-label">UsuarioModificacionId*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'UsuarioModificacionId\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.model.UsuarioModificacionId" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de UsuarioModificacionId.</span></div></div><label class="col-md-2 center-label">UsuarioCreacionid*:</label><div class="col-md-4" style="margin-bottom: 55px"><input uib-tooltip="{{$ctrl.returnDescription(\'UsuarioCreacionid\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.model.UsuarioCreacionid" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de UsuarioCreacionid.</span></div></div></div></form></div></uib-tab><uib-tab index="1" heading="AutoSolicitud Detalle" ng-disabled="true"><div ba-panel="" ba-panel-title="AutoSolicitud Detalle" ba-panel-class="with-scroll" class="add-top-space"><form name="$ctrl.formDetalle" novalidate=""><label class="col-md-2 center-label">OrigenCampo*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'OrigenCampo\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.campoCargado.OrigenCampo" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de OrigenCampo</span></div></div><label class="col-md-2 center-label">IdCampoDestino*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'IdCampoDestino\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.campoCargado.IdCampoDestino" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de IdCampoDestino</span></div></div><label class="col-md-2 center-label">IdCampoOrigen*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'IdCampoOrigen\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.campoCargado.IdCampoOrigen" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de IdCampoOrigen</span></div></div><label class="col-md-2 center-label">OrigenCampoA*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'OrigenCampoA\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.campoCargado.OrigenCampoA" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de OrigenCampoA</span></div></div><label class="col-md-2 center-label">IdCampoOrigenA*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'IdCampoOrigenA\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.campoCargado.IdCampoOrigenA" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de IdCampoOrigenA</span></div></div><label class="col-md-2 center-label">OrigenCampoB*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'OrigenCampoB\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.campoCargado.OrigenCampoB" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de OrigenCampoB</span></div></div><label class="col-md-2 center-label">IdCampoOrigenB*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'IdCampoOrigenB\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.campoCargado.IdCampoOrigenB" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de IdCampoOrigenB</span></div></div><label class="col-md-2 center-label">OrigenCampoC*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'OrigenCampoC\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.campoCargado.OrigenCampoC" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de OrigenCampoC</span></div></div><label class="col-md-2 center-label">IdCampoOrigenC*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'IdCampoOrigenC\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.campoCargado.IdCampoOrigenC" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de IdCampoOrigenC</span></div></div><label class="col-md-2 center-label">ValCampoOrigen*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'ValCampoOrigen\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.campoCargado.ValCampoOrigen" name="name" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de ValCampoOrigen</span></div></div><label class="col-md-2 center-label">UsuarioCreacionid*:</label><div class="col-md-4" style="margin-bottom: 5px"><input uib-tooltip="{{$ctrl.returnDescription(\'UsuarioCreacionid\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.campoCargado.UsuarioCreacionid" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de UsuarioCreacionid</span></div></div><label class="col-md-2 center-label">UsuarioModificacionId*:</label><div class="col-md-4" style="margin-bottom: 35px"><input uib-tooltip="{{$ctrl.returnDescription(\'UsuarioModificacionId\')}}" tooltip-class="customClass" tooltip-placement="bottom" type="text" class="form-control" ng-model="$ctrl.campoCargado.UsuarioModificacionId" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de UsuarioModificacionId</span></div></div><div class="col-md-12"><button class="btn btn-warning" ng-click="$ctrl.clearCampo()" ng-disabled="$ctrl.isBusy || !$ctrl.enableDatosProcesoTab">Limpiar</button> <button class="btn btn-success pull-right" ng-click="$ctrl.editCampo(form)" ng-disabled="$ctrl.isBusy || !$ctrl.enableDatosProcesoTab">Guardar</button></div></form></div><div ba-panel="" ba-panel-title="AutoSolicitud Detalle List" ba-panel-class="with-scroll"><table class="table" st-table="$ctrl.procesoCamposDS" st-safe-src="$ctrl.procesoCamposList"><thead><tr class="sortable"><th class="text-center">Origen Campo</th><th class="text-center" st-sort-default="true">Ide Campo Destino</th><th class="text-center">Id Campo Origen</th><th class="text-center">Acciones</th></tr></thead><tbody ng-show="!$ctrl.isCampoSearching"><tr ng-repeat="item in $ctrl.procesoCamposDS" ng-click="$ctrl.cargarCampo(item)" style="cursor: pointer"><td align="center">{{item.OrigenCampo}}</td><td align="center">{{item.IdCampoDestino}}</td><td align="center">{{item.IdCampoOrigen}}</td><td align="center"><button class="btn btn-success editable-table-button btn-xs" ng-click="$ctrl.cargarCampo(item)" ng-disabled="item.Id==undefined || item.Id ==0">Ver</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.eliminarCampo($index)" ng-disabled="$ctrl.isBusy || !$ctrl.enableDatosProcesoTab">Eliminar</button></td></tr></tbody><tbody ng-show="$ctrl.isCampoSearching"><tr><td colspan="5" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="5" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table></div></uib-tab></uib-tabset><div class="col-md-12"><button class="btn btn-success" ng-click="$ctrl.save(form)" ng-disabled="$ctrl.isBusy">Guardar</button> <button class="btn btn-danger" ng-click="$ctrl.delete()" ng-disabled="$ctrl.isBusy">Eliminar</button> <button class="btn btn-danger" ng-click="$ctrl.cancel()" ng-disabled="$ctrl.isBusy">Cancelar</button></div></div>');
$templateCache.put('app/pages/autosolicitud/list.template.html','<div class="add-row-editable-table"><button class="btn btn-primary" ng-show="$ctrl.mostrarAgregar" ng-click="$ctrl.add()">Agregar</button></div><table class="table" st-pipe="$ctrl.buscar" st-table="$ctrl.resultList"><thead><tr class="sortable"><th class="text-center" st-sort="AutoId">AutoId</th><th class="text-center" st-sort="DetalleAcciones">DetalleAcciones</th><th class="text-center" st-sort="SubjectCorreo">SubjectCorreo</th><th class="text-center" st-sort="OrigenDiasdeCierre">Origen Diasde Cierre</th><th class="text-center">Acci\xF3n</th></tr><tr><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="AutoId" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por AutoId" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="DetalleAcciones" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por DetalleAcciones" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="SubjectCorreo" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por SubjectCorreo" aria-describedby="basic-addon1"></div></th><th></th><th></th></tr></thead><tbody ng-show="!$ctrl.isSearching"><tr ng-repeat="item in $ctrl.resultList" ng-click="$ctrl.edit(item.Id)" style="cursor: pointer"><td align="center">{{item.AutoId}}</td><td align="center">{{item.DetalleAcciones}}</td><td align="center">{{item.SubjectCorreo}}</td><td align="center">{{item.OrigenDiasdeCierre}}</td><td align="center"><a href="" ng-click="$ctrl.edit(item.Id)">Ver</a></td></tr></tbody><tbody ng-show="$ctrl.isSearching"><tr><td colspan="8" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table>');
$templateCache.put('app/pages/campo/edit.template.html','<div ba-panel="" ba-panel-title="{{$ctrl.title}}" ba-panel-class="with-scroll"><form name="form" novalidate=""><div ba-panel="" ba-panel-title="Datos del Campo" ba-panel-class="with-scroll" class="add-top-space"><label class="col-md-2 center-label">Identificador*:</label><div class="col-md-4"><input type="text" class="form-control" ng-model="$ctrl.model.CampoId" name="" placeholder="" required=""><div ng-messages="form.CampoId.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el Identificador del campo.</span></div></div><label class="col-md-2 center-label">Nombre*:</label><div class="col-md-4"><input type="text" class="form-control" ng-model="$ctrl.model.Nombre" name="" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el nombre.</span></div></div><label class="col-md-2 center-label">Tipo*:</label><div class="col-md-4"><select name="" class="form-control" ng-model="$ctrl.model.CampoTipo" required="" ng-options="item as item.Nombre for item in $ctrl.campoTipoList track by item.Id"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un tipo.</span></div></div><label class="col-md-2 center-label" ng-show="$ctrl.model.CampoTipo.Codigo == \'TEXT\' || $ctrl.model.CampoTipo.Codigo == \'LINK\' || $ctrl.model.CampoTipo.Codigo == \'PROCEDURE\'">Valor por defecto:</label><div class="col-md-4" ng-show="$ctrl.model.CampoTipo.Codigo == \'TEXT\' || $ctrl.model.CampoTipo.Codigo == \'LINK\' || $ctrl.model.CampoTipo.Codigo == \'PROCEDURE\'"><input type="text" class="form-control" ng-model="$ctrl.model.defaultValue"></div><label class="col-md-2 center-label" ng-if="$ctrl.model.CampoTipo.Codigo == \'PROCEDURE\'">Se ejecuta siempre?:</label><div class="col-md-4" ng-if="$ctrl.model.CampoTipo.Codigo == \'PROCEDURE\'"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.runProcedure"></ba-switcher></div><label class="col-md-2 center-label" ng-show="$ctrl.model.CampoTipo.Codigo == \'JERARQ\' || $ctrl.model.CampoTipo.Codigo == \'LIST\' || $ctrl.model.CampoTipo.Codigo == \'MULTI_LIST\'">Jerarqu\xEDa*:</label><div class="col-md-4" ng-show="$ctrl.model.CampoTipo.Codigo == \'JERARQ\' || $ctrl.model.CampoTipo.Codigo == \'LIST\' || $ctrl.model.CampoTipo.Codigo == \'MULTI_LIST\'"><select name="" class="form-control" ng-model="$ctrl.model.Jerarquia" ng-options="item as item.Nombre for item in $ctrl.jerarquiaList track by item.Id"></select></div><label class="col-md-2 center-label" ng-show="$ctrl.model.CampoTipo.Codigo == \'TABLE\'">Total Filas*:</label><div class="col-md-4" ng-show="$ctrl.model.CampoTipo.Codigo == \'TABLE\'"><input type="text" class="form-control" ng-model="$ctrl.model.TotalRegistrosTabla" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"></div><label class="col-md-2 center-label" ng-show="$ctrl.model.CampoTipo.Codigo == \'TABLE\'">Permite Editar Columna:</label><div class="col-md-4" ng-show="$ctrl.model.CampoTipo.Codigo == \'TABLE\'"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.permiteEditarColumna"></ba-switcher></div><div class="col-md-4" ng-show="$ctrl.model.CampoTipo.Codigo == \'JERARQ\'" style="margin-top: 10px"><input type="checkbox" ng-model="$ctrl.model.PermiteAltaJerarquia" name=""> Permitir el alta de nuevos elementos</div><div class="col-md-12" ng-show="$ctrl.model.CampoTipo.Codigo == \'JERARQ\'" style="margin-top: 10px"><input type="checkbox" ng-model="$ctrl.model.tipoNumerador" name=""> Es tipo numerador?</div></div><div ba-panel="" ba-panel-title="Columnas de la Tabla" ng-show="$ctrl.model.CampoTipo.Codigo == \'TABLE\'"><label class="col-md-2 center-label" style="margin-top:10px">Campo*:</label><div class="col-md-4"><input type="text" ng-model="$ctrl.campoCargado.ColumnaCampoInput" placeholder="Ingrese un campo a buscar..." uib-typeahead="i as i.Nombre for i in $ctrl.searchColumnaCampo($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingColumnaCampo" typeahead-no-results="noResultsColumnaCampo" class="form-control" typeahead-on-select="$ctrl.onSelectColumnaCampo($model)"> <i ng-show="loadingColumnaCampo" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsColumnaCampo"><i class="glyphicon glyphicon-remove"></i> Campo no encontrado</div></div><button class="btn btn-success" ng-click="$ctrl.editColumnaCampo(form)" ng-disabled="$ctrl.isBusy">Agregar</button><table class="table" st-table="$ctrl.camposTablaList" style="margin-top:20px"><thead><tr class="sortable"><th class="text-center">Nombre</th><th class="text-center">Tipo</th><th class="text-center">Acciones</th></tr></thead><tbody ng-show="!$ctrl.isCampoSearching"><tr ng-repeat="item in $ctrl.camposTablaList"><td align="center">{{item.ColumnaCampo.Nombre}}</td><td align="center">{{item.ColumnaCampo.CampoTipo.Nombre}}</td><td align="center"><button class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.eliminarColumnaCampo($index)" ng-disabled="$ctrl.isBusy">Eliminar</button></td></tr></tbody><tbody ng-show="$ctrl.isCampoSearching"><tr><td colspan="5" class="text-center">Cargando...</td></tr></tbody></table></div><div ba-panel="" ba-panel-title="Condiciones" ng-show="$ctrl.model.CampoTipo.Codigo==\'COND\'"><label class="col-md-2 center-label" style="margin-top:10px">Condicion*:</label><div class="col-md-4"><input type="text" ng-model="$ctrl.campoCargado.condicion" placeholder="Ingrese la condicion" class="form-control"></div><label class="col-md-2 center-label" style="margin-top:10px">Campo*:</label><div class="col-md-4"><input type="text" ng-model="$ctrl.campoCargado.ColumnaCampoInput" placeholder="Ingrese un campo a buscar..." uib-typeahead="i as i.Nombre for i in $ctrl.searchColumnaCampo($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingColumnaCampo" typeahead-no-results="noResultsColumnaCampo" class="form-control" typeahead-on-select="$ctrl.onSelectColumnaCampo($model)"> <i ng-show="loadingColumnaCampo" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsColumnaCampo"><i class="glyphicon glyphicon-remove"></i> Campo no encontrado</div></div><div class="col-md-12" style="margin-top:10px"><button class="btn btn-success pull-right" ng-click="$ctrl.editColumnaCampoCondicional(form)" ng-disabled="$ctrl.isBusy">Agregar</button></div><table class="table" st-table="$ctrl.camposTablaListCondicional" style="margin-top:20px"><thead><tr class="sortable"><th class="text-center">Condicion</th><th class="text-center">Nombre</th><th class="text-center">Tipo</th><th class="text-center">Acciones</th></tr></thead><tbody ng-show="!$ctrl.isCampoSearching"><tr ng-repeat="item in $ctrl.camposTablaListCondicional"><td align="center">{{item.condicion}}</td><td align="center">{{item.ColumnaCampo.Nombre}}</td><td align="center">{{item.ColumnaCampo.CampoTipo.Nombre}}</td><td align="center"><button class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.eliminarColumnaCampoCondicional($index)" ng-disabled="$ctrl.isBusy">Eliminar</button></td></tr></tbody><tbody ng-show="$ctrl.isCampoSearching"><tr><td colspan="5" class="text-center">Cargando...</td></tr></tbody></table></div><div class="col-md-12"><button class="btn btn-success" ng-click="$ctrl.save(form)" ng-disabled="$ctrl.isBusy">Guardar</button> <button class="btn btn-danger" ng-click="$ctrl.cancel()" ng-disabled="$ctrl.isBusy">Cancelar</button> <button class="btn btn-warning pull-right" ng-click="$ctrl.delete()" ng-disabled="$ctrl.isBusy" ng-show="$ctrl.showDelete">Borrar</button></div></form></div>');
$templateCache.put('app/pages/campo/list.template.html','<div class="col-md-12" ng-if="$ctrl.anularVista"><h5>No tiene permisos para visualizar esta vista.</h5></div><div class="add-row-editable-table" ng-if="!$ctrl.anularVista"><button class="btn btn-primary" ng-click="$ctrl.add()">Agregar</button></div><table class="table" st-pipe="$ctrl.buscar" st-table="$ctrl.resultList" ng-if="!$ctrl.anularVista"><thead><tr class="sortable"><th class="text-center" st-sort="Nombre">Nombre</th><th class="text-center" st-sort="CampoTipo.Nombre">Tipo</th><th class="text-center" st-sort="Jerarquia.Nombre">Jerarqu\xEDa</th><th class="text-center">Acci\xF3n</th></tr><tr><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Nombre" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por nombre" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="CampoTipo.Nombre" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por tipo" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Jerarquia.Nombre" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por jerarqu\xEDa" aria-describedby="basic-addon1"></div></th><th></th></tr></thead><tbody ng-show="!$ctrl.isSearching"><tr ng-repeat="item in $ctrl.resultList" ng-click="$ctrl.edit(item.Id)" style="cursor: pointer"><td align="center">{{item.Nombre}}</td><td align="center">{{item.CampoTipo.Nombre}}</td><td align="center">{{item.Jerarquia.Nombre}}</td><td align="center"><a href="" ng-click="$ctrl.edit(item.Id)">Ver</a></td></tr></tbody><tbody ng-show="$ctrl.isSearching"><tr><td colspan="3" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="3" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table>');
$templateCache.put('app/pages/auxparametros/edit.template.html','<div ba-panel="" ba-panel-title="{{$ctrl.title}}" ba-panel-class="with-scroll"><uib-tabset active="$ctrl.active"><uib-tab index="0" heading="Datos Del Parametro" ng-disabled="true"><div ba-panel="" ba-panel-class="with-scroll" class="add-top-space"><form name="$ctrl.form" novalidate=""><div class="form-group" ng-class="{ \'has-error\': form.name.$invalid && (form.name.$dirty || $ctrl.showError) }"><label class="col-md-2 center-label">Ident*:</label><div class="col-md-4"><input type="text" class="form-control" ng-model="$ctrl.model.Ident" name="codigo" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el Ident.</span></div></div><label class="col-md-2 center-label">Descripci\xF3n*:</label><div class="col-md-4"><input type="text" class="form-control" ng-model="$ctrl.model.Descripcion" name="name" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar la Descripci\xF3n.</span></div></div><label class="col-md-2 center-label">TipoCampo*:</label><div class="col-md-4"><input type="text" class="form-control" ng-model="$ctrl.model.TipoCampo" name="name" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el TipoCampo.</span></div></div><label class="col-md-2 center-label">OrdenImp:</label><div class="col-md-4"><input type="text" class="form-control" ng-model="$ctrl.model.OrdenImp" name="name" placeholder="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de OrdenImp.</span></div></div><label class="col-md-2 center-label">Campo *:</label><div class="col-md-4"><input type="text" ng-model="$ctrl.model.campo" placeholder="Ingrese un campo a buscar..." uib-typeahead="i as i.Nombre for i in $ctrl.searchCampos($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingCampo" typeahead-no-results="noResults" class="form-control" typeahead-on-select="$ctrl.onSelectCampo($model)"> <i ng-show="loadingCampo" class="glyphicon glyphicon-refresh"></i><div ng-show="noResults"><i class="glyphicon glyphicon-remove"></i> Campo no encontrado</div></div><label class="col-md-2 center-label">UrlDocumentos*:</label><div class="col-md-4"><input type="text" class="form-control" ng-model="$ctrl.model.UrlDocumentos" name="name" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar la UrlDocumentos.</span></div></div><label class="col-md-2 center-label">ObjetivoParametro*:</label><div class="col-md-4"><input type="text" class="form-control" ng-model="$ctrl.model.ObjetivoParametro" name="name" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar la ObjetivoParametro.</span></div></div></div></form></div></uib-tab></uib-tabset><div class="col-md-12"><button class="btn btn-success" ng-click="$ctrl.save(form)" ng-disabled="$ctrl.isBusy">Guardar</button> <button class="btn btn-danger" ng-click="$ctrl.delete()" ng-disabled="$ctrl.isBusy">Eliminar</button> <button class="btn btn-danger" ng-click="$ctrl.cancel()" ng-disabled="$ctrl.isBusy">Cancelar</button></div></div>');
$templateCache.put('app/pages/auxparametros/list.template.html','<div class="add-row-editable-table"><button class="btn btn-primary" ng-show="$ctrl.mostrarAgregar" ng-click="$ctrl.add()">Agregar</button></div><table class="table" st-pipe="$ctrl.buscar" st-table="$ctrl.resultList"><thead><tr class="sortable"><th class="text-center" st-sort="Ident">Ident</th><th class="text-center" st-sort="Descripcion">Descripcion</th><th class="text-center" st-sort="ObjetivoParametro">ObjetivoParametro</th><th class="text-center">Acci\xF3n</th></tr><tr><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Ident" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por Ident" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Descripcion" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por Descripcion" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="ObjetivoParametro" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por ObjetivoParametro" aria-describedby="basic-addon1"></div></th><th></th><th></th></tr></thead><tbody ng-show="!$ctrl.isSearching"><tr ng-repeat="item in $ctrl.resultList" ng-click="$ctrl.edit(item.Id)" style="cursor: pointer"><td align="center">{{item.Ident}}</td><td align="center">{{item.Descripcion}}</td><td align="center">{{item.ObjetivoParametro}}</td><td align="center"><a href="" ng-click="$ctrl.edit(item.Id)">Ver</a></td></tr></tbody><tbody ng-show="$ctrl.isSearching"><tr><td colspan="8" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table>');
$templateCache.put('app/pages/autoautorizar/edit.template.html','<div ba-panel="" ba-panel-title="{{$ctrl.title}}" ba-panel-class="with-scroll"><uib-tabset active="$ctrl.active"><uib-tab index="0" heading="Datos del Proceso" ng-disabled="true"><div ba-panel="" ba-panel-class="with-scroll" class="add-top-space"><form name="$ctrl.form" novalidate=""><div class="form-group" ng-class="{ \'has-error\': form.name.$invalid && (form.name.$dirty || $ctrl.showError) }"><label class="col-md-2 center-label">AutClave*:</label><div class="col-md-4" style="margin-bottom: 25px"><input type="text" class="form-control" ng-model="$ctrl.model.AutClave" name="codigo" placeholder="" required="" tooltip-placement="bottom" uib-tooltip="{{$ctrl.returnDescription(\'AutClave\')}}" tooltip-class="customClass"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el AutClave.</span></div></div><label class="col-md-2 center-label">Descripci\xF3n*:</label><div class="col-md-4" style="margin-bottom: 25px"><input tooltip-placement="bottom" uib-tooltip="{{$ctrl.returnDescription(\'DescripAccion\')}}" tooltip-class="customClass" type="text" class="form-control" ng-model="$ctrl.model.DescripAccion" name="name" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar la Descripci\xF3n.</span></div></div><label class="col-md-2 center-label">Proceso*:</label><div class="col-md-4" style="margin-bottom: 25px"><select tooltip-placement="bottom" uib-tooltip="{{$ctrl.returnDescription(\'procesoId\')}}" tooltip-class="customClass" name="" class="col-md-6 form-control" ng-model="$ctrl.model.procesoId" ng-change="$ctrl.loadTemplatesProcesos($ctrl.model.procesoId)"><option ng-repeat="proceso in $ctrl.resultListProcesos" value="{{proceso.Id}}">{{ proceso.Id}} - {{proceso.Nombre}}</option></select></div><label class="col-md-2 center-label">Id Proceso Template*:</label><div class="col-md-4" style="margin-bottom: 25px"><select tooltip-placement="bottom" uib-tooltip="{{$ctrl.returnDescription(\'ProcesoTemplate\')}}" tooltip-class="customClass" name="" ng-model="$ctrl.model.ProcesoTemplate" class="form-control" ng-change="$ctrl.setIdSSolicitudEstado()" ng-options="item as item.Template.Nombre for item in $ctrl.resultListTemplatesProcesos track by item.TemplateId"></select></div><label class="col-md-2 center-label">IdSolicitudEstado:</label><div class="col-md-4" style="margin-bottom: 25px"><input tooltip-placement="bottom" uib-tooltip="{{$ctrl.returnDescription(\'IdSolicitudEstado\')}}" tooltip-class="customClass" type="text" class="form-control" ng-model="$ctrl.model.IdSolicitudEstado" name="name" readonly="" placeholder="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de IdSolicitudEstado.</span></div></div><label class="col-md-2 center-label">IdCampoOk:</label><div class="col-md-4" style="margin-bottom: 25px"><select tooltip-placement="bottom" uib-tooltip="{{$ctrl.returnDescription(\'campoId\')}}" tooltip-class="customClass" name="" class="col-md-6 form-control" ng-model="$ctrl.model.campoId"><option ng-repeat="campo in $ctrl.camposList" value="{{campo.Id}}">{{ campo.Id}} - {{campo.Nombre}}</option></select></div><label class="col-md-2 center-label">TipoProcedure*:</label><div class="col-md-4" style="margin-bottom: 25px"><input tooltip-placement="bottom" uib-tooltip="{{$ctrl.returnDescription(\'TipoProcedure\')}}" tooltip-class="customClass" type="text" class="form-control" ng-model="$ctrl.model.TipoProcedure" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de TipoProcedure.</span></div></div><label class="col-md-2 center-label">CodigoProcedure*:</label><div class="col-md-4" style="margin-bottom: 25px"><select tooltip-placement="bottom" uib-tooltip="{{$ctrl.returnDescription(\'CodigoProcedure\')}}" tooltip-class="customClass" name="" class="col-md-6 form-control" ng-model="$ctrl.model.CodigoProcedure"><option ng-repeat="autoSolicitud in $ctrl.listaAutoSolicitud" value="{{autoSolicitud.AutoId}}">{{ autoSolicitud.AutoId}} - {{autoSolicitud.DetalleAcciones}}</option></select></div></div></form></div></uib-tab></uib-tabset><div class="col-md-12"><button class="btn btn-success" ng-click="$ctrl.save(form)" ng-disabled="$ctrl.isBusy">Guardar</button> <button class="btn btn-danger" ng-click="$ctrl.delete()" ng-disabled="$ctrl.isBusy">Eliminar</button> <button class="btn btn-danger" ng-click="$ctrl.cancel()" ng-disabled="$ctrl.isBusy">Cancelar</button></div></div>');
$templateCache.put('app/pages/autoautorizar/list.template.html','<div class="add-row-editable-table"><button class="btn btn-primary" ng-show="$ctrl.mostrarAgregar" ng-click="$ctrl.add()">Agregar</button></div><table class="table" st-pipe="$ctrl.buscar" st-table="$ctrl.resultList"><thead><tr class="sortable"><th class="text-center" st-sort="AutClave">AutClave</th><th class="text-center" st-sort="DescripAccion">Descripcion</th><th class="text-center">Acci\xF3n</th></tr><tr><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="AutClave" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por AutClave" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="DescripAccion" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por Descripcion" aria-describedby="basic-addon1"></div></th><th></th><th></th></tr></thead><tbody ng-show="!$ctrl.isSearching"><tr ng-repeat="item in $ctrl.resultList" ng-click="$ctrl.edit(item.Id)" style="cursor: pointer"><td align="center">{{item.AutClave}}</td><td align="center">{{item.DescripAccion}}</td><td align="center"><a href="" ng-click="$ctrl.edit(item.Id)">Ver</a></td></tr></tbody><tbody ng-show="$ctrl.isSearching"><tr><td colspan="8" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table>');
$templateCache.put('app/pages/grupo/edit.template.html','<div ba-panel="" ba-panel-title="{{$ctrl.title}}" ba-panel-class="with-scroll" class="add-top-space"><form name="form" novalidate=""><div class="form-group" ng-class="{ \'has-error\': form.name.$invalid && (form.name.$dirty || $ctrl.showError) }"><label class="col-md-2 center-label">Nombre*:</label><div class="col-md-10"><input type="text" class="form-control" ng-model="$ctrl.model.Nombre" name="" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el nombre.</span></div></div><label class="col-md-2 center-label">Resumen:</label><div class="col-md-10"><input type="text" class="form-control" ng-model="$ctrl.model.Resumen" name="" placeholder=""></div><label class="col-md-2 center-label">Color de Fondo:</label><div class="col-md-4"><input type="color" class="form-control" ng-model="$ctrl.model.ColorFondo" name="" placeholder=""></div><label class="col-md-2 center-label">Color de Texto:</label><div class="col-md-4"><input type="color" class="form-control" ng-model="$ctrl.model.ColorTexto" name="" placeholder=""></div><label class="col-md-2 center-label">URL Imagen:</label><div class="col-md-10" style="margin-top:17px"><a href="" ng-click="$ctrl.openAttachment($ctrl.model.UrlImagen)">{{$ctrl.model.UrlImagen}}</a><div class="btn btn-success editable-table-button btn-xs" ng-disabled="$ctrl.isBusy" ngf-select="$ctrl.uploadAttachment($file)">Seleccionar</div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment()" ng-disabled="$ctrl.isBusy">Quitar</div><p ng-show="ctrl.model.isImageLoading">Cargando archivo...</p></div><label class="col-md-2 center-label" style="margin-top:25px">Mostrar en Home*:</label><div class="col-md-4"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.MostrarEnHome"></ba-switcher></div><label class="col-md-2 center-label" ng-show="$ctrl.model.MostrarEnHome">Orden en Home:</label><div class="col-md-4" ng-show="$ctrl.model.MostrarEnHome"><input type="text" class="form-control" ng-model="$ctrl.model.HomeOrden" name="" placeholder="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="3"></div></div><div class="col-md-12"><button class="btn btn-success" ng-click="$ctrl.save(form)" ng-disabled="$ctrl.isBusy">Guardar</button> <button class="btn btn-danger" ng-click="$ctrl.cancel()" ng-disabled="$ctrl.isBusy">Cancelar</button> <button class="btn btn-warning pull-right" ng-click="$ctrl.delete()" ng-disabled="$ctrl.isBusy" ng-show="$ctrl.showDelete">Borrar</button></div></form></div>');
$templateCache.put('app/pages/grupo/list.template.html','<div class="col-md-12" ng-if="$ctrl.anularVista"><h5>No tiene permisos para visualizar esta vista.</h5></div><div class="add-row-editable-table" ng-if="!$ctrl.anularVista"><button class="btn btn-primary" ng-click="$ctrl.add()">Agregar</button></div><table class="table" st-pipe="$ctrl.buscar" st-table="$ctrl.resultList" ng-if="!$ctrl.anularVista"><thead><tr class="sortable"><th class="text-center" st-sort="Nombre">Nombre</th><th class="text-center" st-sort="Resumen">Resumen</th><th class="text-center">Acci\xF3n</th></tr><tr><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Nombre" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por nombre" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Resumen" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por resumen" aria-describedby="basic-addon1"></div></th><th></th></tr></thead><tbody ng-show="!$ctrl.isSearching"><tr ng-repeat="item in $ctrl.resultList" ng-click="$ctrl.edit(item.Id)" style="cursor: pointer"><td align="center">{{item.Nombre}}</td><td align="center">{{item.Resumen}}</td><td align="center"><a href="" ng-click="$ctrl.edit(item.Id)">Ver</a></td></tr></tbody><tbody ng-show="$ctrl.isSearching"><tr><td colspan="2" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="2" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table>');
$templateCache.put('app/pages/grupos-usuarios/edit.template.html','<div ba-panel="" ba-panel-title="{{$ctrl.title}}" ba-panel-class="with-scroll" class="add-top-space"><form name="form" novalidate=""><div ba-panel="" ba-panel-title="Datos del Grupo" ba-panel-class="with-scroll"><div class="form-group" ng-class="{ \'has-error\': form.name.$invalid && (form.name.$dirty || $ctrl.showError) }"><label class="col-md-2 center-label">Nombre*:</label><div class="col-md-10"><input type="text" class="form-control" ng-model="$ctrl.model.Nombre" name="" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el nombre.</span></div></div></div></div><div ba-panel="" ba-panel-title="Datos de Usuario" ba-panel-class="with-scroll"><div class="col-md-12"><label class="col-md-2 center-label">Usuario*:</label><div class="col-md-4"><input type="text" ng-model="$ctrl.usuarioCargado.UsuarioInput" placeholder="Ingrese un usuario a buscar..." uib-typeahead="i as i.Login for i in $ctrl.searchUsuario($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingUsuario" typeahead-no-results="noResultsUsuario" class="form-control" typeahead-on-select="$ctrl.onSelectUsuario($model)"> <i ng-show="loadingUsuario" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsUsuario"><i class="glyphicon glyphicon-remove"></i> Usuario no encontrado</div></div></div><div class="col-md-12"><label class="col-md-12 center-label"></label> <label class="col-md-12 center-label"></label></div><div class="col-md-12"><button class="btn btn-warning" ng-click="$ctrl.clearUsuario()" ng-disabled="$ctrl.isBusy">Limpiar</button> <button class="btn btn-success pull-right" ng-click="$ctrl.editUsuario(form)" ng-disabled="$ctrl.isBusy">Guardar</button></div></div><div ba-panel="" ba-panel-title="Usuarios del Grupo" ba-panel-class="with-scroll"><table class="table" st-table="$ctrl.procesoUsuariosDS" st-safe-src="$ctrl.procesoUsuariosList"><thead><tr class="sortable"><th class="text-center" st-sort="Usuario.Login">Usuario</th><th class="text-center">Acciones</th></tr><tr><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Usuario.Login" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por usuario" aria-describedby="basic-addon1"></div></th><th></th><th></th></tr></thead><tbody ng-show="!$ctrl.isUsuarioSearching"><tr ng-repeat="item in $ctrl.procesoUsuariosDS" ng-click="$ctrl.cargarUsuario(item)" style="cursor: pointer"><td align="center">{{item.Usuario.Login}}</td><td align="center"><button class="btn btn-success editable-table-button btn-xs" ng-click="$ctrl.cargarUsuario(item)" ng-disabled="$ctrl.isBusy">Ver</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.eliminarUsuario($index)" ng-disabled="$ctrl.isBusy">Eliminar</button></td></tr></tbody><tbody ng-show="$ctrl.isUsuarioSearching"><tr><td colspan="5" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="5" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table></div><div class="col-md-12"><button class="btn btn-success" ng-click="$ctrl.save(form)" ng-disabled="$ctrl.isBusy">Guardar</button> <button class="btn btn-danger" ng-click="$ctrl.cancel()" ng-disabled="$ctrl.isBusy">Cancelar</button> <button class="btn btn-warning pull-right" ng-click="$ctrl.delete()" ng-disabled="$ctrl.isBusy" ng-show="$ctrl.showDelete">Borrar</button></div></form></div>');
$templateCache.put('app/pages/grupos-usuarios/list.template.html','<div class="add-row-editable-table"><button class="btn btn-primary" ng-click="$ctrl.add()">Agregar</button></div><table class="table" st-pipe="$ctrl.buscar" st-table="$ctrl.resultList"><thead><tr class="sortable"><th class="text-center" st-sort="Nombre">Nombre</th><th class="text-center">Acci\xF3n</th></tr><tr><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Nombre" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por nombre" aria-describedby="basic-addon1"></div></th><th></th></tr></thead><tbody ng-show="!$ctrl.isSearching"><tr ng-repeat="item in $ctrl.resultList" ng-click="$ctrl.edit(item.Id)" style="cursor: pointer"><td align="center">{{item.Nombre}}</td><td align="center"><a href="" ng-click="$ctrl.edit(item.Id)">Ver</a></td></tr></tbody><tbody ng-show="$ctrl.isSearching"><tr><td colspan="3" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="3" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table>');
$templateCache.put('app/pages/home/home.html','<div class="col-md-12"><img class="col-md-5 home-app-logo" src="{{$ctrl.appLogoIcon}}"> <img class="home-client-logo" src="{{$ctrl.clientLogoIcon}}"></div><div style="padding-top: 120px"><div ng-show="$ctrl.isGroupSearching"><h5>Cargando...</h5></div><div class="row" ng-show="!$ctrl.isGroupSearching"><div style="text-align:center" class="col-md-3" ng-repeat="item in $ctrl.grupos"><div class="home-group-button hvr-float" ng-style="{ \'background-color\': item.ColorFondo }" ng-click="$ctrl.setGrupoSeleccionado(item.Id);"><img src="{{item.UrlImagen}}" ng-show="item.UrlImagen != null || item.UrlImagen.lenght > 0"><br><label ng-style="{ \'color\': item.ColorTexto }">{{item.Nombre}}</label><br><span ng-style="{ \'color\': item.ColorTexto }">{{item.Resumen}}</span></div><br></div></div></div>');
$templateCache.put('app/pages/jerarquia/edit.template.html','<div ba-panel="" ba-panel-title="{{$ctrl.title}}" class="add-top-space"><form name="form" novalidate=""><div ba-panel="" ba-panel-title="Datos Principales" class="add-top-space"><label class="col-md-1 center-label">C\xF3digo*:</label><div class="col-md-5"><input type="text" class="form-control" ng-model="$ctrl.model.Codigo" name="" placeholder=""></div><label class="col-md-1 center-label">Nombre*:</label><div class="col-md-5"><input type="text" class="form-control" ng-model="$ctrl.model.Nombre" name="" placeholder=""></div><label class="col-md-1 center-label">Padre:</label><div class="col-md-5"><input type="text" ng-model="$ctrl.model.JerarquiaPadreInput" placeholder="Ingrese una jerarqu\xEDa a buscar..." uib-typeahead="i as i.Nombre for i in $ctrl.searchJerarquiaPadre($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingJerarquiaPadre" typeahead-no-results="noResultsJerarquia" class="form-control" typeahead-on-select="$ctrl.onSelectJerarquia($model)"> <i ng-show="loadingJerarquia" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsJerarquia"><i class="glyphicon glyphicon-remove"></i> Jerarqu\xEDa no encontrada</div></div><label class="col-md-1 center-label">Activo:</label><div class="col-md-5" style="margin-top:1px"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.Activo"></ba-switcher></div><div class="col-md-6" style="margin-top:10px"><input type="checkbox" ng-model="$ctrl.model.MostrarDetalle" name="" ng-disabled="$ctrl.isBusy"> Tiene detalle?</div><div class="col-md-6" style="margin-top:10px"><input type="checkbox" ng-model="$ctrl.model.TienePermisos" name="" ng-disabled="$ctrl.isBusy"> Es de permisos?</div><div class="col-md-6" style="margin-top:10px"><input type="checkbox" ng-model="$ctrl.model.TieneTemplateDependiente" name="" ng-disabled="$ctrl.isBusy"> Tiene Template Dependiente?</div><div class="col-md-12" style="margin-top:10px"><input type="checkbox" ng-model="$ctrl.model.TieneJerarquiaPermisosCampos" name="" ng-disabled="$ctrl.isBusy"> Tiene Seguridad Campos?</div></div><div ba-panel="" ba-panel-title="Template Dependiente" ba-panel-class="with-scroll" ng-show="$ctrl.model.TieneTemplateDependiente" class="add-top-space"><div class="col-md-12"><label class="col-md-4 center-label">Proceso*:</label><div class="col-md-8"><select name="proceso" class="form-control" ng-model="$ctrl.model.procesoId" ng-options="item.Id as item.Nombre for item in $ctrl.resultListProcesos" ng-change="$ctrl.loadJerarquiaProcesos($ctrl.model.procesoId)"></select></div></div><div class="col-md-12" style="margin-top:10px"><ul class="list-group col-md-6 add-top-space"><li class="list-group-item active">Para Seleccionar</li><li multiple="" name="{{item.Campo.Id}}" ng-repeat="j in $ctrl.resultListJerarquiaProcesos track by j.Template.Id" ng-click="$ctrl.actionAddOnClick(j);" class="list-group-item list-group-item-action"><a class="list-group-item list-group-item-action list-group-item-dark">{{j.Template.Nombre}}</a></li></ul><ul class="list-group col-md-6 add-top-space"><li class="list-group-item active">Seleccionado</li><li multiple="" name="{{item.Campo.Id}}" ng-repeat="j in $ctrl.arrayTemplateSeleccionados track by j.Template.Id" class="list-group-item list-group-item-action" ng-click="$ctrl.actionRemoveOnClick(j);"><a class="list-group-item list-group-item-action list-group-item-dark">{{j.Template.Nombre}}</a></li></ul></div></div></form></div><div ba-panel="" ba-panel-title="Detalles de Jerarqu\xEDa" ba-panel-class="with-scroll" ng-show="$ctrl.model.MostrarDetalle"><div ba-panel="" ba-panel-title="Datos del Detalle a Mostrar" ba-panel-class="with-scroll" class="add-top-space"><label class="col-md-2 center-label">T\xEDtulo*:</label><div class="col-md-4"><input type="text" class="form-control" name="" ng-model="$ctrl.detalleCargado.Titulo"></div><label class="col-md-2 center-label">Valor*:</label><div class="col-md-4"><input type="text" class="form-control" name="" ng-model="$ctrl.detalleCargado.Valor"></div><label class="col-md-2 center-label">Orden*:</label><div class="col-md-4"><input type="text" class="form-control" name="" ng-model="$ctrl.detalleCargado.Orden" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"></div><div class="col-md-12"><button class="btn btn-warning" ng-click="$ctrl.clearDetalle()" ng-disabled="$ctrl.isBusy">Limpiar</button> <button class="btn btn-success pull-right" ng-click="$ctrl.editDetalle(form)" ng-disabled="$ctrl.isBusy">Guardar</button></div></div><div ba-panel="" ba-panel-title="Detalles Cargados" ba-panel-class="with-scroll"><table class="table" st-table="$ctrl.jerarquiaDetalleDS" st-safe-src="$ctrl.model.Detalles"><thead><tr class="sortable"><th class="text-center">T\xEDtulo</th><th class="text-center">Valor</th><th class="text-center" st-sort-default="true">Orden</th><th class="text-center">Acciones</th></tr><tr><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Titulo" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por t\xEDtulo" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Valor" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por valor" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Orden" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por orden" aria-describedby="basic-addon1"></div></th><th></th></tr></thead><tbody ng-show="!$ctrl.isDetalleSearching"><tr ng-repeat="item in $ctrl.jerarquiaDetalleDS" ng-click="$ctrl.cargarDetalle(item)" style="cursor: pointer"><td align="center">{{item.Titulo}}</td><td align="center">{{item.Valor}}</td><td align="center">{{item.Orden}}</td><td align="center"><button class="btn btn-success editable-table-button btn-xs" ng-click="$ctrl.cargarDetalle(item)" ng-disabled="$ctrl.isBusy">Ver</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.eliminarDetalle($index)" ng-disabled="$ctrl.isBusy">Eliminar</button></td></tr></tbody><tbody ng-show="$ctrl.isDetalleSearching"><tr><td colspan="4" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="4" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div><div ba-panel="" ba-panel-title="Permisos de Jerarqu\xEDa" ba-panel-class="with-scroll" ng-show="$ctrl.model.TienePermisos"><div ba-panel="" ba-panel-title="Datos Etapa 2" ba-panel-class="with-scroll" class="add-top-space"><label class="col-md-2 center-label">Subject Correo</label><div class="col-md-4"><input type="text" class="form-control" name="" ng-model="$ctrl.model.Permisos.subjectCorreoEtapa2"></div><label class="col-md-2 center-label">Correo</label><div class="col-md-4"><textarea type="text" class="form-control" name="" ng-model="$ctrl.model.Permisos.cuerpoCorreoEtapa2" cols="40" rows="5"></textarea></div><label class="col-md-2 center-label">Grupo 1 *:</label><div class="col-md-4"><select name="grupo" class="form-control" ng-model="$ctrl.model.Permisos.grupo1Etapa2Id" ng-options="item.Id as item.Nombre for item in $ctrl.GruposUsuariosList"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un grupo.</span></div></div><label class="col-md-2 center-label">Grupo 2:</label><div class="col-md-4"><select name="grupo" class="form-control" ng-model="$ctrl.model.Permisos.grupo2Etapa2Id" ng-options="item.Id as item.Nombre for item in $ctrl.GruposUsuariosList"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un grupo.</span></div></div><label class="col-md-2 center-label">Grupo 3:</label><div class="col-md-4"><select name="grupo" class="form-control" ng-model="$ctrl.model.Permisos.grupo3Etapa2Id" ng-options="item.Id as item.Nombre for item in $ctrl.GruposUsuariosList"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un grupo.</span></div></div></div><div ba-panel="" ba-panel-title="Datos Etapa 3" ba-panel-class="with-scroll" class="add-top-space"><label class="col-md-2 center-label">Subject Correo</label><div class="col-md-4"><input type="text" class="form-control" name="" ng-model="$ctrl.model.Permisos.subjectCorreoEtapa3"></div><label class="col-md-2 center-label">Correo</label><div class="col-md-4"><textarea type="text" class="form-control" name="" ng-model="$ctrl.model.Permisos.cuerpoCorreoEtapa3" cols="40" rows="5"></textarea></div><label class="col-md-2 center-label">Grupo 1 *:</label><div class="col-md-4"><select name="grupo" class="form-control" ng-model="$ctrl.model.Permisos.grupo1Etapa3Id" ng-options="item.Id as item.Nombre for item in $ctrl.GruposUsuariosList"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un grupo.</span></div></div><label class="col-md-2 center-label">Grupo 2:</label><div class="col-md-4"><select name="grupo" class="form-control" ng-model="$ctrl.model.Permisos.grupo2Etapa3Id" ng-options="item.Id as item.Nombre for item in $ctrl.GruposUsuariosList"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un grupo.</span></div></div><label class="col-md-2 center-label">Grupo 3:</label><div class="col-md-4"><select name="grupo" class="form-control" ng-model="$ctrl.model.Permisos.grupo3Etapa3Id" ng-options="item.Id as item.Nombre for item in $ctrl.GruposUsuariosList"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un grupo.</span></div></div></div><div ba-panel="" ba-panel-title="Datos Etapa 4" ba-panel-class="with-scroll" class="add-top-space"><label class="col-md-2 center-label">Subject Correo</label><div class="col-md-4"><input type="text" class="form-control" name="" ng-model="$ctrl.model.Permisos.subjectCorreoEtapa4"></div><label class="col-md-2 center-label">Correo</label><div class="col-md-4"><textarea type="text" class="form-control" name="" ng-model="$ctrl.model.Permisos.cuerpoCorreoEtapa4" cols="40" rows="5"></textarea></div><label class="col-md-2 center-label">Grupo 1 *:</label><div class="col-md-4"><select name="grupo" class="form-control" ng-model="$ctrl.model.Permisos.grupo1Etapa4Id" ng-options="item.Id as item.Nombre for item in $ctrl.GruposUsuariosList"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un grupo.</span></div></div><label class="col-md-2 center-label">Grupo 2:</label><div class="col-md-4"><select name="grupo" class="form-control" ng-model="$ctrl.model.Permisos.grupo2Etapa4Id" ng-options="item.Id as item.Nombre for item in $ctrl.GruposUsuariosList"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un grupo.</span></div></div><label class="col-md-2 center-label">Grupo 3:</label><div class="col-md-4"><select name="grupo" class="form-control" ng-model="$ctrl.model.Permisos.grupo3Etapa4Id" ng-options="item.Id as item.Nombre for item in $ctrl.GruposUsuariosList"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un grupo.</span></div></div></div><div ba-panel="" ba-panel-title="Datos Etapa 5" ba-panel-class="with-scroll" class="add-top-space"><label class="col-md-2 center-label">Subject Correo</label><div class="col-md-4"><input type="text" class="form-control" name="" ng-model="$ctrl.model.Permisos.subjectCorreoEtapa5"></div><label class="col-md-2 center-label">Correo</label><div class="col-md-4"><textarea type="text" class="form-control" name="" ng-model="$ctrl.model.Permisos.cuerpoCorreoEtapa5" cols="40" rows="5"></textarea></div><label class="col-md-2 center-label">Grupo 1 *:</label><div class="col-md-4"><select name="grupo" class="form-control" ng-model="$ctrl.model.Permisos.grupo1Etapa5Id" ng-options="item.Id as item.Nombre for item in $ctrl.GruposUsuariosList"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un grupo.</span></div></div><label class="col-md-2 center-label">Grupo 2:</label><div class="col-md-4"><select name="grupo" class="form-control" ng-model="$ctrl.model.Permisos.grupo2Etapa5Id" ng-options="item.Id as item.Nombre for item in $ctrl.GruposUsuariosList"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un grupo.</span></div></div><label class="col-md-2 center-label">Grupo 3:</label><div class="col-md-4"><select name="grupo" class="form-control" ng-model="$ctrl.model.Permisos.grupo3Etapa5Id" ng-options="item.Id as item.Nombre for item in $ctrl.GruposUsuariosList"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un grupo.</span></div></div></div><div ba-panel="" ba-panel-title="Datos Lectores" ba-panel-class="with-scroll" class="add-top-space"><label class="col-md-2 center-label">Subject Correo:</label><div class="col-md-4"><input type="text" class="form-control" name="" ng-model="$ctrl.model.Permisos.subjectCorreoLectores"></div><label class="col-md-2 center-label">Correo:</label><div class="col-md-4"><textarea type="text" class="form-control" name="" ng-model="$ctrl.model.Permisos.cuerpoCorreoLectores" cols="40" rows="5"></textarea></div><label class="col-md-2 center-label">Grupo 1 *:</label><div class="col-md-4"><select name="grupo" class="form-control" ng-model="$ctrl.model.Permisos.grupo1EtapaLectoresId" ng-options="item.Id as item.Nombre for item in $ctrl.GruposUsuariosList"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un grupo.</span></div></div><label class="col-md-2 center-label">Grupo 2:</label><div class="col-md-4"><select name="grupo" class="form-control" ng-model="$ctrl.model.Permisos.grupo2EtapaLectoresId" ng-options="item.Id as item.Nombre for item in $ctrl.GruposUsuariosList"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un grupo.</span></div></div><label class="col-md-2 center-label">Grupo 3:</label><div class="col-md-4"><select name="grupo" class="form-control" ng-model="$ctrl.model.Permisos.grupo3EtapaLectoresId" ng-options="item.Id as item.Nombre for item in $ctrl.GruposUsuariosList"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un grupo.</span></div></div></div></div><div ba-panel="" ba-panel-title="Seguridad de Campos" ba-panel-class="with-scroll" ng-show="$ctrl.model.TieneJerarquiaPermisosCampos"><div ba-panel="" ba-panel-title="Proceso"><label class="col-md-2 center-label">Proceso*:</label><div class="col-md-4"><select name="" class="col-md-6 form-control" ng-model="$ctrl.model.procesoId" ng-change="$ctrl.loadCamposProceso($ctrl.model.procesoId)"><option ng-repeat="proceso in $ctrl.resultListProcesos" value="{{proceso.Id}}">{{ proceso.Id}} - {{proceso.Nombre}}</option></select></div></div><div ba-panel="" ba-panel-title="Campos de Proceso" ng-if="$ctrl.resultListCamposProceso.length>0"><div ba-panel="" ba-panel-title="Datos del Campo" ba-panel-class="with-scroll" class="add-top-space"><label class="col-md-2 center-label">Campo*:</label><div class="col-md-4"><select name="" ng-model="$ctrl.campoCargado.Campo" class="form-control" ng-options="item as item.Nombre for item in $ctrl.resultListCamposProceso track by item.Id"></select></div><div class="col-md-12"><button class="btn btn-warning" ng-click="$ctrl.clearCampo()" ng-disabled="$ctrl.isBusy">Limpiar</button> <button class="btn btn-success pull-right" ng-click="$ctrl.editCampo(form)" ng-disabled="$ctrl.isBusy">Guardar</button></div></div><div ba-panel="" ba-panel-title="Campos Cargados" ba-panel-class="with-scroll"><table class="table" st-table="$ctrl.procesoCamposDS" st-safe-src="$ctrl.procesoCamposList"><thead><tr class="sortable"><th class="text-center">Nombre</th><th class="text-center">Acciones</th></tr><tr><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Campo.Nombre" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por campo" aria-describedby="basic-addon1"></div></th><th></th></tr></thead><tbody ng-show="!$ctrl.isCampoSearching"><tr ng-repeat="item in $ctrl.procesoCamposDS" ng-click="$ctrl.cargarCampo(item)" style="cursor: pointer"><td align="center">{{item.Campo.Nombre}}</td><td align="center"><button class="btn btn-success editable-table-button btn-xs" ng-click="$ctrl.cargarCampo(item)" ng-disabled="$ctrl.isBusy">Ver</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.eliminarCampo($index)" ng-disabled="$ctrl.isBusy">Eliminar</button></td></tr></tbody><tbody ng-show="$ctrl.isCampoSearching"><tr><td colspan="5" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="5" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div><div class="col-md-12" style="padding-top: 25px;margin-top: 5px; margin-bottom: 15px;"><button class="btn btn-success" ng-click="$ctrl.save(form)" ng-disabled="$ctrl.isBusy">Guardar</button> <button class="btn btn-danger" ng-click="$ctrl.cancel()" ng-disabled="$ctrl.isBusy">Cancelar</button> <button class="btn btn-warning pull-right" ng-click="$ctrl.delete()" ng-disabled="$ctrl.isBusy" ng-show="$ctrl.showDelete">Borrar</button></div>');
$templateCache.put('app/pages/jerarquia/list.template.html','<div class="add-row-editable-table"><button class="btn btn-primary" ng-click="$ctrl.add()">Agregar</button></div><table class="table" st-pipe="$ctrl.buscar" st-table="$ctrl.resultList"><thead><tr class="sortable"><th class="text-center" st-sort="Codigo">C\xF3digo</th><th class="text-center" st-sort="Nombre">Nombre</th><th class="text-center" st-sort="JerarquiaPadre.Nombre">Jerarqu\xEDa Padre</th><th class="text-center">Acci\xF3n</th></tr><tr><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Codigo" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por c\xF3digo" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Nombre" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por nombre" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="JerarquiaPadre.Nombre" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por jerarqu\xEDa padre" aria-describedby="basic-addon1"></div></th></tr></thead><tbody ng-show="!$ctrl.isSearching"><tr ng-repeat="item in $ctrl.resultList" ng-click="$ctrl.edit(item.Id)" style="cursor: pointer"><td align="center">{{item.Codigo}}</td><td align="center">{{item.Nombre}}</td><td align="center">{{item.JerarquiaPadre.Nombre}}</td><td align="center"><a href="" ng-click="$ctrl.edit(item.Id)">Ver</a></td></tr></tbody><tbody ng-show="$ctrl.isSearching"><tr><td colspan="4" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="4" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table>');
$templateCache.put('app/pages/proceso/edit.template.html','<div ba-panel="" ba-panel-title="{{$ctrl.title}}" ba-panel-class="with-scroll"><uib-tabset active="$ctrl.active"><uib-tab index="0" heading="Datos del Proceso" ng-disabled="true" ng-if="$ctrl.lsuarioLogueadoIsSysAdmin"><div ba-panel="" ba-panel-class="with-scroll" class="add-top-space"><form name="form" novalidate=""><div class="form-group" ng-class="{ \'has-error\': form.name.$invalid && (form.name.$dirty || $ctrl.showError) }"><label class="col-md-2 center-label">C\xF3digo*:</label><div class="col-md-4"><input type="text" class="form-control" ng-model="$ctrl.model.Codigo" name="codigo" placeholder="" required="" ng-disabled="!$ctrl.enableDatosProcesoTab"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el c\xF3digo.</span></div></div><label class="col-md-2 center-label">Nombre*:</label><div class="col-md-4"><input type="text" class="form-control" ng-model="$ctrl.model.Nombre" name="name" placeholder="" required="" ng-disabled="!$ctrl.enableDatosProcesoTab" ng-change="$ctrl.actualizarTitulo()"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el nombre.</span></div></div><label class="col-md-2 center-label">Grupo*:</label><div class="col-md-4"><select name="grupo" class="form-control" ng-model="$ctrl.model.Grupo" ng-disabled="!$ctrl.enableDatosProcesoTab" ng-options="item as item.Nombre for item in $ctrl.gruposList track by item.Id"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un grupo.</span></div></div><label class="col-md-2 center-label">Cantidad D\xEDas Cierre*:</label><div class="col-md-4"><input type="text" class="form-control" ng-model="$ctrl.model.CantidadDiasCierre" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8" ng-disabled="!$ctrl.enableDatosProcesoTab"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de d\xEDas al cierre.</span></div></div><div class="col-md-12"><label class="col-md-2 center-label" ng-if="$ctrl.enableDatosProcesoTab" style="margin-top:25px">Requiere Validaci\xF3n*:</label> <label class="col-md-2 center-label" ng-if="!$ctrl.enableDatosProcesoTab">Requiere Validaci\xF3n*:</label><div class="col-md-2" ng-if="!$ctrl.enableDatosProcesoTab"><label ng-if="$ctrl.model.RequiereValidacion">S\xED</label> <label ng-if="!$ctrl.model.RequiereValidacion">No</label></div><div class="col-md-2" ng-if="$ctrl.enableDatosProcesoTab"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.RequiereValidacion"></ba-switcher></div><label class="col-md-2 center-label" ng-if="$ctrl.enableDatosProcesoTab" style="margin-top:25px">Requiere Verificaci\xF3n*:</label> <label class="col-md-2 center-label" ng-if="!$ctrl.enableDatosProcesoTab">Requiere Verificaci\xF3n*:</label><div class="col-md-2" ng-if="!$ctrl.enableDatosProcesoTab"><label ng-if="$ctrl.model.RequiereVerificacion">S\xED</label> <label ng-if="!$ctrl.model.RequiereVerificacion">No</label></div><div class="col-md-2" ng-if="$ctrl.enableDatosProcesoTab"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.RequiereVerificacion" ng-disabled="!$ctrl.enableDatosProcesoTab"></ba-switcher></div><label class="col-md-2 center-label" ng-if="$ctrl.enableDatosProcesoTab" style="margin-top:25px">Requiere Aprobaci\xF3n*:</label> <label class="col-md-2 center-label" ng-if="!$ctrl.enableDatosProcesoTab">Requiere Aprobaci\xF3n*:</label><div class="col-md-2" ng-if="!$ctrl.enableDatosProcesoTab"><label ng-if="$ctrl.model.RequiereAutorizacion">S\xED</label> <label ng-if="!$ctrl.model.RequiereAutorizacion">No</label></div><div class="col-md-2" ng-if="$ctrl.enableDatosProcesoTab"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.RequiereAutorizacion" ng-disabled="!$ctrl.enableDatosProcesoTab"></ba-switcher></div></div><div class="col-md-12"><label class="col-md-2 center-label" ng-if="$ctrl.enableDatosProcesoTab" style="margin-top:25px">Ver Boton Agregar*:</label> <label class="col-md-2 center-label" ng-if="!$ctrl.enableDatosProcesoTab">Boton Agregar*:</label><div class="col-md-2" ng-if="!$ctrl.enableDatosProcesoTab"><label ng-if="$ctrl.model.verBtnAgregar">S\xED</label> <label ng-if="!$ctrl.model.verBtnAgregar">No</label></div><div class="col-md-2" ng-if="$ctrl.enableDatosProcesoTab"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.verBtnAgregar"></ba-switcher></div></div><label class="col-md-2 center-label">Nombre de Link del Proceso:</label><div class="col-md-4"><input type="text" class="form-control" ng-model="$ctrl.model.NombreLink" name="" placeholder="" ng-disabled="!$ctrl.enableDatosProcesoTab"></div><label class="col-md-2 center-label">URL de Link del Proceso:</label><div class="col-md-4"><input type="text" class="form-control" ng-model="$ctrl.model.UrlLink" name="" placeholder="" ng-disabled="!$ctrl.enableDatosProcesoTab"></div><label class="col-md-2 center-label">Nombre de Link de Solicitud:</label><div class="col-md-4"><input type="text" class="form-control" ng-model="$ctrl.model.NombreSolicitudLink" name="" placeholder="" ng-disabled="!$ctrl.enableDatosProcesoTab"></div><label class="col-md-2 center-label">URL de Link de Solicitud:</label><div class="col-md-4"><input type="text" class="form-control" ng-model="$ctrl.model.UrlSolicitudLink" name="" placeholder="" ng-disabled="!$ctrl.enableDatosProcesoTab"></div><label class="col-md-2 center-label">Color de Fondo:</label><div class="col-md-4"><input type="color" class="form-control" ng-model="$ctrl.model.ColorFondo" name="" placeholder=""></div><label class="col-md-2 center-label">Color de Texto:</label><div class="col-md-4"><input type="color" class="form-control" ng-model="$ctrl.model.ColorTexto" name="" placeholder=""></div><label class="col-md-2 center-label">Imagen:</label><div class="col-md-10" style="margin-top:12px"><a href="" ng-click="$ctrl.openAttachment($ctrl.model.UrlImagen)">{{$ctrl.model.UrlImagen}}</a><div class="btn btn-success editable-table-button btn-xs" ng-disabled="$ctrl.isBusy" ngf-select="$ctrl.uploadAttachment($file)">Seleccionar</div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment()" ng-disabled="$ctrl.isBusy">Quitar</div><p ng-show="ctrl.model.isImageLoading">Cargando archivo...</p></div><label class="col-md-2 center-label" ng-if="$ctrl.enableDatosProcesoTab" style="margin-top:25px">Mostrar en Home*:</label> <label class="col-md-2 center-label" ng-if="!$ctrl.enableDatosProcesoTab">Mostrar en Home*:</label><div class="col-md-4" ng-if="!$ctrl.enableDatosProcesoTab"><label ng-if="$ctrl.model.MostrarEnHome">S\xED</label> <label ng-if="!$ctrl.model.MostrarEnHome">No</label></div><div class="col-md-4" ng-if="$ctrl.enableDatosProcesoTab"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.MostrarEnHome"></ba-switcher></div><label class="col-md-2 center-label" style="margin-top:25px">Requiere Justificacion:</label><div class="col-md-4"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.justificacionEsRequerida"></ba-switcher></div><div class="col-md-12 center-label" style="padding-left: 0px;"><label class="col-md-2 center-label" style="margin-top:25px" ng-show="$ctrl.model.MostrarEnHome">Jerarquia Template:</label><div class="col-md-10" ng-show="$ctrl.model.MostrarEnHome" style="margin-top:10px"><select name="" class="form-control" ng-model="$ctrl.model.jerarquiatemplate"><option ng-repeat="item in $ctrl.procesoCamposList" value="{{item.Campo.Id}}">{{ item.Campo.Id }} - {{item.Campo.Nombre}}</option></select></div></div><label class="col-md-2 center-label" style="margin-top:25px">Permite Copia:</label><div class="col-md-4"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.permiteCopia"></ba-switcher></div><label class="col-md-2 center-label" style="margin-top:25px">Permite Enviar a Obsoleto:</label><div class="col-md-4"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.permiteEnviarObsoleto"></ba-switcher></div><label class="col-md-2 center-label" style="margin-top:25px">Ver Procesos Cerrados:</label><div class="col-md-10"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.verProcesosCerrados"></ba-switcher></div><label class="col-md-2 center-label" style="margin-top:25px">Es de Autorizaciones?:</label><div class="col-md-4"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.autorizaciones"></ba-switcher></div><label class="col-md-2 center-label" style="margin-top:25px">Proceso de Evidencia?:</label><div class="col-md-4"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.mcaOcultaAvanzarEtapa"></ba-switcher></div><div class="col-md-6" ng-show="$ctrl.model.autorizaciones"><label class="col-md-6 center-label" style="margin-top:25px">Campo Autorizaci\xF3n:</label><select name="" class="col-md-6 form-control" ng-model="$ctrl.model.campoIdAutorizacion"><option ng-repeat="item in $ctrl.procesoCamposList" value="{{item.Campo.Id}}">{{ item.Campo.Id }} - {{item.Campo.Nombre}}</option></select></div><div class="col-md-6" ng-show="$ctrl.model.autorizaciones"><label class="col-md-6 center-label" style="margin-top:25px">Campo de tipo de documento:</label><select name="" class="col-md-6 form-control" ng-model="$ctrl.model.tipoDocumentoId"><option ng-repeat="item in $ctrl.procesoCamposList" value="{{item.Campo.Id}}">{{ item.Campo.Id }} - {{item.Campo.Nombre}}</option></select></div><div class="col-md-6" ng-show="$ctrl.model.autorizaciones"><label class="col-md-6 center-label" style="margin-top:25px">Campo Documento Publicable:</label><select name="" class="col-md-6 form-control" ng-model="$ctrl.model.documentoPublicableId"><option ng-repeat="item in $ctrl.procesoCamposList" value="{{item.Campo.Id}}">{{ item.Campo.Id }} - {{item.Campo.Nombre}}</option></select></div><div class="col-md-6" ng-show="$ctrl.model.autorizaciones"><label class="col-md-6 center-label" style="margin-top:25px">Codigo Numerador Documental:</label><select name="" class="col-md-6 form-control" ng-model="$ctrl.model.numeradorDocumentalId"><option ng-repeat="item in $ctrl.procesoCamposList" value="{{item.Campo.Id}}">{{ item.Campo.Id }} - {{item.Campo.Nombre}}</option></select></div><label class="col-md-2 center-label" style="margin-top:25px" ng-show="$ctrl.model.autorizaciones">Autorizaci\xF3n Documental (V.2)?:</label><div class="col-md-4" ng-show="$ctrl.model.autorizaciones"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.autorizacionesDocumental"></ba-switcher></div><label class="col-md-2 center-label" ng-show="$ctrl.model.autorizaciones">Link:</label><div class="col-md-4" ng-show="$ctrl.model.autorizaciones"><input type="text" class="form-control" ng-model="$ctrl.model.LinkDocumental" name="name" placeholder=""></div><div class="col-md-12 center-label"><label class="col-md-2 center-label" style="margin-top:25px" ng-show="$ctrl.model.MostrarEnHome">Orden en Home:</label><div class="col-md-10" ng-show="$ctrl.model.MostrarEnHome" style="margin-top:10px"><input type="text" class="form-control" ng-model="$ctrl.model.HomeOrden" name="" placeholder="" onkeypress="return (event.charCode >= 48 && event.charCode <= 57)" maxlength="3" ng-disabled="!$ctrl.enableDatosProcesoTab"></div></div><label class="col-md-12 center-label">Configuraci\xF3n de T\xEDtulo: <a href="" style="margin-left:5px" ng-click="$ctrl.showTituloConfigText = !$ctrl.showTituloConfigText"><i class="fa fa-eye"></i></a></label><div class="col-md-12" ng-show="!$ctrl.showTituloConfigText"><input type="text" class="form-control" ng-model="$ctrl.model.ConfiguracionTitulo" placeholder="" id="configuracionTitulo" ng-disabled="!$ctrl.enableDatosProcesoTab" ng-change="$ctrl.actualizarTituloConfigText()" ng-model-options="{ debounce: 1500 }"></div><label class="col-md-12 center-label" ng-show="$ctrl.showTituloConfigText" style="margin-top: 0px">{{$ctrl.configuracionTituloText}}</label><div class="col-md-12" style="margin-top:5px" ng-show="$ctrl.enableDatosProcesoTab"><a href="" ng-click="$ctrl.buscarCampoProcesoTitulo(!$ctrl.showCampoProcesoTituloSelect)"><i class="ion-ios-search-strong"></i> Incluir campo del proceso</a></div><div class="col-md-12" style="margin-top:5px" ng-show="$ctrl.enableDatosProcesoTab"><a href="" ng-click="$ctrl.buscarCampoTemplateTitulo(!$ctrl.showTemplateTituloSelect)"><i class="ion-ios-search-strong"></i> Incluir campo de template</a></div><div class="col-md-4" ng-show="$ctrl.showCampoProcesoTituloSelect"><select name="" class="form-control" ng-model="$ctrl.campoTituloSeleccionado" ng-options="item as item.Campo.Nombre for item in $ctrl.procesoCamposList track by item.Campo.Id" ng-change="$ctrl.onSelectCampoProcesoTitulo($ctrl.campoTituloSeleccionado)"><option value="" disabled="" selected="">Seleccione un campo de proceso...</option></select></div><div class="col-md-4" ng-show="$ctrl.showTemplateTituloSelect"><select name="" class="form-control" ng-model="$ctrl.templateTituloSeleccionado" ng-options="item as item.Template.Nombre for item in $ctrl.procesoTemplatesList track by item.Template.Id" ng-change="$ctrl.onSelectTemplateTitulo($ctrl.templateTituloSeleccionado)"><option value="" disabled="" selected="">Seleccione un template del proceso...</option></select></div><div class="col-md-4" ng-show="$ctrl.showCampoTemplateTituloSelect"><select name="" class="form-control" ng-model="$ctrl.campoTituloSeleccionado" ng-options="item as item.Nombre for item in $ctrl.templateCamposList track by item.Id" ng-change="$ctrl.onSelectCampoTemplateTitulo($ctrl.templateTituloSeleccionado, $ctrl.campoTituloSeleccionado)"><option value="" disabled="" selected="">Seleccione un campo del template...</option></select></div><div class="col-md-12"><label class="col-md-4 center-label" ng-if="$ctrl.enableDatosProcesoTab" style="margin-top:25px">Desea generar automaticamente todos los procesos relacionados?*:</label><div class="col-md-2" ng-if="!$ctrl.enableDatosProcesoTab"><label ng-if="$ctrl.model.generaProcesosRelacionados">S\xED</label> <label ng-if="!$ctrl.model.generaProcesosRelacionados">No</label></div><div class="col-md-2" ng-if="$ctrl.enableDatosProcesoTab"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.generaProcesosRelacionados" ng-disabled="!$ctrl.enableDatosProcesoTab"></ba-switcher></div></div><div class="col-md-12"><label class="col-md-4 center-label" style="margin-top:25px">Documental:</label><div class="col-md-4"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.isDocumental"></ba-switcher></div></div><div class="col-md-12" ng-if="$ctrl.model.isDocumental"><label class="col-md-4 center-label">Proceso Id Versiones*:</label><div class="col-md-8"><select name="" class="col-md-6 form-control" ng-model="$ctrl.model.procesoIdVersiones"><option ng-repeat="proceso in $ctrl.resultListProcesos" value="{{proceso.Id}}">{{ proceso.Id}} - {{proceso.Nombre}}</option></select></div></div><div class="col-md-12" ng-if="$ctrl.model.isDocumental"><label class="col-md-4 center-label">Proceso Id Obsoletos*:</label><div class="col-md-8"><select name="" class="col-md-6 form-control" ng-model="$ctrl.model.procesoIdObsoletos"><option ng-repeat="proceso in $ctrl.resultListProcesos" value="{{proceso.Id}}">{{ proceso.Id }}- {{proceso.Nombre}}</option></select></div></div></div></form></div></uib-tab><uib-tab index="1" heading="Campos de Proceso" ng-disabled="true" ng-if="$ctrl.lsuarioLogueadoIsSysAdmin"><div ba-panel="" ba-panel-title="Datos del Campo" ba-panel-class="with-scroll" class="add-top-space"><label class="col-md-2 center-label">Campo*:</label><div class="col-md-4"><select name="" ng-model="$ctrl.campoCargado.Campo" class="form-control" ng-disabled="!$ctrl.enableDatosProcesoTab" ng-options="item as item.Nombre for item in $ctrl.camposList track by item.Id"></select></div><label class="col-md-2 center-label">Tipo Campo Solicitud*:</label><div class="col-md-4"><select name="" ng-model="$ctrl.campoCargado.TipoCampoSolicitud" class="form-control" ng-disabled="!$ctrl.enableDatosProcesoTab" ng-options="item as item.Nombre for item in $ctrl.tipoCampoSolicitudList track by item.Id"></select></div><label class="col-md-2 center-label">Orden*:</label><div class="col-md-4"><input type="text" class="form-control" name="" ng-model="$ctrl.campoCargado.Orden" ng-disabled="!$ctrl.enableDatosProcesoTab" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"></div><label class="col-md-2 center-label" ng-if="$ctrl.enableDatosProcesoTab" style="margin-top:25px">Obligatorio*:</label> <label class="col-md-2 center-label" ng-if="!$ctrl.enableDatosProcesoTab">Obligatorio*:</label><div class="col-md-4" ng-if="!$ctrl.enableDatosProcesoTab"><label ng-if="$ctrl.campoCargado.Obligatorio">S\xED</label> <label ng-if="!$ctrl.campoCargado.Obligatorio">No</label></div><div class="col-md-4" ng-if="$ctrl.enableDatosProcesoTab"><ba-switcher switcher-style="primary" switcher-value="$ctrl.campoCargado.Obligatorio"></ba-switcher></div><div class="col-md-12"><button class="btn btn-warning" ng-click="$ctrl.clearCampo()" ng-disabled="$ctrl.isBusy || !$ctrl.enableDatosProcesoTab">Limpiar</button> <button class="btn btn-success pull-right" ng-click="$ctrl.editCampo(form)" ng-disabled="$ctrl.isBusy || !$ctrl.enableDatosProcesoTab">Guardar</button></div></div><div ba-panel="" ba-panel-title="Campos Cargados" ba-panel-class="with-scroll"><table class="table" st-table="$ctrl.procesoCamposDS" st-safe-src="$ctrl.procesoCamposList"><thead><tr class="sortable"><th class="text-center">Nombre</th><th class="text-center">Tipo</th><th class="text-center" st-sort-default="true">Orden</th><th class="text-center">Tipo Campo Solicitud</th><th class="text-center">Obligatorio</th><th class="text-center">Acciones</th></tr><tr><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Campo.Nombre" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por campo" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Campo.CampoTipo.Nombre" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por tipo de campo" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Orden" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por orden" aria-describedby="basic-addon1"></div></th><th></th></tr></thead><tbody ng-show="!$ctrl.isCampoSearching"><tr ng-repeat="item in $ctrl.procesoCamposDS" ng-click="$ctrl.cargarCampo(item)" style="cursor: pointer"><td align="center">{{item.Campo.Nombre}}</td><td align="center">{{item.Campo.CampoTipo.Nombre}}</td><td align="center">{{item.Orden}}</td><td align="center">{{item.TipoCampoSolicitud.Nombre}}</td><td align="center"><i class="fa fa-check" style="color:green" ng-show="item.Obligatorio"></i> <i class="fa fa-times" style="color:red" ng-hide="item.Obligatorio"></i></td><td align="center"><button class="btn btn-success editable-table-button btn-xs" ng-click="$ctrl.cargarCampo(item)" ng-disabled="$ctrl.isBusy">Ver</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.eliminarCampo($index)" ng-disabled="$ctrl.isBusy || !$ctrl.enableDatosProcesoTab">Eliminar</button></td></tr></tbody><tbody ng-show="$ctrl.isCampoSearching"><tr><td colspan="5" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="5" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table></div></uib-tab><uib-tab index="2" heading="Seguridad de Procesos" select="$ctrl.loadSeguridadProcesosTab()" ng-disabled="true"><div ba-panel="" ba-panel-class="with-scroll" ng-if="$ctrl.lsuarioLogueadoIsSysAdmin"><div class="col-md-12"><input type="checkbox" ng-model="$ctrl.model.MostrarOpcionProcesosPendientes" name="" ng-disabled="$ctrl.isBusy"> Mostrar filtro de \'Ver procesos pendientes de cualquier usuario\'</div><div class="col-md-12"><input type="checkbox" ng-model="$ctrl.model.MostrarSolicitudesAUsuariosInvolucrados" name="" ng-disabled="$ctrl.isBusy"> Mostrar todas las solicitudes a los usuarios involucrados en el proceso</div><div class="col-md-12"><input type="checkbox" ng-model="$ctrl.model.PermiteAvanzarProceso" name="" ng-disabled="$ctrl.isBusy"> Permitir Avanzar cuando sus procesos hijos NO est\xE1n en una etapa posterior a la etapa actual del proceso padre</div><div class="col-md-12"><input type="checkbox" ng-model="$ctrl.model.PermiteDerivarRes" name="" ng-disabled="$ctrl.isBusy"> Permitir derivar responsabilidad a otro usuario con el mismo rol</div></div><div ba-panel="" ba-panel-title="Datos de Usuario" ba-panel-class="with-scroll"><div class="col-md-12"><label class="col-md-2 center-label">Usuario*:</label><div class="col-md-4"><input type="text" ng-model="$ctrl.usuarioCargado.UsuarioInput" placeholder="Ingrese un usuario a buscar..." uib-typeahead="i as i.Login for i in $ctrl.searchUsuario($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingUsuario" typeahead-no-results="noResultsUsuario" class="form-control" typeahead-on-select="$ctrl.onSelectUsuario($model)"> <i ng-show="loadingUsuario" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsUsuario"><i class="glyphicon glyphicon-remove"></i> Usuario no encontrado</div></div><label class="col-md-2 center-label">Roles*:</label><div class="col-md-4" style="height:125px"><select multiple="" name="" ng-model="$ctrl.usuarioCargado.RolProcesoList" class="form-control" style="height:125px" ng-options="item as item.Nombre for item in $ctrl.rolProcesoFilteredList track by item.Id"></select></div></div><div class="col-md-12"><label class="col-md-12 center-label"></label> <label class="col-md-12 center-label"></label></div><div class="col-md-12"><button class="btn btn-warning" ng-click="$ctrl.clearUsuario()" ng-disabled="$ctrl.isBusy">Limpiar</button> <button class="btn btn-success pull-right" ng-click="$ctrl.editUsuario(form)" ng-disabled="$ctrl.isBusy">Guardar</button></div></div><div ba-panel="" ba-panel-title="Usuarios Cargados" ba-panel-class="with-scroll"><table class="table" st-table="$ctrl.procesoUsuariosDS" st-safe-src="$ctrl.procesoUsuariosList"><thead><tr class="sortable"><th class="text-center" st-sort="Usuario.Login">Usuario</th><th class="text-center">Roles Asociados</th><th class="text-center">Acciones</th></tr><tr><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Usuario.Login" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por usuario" aria-describedby="basic-addon1"></div></th><th></th><th></th></tr></thead><tbody ng-show="!$ctrl.isUsuarioSearching"><tr ng-repeat="item in $ctrl.procesoUsuariosDS" ng-click="$ctrl.cargarUsuario(item)" style="cursor: pointer"><td align="center">{{item.Usuario.Login}}</td><td align="center">{{$ctrl.concatRolesString(item.RolProcesoList)}}</td><td align="center"><button class="btn btn-success editable-table-button btn-xs" ng-click="$ctrl.cargarUsuario(item)" ng-disabled="$ctrl.isBusy">Ver</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.eliminarUsuario($index)" ng-disabled="$ctrl.isBusy">Eliminar</button></td></tr></tbody><tbody ng-show="$ctrl.isUsuarioSearching"><tr><td colspan="5" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="5" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table></div></uib-tab><uib-tab index="3" heading="Templates Asociados" select="$ctrl.loadTemplatesTab()" ng-disabled="true" ng-if="$ctrl.lsuarioLogueadoIsSysAdmin"><div ba-panel="" ba-panel-title="Datos del Template" ba-panel-class="with-scroll" class="add-top-space"><label class="col-md-2 center-label">Template*:</label><div class="col-md-4"><input type="text" ng-model="$ctrl.templateCargado.TemplateInput" placeholder="Ingrese un template a buscar..." uib-typeahead="i as i.Nombre for i in $ctrl.searchTemplate($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingTemplate" typeahead-no-results="noResultsTemplate" class="form-control" typeahead-on-select="$ctrl.onSelectTemplate($model)" ng-disabled="!$ctrl.enableDatosProcesoTab"> <i ng-show="loadingTemplate" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsTemplate"><i class="glyphicon glyphicon-remove"></i> Template no encontrado</div></div><label class="col-md-2 center-label">Etapa:</label><div class="col-md-4"><select name="" ng-model="$ctrl.templateCargado.SolicitudEstado" class="form-control" ng-disabled="!$ctrl.enableDatosProcesoTab" ng-options="item as item.NombreEtapa for item in $ctrl.estadosFilteredList track by item.Id"></select></div><label class="col-md-2 center-label">Ocurrencia*:</label><div class="col-md-4"><input type="text" class="form-control" ng-model="$ctrl.templateCargado.Ocurrencia" name="" placeholder="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8" ng-disabled="!$ctrl.enableDatosProcesoTab"></div><label class="col-md-2 center-label" ng-if="$ctrl.enableDatosProcesoTab">Obligatorio*:</label> <label class="col-md-2 center-label" style="margin-top:16px;margin-bottom:15px" ng-if="!$ctrl.enableDatosProcesoTab">Obligatorio*:</label><div class="col-md-4" style="margin-top:2px;margin-bottom:10px" ng-if="!$ctrl.enableDatosProcesoTab"><label ng-if="$ctrl.templateCargado.Obligatorio">S\xED</label> <label ng-if="!$ctrl.templateCargado.Obligatorio">No</label></div><div class="col-md-4" ng-if="$ctrl.enableDatosProcesoTab" style="margin-top:-10px"><ba-switcher switcher-style="primary" switcher-value="$ctrl.templateCargado.Obligatorio"></ba-switcher></div><label class="col-md-2 center-label" style="margin-top:10px" ng-if="$ctrl.enableDatosProcesoTab">Acceso Directo*:</label> <label class="col-md-2 center-label" style="margin-top:5px" ng-if="!$ctrl.enableDatosProcesoTab">Acceso Directo*:</label><div class="col-md-4" ng-if="!$ctrl.enableDatosProcesoTab" style="margin-top:-10px"><label ng-if="$ctrl.templateCargado.EsAccesoDirecto">S\xED</label> <label ng-if="!$ctrl.templateCargado.EsAccesoDirecto">No</label></div><div class="col-md-4" style="margin-top:-16px" ng-if="$ctrl.enableDatosProcesoTab"><ba-switcher switcher-style="primary" switcher-value="$ctrl.templateCargado.EsAccesoDirecto"></ba-switcher></div><div class="col-md-12"><button class="btn btn-warning" ng-click="$ctrl.clearTemplate()" ng-disabled="$ctrl.isBusy || !$ctrl.enableDatosProcesoTab">Limpiar</button> <button class="btn btn-success pull-right" ng-click="$ctrl.editTemplate(form)" ng-disabled="$ctrl.isBusy || !$ctrl.enableDatosProcesoTab">Guardar</button></div></div><div ba-panel="" ba-panel-title="Templates Cargados" ba-panel-class="with-scroll"><table class="table" st-table="$ctrl.procesoTemplatesDS" st-safe-src="$ctrl.procesoTemplatesList"><thead><tr class="sortable"><th class="text-center" st-sort="Template.Codigo">C\xF3digo</th><th class="text-center" st-sort="Template.Nombre">Nombre</th><th class="text-center" st-sort="SolicitudEstado.Nombre">Etapa</th><th class="text-center" st-sort="Ocurrencia">Ocurrencia</th><th class="text-center" st-sort="Obligatorio">Obligatorio</th><th class="text-center" st-sort="EsAccesoDirecto">Acceso Directo</th><th class="text-center">Acciones</th></tr><tr><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Template.Codigo" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por c\xF3digo" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Template.Nombre" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por nombre" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="SolicitudEstado.Nombre" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por estado" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Ocurrencia" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por ocurrencia" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Obligatorio" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por obligatorio" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="EsAccesoDirecto" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por acceso directo" aria-describedby="basic-addon1"></div></th><th></th></tr></thead><tbody ng-show="!$ctrl.isTemplateSearching"><tr ng-repeat="item in $ctrl.procesoTemplatesDS" ng-click="$ctrl.cargarTemplate(item)" style="cursor: pointer"><td align="center">{{item.Template.Codigo}}</td><td align="center">{{item.Template.Nombre}}</td><td align="center">{{item.SolicitudEstado.NombreEtapa}}</td><td align="center">{{item.Ocurrencia}}</td><td align="center"><i class="fa fa-check" style="color:green" ng-show="item.Obligatorio"></i> <i class="fa fa-times" style="color:red" ng-hide="item.Obligatorio"></i></td><td align="center"><i class="fa fa-check" style="color:green" ng-show="item.EsAccesoDirecto"></i> <i class="fa fa-times" style="color:red" ng-hide="item.EsAccesoDirecto"></i></td><td align="center"><button class="btn btn-success editable-table-button btn-xs" ng-click="$ctrl.cargarTemplate(item)" ng-disabled="$ctrl.isBusy">Ver</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.eliminarTemplate($index)" ng-disabled="$ctrl.isBusy || !$ctrl.enableDatosProcesoTab">Eliminar</button></td></tr></tbody><tbody ng-show="$ctrl.isTemplateSearching"><tr><td colspan="7" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="7" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table></div></uib-tab><uib-tab index="4" heading="Seguridad de Templates" select="$ctrl.loadSeguridadTemplatesTab()" ng-disabled="true"><div ba-panel="" ba-panel-class="with-scroll" class="add-top-space"><div class="col-md-8"><label class="col-md-3 center-label">Template*:</label><div class="col-md-9"><select name="" class="form-control" ng-model="$ctrl.usuarioTemplateCargado.ProcesoTemplate" ng-options="item as item.Template.Nombre for item in $ctrl.procesoTemplatesList track by item.Template.Id" ng-change="$ctrl.loadTemplateUsuarioSeleccionado()"></select></div></div><div class="col-md-8" ng-repeat="item in $ctrl.usuarioTemplateCargado.Usuarios" ng-show="$ctrl.usuarioTemplateCargado.ProcesoTemplate != null"><label class="col-md-3 center-label">{{item.Nombre}} {{item.Apellido}}<br>{{item.Login}}</label><div class="col-md-9"><select multiple="" name="" ng-model="item.RolTemplateList" style="height:90px" class="form-control" ng-options="rol as rol.Nombre for rol in $ctrl.rolTemplateList track by rol.Id" ng-change="$ctrl.onRolTemplateSeleccionado($ctrl.usuarioTemplateCargado.ProcesoTemplate, item)"></select></div></div></div></uib-tab><uib-tab index="5" heading="Campos del Proceso en Templates" select="$ctrl.loadCamposTemplatesTab()" ng-disabled="true" ng-if="$ctrl.lsuarioLogueadoIsSysAdmin"><div ba-panel="" ba-panel-class="with-scroll" class="add-top-space"><div class="col-md-8"><label class="col-md-3 center-label">Template*:</label><div class="col-md-9"><select name="" class="form-control" ng-model="$ctrl.campoTemplateCargado.ProcesoTemplate" ng-options="item as item.Template.Nombre for item in $ctrl.procesoTemplatesList track by item.Template.Id" ng-change="$ctrl.loadTemplateCampoSeleccionado()"></select></div></div><div class="col-md-8" ng-show="$ctrl.campoTemplateCargado.ProcesoTemplate != null"><label class="col-md-12 center-label">Campos:</label><div class="col-md-12 col-md-offset-3" ng-repeat="item in $ctrl.procesoCamposList"><input type="checkbox" ng-model="item.Seleccionado" name="" ng-click="$ctrl.onTemplateCampoSeleccionado(item)" ng-disabled="!$ctrl.enableDatosProcesoTab"> <span>{{item.Campo.Nombre}}</span> <input type="number" ng-model="item.orden" name="" ng-disabled="!$ctrl.enableDatosProcesoTab" ng-change="$ctrl.onTemplateCampoSeleccionadoOrden(item)" ng-keydown="$ctrl.evaluatenumberDigit($event)" style="float: right;margin-right: 50px;"></div></div></div></uib-tab><uib-tab index="6" heading="Procesos Hijo" ng-disabled="true" ng-if="$ctrl.lsuarioLogueadoIsSysAdmin"><div ba-panel="" ba-panel-class="with-scroll"><input type="checkbox" ng-model="$ctrl.model.AceptaHijos" ng-click="$ctrl.loadProcesosHijoTab($ctrl.model.AceptaHijos)" name="" ng-disabled="!$ctrl.enableDatosProcesoTab"> Acepta Procesos Hijo</div><div ba-panel="" ba-panel-title="Procesos Seleccionables Como Hijo" ba-panel-class="with-scroll" ng-show="$ctrl.model.AceptaHijos" class="add-top-space"><div class="col-md-8"><label class="col-md-2 center-label">Grupo*:</label><div class="col-md-10"><select name="" class="form-control" ng-model="$ctrl.procesoHijoCargado" ng-options="item as item.Grupo.Nombre for item in $ctrl.allProcesosList track by item.Grupo.Id" ng-change="$ctrl.loadProcesosByGrupo()"></select></div></div><div class="col-md-8"><label class="col-md-2 center-label">Procesos*:</label><div class="col-md-10"><select multiple="" name="" ng-model="$ctrl.procesoHijoCargado.ProcesosHijoSeleccionados" class="form-control" ng-options="item as item.Nombre for item in $ctrl.procesoHijoCargado.ProcesosHijosList track by item.Id" ng-change="$ctrl.onProcesoHijoSeleccionado($ctrl.procesoHijoCargado.ProcesosHijoSeleccionados, item)" ng-disabled="!$ctrl.enableDatosProcesoTab"></select></div></div></div><div ba-panel="" ba-panel-title="Procesos Hijos" ba-panel-class="with-scroll" ng-show="$ctrl.model.AceptaHijos" class="add-top-space"><table class="table"><thead><tr><th class="text-center">Nombre Proceso Hijo</th><th class="text-center">Permite Avanzar</th></tr></thead><tbody><tr ng-repeat="item in $ctrl.procesoHijosSeleccionables"><td align="center">{{item.ProcesoHijo.Nombre}}</td><td align="center"><input type="checkbox" ng-model="item.permiteAvanzar" ng-disabled="!$ctrl.enableDatosProcesoTab" name="" style="height: 18px;width: 18px;vertical-align: middle;"></td></tr></tbody></table></div></uib-tab><uib-tab index="7" heading="Etapas" ng-disabled="true" ng-if="$ctrl.lsuarioLogueadoIsSysAdmin"><div ba-panel="" ba-panel-title="Personalizaci\xF3n de Nombres de Etapas" ba-panel-class="with-scroll"><table class="table" st-table="$ctrl.model.EtapasNombres"><thead><tr><th class="text-center">Nombre Etapa Original</th><th class="text-center">Nombre Etapa Proceso</th><th class="text-center">Ver Procesos Hijo</th><th class="text-center">Permite Forzar Cierre</th></tr></thead><tbody><tr ng-repeat="item in $ctrl.model.EtapasNombres"><td align="center">{{item.SolicitudEstado.NombreEtapa}}</td><td align="center"><input type="text" class="form-control" ng-model="item.NombreEtapa" placeholder="Ingrese un nuevo nombre para la etapa..." ng-disabled="!$ctrl.enableDatosProcesoTab"></td><td align="center"><input type="checkbox" ng-model="item.procesoHijo" ng-disabled="!$ctrl.enableDatosProcesoTab" name="" style="height: 18px;width: 18px;vertical-align: middle;"></td><td align="center"><input type="checkbox" ng-model="item.forzarCierre" ng-disabled="!$ctrl.enableDatosProcesoTab" name="" style="height: 18px;width: 18px;vertical-align: middle;"></td></tr></tbody></table></div></uib-tab><uib-tab index="8" heading="Columnas de Listado" ng-disabled="true" ng-if="$ctrl.lsuarioLogueadoIsSysAdmin"><div ba-panel="" ba-panel-title="Columnas a Mostrar en Listado" ba-panel-class="with-scroll"><label class="col-md-12 center-label">Campos Nativos del Proceso:</label><table class="table" st-table="$ctrl.columnasProcesoList"><thead><tr><th class="text-center">Seleccionado</th><th class="text-center">Columna del Proceso</th><th class="text-center">Orden</th></tr></thead><tbody><tr ng-repeat="item in $ctrl.columnasProcesoList"><td align="center"><input type="checkbox" ng-model="item.SeleccionLista" ng-disabled="!$ctrl.enableDatosProcesoTab"></td><td align="center">{{item.Nombre}}</td><td align="center"><input type="text" ng-model="item.OrdenLista" onkeypress="return (event.charCode >= 48 && event.charCode <= 57)" style="text-align:right;" ng-show="item.SeleccionLista" ng-disabled="!$ctrl.enableDatosProcesoTab"><p ng-show="!item.SeleccionLista" style="font-size: inherit">{{item.OrdenLista}}</p></td></tr></tbody></table><br><label class="col-md-12 center-label">Campos del Proceso:</label><table class="table" st-table="$ctrl.procesoCamposList"><thead><tr><th class="text-center">Seleccionado</th><th class="text-center">Columna del Proceso</th><th class="text-center">Orden</th></tr></thead><tbody><tr ng-repeat="item in $ctrl.procesoCamposList"><td align="center"><input type="checkbox" ng-model="item.SeleccionLista" ng-disabled="!$ctrl.enableDatosProcesoTab"></td><td align="center">{{item.Campo.Nombre}}</td><td align="center"><input type="text" ng-model="item.OrdenLista" onkeypress="return (event.charCode >= 48 && event.charCode <= 57)" style="text-align:right;" ng-show="item.SeleccionLista" ng-disabled="!$ctrl.enableDatosProcesoTab"><p ng-show="!item.SeleccionLista" style="font-size: inherit">{{item.OrdenLista}}</p></td></tr></tbody></table></div></uib-tab><uib-tab index="9" heading="Links Personalizados" ng-disabled="true" ng-if="$ctrl.lsuarioLogueadoIsSysAdmin"><div ba-panel="" ba-panel-title="Datos del Link" ba-panel-class="with-scroll" class="add-top-space"><label class="col-md-2 center-label">Nombre del Link*:</label><div class="col-md-4"><input type="text" class="form-control" ng-model="$ctrl.procesoLinkCargado.NombreLink" name="" placeholder=""></div><label class="col-md-2 center-label">URL del Link*:</label><div class="col-md-4"><input type="text" class="form-control" ng-model="$ctrl.procesoLinkCargado.UrlLink" name="" placeholder=""></div><label class="col-md-2 center-label">Link Nivel Solicitud*:</label><div class="col-md-4"><div class="col-md-2"><label ng-if="$ctrl.procesoLinkCargado.solicitudLevel">S\xED</label> <label ng-if="!$ctrl.procesoLinkCargado.solicitudLevel">No</label></div><div class="col-md-2"><ba-switcher switcher-style="primary" switcher-value="$ctrl.procesoLinkCargado.solicitudLevel"></ba-switcher></div></div><label class="col-md-2 center-label">Ejecuta Procedure?*:</label><div class="col-md-2"><ba-switcher switcher-style="primary" switcher-value="$ctrl.procesoLinkCargado.ejecutaProcedure"></ba-switcher></div><div class="col-md-12"><button class="btn btn-warning" ng-click="$ctrl.clearProcesoLink()" ng-disabled="$ctrl.isBusy">Limpiar</button> <button class="btn btn-success pull-right" ng-click="$ctrl.editProcesoLink()" ng-disabled="$ctrl.isBusy">Guardar</button></div></div><div ba-panel="" ba-panel-title="Links Cargados" ba-panel-class="with-scroll"><table class="table" st-table="$ctrl.procesoLinksList"><thead><tr class="sortable"><th class="text-center" st-sort="NombreLink">Nombre Link</th><th class="text-center" st-sort="UrlLink">URL Link</th><th class="text-center" st-sort="solicitudLevel">Link Nivel Solicitud</th><th class="text-center">Acciones</th></tr></thead><tbody ng-show="!$ctrl.isProcesoLinkSearching"><tr ng-repeat="item in $ctrl.procesoLinksList" ng-click="$ctrl.cargarProcesoLink(item)" style="cursor: pointer"><td align="center">{{item.NombreLink}}</td><td align="center">{{item.UrlLink}}</td><td align="center">{{item.solicitudLevel}}</td><td align="center"><button class="btn btn-success editable-table-button btn-xs" ng-click="$ctrl.cargarProcesoLink(item)" ng-disabled="$ctrl.isBusy">Ver</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.eliminarProcesoLink($index)" ng-disabled="$ctrl.isBusy">Eliminar</button></td></tr></tbody><tbody ng-show="$ctrl.isProcesoLinkSearching"><tr><td colspan="2" class="text-center">Cargando...</td></tr></tbody></table></div></uib-tab></uib-tabset><div class="col-md-12"><button class="btn btn-success" ng-click="$ctrl.save(form)" ng-disabled="$ctrl.isBusy">Guardar</button> <button class="btn btn-danger" ng-click="$ctrl.cancel()" ng-disabled="$ctrl.isBusy">Cancelar</button></div></div>');
$templateCache.put('app/pages/proceso/list.template.html','<div class="add-row-editable-table"><button class="btn btn-primary" ng-show="$ctrl.mostrarAgregar" ng-click="$ctrl.add()">Agregar</button></div><table class="table" st-pipe="$ctrl.buscar" st-table="$ctrl.resultList"><thead><tr class="sortable"><th class="text-center" st-sort="Codigo">C\xF3digo</th><th class="text-center" st-sort="Nombre">Nombre</th><th class="text-center" st-sort="Grupo.Nombre">Grupo</th><th class="text-center" st-sort="RequiereValidacion">Requiere Validaci\xF3n</th><th class="text-center" st-sort="RequiereVerificacion">Requiere Verificaci\xF3n</th><th class="text-center" st-sort="RequiereAutorizacion">Requiere Autorizaci\xF3n</th><th class="text-center" st-sort="CantidadDiasCierre">Cant. D\xEDas Cierre</th><th class="text-center">Acci\xF3n</th></tr><tr><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Codigo" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por c\xF3digo" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Nombre" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por nombre" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Grupo.Nombre" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por grupo" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="RequiereValidacion" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por validaci\xF3n" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="RequiereVerificacion" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por verificaci\xF3n" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="RequiereAutorizacion" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por aprobaci\xF3n" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="CantidadDiasCierre" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por cant. d\xEDas cierre" aria-describedby="basic-addon1"></div></th><th></th></tr></thead><tbody ng-show="!$ctrl.isSearching"><tr ng-repeat="item in $ctrl.resultList" ng-click="$ctrl.edit(item.Id)" style="cursor: pointer"><td align="center">{{item.Codigo}}</td><td align="center">{{item.Nombre}}</td><td align="center">{{item.Grupo.Nombre}}</td><td align="center"><i class="fa fa-check" style="color:green" ng-show="item.RequiereValidacion"></i> <i class="fa fa-times" style="color:red" ng-hide="item.RequiereValidacion"></i></td><td align="center"><i class="fa fa-check" style="color:green" ng-show="item.RequiereVerificacion"></i> <i class="fa fa-times" style="color:red" ng-hide="item.RequiereVerificacion"></i></td><td align="center"><i class="fa fa-check" style="color:green" ng-show="item.RequiereAutorizacion"></i> <i class="fa fa-times" style="color:red" ng-hide="item.RequiereAutorizacion"></i></td><td align="center">{{item.CantidadDiasCierre}}</td><td align="center"><a href="" ng-click="$ctrl.edit(item.Id)">Ver</a></td></tr></tbody><tbody ng-show="$ctrl.isSearching"><tr><td colspan="8" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table>');
$templateCache.put('app/pages/reporte/templatespendienteslist.template.html','<div ba-panel="" ba-panel-class="with-scroll" class="add-top-space" ng-show="$ctrl.anularVista"><label class="center-label" ng-show="!$ctrl.viewLoading">{{$ctrl.motivoBloqueo}}</label> <label class="center-label" ng-show="$ctrl.viewLoading">Cargando datos...</label></div><div ba-panel="" ba-panel-class="with-scroll" ng-show="!$ctrl.anularVista"><div class="add-top-space col-md-12 col-xs-12"><label class="col-md-12 col-xs-12 center-label">Reporte Generado en una nueva pesta\xF1a</label></div></div>');
$templateCache.put('app/pages/solicitud/edit.template.html','<script>\r\n    $(document).ready(function () {\r\n        //Div que envuelve el tab\r\n        $(\'#divTab .panel-body\').first().css(\'padding\', \'0px\');\r\n\r\n\r\n        //Letra en negrita\r\n        $(\'#cabecera .panel-title\').css(\'font-weight\', \'bold\');\r\n        $(\'#camposProceso .panel-title\').css(\'font-weight\', \'bold\');\r\n        $(\'#procesosHijo .panel-title\').css(\'font-weight\', \'bold\');\r\n        $(\'#templates .panel-title\').css(\'font-weight\', \'bold\');\r\n        $(\'#etapas .panel-title\').css(\'font-weight\', \'bold\');\r\n        $(\'#etapaActual .panel-title\').css(\'font-weight\', \'bold\');\r\n        $(\'#etapaAnterior .panel-title\').css(\'font-weight\', \'bold\');\r\n        $(\'#etapaSiguiente .panel-title\').css(\'font-weight\', \'bold\');\r\n        $(\'#historial .panel-title\').css(\'font-weight\', \'bold\');\r\n        $(\'#copiaControlada .panel-title\').css(\'font-weight\', \'bold\');\r\n\r\n        //Color en cabecera\r\n        $(\'#titulo .panel\').css(\'background-color\', \'#dddddd\');\r\n\r\n        $(\'#cabecera .panel-heading\').css(\'background-color\', \'#f99d3b\'); //f58307\r\n        $(\'#cabecera .panel-body\').css(\'background-color\', \'#f9f2ea\'); //ffdcb7\r\n        \r\n        $(\'#camposProceso .panel-heading\').css(\'background-color\', \'#f99d3b\');\r\n        $(\'#camposProceso .panel-body\').css(\'background-color\', \'#f9f2ea\');\r\n\r\n        $(\'#procesosHijo .panel-heading\').css(\'background-color\', \'#f99d3b\'); //f99d3b\r\n        // $(\'#procesosHijo .panel-body\').css(\'background-color\',\'#bcbcbc\'); //f9f2ea\r\n\r\n        $(\'#templates .panel-heading\').css(\'background-color\', \'#bcbcbc\'); //45ee61\r\n\r\n        $(\'#etapas .panel-heading\').css(\'background-color\', \'#bcbcbc\'); //60cbf2\r\n        $(\'#etapaActual .panel-heading\').css(\'background-color\', \'#bcbcbc\');\r\n        $(\'#etapaAnterior .panel-heading\').css(\'background-color\', \'#bcbcbc\');\r\n        $(\'#etapaSiguiente .panel-heading\').css(\'background-color\', \'#bcbcbc\');\r\n\r\n        $(\'#historial .panel-heading\').css(\'background-color\', \'#bcbcbc\');\r\n        $(\'#copiaControlada .panel-heading\').css(\'background-color\', \'#bcbcbc\');\r\n\r\n        $(\'#camposProceso > div > div.panel-body\').css(\'background-color\', \'rgba(204, 216, 239, 0.4)\');\r\n\r\n    });\r\n</script><div ba-panel="" ba-panel-title="{{$ctrl.title}}" ba-panel-class="with-scroll" ng-show="$ctrl.anularVista" class="add-top-space"><label class="center-label" ng-show="!$ctrl.viewLoading">{{$ctrl.motivoBloqueo}}</label> <label class="center-label" ng-show="$ctrl.viewLoading">Cargando datos...</label></div><div ba-panel="" ba-panel-class="with-scroll" ng-show="!$ctrl.anularVista" class="add-top-space" id="titulo" style="padding:0px"><div class="col-xs-12 col-md-7"><h4 class="title" style="display:inline">{{$ctrl.model.Proceso.Nombre}}</h4></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><button class="col-xs-12 col-sm-3 col-md-3 col-lg-2 btn btn-success pull-right" ng-click="$ctrl.crearVersion()" ng-disabled="$ctrl.isBusy" ng-show="$ctrl.lProcesoIsDocumentalAutorizacionesV2 && $ctrl.IdSolicitudEtapa==6 && ($ctrl.lsuarioLogueadoIsAdminProceso || $ctrl.lsuarioLogueadoIsSysAdmin || $ctrl.lsuarioLogueadoIsSupervisorProceso || $ctrl.lDocIsUserAbleToCreateDocumentV2)" style="margin-bottom: 2px;margin-left:5px;padding-top: 2px;padding-bottom: 2px;"><span class="ion-ios-albums ion-2x" aria-hidden="true"></span> Crear Version</button> <button class="col-xs-12 col-sm-3 col-md-3 col-lg-2 btn btn-success pull-right" ng-click="$ctrl.enviarObsoleto()" ng-disabled="$ctrl.isBusy" ng-show="$ctrl.model.Proceso.permiteEnviarObsoleto && $ctrl.lProcesoIsDocumentalAutorizacionesV2 && $ctrl.IdSolicitudEtapa==6 && ($ctrl.lsuarioLogueadoIsAdminProceso || $ctrl.lsuarioLogueadoIsSysAdmin || $ctrl.userTieneMarcaObsoleto)" style="margin-bottom: 2px;margin-left:5px;padding-top: 2px;padding-bottom: 2px;"><span class="ion-social-buffer ion-2x" aria-hidden="true"></span> Enviar a Obsoleto</button> <button class="col-xs-12 col-sm-3 col-md-3 col-lg-2 btn btn-success pull-right" ng-click="$ctrl.crearCopia()" ng-disabled="$ctrl.isBusy" ng-show="($ctrl.model.Proceso.permiteCopia && ($ctrl.lsuarioLogueadoIsAdminProceso || $ctrl.lsuarioLogueadoIsSysAdmin ))" style="margin-bottom: 2px;margin-left:5px;padding-top: 2px;padding-bottom: 2px;"><span class="ion-ios-copy-outline ion-2x" aria-hidden="true"></span> Crear Copia</button></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><button class="col-xs-12 col-sm-3 col-md-3 col-lg-2 btn btn-danger pull-right" ng-click="$ctrl.goListado()" ng-disabled="$ctrl.isBusy" ng-show="!$ctrl.anularVista" style="margin-bottom: 2px;margin-left:5px;padding-top: 2px;padding-bottom: 2px;"><span class="ion-ios-list-outline ion-2x" aria-hidden="true"></span> Ir al Listado</button> <button class="col-xs-12 col-sm-3 col-md-3 col-lg-2 btn btn-danger pull-right" ng-click="$ctrl.imprimirSolicitud()" ng-disabled="$ctrl.isBusy" ng-show="!$ctrl.anularVista && $ctrl.model.Id > 0" style="margin-bottom: 2px;margin-left:5px;padding-top: 2px;padding-bottom: 2px;"><span class="ion-android-print ion-2x" aria-hidden="true"></span></button> <button class="col-xs-12 col-sm-3 col-md-3 col-lg-2 btn btn-danger pull-right" ng-click="$ctrl.goBack()" ng-disabled="$ctrl.isBusy" ng-show="!$ctrl.anularVista" style="margin-bottom: 2px;margin-left:5px;padding-top: 2px;padding-bottom: 2px;"><span class="ion-arrow-left-c ion-2x" aria-hidden="true"></span> Ir Atr\xE1s</button></div></div><div ba-panel="" ba-panel-class="with-scroll" ng-show="!$ctrl.anularVista && $ctrl.model.Proceso.Links != null && $ctrl.model.Proceso.Links.length > 0"><div class="col-xs-12 col-md-7"><h4 class="title" style="display:inline">Links</h4></div><div class="col-xs-12 col-md-10" style="float:right"><div ng-repeat="item in $ctrl.model.Proceso.Links track by $index"><button class="btn btn-primary" ng-if="!item.ejecutaProcedure && item.solicitudLevel" ng-click="$ctrl.openUrlLink(item.UrlLink)" style="margin-right: 5px; float:right">{{item.NombreLink}}</button> <button class="btn btn-primary" ng-if="item.ejecutaProcedure && item.solicitudLevel" ng-click="$ctrl.executeProcedure(item)" style="margin-right: 5px; float:right">{{item.NombreLink}}</button></div></div></div><div ba-panel="" id="divTab"><div class="container stepcontainer" id="steeper"><table class="table tableStep"><tbody><tr><td align="center" class="removePaddingCell" ng-repeat="step in $ctrl.objSteps" style="padding-top: 10px; padding-bottom: 13px;"><div class="stepBlock"><div ng-class="step.ngclass" style="margin-bottom: 0px;margin-right: 0px;"><div style="height: 100%;margin: auto;margin-top: 8px;display: block;font-size: 30px;text-decoration: none;text-shadow: 0px -1px 1px #bdb5b4, 1px 1px 1px white;" class="ng-binding">{{step.Imgtext}}</div></div><div class="cssForMdDividerLabel"></div></div></td></tr><tr><td align="center" ng-repeat="step in $ctrl.objSteps" style="text-align: left;"><div class="stepBlock"><label class="stepsTextLabel">{{step.label}}</label><div class="cssForMdDividerLabel"></div></div></td></tr></tbody></table></div><uib-tabset active="$ctrl.active" ng-show="!$ctrl.anularVista"><uib-tab index="0" heading="Principal" ng-disabled="true"><div ba-panel="" ba-panel-title="Cabecera" ba-panel-class="with-scroll" ng-show="!$ctrl.anularVista" class="add-top-space" id="cabecera"><label class="col-xs-12 col-md-3 center-label cabeceraLbl"><b>N\xFAmero:</b> {{$ctrl.model.NumeroCompleto}}</label><label class="col-xs-12 col-md-3 center-label cabeceraLbl"><b>Fecha de Alta:</b> {{$ctrl.model.CreationDate|date:\'dd-MM-yyyy\'}}</label> <label class="col-xs-12 col-md-6 center-label cabeceraLbl"><b>Usuario Solicitante:</b> {{$ctrl.model.UsuarioCreacion.NombreMostrar}}</label> <label class="col-xs-12 col-md-3 center-label cabeceraLbl"><b>Etapa Actual:</b> {{$ctrl.model.SolicitudEtapaNombre}}</label> <label class="col-xs-12 col-md-4 center-label cabeceraLbl"><b>Usuario Etapa Actual:</b> {{$ctrl.model.UsuarioAprobador.NombreMostrar}}</label><label ng-if="!$ctrl.puedeEditarDescripcion($ctrl.model)" class="col-xs-12 col-md-12 center-label cabeceraLbl"><b>Descripci\xF3n Resumida:</b> {{$ctrl.model.DescripcionResumida}}</label> <label ng-if="$ctrl.puedeEditarDescripcion($ctrl.model)" class="col-xs-12 col-md-12 center-label cabeceraLbl"><b>Descripci\xF3n Resumida:</b> <input type="text" class="form-control" ng-model="$ctrl.model.DescripcionResumida" name=""></label></div><div ba-panel="" ba-panel-title="Proceso Padre" ba-panel-class="with-scroll" ng-show="$ctrl.model.SolicitudPadreId > 0"><table class="table" st-table="$ctrl.solicitudesPadreList" ng-show="$ctrl.model.SolicitudPadreId > 0"><thead><tr class="sortable"><th class="text-center" st-sort="{{col.SolicitudColumna.Codigo}}{{col.Campo.Id}}" ng-repeat="col in $ctrl.model.SolicitudPadre.Proceso.CamposListado"><span ng-show="col.SolicitudColumna != null">{{col.SolicitudColumna.Nombre}}</span> <span ng-show="col.Campo != null">{{col.Campo.Nombre}}</span></th><th class="text-center">Acci\xF3n</th></tr></thead><tbody ng-show="!$ctrl.isSolicitudSearching"><tr ng-repeat="fila in $ctrl.solicitudesPadreList" ng-click="$ctrl.verSolicitudPadre(fila)" style="cursor: pointer"><td align="left" ng-repeat="colValor in fila.ValorMostrarBusqueda track by $index" style="text-align: left"><div ng-switch="" on="$ctrl.model.SolicitudPadre.Proceso.CamposListado[$index].Campo.CampoTipo.Codigo"><div ng-switch-when="DATE">{{colValor | date:\'dd/MM/yyyy\'}}</div><div ng-switch-when="INT" align="right">{{colValor}}</div><div ng-switch-when="DECIMAL" align="right">{{colValor}}</div><div ng-switch-when="JERARQ" align="right"><div ng-repeat="c in colValor">{{c.Nombre}}</div></div><div ng-switch-when="BOOL"><i class="fa fa-check" style="color:green" ng-show="{{colValor}} == true"></i> <i class="fa fa-times" style="color:red" ng-hide="{{colValor}} == true"></i></div><div ng-switch-when="ATTACH"><a href="{{colValor}}" target="_blank">{{colValor}}</a></div><div ng-switch-default=""><div ng-switch="" on="$ctrl.model.SolicitudPadre.Proceso.CamposListado[$index].SolicitudColumna.Codigo"><div ng-switch-when="LastUpdate">{{colValor | date:\'dd/MM/yyyy\'}}</div><div ng-switch-when="FechaCierre">{{colValor | date:\'dd/MM/yyyy\'}}</div><div ng-switch-when="CreationDate">{{colValor | date:\'dd/MM/yyyy\'}}</div><div ng-switch-when="Activo"><i class="fa fa-check" style="color:green" ng-show="{{colValor}} == true"></i> <i class="fa fa-times" style="color:red" ng-hide="{{colValor}} == true"></i></div><div ng-switch-default="">{{colValor}}</div></div></div></div></td><td align="center"><div class="btn btn-success editable-table-button btn-xs" ng-click="$ctrl.verSolicitudPadre(fila)" ng-disabled="$ctrl.isBusy">Ver</div><a href="{{fila.UrlLink}}" target="_blank" ng-show="!$ctrl.isBusy">{{fila.NombreLink}}</a></td></tr></tbody><tbody ng-show="$ctrl.isSolicitudPadreSearching"><tr><td colspan="5" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="5" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table></div><div ba-panel="" ba-panel-title="Gestiones" ba-panel-class="with-scroll" ng-show="$ctrl.model.Id > 0 && !$ctrl.anularVista" id="templates"><form editable-form="" name="formTemplates" novalidate=""><div class="col-md-4" ng-show="$ctrl.templatePendientesIsSearching">Cargando...</div><div class="col-sm-12 col-md-12 form-group add-top-space" style="min-height: 25px;"><label class="col-xs-12 col-md-2 center-label">Gestiones por Cargar:</label><div class="col-xs-12 col-md-4" ng-show="!$ctrl.templatePendientesIsSearching"><select name="templates" ng-model="$ctrl.procesoTemplateSeleccionado" class="form-control" ng-options="item as item.Template.Nombre for item in $ctrl.templatesPendientesList track by item.Id"></select></div><div class="col-xs-12 col-md-4 add-row-editable-table"><button class="col-xs-12 col-md-2 btn btn-primary" ng-disabled="(($ctrl.isBusy || $ctrl.model.Estado.Codigo == \'APRO\' || $ctrl.model.Estado.Codigo == \'CERR\') && !$ctrl.lProcesoIsDocumental)" ng-click="$ctrl.cargarTemplate()">Cargar</button></div></div><div class="col-xs-12 col-md-12 col-sm-12" style="position: inherit;"><button class="col-sm-12 col-md-3 col-xs-12 btn btn-primary" ng-click="$ctrl.cargarAccesoDirectoTemplate(item)" ng-disabled="(($ctrl.isBusy || $ctrl.model.Estado.Codigo == \'APRO\' || $ctrl.model.Estado.Codigo == \'CERR\') && !$ctrl.lProcesoIsDocumental)" ng-repeat="item in $ctrl.templatesPendientesAccesoDirectoList track by $index" style="margin-bottom: 2px; margin-right: 10px; padding-bottom:4px;">{{item.Template.Nombre}}</button></div><table class="table" st-pipe="$ctrl.buscarTemplatesCargados" st-table="$ctrl.templatesCargadosList" style="margin-top:10px"><thead><tr class="sortable center-label row"><th class="text-center"><b>T\xEDtulo</b></th><th class="text-center"><b>Nombre Gesti\xF3n</b></th><th class="text-center"><b>Nombre Etapa</b></th><th class="text-center"><b>Fecha \xDAlt. Modif.</b></th><th class="text-center"><b>Usuario \xDAlt. Modif.</b></th><th class="text-center"><b>Acci\xF3n</b></th></tr><tr class="center-label row"><th class="col-sm-4 col-md-4"><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Resumen" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por t\xEDtulo" aria-describedby="basic-addon1"></div></th><th class="col-sm-2 col-md-2"><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Template.Nombre" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por gesti\xF3n" aria-describedby="basic-addon1"></div></th><th class="col-sm-2 col-md-2"><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="SolicitudEtapaNombre" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por etapa" aria-describedby="basic-addon1"></div></th><th class="col-sm-1 col-md-1"><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="LastUpdate" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por \xFAlt. modif." aria-describedby="basic-addon1"></div></th><th class="col-sm-2 col-md-2"><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="UsuarioModificacion.Nombre" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por usuario" aria-describedby="basic-addon1"></div></th><th></th></tr></thead><tbody ng-show="!$ctrl.templateCargadosIsSearching"><tr ng-repeat="item in $ctrl.templatesCargadosList" ng-click="$ctrl.openTemplate(item)" style="cursor: pointer" class="row"><td align="left" style="text-align:left" ng-if="item.Resumen.length &gt; 50" class="col-sm-4 col-md-4">{{item.Resumen | limitTo : 50 : 0}} ...</td><td align="left" style="text-align:left" ng-if="item.Resumen == null || item.Resumen.length &lt;= 50" class="col-sm-4 col-md-4">{{item.Resumen}}</td><td align="left" ng-if="item.ProcesoTemplate.Template.Nombre.length &gt; 30">{{item.ProcesoTemplate.Template.Nombre | limitTo : 30 : 0}} ...</td><td align="left" ng-if="item.ProcesoTemplate.Template.Nombre.length &lt;= 30">{{item.ProcesoTemplate.Template.Nombre}}</td><td align="left">{{item.SolicitudEtapaNombre}}</td><td align="left" class="col-sm-1 col-md-1">{{item.LastUpdate | date:\'dd/MM/yyyy\'}}</td><td align="left" ng-if="(item.UsuarioModificacion.Apellido + \' \' + item.UsuarioModificacion.Nombre).length &gt; 20">{{item.UsuarioModificacion.Apellido + \' \' + item.UsuarioModificacion.Nombre | limitTo : 20 : 0}} ...</td><td align="left" ng-if="(item.UsuarioModificacion.Apellido + \' \' + item.UsuarioModificacion.Nombre).length &lt;= 20">{{item.UsuarioModificacion.Apellido}} {{item.UsuarioModificacion.Nombre}}</td><td align="center" class="col-sm-2 col-md-2"><a href="" ng-click="$ctrl.openTemplate(item)">Ver</a> <a href="{{item.ProcesoTemplate.Template.UrlLink}}" target="_blank">{{item.ProcesoTemplate.Template.NombreLink}}</a></td></tr></tbody><tbody ng-show="$ctrl.templateCargadosIsSearching"><tr><td colspan="5" class="text-center">Cargando...</td></tr></tbody></table></form><button class="col-xs-12 col-sm-3 col-md-3 col-lg-2 btn btn-success pull-right" ng-click="$ctrl.verDocumento(\'descarga de documento Kahuna - APP\')" ng-disabled="$ctrl.isBusy" ng-show="$ctrl.lProcesoIsDocumental && $ctrl.IdSolicitudEtapa>=2 && $ctrl.lProcesoIsDocumentalAutorizacionesV2" style="margin-bottom: 2px;margin-left: 1px;padding-top: 2px;padding-bottom: 2px;margin-top: 20px;margin-right: 30px;"><span class="ion-ios-albums ion-2x" aria-hidden="true"></span> Ver Documento</button></div><div ba-panel="" ba-panel-title="Copia controlada y notificacion" ba-panel-class="with-scroll" class="add-top-space" id="copiaControlada" ng-show="$ctrl.lProcesoIsDocumental && $ctrl.IdSolicitudEtapa==6 && $ctrl.lProcesoIsDocumentalAutorizacionesV2"><label class="col-md-12 center-label">Destinada a *:</label><div class="col-md-12"><input type="text" class="form-control" ng-model="$ctrl.copiaDestinadaA" name="" required=""></div><div class="col-md-12"><button class="btn btn-success pull-right" ng-click="$ctrl.imprimirCopiaControlada($ctrl.copiaDestinadaA)" ng-disabled="$ctrl.isBusy">Crear Copia controlada</button></div></div><uib-tabset active="$ctrl.active2"><uib-tab index="66" heading="Etapas" ng-disabled="true" ng-show="($ctrl.model.EstadoId==1 && $ctrl.lProcesoIsDocumentalAutorizacionesV2 && $ctrl.mostrarAprobacion && !$ctrl.anularVista) || (!$ctrl.lProcesoIsDocumentalAutorizacionesV2 && $ctrl.mostrarAprobacion && !$ctrl.anularVista)"><div ng-if="!$ctrl.procesomcaOcultaAvanzarEtapa"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll" style="padding: 0;" ng-show="($ctrl.model.EstadoId==1 && $ctrl.lProcesoIsDocumentalAutorizacionesV2 && $ctrl.mostrarAprobacion && !$ctrl.anularVista) || (!$ctrl.lProcesoIsDocumentalAutorizacionesV2 && $ctrl.mostrarAprobacion && !$ctrl.anularVista)" id="etapas"><div ba-panel="" ba-panel-title="Etapa Actual: {{$ctrl.model.SolicitudEtapaNombre}}" ba-panel-class="with-scroll" ng-show="$ctrl.mostrarControlesAprobacion($ctrl.model.Estado.Codigo)" id="etapaActual" class="add-top-space"><label class="col-md-2 center-label">\xBFCiclo Cerrado?</label><div class="col-md-2" style="margin-top:-10px"><ba-switcher switcher-style="primary" switcher-value="$ctrl.aceptadoEtapa"></ba-switcher></div><label class="col-md-2 center-label">Fecha de Cierre de Ciclo:</label><div class="col-md-6"><label class="col-md-6 center-label" style="font-weight:normal">{{$ctrl.fechaEtapa|date:\'dd-MM-yyyy\'}}</label></div><label class="col-md-12 center-label" ng-show="$ctrl.model.Proceso.justificacionEsRequerida">Justificaci\xF3n*:</label> <label class="col-md-12 center-label" ng-show="!$ctrl.model.Proceso.justificacionEsRequerida">Justificaci\xF3n:</label><div class="col-md-12"><input type="text" class="form-control" ng-model="$ctrl.justificacionEtapa" name=""></div></div><div ba-panel="" ba-panel-title="Etapa Anterior: {{$ctrl.anteriorEstadoSolicitud.NombreEtapa}}" ba-panel-class="with-scroll" ng-show="!$ctrl.aceptadoEtapa && $ctrl.anteriorEstadoSolicitud != null" class="add-top-space" id="etapaAnterior"><div class="col-md-12" ng-show="$ctrl.isDatosAnteriorEstadoLoading">Cargando...</div><div class="col-md-12" ng-show="!$ctrl.isDatosAnteriorEstadoLoading"><label class="col-md-2 center-label">Derivar A:</label><div class="col-md-3"><input type="text" class="form-control" ng-model="$ctrl.model.findUsuarioAnterior" name="" ng-change="$ctrl.onChangeInputUsuarioAnterior($ctrl.model.findUsuarioAnterior)" placeholder="Buscar por Usuario"></div><div class="col-md-5"><select name="" class="form-control" ng-model="$ctrl.usuarioEtapaAnterior" ng-options="item as item.NombreMostrar for item in $ctrl.anteriorEstadoUsuariosList track by item.Id"></select></div><div class="col-md-2"><button class="btn btn-warning pull-right" ng-click="$ctrl.retrocederEtapa()" ng-disabled="$ctrl.isBusy" ng-show="$ctrl.puedeRetrocederEstado($ctrl.model)">Regresar Etapa</button></div></div></div><div ba-panel="" ba-panel-title="Etapa Siguiente: {{$ctrl.siguienteEstadoSolicitud.NombreEtapa}}" ba-panel-class="with-scroll" ng-show="$ctrl.aceptadoEtapa && $ctrl.siguienteEstadoSolicitud != null" class="add-top-space" id="etapaSiguiente"><div class="col-md-12" ng-show="$ctrl.isDatosSiguienteEstadoLoading">Cargando...</div><div ng-show="!$ctrl.isDatosSiguienteEstadoLoading"><label class="col-md-2 center-label">Derivar A:</label><div class="col-md-3"><input type="text" class="form-control" ng-model="$ctrl.model.findUsuarioSiguiente" name="" ng-change="$ctrl.onChangeInputUsuarioSiguiente($ctrl.model.findUsuarioSiguiente)" placeholder="Buscar por Usuario"></div><div class="col-md-5" ng-show="$ctrl.mostrarComboSiguienteEstado($ctrl.siguienteEstadoSolicitud.Codigo)" style="min-height: 55px;"><select name="" class="form-control" ng-model="$ctrl.usuarioEtapaSiguiente" ng-options="item as item.NombreMostrar for item in $ctrl.siguienteEstadoUsuariosList track by item.Id"></select></div><div class="col-md-2"><button class="btn btn-warning pull-right" ng-click="$ctrl.avanzarEtapa()" ng-disabled="$ctrl.isBusy" ng-show="$ctrl.puedeAvanzarEstado($ctrl.model)">Avanzar Etapa</button></div></div></div></div></div></uib-tab><uib-tab index="88" heading="Derivar Responsabilidad" ng-disabled="true" ng-show="($ctrl.model.Id!=0 && $ctrl.model.Proceso.PermiteDerivarRes==1) && ($ctrl.lsuarioLogueadoIsAdminProceso || $ctrl.model.UsuarioAprobadorId == $ctrl.lUsuarioLogeado.Id) && ($ctrl.model.EstadoId!=6) && !$ctrl.lProcesoIsDocumentalAutorizacionesV2"><div ba-panel="" ba-panel-title="Derivar Responsabilidad" ba-panel-class="with-scroll" class="add-top-space" id="etapaSiguiente" ng-show="(!$ctrl.lProcesoIsDocumentalAutorizacionesV2 && $ctrl.model.Id!=0 && $ctrl.model.Proceso.PermiteDerivarRes==1) && ($ctrl.lsuarioLogueadoIsAdminProceso || $ctrl.model.UsuarioAprobadorId == $ctrl.lUsuarioLogeado.Id)"><div class="col-md-12" ng-show="$ctrl.isDatosSiguienteEstadoLoading">Cargando...</div><div ng-show="!$ctrl.isDatosSiguienteEstadoLoading"><label class="col-md-2 center-label">Derivar A:</label><div class="col-md-3"><input type="text" class="form-control" ng-model="$ctrl.model.listaUsuariosDerivarResponsabilidad" name="" ng-change="$ctrl.onChangeInputUsuarioSiguienteDerivar($ctrl.model.listaUsuariosDerivarResponsabilidad)" placeholder="Buscar por Usuario"></div><div class="col-md-5"><select name="" class="form-control" ng-model="$ctrl.usuarioEtapaSiguienteDerivar" ng-options="item as item.NombreMostrar for item in $ctrl.listaUsuariosDerivarResponsabilidad track by item.Id"></select></div><div class="col-md-2"><button class="btn btn-warning pull-right" ng-click="$ctrl.derivarEtapa()" ng-disabled="$ctrl.isBusy">Derivar</button></div></div></div></uib-tab><uib-tab index="99" heading="Forzar Cierre" ng-disabled="true" ng-show="$ctrl.showForzarCierre && !$ctrl.lProcesoIsDocumentalAutorizacionesV2"><div ba-panel="" ba-panel-title="Forzar cierre de proceso" ba-panel-class="with-scroll" id="etapaActual" class="add-top-space" ng-show="$ctrl.showForzarCierre && !$ctrl.lProcesoIsDocumentalAutorizacionesV2"><label class="col-md-2 center-label">Fecha de Cierre:</label><div class="col-md-6"><label class="col-md-6 center-label" style="font-weight:normal">{{$ctrl.fechaEtapaForzarCierre|date:\'dd-MM-yyyy\'}}</label></div><label class="col-md-12 center-label">Justificaci\xF3n*:</label><div class="col-md-12"><input type="text" class="form-control" ng-model="$ctrl.justificacionEtapaForzarCierre" name="" required=""></div><div class="col-md-12"><button class="btn btn-warning pull-right" ng-click="$ctrl.forzarCierre()" ng-disabled="$ctrl.justificacionEtapaForzarCierre.length === 0 || $ctrl.justificacionEtapaForzarCierre==undefined">Forzar Cierre Proceso</button></div></div></uib-tab><uib-tab index="77" heading="Autorizar el Documento" ng-disabled="true" ng-show="($ctrl.model.Id!=0 && $ctrl.model.Proceso.autorizaciones==1 && $ctrl.usuarioPuedeAutorizar && !$ctrl.usuarioYaAutorizo) && ($ctrl.model.EstadoId>=2 && $ctrl.model.EstadoId!=6)"><div ba-panel="" ba-panel-title="Autorizar o Rechazar" ba-panel-class="with-scroll" class="add-top-space" id="etapaSiguiente" ng-show="$ctrl.usuarioPuedeAutorizar"><div class="col-md-12"><label class="col-md-12 center-label">Comentarios*:</label><div class="col-md-12"><input type="text" class="form-control" ng-model="$ctrl.AutorizarMsg" name="" required=""></div><div class="col-md-12"><button class="btn btn-danger pull-right col-md-2" ng-click="$ctrl.RechazarAction()" ng-disabled="$ctrl.isBusy" style="margin-left: 2px;font-size: 15px; margin-top: 8px;" ng-show="$ctrl.lProcesoIsDocumentalAutorizacionesV2"><span class="glyphicon glyphicon-remove" aria-hidden="true"></span> Rechazar</button> <button class="btn btn-success pull-right col-md-2" ng-click="$ctrl.AutorizarAction()" ng-disabled="$ctrl.isBusy" style="margin-left: 2px;font-size: 15px; margin-top: 8px;"><span class="glyphicon glyphicon-ok" aria-hidden="true"></span> Autorizar</button></div></div></div><div ba-panel="" ba-panel-title="Autorizar el Documento" ba-panel-class="with-scroll" class="add-top-space" id="etapaSiguiente" ng-show="!$ctrl.lProcesoIsDocumentalAutorizacionesV2"><div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="Grupo 1 - {{$ctrl.grupoUsuariosObj.grupo1Obj.Nombre}}" ng-show="$ctrl.grupoUsuariosObj.grupo1Obj.gruposUsuariosRelacion.length>0"><div ng-repeat="Usuario in $ctrl.grupoUsuariosObj.grupo1Obj.gruposUsuariosRelacion" style="margin-bottom: 5px;"><div ng-show="Usuario.hasAutorized" class="mdc-card cardAutorizaciones"><img src="/images/user1.png" height="45" width="45" style="float: left;margin: 5px;display: block;"><div class="demo-card__title"><label>Usuario {{ Usuario.Usuario.Id }} - {{ Usuario.Usuario.Nombre }}</label> <img src="/images/check2.png" height="45" width="45" style="float: right;margin: 5px;"></div><div class="demo-card__subhead"><label style="margin: 0px;">Comentarios: {{ Usuario.Comentario }}</label></div><div class="demo-card__subhead"><label style="margin: 0px;">Fecha Autorizacion: {{ Usuario.FechaAutorizacion}}</label></div></div></div><div style="margin-bottom: 5px;" ng-show="!$ctrl.grupoUsuariosObj.grupo1Obj.GrupoIsAutorizated==true"><div class="mdc-card cardAutorizaciones"><div class="demo-card__title"><label style="padding: 5px;margin-left: 10px;margin: auto;text-align: center;width: 80%;margin-top: 15px;">No se encontraron Autorizaciones</label> <img src="/images/cancel1.png" height="45" width="45"></div></div></div></div><div ba-panel="" ba-panel-class="with-scroll" class="add-top-space" ba-panel-title="Grupo 2 - {{$ctrl.grupoUsuariosObj.grupo2Obj.Nombre}}" ng-show="$ctrl.grupoUsuariosObj.grupo2Obj.gruposUsuariosRelacion.length>0"><div ng-repeat="Usuario in $ctrl.grupoUsuariosObj.grupo2Obj.gruposUsuariosRelacion" style="margin-bottom: 5px;"><div ng-show="Usuario.hasAutorized" class="mdc-card cardAutorizaciones"><img src="/images/user1.png" height="45" width="45" style="float: left;margin: 5px;display: block;"><div class="demo-card__title"><label>Usuario {{ Usuario.Usuario.Id }} - {{ Usuario.Usuario.Nombre }}</label> <img src="/images/check2.png" height="45" width="45" style="float: right;margin: 5px;"></div><div class="demo-card__subhead"><label style="margin: 0px;">Comentarios: {{ Usuario.Comentario }}</label></div><div class="demo-card__subhead"><label style="margin: 0px;">Fecha Autorizacion: {{ Usuario.FechaAutorizacion}}</label></div></div></div><div style="margin-bottom: 5px;" ng-show="!$ctrl.grupoUsuariosObj.grupo2Obj.GrupoIsAutorizated==true"><div class="mdc-card cardAutorizaciones"><div class="demo-card__title"><label style="padding: 5px;margin-left: 10px;margin: auto;text-align: center;width: 80%;margin-top: 15px;">No se encontraron Autorizaciones</label> <img src="/images/cancel1.png" height="45" width="45"></div></div></div></div><div ba-panel="" ba-panel-class="with-scroll" class="add-top-space" ba-panel-title="Grupo 3 - {{ $ctrl.grupoUsuariosObj.grupo3Obj.Nombre}}" ng-show="$ctrl.grupoUsuariosObj.grupo3Obj.gruposUsuariosRelacion.length>0"><div ng-repeat="Usuario in $ctrl.grupoUsuariosObj.grupo3Obj.gruposUsuariosRelacion" style="margin-bottom: 5px;"><div ng-show="Usuario.hasAutorized" class="mdc-card cardAutorizaciones"><img src="/images/user1.png" height="45" width="45" style="float: left;margin: 5px;display: block;"><div class="demo-card__title"><label>Usuario {{ Usuario.Usuario.Id }} - {{ Usuario.Usuario.Nombre }}</label> <img src="/images/check2.png" height="45" width="45" style="float: right;margin: 5px;"></div><div class="demo-card__subhead"><label style="margin: 0px;">Comentarios: {{ Usuario.Comentario }}</label></div><div class="demo-card__subhead"><label style="margin: 0px;">Fecha Autorizacion: {{ Usuario.FechaAutorizacion}}</label></div></div></div><div style="margin-bottom: 5px;" ng-show="!$ctrl.grupoUsuariosObj.grupo3Obj.GrupoIsAutorizated==true"><div class="mdc-card cardAutorizaciones"><div class="demo-card__title"><label style="padding: 5px;margin-left: 10px;margin: auto;text-align: center;width: 80%;margin-top: 15px;">No se encontraron Autorizaciones</label> <img src="/images/cancel1.png" height="45" width="45"></div></div></div></div></div></uib-tab></uib-tabset><div listado-usuarios-autorizacion=""></div><div listado-historial-autorizacion=""></div><div ba-panel="" ba-panel-title="Procesos Asociados" ba-panel-class="with-scroll" ng-show="$ctrl.model.Id > 0 && $ctrl.model.Proceso.AceptaHijos && !$ctrl.anularVista" class="add-top-space" id="procesosHijo"><div class="col-xs-12 col-md-12"><input type="checkbox" ng-model="$ctrl.verTodosProcesosAsociados" ng-click="$ctrl.buscarSolicitudesHijo()" ng-disabled="$ctrl.isBusy" style="margin-top:10px;margin-bottom:10px" name=""> <span>Ver procesos cerrados</span> <button class="col-xs-12 col-md-3 btn btn-primary pull-right" ng-show="$ctrl.showProcesosHijosEtapaActual" ng-click="$ctrl.agregarSolicitudHijo()" ng-disabled="$ctrl.isBusy">Agregar Proceso Asociado</button></div><span ng-show="$ctrl.solicitudesHijoIsSearching">Cargando...</span><div ng-repeat="(nombreProceso, solicitudesHijo) in $ctrl.solicitudesHijoList" ng-show="!$ctrl.solicitudesHijoIsSearching"><label class="col-md-12" style="margin-top:20px;margin-bottom:10px" ng-show="$ctrl.totalProcesosHijo()"><b>{{nombreProceso}}:</b></label><table class="table" st-table="solicitudesHijo"><thead><tr class="sortable"><th class="text-center" ng-repeat="col in solicitudesHijo[0].Proceso.CamposListado"><span ng-show="col.SolicitudColumna != null">{{col.SolicitudColumna.Nombre}}</span> <span ng-show="col.Campo != null">{{col.Campo.Nombre}}</span></th><th class="text-center">Acci\xF3n</th></tr></thead><tbody ng-show="!$ctrl.solicitudesHijoIsSearching"><tr ng-repeat="fila in solicitudesHijo" ng-click="$ctrl.verSolicitudHijo(fila)" style="cursor: pointer" ng-class="{ \'solicitud-vencida\': fila.EstaVencida }"><td align="left" ng-repeat="colValor in fila.ValorMostrarBusqueda track by $index" style="text-align: left"><div ng-switch="" on="solicitudesHijo[0].Proceso.CamposListado[$index].Campo.CampoTipo.Codigo"><div ng-switch-when="DATE">{{colValor | date:\'dd/MM/yyyy\'}}</div><div ng-switch-when="INT" align="right">{{colValor}}</div><div ng-switch-when="DECIMAL" align="right">{{colValor}}</div><div ng-switch-when="JERARQ" align="right"><div ng-repeat="c in colValor">{{c.Nombre}}</div></div><div ng-switch-when="BOOL"><i class="fa fa-check" style="color:green" ng-show="{{colValor}} != \'\' && {{colValor}} == true"></i> <i class="fa fa-times" style="color:red" ng-hide="{{colValor}} != \'\' && {{colValor}} == true"></i></div><div ng-switch-when="ATTACH"><a href="{{colValor}}" target="_blank">{{colValor}}</a></div><div ng-switch-default=""><div ng-switch="" on="solicitudesHijo[0].Proceso.CamposListado[$index].SolicitudColumna.Codigo"><div ng-switch-when="LastUpdate">{{colValor | date:\'dd/MM/yyyy\'}}</div><div ng-switch-when="FechaCierre">{{colValor | date:\'dd/MM/yyyy\'}}</div><div ng-switch-when="CreationDate">{{colValor | date:\'dd/MM/yyyy\'}}</div><div ng-switch-when="Activo"><i class="fa fa-check" style="color:green" ng-show="{{colValor}} == true"></i> <i class="fa fa-times" style="color:red" ng-hide="{{colValor}} == true"></i></div><div ng-switch-default="">{{colValor}}</div></div></div></div></td><td align="center"><a href="" ng-click="$ctrl.edit(fila.Id)" ng-show="!$ctrl.isBusy">Ver</a> <a href="{{fila.UrlLink}}" target="_blank" ng-show="!$ctrl.isBusy">{{fila.NombreLink}}</a></td></tr></tbody><tbody ng-show="$ctrl.solicitudesHijoIsSearching"><tr><td colspan="5" class="text-center">Cargando...</td></tr></tbody></table></div></div></uib-tab><uib-tab index="1" heading="Datos del Proceso" ng-disabled="true" ng-click="$ctrl.runModal()" ng-hide="($ctrl.lProcesoIsDocumentalAutorizacionesV2 && $ctrl.model.EstadoId==6)"><div ba-panel="" ba-panel-title="Datos" ba-panel-class="with-scroll" ng-show="!$ctrl.anularVista" class="add-top-space" id="camposProceso"><div class="col-md-12" ng-show="$ctrl.isCamposLoading">Cargando...</div><div ng-show="!$ctrl.isCamposLoading" ng-if="$ctrl.puedeEditarCampos"><div ng-repeat="item in $ctrl.camposList" style="margin-bottom: 2px;"><div class="add-top-space col-md-3 center-label cssForCamposLabel" ng-if="item.Campo.CampoTipo.Codigo != \'TITLE\' && item.Campo.CampoTipo.Codigo != \'LINK\'"><label class="col-md-12 center-label"><b>{{item.Campo.Nombre}}:</b></label></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'TEXT\'"><input type="text" class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" required=""></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'PROCEDURE\'"><i class="glyphicon glyphicon-cog" style="font-size: 18px;float: left;padding: 9px;"></i><ba-switcher switcher-style="primary" switcher-value="item.ValorObjeto" ng-if="item.Campo.runProcedure==\'0\'"></ba-switcher></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'LINK\'"><a href="{{item.ValorObjeto}}" target="_blank"><button class="col-xs-12 col-sm-3 col-md-3 col-lg-2 btn btn-success pull-right" style="margin-top: 15px;"><span class="glyphicon glyphicon-link" aria-hidden="true"></span> {{item.Campo.Nombre}}</button></a></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'TEXTAREA\'"><textarea class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" required="" cols="40" rows="5">\r\n                            </textarea></div><div class="col-md-3" ng-if="item.Campo.CampoTipo.Codigo==\'VERSION\' && $ctrl.model.Id==0"><input type="number" min="0" pattern="[0-9]*" ng-keydown="$ctrl.evaluatenumberDigit($event)" class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto"></div><div class="col-md-3" ng-if="item.Campo.CampoTipo.Codigo==\'VERSION\' && $ctrl.model.Id!=0"><input type="number" min="0" pattern="[0-9]*" ng-keydown="$ctrl.evaluatenumberDigit($event)" class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" readonly="" style="color: #676565;"></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'NUMERADOR\'"><input type="text" class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" readonly="" style="color: #666666;"></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'TEXTENR\'"><wysiwyg textarea-id="{{item.Campo.Id}}" textarea-class="form-control" textarea-height="180px" textarea-name="{{item.Campo.Id}}" textarea-required="" ng-model="item.ValorObjeto" enable-bootstrap-title="true"></wysiwyg></div><div class="col-md-3" ng-if="item.Campo.CampoTipo.Codigo==\'INT\'"><input type="text" class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" required="" maxlength="22" style="text-align:right;" ng-keydown="$ctrl.evaluatenumber($event)" ng-focus="item.ValorObjeto = $ctrl.onNumericInputGotFocus(item.ValorObjeto)" ng-blur="item.ValorObjeto = $ctrl.onNumericInputLostFocus(item.ValorObjeto)"></div><div class="col-md-3" ng-if="item.Campo.CampoTipo.Codigo==\'DECIMAL\'"><input type="text" class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" required="" ng-keydown="$ctrl.evaluatenumberDecimal($event)" maxlength="20" style="text-align:right;" ng-focus="item.ValorObjeto = $ctrl.onNumericInputGotFocus(item.ValorObjeto)" ng-blur="item.ValorObjeto = $ctrl.onNumericInputLostFocus(item.ValorObjeto)"></div><div class="col-md-3" ng-if="item.Campo.CampoTipo.Codigo==\'DATE\'"><input type="date" class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" required="" min="1900-01-01" max="2100-12-31" style="min-height: 35px;"></div><div class="col-md-3" ng-if="item.Campo.CampoTipo.Codigo==\'DATETIMEREGIONAL\'"><input type="text" class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" readonly="" style="color: #757171;"></div><div class="col-md-3" ng-if="item.Campo.CampoTipo.Codigo==\'BOOL\'"><ba-switcher switcher-style="primary" switcher-value="item.ValorObjeto"></ba-switcher></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'LIST\'"><select name="{{item.Campo.Id}}" class="form-control" ng-model="item.ValorObjeto" ng-options="j as j.Nombre for j in item.SourceObjeto track by j.Id"></select></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'MULTI_LIST\'"><div class="col-md-6" style="margin-bottom: 10px; margin-left: 2px;"><input type="text" class="form-control" ng-model="item.TextoBusqueda" name="" ng-change="$ctrl.onChangeInputCampostList(item.TextoBusqueda, item)" placeholder="Buscar"></div><ul class="list-group col-md-6"><li class="list-group-item active">Para Seleccionar</li><div style="min-height: 100px; max-height: 190px; overflow-y: auto;"><li multiple="" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" ng-repeat="j in item.SourceObjeto track by j.Id" ng-click="$ctrl.actionAddOnClick(j, item);" class="list-group-item list-group-item-action" style="padding: 2px 2px;"><a class="list-group-item list-group-item-action list-group-item-dark" ng-click="$ctrl.actionAddOnClick(j, item);">{{j.Nombre}}</a></li></div></ul><ul class="list-group col-md-6"><li class="list-group-item active">Seleccionado</li><div style="min-height: 100px; max-height: 190px; overflow-y: auto;"><li multiple="" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" ng-repeat="j in item.ValorObjeto track by j.Id" class="list-group-item list-group-item-action" ng-click="$ctrl.actionRemoveOnClick(j, item);" style="padding: 2px 2px;"><a class="list-group-item list-group-item-action list-group-item-dark">{{j.Nombre}}</a></li></div></ul></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'JERARQ\' && item.Campo.tipoNumerador==true"><div ng-repeat="j in item.ValorObjeto"><input type="text" ng-model="j.ValorInput" placeholder="{{j.Placeholder}}" autocomplete="off" uib-typeahead="i as i.Nombre for i in $ctrl.searchJerarquia(j.ValorInput, j.JerarquiaPadreId)" typeahead-wait-ms="500" typeahead-loading="j.LoadingJerarquia" typeahead-no-results="j.NoResults" class="form-control" typeahead-on-select="$ctrl.onSelectJerarquia($parent.$index, $index, $model)" ng-readonly="(!$ctrl.model.Id==0) || (item.Solicitud.Proceso.isDocumental && item.Solicitud.Proceso.autorizacionesDocumental && item.Solicitud.Proceso.campoIdAutorizacion == item.Campo.Id)" style="color: #666666;"> <i ng-show="j.LoadingJerarquia" class="glyphicon glyphicon-refresh"></i><div ng-show="j.NoResults"><i class="glyphicon glyphicon-remove"></i> Valor no encontrado</div><a href="" class="pull-right" ng-if="item.Campo.PermiteAltaJerarquia" ng-click="$ctrl.altaNuevaJerarquia($parent.$parent.$index, $parent.$index)"><i class="ion-plus-circled"></i></a><div class="col-md-12" ng-show="j.MostrarDetalle" ng-repeat="det in j.Detalles"><label>{{det.Titulo}}: {{det.Valor}}</label></div></div></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'JERARQ\' && item.Campo.tipoNumerador==false"><div ng-repeat="j in item.ValorObjeto"><input type="text" ng-model="j.ValorInput" placeholder="{{j.Placeholder}}" autocomplete="off" uib-typeahead="i as i.Nombre for i in $ctrl.searchJerarquia(j.ValorInput, j.JerarquiaPadreId)" typeahead-wait-ms="500" typeahead-loading="j.LoadingJerarquia" typeahead-no-results="j.NoResults" class="form-control" typeahead-on-select="$ctrl.onSelectJerarquia($parent.$index, $index, $model)"> <i ng-show="j.LoadingJerarquia" class="glyphicon glyphicon-refresh"></i><div ng-show="j.NoResults"><i class="glyphicon glyphicon-remove"></i> Valor no encontrado</div><a href="" class="pull-right" ng-if="item.Campo.PermiteAltaJerarquia" ng-click="$ctrl.altaNuevaJerarquia($parent.$parent.$index, $parent.$index)"><i class="ion-plus-circled"></i></a><div class="col-md-12" ng-show="j.MostrarDetalle" ng-repeat="det in j.Detalles"><label>{{det.Titulo}}: {{det.Valor}}</label></div></div></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'NOTIF\'"><input type="text" class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" required=""> <label class="center-label" style="margin-top:5px"><h6><u>NOTA</u>: para ingresar m\xFAltiples direcciones de mail, separe cada una con punto y coma (;).</h6></label></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'USER\'"><div class="col-md-3"><input type="text" class="form-control" style="width: 195px;" ng-model="$ctrl.usuarioCargado" placeholder="Ingrese un usuario a agregar..." uib-typeahead="i as i.Login for i in $ctrl.searchCampoUsuario($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingUsuario" typeahead-no-results="noResultsUsuario" typeahead-on-select="$ctrl.onSelectUsuarioMultiList($index, $model)"> <i ng-show="loadingUsuario" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsUsuario"><i class="glyphicon glyphicon-remove"></i> Usuario no encontrado</div></div><div class="col-md-9" style="margin-top:5px;margin-bottom:20px"><i class="glyphicon glyphicon-info-sign"></i> <a href="" ng-click="$ctrl.onSelectUsuarioMultiList($index, $ctrl.model.UsuarioCreacion)">Usuario Solicitante: {{$ctrl.model.UsuarioCreacion.Nombre}} {{$ctrl.model.UsuarioCreacion.Apellido}}</a></div><table class="table" style="margin-bottom: 20px;" st-table="item.ValorObjeto"><thead><tr class="sortable"><th class="text-center">Login</th><th class="text-center">Nombre</th><th class="text-center">Apellido</th><th class="text-center">Acci\xF3n</th></tr></thead><tbody><tr ng-repeat="u in item.ValorObjeto"><td align="center">{{u.Login}}</td><td align="center">{{u.Nombre}}</td><td align="center">{{u.Apellido}}</td><td align="center"><a href="" ng-click="$ctrl.deleteCampoUsuario($parent.$index, u.Id)">Quitar</a></td></tr></tbody></table></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'SOLPROCESOSREL\'" ng-init="$ctrl.initListadoProcesos()"><div class="col-xs-12 col-md-6" style="margin-bottom:20px"><label>Seleccione el proceso:</label><select name="templates" ng-model="$ctrl.procesoSeleccionado" class="form-control" ng-change="$ctrl.onChangeSelectProcesoSeleccionado($ctrl.procesoSeleccionado)" ng-options="item as item.Nombre for item in $ctrl.listadoDeProcesos track by item.Id"></select></div><div class="col-xs-12 col-md-6" style="margin-bottom:20px"><label>Seleccione la solicitud:</label> <input type="text" ng-model="$ctrl.solicitudCargada" placeholder="Ingrese una Solicitud" uib-typeahead="descripcion as solicitud.Descripcion for solicitud in $ctrl.searchCampoSolicitud($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingSolicitud" typeahead-no-results="noResultsSolicitud" class="form-control" typeahead-editable="false" typeahead-on-select="$ctrl.onSelectSolicitudMultiList($index, $item)"> <i ng-show="loadingSolicitud" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsSolicitud"><i class="glyphicon glyphicon-remove"></i> Solicitud no encontrada</div></div><table class="table" st-table="item.ValorObjeto"><thead><tr class="sortable"><th class="text-center">Nombre Proceso</th><th class="text-center">Descripcion Resumida</th><th class="text-center">Numero Completo</th><th class="text-center">LINK</th><th class="text-center">Acci\xF3n</th></tr></thead><tbody><tr ng-repeat="obj in item.ValorObjeto track by $index"><td align="center">{{obj.Proceso.Nombre}}</td><td align="center">{{obj.DescripcionResumida}}</td><td align="center">{{obj.NumeroCompleto}}</td><td align="center"><a href="#/solicitud/edit/{{obj.Id}}/{{obj.Proceso.GrupoId}}/{{obj.Proceso.Id}}/0" target="_blank">Abrir link</a></td><td align="center"><a href="" ng-click="$ctrl.deleteCampoSolicitud($parent.$index, obj.Id)">Quitar</a></td></tr></tbody></table></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'SOLPROCESOSREL_DOCASO\'" ng-init="$ctrl.initListadoProcesos_doc()"><div class="col-xs-12 col-md-6" style="margin-bottom:20px"><label>Seleccione el proceso:</label><select name="templates" ng-model="$ctrl.procesoSeleccionado_doc" class="form-control" ng-change="$ctrl.onChangeSelectProcesoSeleccionado_doc($ctrl.procesoSeleccionado_doc)" ng-options="item as item.Nombre for item in $ctrl.listadoDeProcesos_doc track by item.Id"></select></div><div class="col-xs-12 col-md-6" style="margin-bottom:20px"><label>Seleccione la solicitud:</label> <input type="text" ng-model="$ctrl.solicitudCargada_doc" placeholder="Ingrese una Solicitud" uib-typeahead="descripcion as solicitud.Descripcion for solicitud in $ctrl.searchCampoSolicitud_doc($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingSolicitud" typeahead-no-results="noResultsSolicitud" class="form-control" typeahead-editable="false" typeahead-on-select="$ctrl.onSelectSolicitudMultiList_doc($index, $item)"> <i ng-show="loadingSolicitud" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsSolicitud"><i class="glyphicon glyphicon-remove"></i> Solicitud no encontrada</div></div><table class="table" st-table="item.ValorObjeto"><thead><tr class="sortable"><th class="text-center">Nombre Proceso</th><th class="text-center">Descripcion Resumida</th><th class="text-center">Numero Completo</th><th class="text-center">LINK</th><th class="text-center">Acci\xF3n</th></tr></thead><tbody><tr ng-repeat="obj in item.ValorObjeto track by $index"><td align="center">{{obj.Proceso.Nombre}}</td><td align="center">{{obj.DescripcionResumida}}</td><td align="center">{{obj.NumeroCompleto}}</td><td align="center"><a href="#/solicitud/edit/{{obj.Id}}/{{obj.Proceso.GrupoId}}/{{obj.Proceso.Id}}/0" target="_blank">Abrir link</a></td><td align="center"><a href="" ng-click="$ctrl.deleteCampoSolicitud($parent.$index, obj.Id)">Quitar</a></td></tr></tbody></table></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'ATTACH\'"><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item)" ng-disabled="$ctrl.isBusy">Seleccionar</div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment(item)" ng-disabled="$ctrl.isBusy">Eliminar</div><a href="" ng-click="$ctrl.openAttachment(item.ValorObjeto)">{{item.ValorObjeto}}</a><p ng-show="item.isLoading">Cargando archivo...</p></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'IMG\'"><img src="{{$ctrl.imgFile}}{{item.ValorObjeto}}" height="350" width="350" ng-if="item.ValorObjeto!=\'\'"><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item)" ngf-accept="\'image/*\'" ng-disabled="$ctrl.isBusy">Seleccionar</div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment(item)" ng-disabled="$ctrl.isBusy">Eliminar</div><p ng-show="item.isLoading">Cargando Imagen...</p></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'COND\'"><select name="{{item.Campo.Id}}" class="form-control" ng-model="item.TablaFilas[0].Valor[0]" ng-options="j.condicion as j.condicion for j in item.Campo.Columnas" ng-change="$ctrl.onChangeInputcond(item.TablaFilas[0])"></select></div><div ng-if="item.Campo.CampoTipo.Codigo==\'COND\'"><div ng-repeat="col in item.Campo.Columnas track by $index"><div class="add-top-space col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo != \'TITLE\'" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="center-label">{{col.ColumnaCampo.Nombre}}:</label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'TEXT\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><input type="text" class="form-control" name="TEXT" ng-init="item.TablaFilas[0].Valor[1]==\'\'?item.TablaFilas[0].Valor[1]=col.ColumnaCampo.defaultValue:item.TablaFilas[0].Valor[1]" ng-model="item.TablaFilas[0].Valor[1]" ng-change="$ctrl.onChangeInputTableCond($parent.$parent.$parent.$index, 0, 1,item.TablaFilas[0].Valor[1])"></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'TEXTAREA\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><textarea class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" cols="40" rows="5" ng-change="$ctrl.onChangeInputTableCond($parent.$parent.$parent.$index, 0, 1,item.TablaFilas[0].Valor[1])">\r\n                                    </textarea></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'DECIMAL\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><input type="text" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" maxlength="22" style="text-align:right;"></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'INT\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><input type="text" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" style="text-align:right;" maxlength="22" ng-change="$ctrl.onChangeInputTableCond($parent.$parent.$parent.$index, 0, 1,item.TablaFilas[0].Valor[1])" ng-keydown="$ctrl.evaluatenumber($event)" ng-focus="item.TablaFilas[0].Valor[1] = $ctrl.onNumericInputGotFocus(item.TablaFilas[0].Valor[1])" ng-blur="item.TablaFilas[0].Valor[1] = $ctrl.onNumericInputLostFocus(item.TablaFilas[0].Valor[1])"></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'DATE\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><input type="date" class="form-control" name="{{item.Campo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" min="1900-01-01" max="2100-12-31" ng-change="$ctrl.onChangeInputTableCond($parent.$parent.$parent.$index, 0, 1,item.TablaFilas[0].Valor[1])" style="min-height: 35px;"></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'DATETIMEREGIONAL\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><input type="text" class="form-control" name="{{item.Campo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" readonly="" style="color: #757171;" ng-change="$ctrl.onChangeInputTableCond($parent.$parent.$parent.$index, 0, 1,item.TablaFilas[0].Valor[1])"></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'BOOL\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><input type="checkbox" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" ng-change="$ctrl.onChangeInputTableCond($parent.$parent.$parent.$index, 0, 1,item.TablaFilas[0].Valor[1])"></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'ATTACH\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><a href="" ng-click="$ctrl.openAttachment(item.ValorObjeto)">{{item.ValorObjeto}}</a><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item)" ng-disabled="$ctrl.isBusy">Seleccionar</div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment(item)" ng-disabled="$ctrl.isBusy">Eliminar</div></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'IMG\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><img src="{{$ctrl.imgFile}}{{item.ValorObjeto}}" height="350" width="350" ng-if="item.ValorObjeto!=\'\'"><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item)" ngf-accept="\'image/*\'" accept="image/*" ng-disabled="$ctrl.isBusy">Seleccionar</div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment(item)" ng-disabled="$ctrl.isBusy">Eliminar</div><p ng-show="item.isLoading">Cargando Imagen...</p></div></div></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'TEMPLATE\'"><select name="{{item.Campo.Id}}" class="form-control" ng-model="item.ValorObjeto" ng-options="t as t.Template.Nombre for t in item.SourceObjeto track by t.Id"></select></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'TITLE\'" style="text-align: center;"><h3 class="campo-title">{{item.Campo.Nombre}}</h3></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'PERIODO\'"><select name="{{item.Campo.Id}}" class="form-control" ng-model="item.ValorObjeto" ng-options="j as j.Nombre for j in item.SourceObjeto track by j.Id"></select></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'TABLE\'"><table class="table campo-tabla"><thead><tr class="sortable center-label"><th class="text-center" ng-repeat="col in item.Campo.Columnas">{{col.ColumnaCampo.Nombre}}</th></tr></thead><tbody><tr ng-repeat="fila in item.TablaFilas"><td align="center" ng-repeat="colValor in fila.Valor track by $index"><div ng-if="$index==0 && !item.Campo.permiteEditarColumna" id="no_permite_editar_columna"><div class="col-md-12" style="margin-bottom:10px"><label class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}">{{colValor}}</label></div></div><div id="permite_editar_columna" ng-if="$index==0 && item.Campo.permiteEditarColumna"><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'TEXT\'" style="margin-bottom:10px"><input type="text" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'TEXTAREA\'" style="margin-bottom:10px"><textarea class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" cols="40" rows="5" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)">\r\n                                                    </textarea></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'INT\'" style="margin-bottom:10px"><input type="text" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" style="text-align:right;" maxlength="22" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)" ng-keydown="$ctrl.evaluatenumber($event)" ng-focus="colValor = $ctrl.onNumericInputGotFocus(colValor)" ng-blur="colValor = $ctrl.onNumericInputLostFocus(colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DECIMAL\'" style="margin-bottom:10px"><input type="text" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" maxlength="22" style="text-align:right;" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)" ng-keydown="$ctrl.evaluatenumberDecimal($event)" ng-focus="colValor = $ctrl.onNumericInputGotFocus(colValor)" ng-blur="colValor = $ctrl.onNumericInputLostFocus(colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DATE\'" style="margin-bottom:10px"><input type="date" class="form-control" name="{{item.Campo.Id}}" ng-model="colValor" min="1900-01-01" max="2100-12-31" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DATETIMEREGIONAL\'" style="margin-bottom:10px"><input type="text" class="form-control" name="{{item.Campo.Id}}" ng-model="colValor" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" readonly="" style="color: #757171;" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'BOOL\'" style="margin-bottom:10px"><input type="checkbox" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'ATTACH\'" style="margin-bottom:10px"><a href="" ng-click="$ctrl.openAttachment(colValor)">{{colValor}}</a><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item)" ng-disabled="$ctrl.isBusy">Seleccionar</div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment(item)" ng-disabled="$ctrl.isBusy">Eliminar</div></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'IMG\'" style="margin-bottom:10px"><img src="{{$ctrl.imgFile}}{{colValor}}" height="350" width="350" ng-if="colValor!=\'\'"><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item)" ngf-accept="\'image/*\'" accept="image/*" ng-disabled="$ctrl.isBusy">Seleccionar</div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment(item)" ng-disabled="$ctrl.isBusy">Eliminar</div><p ng-show="item.isLoading">Cargando Imagen...</p></div></div><div id="permite_editar_columna" ng-if="$index!=0"><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'TEXT\'" style="margin-bottom:10px"><input type="text" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'TEXTAREA\'" style="margin-bottom:10px"><textarea class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" cols="40" rows="5" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)">\r\n                                                    </textarea></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'INT\'" style="margin-bottom:10px"><input type="text" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" style="text-align:right;" maxlength="22" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)" ng-keydown="$ctrl.evaluatenumber($event)" ng-focus="colValor = $ctrl.onNumericInputGotFocus(colValor)" ng-blur="colValor = $ctrl.onNumericInputLostFocus(colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DECIMAL\'" style="margin-bottom:10px"><input type="text" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" maxlength="22" style="text-align:right;" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)" ng-keydown="$ctrl.evaluatenumberDecimal($event)" ng-focus="colValor = $ctrl.onNumericInputGotFocus(colValor)" ng-blur="colValor = $ctrl.onNumericInputLostFocus(colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DATE\'" style="margin-bottom:10px"><input type="date" class="form-control" name="{{item.Campo.Id}}" ng-model="colValor" min="1900-01-01" max="2100-12-31" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DATETIMEREGIONAL\'" style="margin-bottom:10px"><input type="text" class="form-control" name="{{item.Campo.Id}}" ng-model="colValor" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" readonly="" style="color: #757171;" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'BOOL\'" style="margin-bottom:10px"><input type="checkbox" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'ATTACH\'" style="margin-bottom:10px"><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item)" ng-disabled="$ctrl.isBusy">Seleccionar</div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment(item)" ng-disabled="$ctrl.isBusy">Eliminar</div><a href="" ng-click="$ctrl.openAttachment(colValor)">{{colValor}}</a></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'IMG\'" style="margin-bottom:10px"><img src="{{$ctrl.imgFile}}{{colValor}}" height="350" width="350" ng-if="colValor!=\'\'"><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item)" ngf-accept="\'image/*\'" accept="image/*" ng-disabled="$ctrl.isBusy">Seleccionar</div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment(item)" ng-disabled="$ctrl.isBusy">Eliminar</div><p ng-show="item.isLoading">Cargando Imagen...</p></div></div></td></tr></tbody></table></div><div style="clear: both;"></div><br></div></div><div ng-show="!$ctrl.isCamposLoading" ng-if="!$ctrl.puedeEditarCampos"><div ng-repeat="item in $ctrl.camposList" style="margin-bottom: 2px;"><div class="col-md-3 center-label cssForCamposLabel" ng-if="item.Campo.CampoTipo.Codigo != \'TITLE\' && item.Campo.CampoTipo.Codigo != \'LINK\'"><label class="col-md-12 center-label"><b>{{item.Campo.Nombre}}</b></label></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'TEXTAREA\'" style="display: inline;"><label class="col-md-9 center-label" style="font-weight:normal; font-weight: normal;margin-left: 0px;padding-left: 0px;">{{item.Valor}}</label></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'LINK\'"><a href="{{item.ValorObjeto}}" target="_blank"><button class="col-xs-12 col-sm-3 col-md-3 col-lg-2 btn btn-success pull-right" style="margin-top: 15px;"><span class="glyphicon glyphicon-link" aria-hidden="true"></span> {{item.Campo.Nombre}}</button></a></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'NUMERADOR\'" style="display: inline;"><label class="col-md-9 center-label" style="font-weight:normal">{{item.Valor}}</label></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'TEXTENR\'" style="display: inline;"><div ng-bind-html="item.Valor"></div></div><div ng-if="item.Campo.CampoTipo.Codigo==\'DATE\'" style="display: inline;"><label class="col-md-9 center-label" style="font-weight:normal">{{item.Valor | date:\'dd/MM/yyyy\'}}</label></div><div ng-if="item.Campo.CampoTipo.Codigo==\'DATETIMEREGIONAL\'" style="display: inline;"><label class="col-md-9 center-label" style="font-weight:normal">{{item.Valor | date:\'dd/MM/yyyy\'}}</label></div><div ng-if="item.Campo.CampoTipo.Codigo==\'ATTACH\' && item.Valor != \'\'"><a class="col-md-9" href="" style="font-weight:normal; padding-top: 8px;" ng-click="$ctrl.openAttachment(item.Valor)">Documento</a></div><div ng-if="item.Campo.CampoTipo.Codigo==\'IMG\'"><img src="{{$ctrl.imgFile}}{{item.Valor}}" height="350" width="350" ng-if="item.Valor!=\'\'"></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'TITLE\'" style="text-align: center;"><h3 class="campo-title">{{item.Campo.Nombre}}</h3></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'TABLE\'"><table class="table campo-tabla"><thead><tr class="sortable center-label"><th class="text-center" ng-repeat="col in item.Campo.Columnas">{{col.ColumnaCampo.Nombre}}</th></tr></thead><tbody><tr ng-repeat="fila in item.TablaFilas"><td align="center" ng-repeat="colValor in fila.Valor track by $index"><div class="col-md-12" style="margin-bottom:10px" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo!=\'TEXTAREA\' && item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo!=\'DATE\' && item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo!=\'ATTACH\' && item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo!=\'INT\' && item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo!=\'DECIMAL\'">{{colValor}}</div><div ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'INT\' || item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DECIMAL\'" align="right">{{colValor}}</div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'ATTACH\'" style="margin-bottom:10px"><a class="col-md-12" href="" style="font-weight:normal" ng-click="$ctrl.openAttachment(colValor)">{{colValor}}</a></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'IMG\'" style="margin-bottom:10px"><img src="{{$ctrl.imgFile}}{{colValor}}" height="350" width="350" ng-if="colValor!=\'\'"></div><div ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'TEXTAREA\'"><pre class="col-md-12" style="background: transparent; border: transparent; font-family:inherit">{{colValor}}</pre></div><div ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DATE\'"><label class="col-md-12 center-label" style="font-weight:normal">{{colValor | date:\'dd/MM/yyyy\'}}</label></div><div ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DATETIMEREGIONAL\'"><label class="col-md-12 center-label" style="font-weight:normal">{{colValor | date:\'dd/MM/yyyy\'}}</label></div></td></tr></tbody></table></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'JERARQ\'" style="display: inline;"><div style="font-family:inherit; color:black; -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */ -moz-box-sizing: border-box; /* Firefox, other Gecko */ box-sizing: border-box; /* Opera/IE 8+ */ padding:1%; border:none; padding-left: 0px; padding-top: 0px;"><div ng-repeat="j in item.ValorObjeto"><label class="center-label" style="font-weight:normal; margin: 2px;">{{j.ValorInput}}</label><div class="col-md-12" ng-show="j.MostrarDetalle" ng-repeat="det in j.Detalles" style="display: inline;"><label>{{det.Titulo}}: {{det.Valor}}</label></div></div></div></div><div ng-if="item.Campo.CampoTipo.Codigo==\'COND\'"><input type="text" style="color:black" class="form-control" name="{{item.Campo.Id}}" ng-model="item.TablaFilas[0].Valor[0]" readonly=""></div><div ng-if="item.Campo.CampoTipo.Codigo==\'COND\'"><div ng-repeat="col in item.Campo.Columnas track by $index"><div class="add-top-space" ng-if="col.ColumnaCampo.CampoTipo.Codigo != \'TITLE\'" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="center-label">{{col.ColumnaCampo.Nombre}}:</label></div><div ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'TEXT\'" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><input type="text" style="color:black" class="form-control" name="{{item.Campo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" readonly=""></div><div ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'TEXTAREA\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="center-label" style="font-weight:normal">{{item.TablaFilas[0].Valor[1]}}</label></div><div ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'INT\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="center-label" style="font-weight:normal">{{item.TablaFilas[0].Valor[1]}}</label></div><div ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'DECIMAL\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="center-label" style="font-weight:normal">{{item.TablaFilas[0].Valor[1]}}</label></div><div ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'DATE\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="col-md-12 center-label" style="font-weight:normal">{{item.TablaFilas[0].Valor[1] | date:\'dd/MM/yyyy\'}}</label></div><div ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'DATETIMEREGIONAL\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="col-md-12 center-label" style="font-weight:normal">{{item.TablaFilas[0].Valor[1] | date:\'dd/MM/yyyy\'}}</label></div><div ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'BOOL\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><input type="checkbox" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" readonly=""></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'PROCEDURE\'"><i class="glyphicon glyphicon-cog" style="font-size: 18px;float: left;padding: 9px;"></i></div><div ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'ATTACH\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><a href="" ng-click="$ctrl.openAttachment(item.ValorObjeto)">{{item.ValorObjeto}}</a><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item)" ng-disabled="$ctrl.isBusy"></div></div><div ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'IMG\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><img src="{{$ctrl.imgFile}}{{item.ValorObjeto}}" height="350" width="350" ng-if="item.TablaFilas[0].Valor[1]!=\'\'"></div></div></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'SOLPROCESOSREL\'"><table class="table" st-table="item.ValorObjeto"><thead><tr class="sortable"><th class="text-center">Nombre Proceso</th><th class="text-center">Descripcion Resumida</th><th class="text-center">Numero Completo</th><th class="text-center">LINK</th><th class="text-center">Acci\xF3n</th></tr></thead><tbody><tr ng-repeat="obj in item.ValorObjeto track by $index"><td align="center">{{obj.Proceso.Nombre}}</td><td align="center">{{obj.DescripcionResumida}}</td><td align="center">{{obj.NumeroCompleto}}</td><td align="center"><a href="#/solicitud/edit/{{obj.Id}}/{{obj.Proceso.GrupoId}}/{{obj.Proceso.Id}}/0" target="_blank">Abrir link</a></td><td align="center"></td></tr></tbody></table></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'SOLPROCESOSREL_DOCASO\'"><table class="table" st-table="item.ValorObjeto"><thead><tr class="sortable"><th class="text-center">Nombre Proceso</th><th class="text-center">Descripcion Resumida</th><th class="text-center">Numero Completo</th><th class="text-center">LINK</th><th class="text-center">Acci\xF3n</th></tr></thead><tbody><tr ng-repeat="obj in item.ValorObjeto track by $index"><td align="center">{{obj.Proceso.Nombre}}</td><td align="center">{{obj.DescripcionResumida}}</td><td align="center">{{obj.NumeroCompleto}}</td><td align="center"><a href="#/solicitud/edit/{{obj.Id}}/{{obj.Proceso.GrupoId}}/{{obj.Proceso.Id}}/0" target="_blank">Abrir link</a></td><td align="center"></td></tr></tbody></table></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'MULTI_LIST\'" style="display: inline;"><ul class="list-group col-md-6"><div style="min-height: 100px; overflow-y: auto;"><li multiple="" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" ng-repeat="j in item.ValorObjeto track by j.Id" class="list-group-item list-group-item-action">{{j.Nombre}}</li></div></ul></div><div ng-if="item.Campo.CampoTipo.Codigo!==\'TABLE\' && item.Campo.CampoTipo.Codigo!==\'TEXTAREA\' && item.Campo.CampoTipo.Codigo!==\'DATE\' && item.Campo.CampoTipo.Codigo!==\'ATTACH\' && item.Campo.CampoTipo.Codigo!==\'COND\' && item.Campo.CampoTipo.Codigo!==\'TEXTENR\' && item.Campo.CampoTipo.Codigo!==\'NUMERADOR\' && item.Campo.CampoTipo.Codigo!==\'SOLPROCESOSREL\' && item.Campo.CampoTipo.Codigo!==\'SOLPROCESOSREL_DOCASO\' && item.Campo.CampoTipo.Codigo!==\'LINK\' && item.Campo.CampoTipo.Codigo!==\'PROCEDURE\' && item.Campo.CampoTipo.Codigo!==\'MULTI_LIST\' && item.Campo.CampoTipo.Codigo!==\'TITLE\' && item.Campo.CampoTipo.Codigo!==\'IMG\' && item.Campo.CampoTipo.Codigo!==\'DATETIMEREGIONAL\' && item.Campo.CampoTipo.Codigo!==\'JERARQ\'" style="display: inline;"><label class="col-md-9 center-label" style="font-weight:normal">{{item.Valor}}</label></div><div style="clear: both;"></div></div></div><div class="add-top-space col-md-8" ng-if="$ctrl.solicitudHasProceduresField && !$ctrl.procesoGeneraProcesosRelacionados"><label class="center-label">Desea generar automaticamente todos los procesos relacionados?:</label></div><div class="col-md-8" ng-if="$ctrl.solicitudHasProceduresField && !$ctrl.procesoGeneraProcesosRelacionados"><ba-switcher switcher-style="primary" switcher-value="$ctrl.generaProcesoRelacionados"></ba-switcher></div><div class="col-md-12" ng-show="!$ctrl.isCamposLoading"><button class="btn btn-success pull-right" ng-click="$ctrl.saveCamposSolicitud()" ng-disabled="$ctrl.isBusy" ng-show="$ctrl.puedeEditarCampos && $ctrl.mostrarCamposBoton && $ctrl.model.Id > 0">Guardar Campos</button></div></div><div modal-directive=""></div></uib-tab><uib-tab index="2" heading="Historial" ng-disabled="true" ng-show="$ctrl.model.Id > 0"><div ba-panel="" ba-panel-title="Historial" ba-panel-class="with-scroll" ng-show="$ctrl.model.Id > 0 && !$ctrl.anularVista" id="historial"><table class="table" st-table="$ctrl.historialSolicitud" st-safe-src="$ctrl.dataSource"><thead><tr class="sortable center-label"><th class="text-center">Fecha</th><th class="text-center">Etapa</th><th class="text-center">Procesado</th><th class="text-center">Comentarios</th><th class="text-center">Usuario</th></tr></thead><tbody ng-show="!$ctrl.historialIsSearching"><tr ng-repeat="item in $ctrl.historialSolicitud"><td align="center">{{item.LastUpdate | date:\'dd/MM/yyyy\'}}</td><td align="center">{{item.SolicitudEtapaNombre}}</td><td align="center">{{item.AprobadoText}}</td><td align="center">{{item.Comentarios}}</td><td align="center">{{item.UsuarioCreacion.Login}}</td></tr></tbody><tbody ng-show="$ctrl.historialIsSearching"><tr><td colspan="5" class="text-center">Cargando...</td></tr></tbody></table></div></uib-tab><uib-tab index="3" heading="Trazabilidad" ng-disabled="true" ng-show="$ctrl.model.Id > 0" ng-click="$ctrl.getHistorialTrazabilidadSolicitud()"><div ba-panel="" ba-panel-title="Trazabilidad" ba-panel-class="with-scroll" ng-show="$ctrl.model.Id > 0 && !$ctrl.anularVista" id="historial"><table class="table" st-table="$ctrl.TrazabilidadSolicitud" st-safe-src="$ctrl.dataSource"><thead><tr class="sortable center-label"><th class="text-center">Fecha</th><th class="text-center">Nombre Proceso</th><th class="text-center">Comentarios</th><th class="text-center">Usuario</th><th class="text-center">Nombre Template</th><th class="text-center">Titulo Template</th><th class="text-center">Texto Datos</th><th class="text-center">Destinatarios correos</th><th class="text-center">Fecha creacion</th><th class="text-center">Fecha update</th><th class="text-center">Accion Realizada</th></tr></thead><tbody ng-show="!$ctrl.historialIsSearchingTrazabilidad"><tr ng-repeat="item in $ctrl.TrazabilidadSolicitud"><td align="center">{{item.LastUpdate | date:\'dd/MM/yyyy\'}}</td><td align="center">{{item.NombreProceso}}</td><td align="center">{{item.DescripcionResumidaProceso}}</td><td align="center">{{item.NombreApellidoUsuario}}</td><td align="center">{{item.NombreTemplate}}</td><td align="center">{{item.TituloTemplate}}</td><td align="center">{{item.TextoDatos}}</td><td align="center">{{item.DestinatariosCorreo}}</td><td align="center">{{item.CreationDate}}</td><td align="center">{{item.LastUpdate}}</td><td align="center">{{item.AccionRealizada}}</td></tr></tbody><tbody ng-show="$ctrl.historialIsSearchingTrazabilidad"><tr><td colspan="5" class="text-center">Cargando...</td></tr></tbody></table></div></uib-tab></uib-tabset></div><div class="col-md-12"><button class="btn btn-success pull-right" ng-click="$ctrl.createSolicitud()" ng-disabled="$ctrl.isBusy" ng-show="$ctrl.puedeEditarSolicitud && $ctrl.model.Id == 0">Crear Proceso</button> <button class="btn btn-danger" ng-click="$ctrl.goBack()" ng-disabled="$ctrl.isBusy">Ir Atr\xE1s</button> <button class="btn btn-danger" ng-click="$ctrl.goListado()" ng-disabled="$ctrl.isBusy">Ir al Listado</button> <button class="btn btn-danger pull-right" ng-click="$ctrl.delete()" ng-disabled="$ctrl.isBusy" ng-show="!$ctrl.lProcesoIsDocumentalAutorizacionesV2 && $ctrl.showDelete && !$ctrl.anularVista && $ctrl.puedeEditarSolicitud && ($ctrl.lsuarioLogueadoIsAdminProceso || $ctrl.lsuarioLogueadoIsSysAdmin)">Borrar Proceso</button></div>');
$templateCache.put('app/pages/solicitud/list.template.html','<div ba-panel="" ba-panel-title="Proceso: {{$ctrl.procesoSeleccionado.Codigo}} - {{$ctrl.procesoSeleccionado.Nombre}}" ba-panel-class="with-scroll"><div ba-panel="" ba-panel-class="with-scroll" ng-show="$ctrl.anularVista"><h5>Debe seleccionar un grupo y un proceso ingresando por la <a href="" ng-click="$ctrl.goHome()">home</a>.</h5></div><div ba-panel="" ba-panel-class="with-scroll" ng-show="!$ctrl.anularVista"><div class="col-md-12"><button class="btn btn-primary col-md-1 col-xs-12" ng-click="$ctrl.cancel()" style="margin-top: 5px" ng-disabled="$ctrl.isBusy">Volver</button> <img src="/images/doc_cerrados.png" class="imgZoom" height="40" width="40" style="cursor: pointer; float: left; margin-left: 15px;display: block;" ng-if="$ctrl.lProcesoIsDocumentalAutorizacionesV2 && !$ctrl.documentalGetCerrados" ng-click="$ctrl.verDocPendientes()" alt="Cerrados" data-toggle="tooltip" title="Cerrados!"> <img src="/images/doc_pendientes.png" class="imgZoom" height="40" width="40" style="cursor: pointer; float: left; margin-left: 15px;display: block;" ng-if="$ctrl.lProcesoIsDocumentalAutorizacionesV2 && $ctrl.documentalGetCerrados" ng-click="$ctrl.verDocPendientes()" alt="Pendientes" data-toggle="tooltip" title="Pendientes!"><button class="btn btn-primary pull-right col-md-1 col-xs-12" style="margin-top: 5px; margin-left: 5px" ng-click="$ctrl.add()" ng-if="$ctrl.procesoSeleccionado.verBtnAgregar && $ctrl.puedeCrearSolicitud" ng-disabled="$ctrl.isBusy">Agregar</button> <button class="btn btn-danger pull-right col-md-1 col-xs-12" ng-click="$ctrl.deleteAll()" ng-disabled="$ctrl.isBusy" ng-show="$ctrl.isSysAdmin" style="margin-top: 5px">Borrar Todas</button></div><div class="col-md-12 col-xs-12" style="margin-top:10px" ng-show="$ctrl.showCheckProcesosCerrados"><input type="checkbox" ng-model="$ctrl.verTodos" ng-click="$ctrl.buscarSolicitud($ctrl.solicitudTableState)" ng-disabled="$ctrl.isBusy" name=""> <span>Ver procesos cerrados</span></div><div class="col-md-12 col-xs-12"><input type="checkbox" ng-model="$ctrl.verProcesosPendientesOtrosUsuarios" ng-click="$ctrl.buscarSolicitud($ctrl.solicitudTableState)" ng-disabled="$ctrl.isBusy" ng-show="$ctrl.procesoSeleccionado.MostrarOpcionProcesosPendientes" name=""> <span ng-show="$ctrl.procesoSeleccionado.MostrarOpcionProcesosPendientes">Ver procesos pendientes de cualquier usuario</span></div></div><div ba-panel="" ba-panel-class="with-scroll" ng-show="!$ctrl.anularVista && $ctrl.procesoSeleccionado.Links != null && $ctrl.procesoSeleccionado.Links.length > 0"><button class="btn btn-primary" ng-click="$ctrl.openUrl(item.UrlLink)" ng-repeat="item in $ctrl.procesoSeleccionado.Links track by $index" style="margin-right: 10px" ng-if="!item.solicitudLevel">{{item.NombreLink}}</button></div><div ba-panel="" ba-panel-class="with-scroll" ng-show="!$ctrl.anularVista"><table class="table" st-pipe="$ctrl.buscarSolicitud" st-table="$ctrl.solicitudesList"><thead><tr><div style="width: auto;margin-right: 1px;float: right;padding: 6px;" class="ng-scope"><button class="btn btn-primary col-md-3 col-xs-12" ng-click="$ctrl.triggerFind()" style="margin-top: 5px;min-width: 150px;margin-left: 15px;" ng-disabled="$ctrl.isBusy"><i class="fa fa-search" style="font-size: 16px;margin-right: 5px;"></i> Buscar</button> <button class="btn btn-primary col-md-3 col-xs-12" ng-click="$ctrl.cleanFilters()" style="margin-top: 5px;min-width: 150px;margin-left: 15px;" ng-disabled="$ctrl.isBusy"><i class="fa fa-pencil-square-o" style="font-size: 16px;margin-right: 5px;" aria-hidden="true"></i>Limpiar</button></div></tr><tr class="sortable"><th class="text-center" st-sort="{{col.SolicitudColumna.Codigo}}{{col.Campo.Id}}" ng-repeat="col in $ctrl.procesoSeleccionado.CamposListado"><span ng-show="col.SolicitudColumna != null">{{col.SolicitudColumna.Nombre}}</span> <span ng-show="col.Campo != null">{{col.Campo.Nombre}}</span></th><th class="text-center">Acci\xF3n</th></tr><tr><th ng-repeat="col in $ctrl.procesoSeleccionado.CamposListado"><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input type="search" ng-model="$ctrl.values[$index]" class="input-sm form-control with-primary-addon" placeholder="Buscar por {{col.SolicitudColumna.Nombre}}" aria-describedby="basic-addon1" ng-show="col.SolicitudColumna != null"> <input type="search" ng-model="$ctrl.values[$index]" class="input-sm form-control with-primary-addon" placeholder="Buscar por {{col.Campo.Nombre}}" aria-describedby="basic-addon1" ng-show="col.Campo != null"></div></th><th></th></tr></thead><tbody ng-show="!$ctrl.isSolicitudSearching"><tr ng-repeat="fila in $ctrl.solicitudesList" ng-class="{ \'solicitud-vencida\': fila.EstaVencida }" style="cursor: pointer"><td align="left" ng-repeat="colValor in fila.ValorMostrarBusqueda track by $index" style="text-align: left" ng-click="$ctrl.edit(fila.Id)"><div ng-switch="" on="$ctrl.procesoSeleccionado.CamposListado[$index].Campo.CampoTipo.Codigo"><div ng-switch-when="DATE">{{colValor | date:\'dd/MM/yyyy\'}}</div><div ng-switch-when="INT" align="right">{{colValor}}</div><div ng-switch-when="DECIMAL" align="right">{{colValor}}</div><div ng-switch-when="JERARQ" align="right"><div ng-repeat="c in colValor">{{c.Nombre}}</div></div><div ng-switch-when="BOOL"><i class="fa fa-check" style="color:green" ng-show="{{colValor}} == true"></i> <i class="fa fa-times" style="color:red" ng-hide="{{colValor}} == true"></i></div><div ng-switch-when="ATTACH"><a href="{{colValor}}" target="_blank">{{colValor}}</a></div><div ng-switch-default=""><div ng-switch="" on="$ctrl.procesoSeleccionado.CamposListado[$index].SolicitudColumna.Codigo"><div ng-switch-when="LastUpdate">{{colValor | date:\'dd/MM/yyyy\'}}</div><div ng-switch-when="FechaCierre">{{colValor | date:\'dd/MM/yyyy\'}}</div><div ng-switch-when="CreationDate">{{colValor | date:\'dd/MM/yyyy\'}}</div><div ng-switch-when="Activo"><i class="fa fa-check" style="color:green" ng-show="{{colValor}} == true"></i> <i class="fa fa-times" style="color:red" ng-hide="{{colValor}} == true"></i></div><div ng-switch-default="">{{colValor}}</div></div></div></div></td><td align="center"><a ng-click="$ctrl.openNewTab(fila)" target="_blank">{{fila.NombreLink}}</a></td></tr></tbody><tbody ng-show="$ctrl.isSolicitudSearching"><tr><td colspan="1" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="10"><div st-template="app/pages/solicitud/pagination.html" st-pagination="" st-items-by-page="$ctrl.itemsByPage" style="display: inline-block;text-align: center;margin: auto;width: 100%;"></div><div class="btn-group pull-right ng-scope"><button type="button" ng-class="{\'active\':$ctrl.itemsByPage==10}" ng-click="$ctrl.itemsByPage=10" class="btn btn-default">10</button> <button type="button" ng-class="{\'active\':$ctrl.itemsByPage==25}" ng-click="$ctrl.itemsByPage=25" class="btn btn-default">25</button> <button type="button" ng-class="{\'active\':$ctrl.itemsByPage==50}" ng-click="$ctrl.itemsByPage=50" class="btn btn-default">50</button></div></td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/solicitud/pagination.html','<div class="pagination" ng-if="pages.length >= 2"><ul class="pagination"><li ng-if="currentPage > 1"><a ng-click="selectPage(1)">Primero</a></li><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a ng-click="selectPage(page)">{{page}}</a></li><li ng-if="currentPage<numPages"><a ng-click="selectPage(numPages)">\xDAltimo</a></li></ul></div>');
$templateCache.put('app/pages/solicitud/procesolist.template.html','<h4>Grupo: {{$ctrl.grupoSeleccionado.Nombre}}</h4><div><div ng-show="$ctrl.anularVista"><h5>Debe seleccionar un grupo de proceso ingresando por la <a href="" ng-click="$ctrl.goHome()">home</a>.</h5></div><div ng-show="!$ctrl.anularVista"><div ng-show="$ctrl.isProcesoSearching"><h5>Cargando...</h5></div><div class="row" ng-show="!$ctrl.isProcesoSearching"><div style="text-align:center" class="col-md-3" ng-repeat="item in $ctrl.procesosList"><div class="home-group-button hvr-float" ng-style="{ \'background-color\': item.ColorFondo }" ng-click="$ctrl.setProcesoSeleccionado(item)"><img src="{{item.UrlImagen}}" ng-show="item.UrlImagen != null || item.UrlImagen.lenght > 0"><br><label ng-style="{ \'color\': item.ColorTexto }">{{item.Nombre}}</label><br><span ng-style="{ \'color\': item.ColorTexto }">{{item.Codigo}}</span></div><br></div></div></div><button class="btn btn-danger" ng-click="$ctrl.goHome()">Volver</button></div>');
$templateCache.put('app/pages/solicitud/template.template.html','<div ba-panel="" ba-panel-title="{{$ctrl.title}}" ba-panel-class="with-scroll"><div class="col-md-12"><div ba-panel="" ba-panel-title="Cabecera" ba-panel-class="with-scroll" ng-show="!$ctrl.anularVista" class="add-top-space" id="cabecera"><label class="col-xs-12 col-md-3 center-label cabeceraLbl"><b>N\xFAmero:</b> {{$ctrl.solicitud.NumeroCompleto}}</label> <label class="col-xs-12 col-md-3 center-label cabeceraLbl"><b>Fecha de Alta:</b> {{$ctrl.solicitud.CreationDate|date:\'dd-MM-yyyy\'}}</label> <label class="col-xs-12 col-md-6 center-label cabeceraLbl"><b>Usuario Solicitante:</b> {{$ctrl.solicitud.UsuarioCreacion.NombreMostrar}}</label> <label class="col-xs-12 col-md-3 center-label cabeceraLbl"><b>Etapa Actual:</b> {{$ctrl.solicitud.SolicitudEtapaNombre}}</label> <label class="col-xs-12 col-md-4 center-label cabeceraLbl"><b>Usuario Etapa Actual:</b> {{$ctrl.solicitud.UsuarioAprobador.NombreMostrar}}</label> <label ng-if="!$ctrl.puedeEditarDescripcion($ctrl.model)" class="col-xs-12 col-md-12 center-label cabeceraLbl"><b>Descripci\xF3n Resumida:</b> {{$ctrl.solicitud.DescripcionResumida}}</label></div><form editable-form="" name="form" novalidate=""><div class="form-group" ng-class="{ \'has-error\': form.name.$invalid && (form.name.$dirty || $ctrl.showError) }"><div ba-panel="" ba-panel-title="Datos de la Carga" ba-panel-class="with-scroll" class="add-top-space" ng-show="!$ctrl.viewLoading"><label class="col-xs-12 col-md-4 center-label" ng-show="!$ctrl.anularVista" style="font-weight:normal"><b>Fecha Modificaci\xF3n:</b> {{$ctrl.camposList[0].LastUpdate|date:\'dd/MM/yyyy HH:mm:ss\'}}</label> <label class="col-xs-12 col-md-4 center-label" ng-show="!$ctrl.anularVista" style="font-weight:normal"><b>Usuario:</b> {{$ctrl.camposList[0].UsuarioModificacion.NombreMostrar}}</label> <label class="col-xs-12 col-md-12 center-label"><b>T\xEDtulo:</b></label> <label class="col-xs-12 col-md-12 center-label" style="font-weight:normal" ng-show="!$ctrl.anularVista" ng-if="$ctrl.soloLectura==1 && $ctrl.camposList[0].SolicitudProcesoTemplate.ProcesoTemplate.Template.ConfiguracionTitulo.length > 0">{{$ctrl.tituloCampoValor}}</label><div class="col-xs-12 col-md-12" ng-show="!$ctrl.anularVista" ng-if="$ctrl.soloLectura==0 && !($ctrl.camposList[0].SolicitudProcesoTemplate.ProcesoTemplate.Template.ConfiguracionTitulo.length > 0)"><input type="text" class="form-control" name="" ng-model="$ctrl.tituloCampoValor"></div></div><div ba-panel="" ba-panel-title="Datos del Proceso..." ba-panel-class="with-scroll" class="add-top-space" ng-show="!$ctrl.viewLoading"><div ng-repeat="item in $ctrl.valoresCampoSolicitudList"><div class="col-md-6" ng-if="item.Campo.CampoTipo.Codigo!=\'JERARQ\' && item.Campo.CampoTipo.Codigo!=\'COND\' && item.Campo.CampoTipo.Codigo!=\'NUMERADOR\' && item.Campo.CampoTipo.Codigo!=\'VERSION\' && item.Campo.CampoTipo.Codigo!=\'TEXTENR\'"><label class="col-xs-6 col-md-6 center-label" ng-if="item.Campo.CampoTipo.Codigo != \'LINK\'" ng-style="$ctrl.styleFontTitle"><b>{{item.Campo.Nombre}}:</b></label><div class="col-md-6"><label class="col-xs-12 col-md-12 center-label">{{item.Valor}}</label></div></div><div class="col-md-3" ng-if="item.Campo.CampoTipo.Codigo==\'VERSION\'"><label class="col-xs-6 col-md-6 center-label" ng-if="item.Campo.CampoTipo.Codigo != \'LINK\'" ng-style="$ctrl.styleFontTitle"><b>{{item.Campo.Nombre}}:</b></label><div class="col-md-6"><label class="col-xs-12 col-md-12 center-label">{{item.Valor}}</label></div></div><div class="col-md-6" ng-if="item.Campo.CampoTipo.Codigo==\'PROCEDURE\'"><label class="col-xs-6 col-md-6 center-label" ng-if="item.Campo.CampoTipo.Codigo != \'LINK\'" ng-style="$ctrl.styleFontTitle"><b>{{item.Campo.Nombre}}:</b></label><div class="col-md-6"><i class="glyphicon glyphicon-cog" style="font-size: 18px;float: left;padding: 9px;"></i><ba-switcher switcher-style="primary" switcher-value="item.Valor" ng-if="item.Campo.runProcedure==\'0\'"></ba-switcher></div></div><div class="col-md-6" ng-if="item.Campo.CampoTipo.Codigo==\'NUMERADOR\'"><label class="col-xs-6 col-md-6 center-label" ng-if="item.Campo.CampoTipo.Codigo != \'LINK\'" ng-style="$ctrl.styleFontTitle"><b>{{item.Campo.Nombre}}:</b></label><div class="col-md-6"><label class="col-xs-12 col-md-12 center-label">{{item.Valor}}</label></div></div><div class="col-md-6" ng-if="item.Campo.CampoTipo.Codigo==\'LINK\'"><label class="col-xs-6 col-md-6 center-label" ng-if="item.Campo.CampoTipo.Codigo != \'LINK\'" ng-style="$ctrl.styleFontTitle"><b>{{item.Campo.Nombre}}:</b></label><div class="col-md-6"><a href="{{item.Valor}}" target="_blank"><button class="col-xs-12 col-sm-3 col-md-3 col-lg-2 btn btn-success pull-right" style="margin-top: 15px;" onclick="$ctrl.openLink(item.Valor);"><span class="glyphicon glyphicon-link" aria-hidden="true"></span> {{item.Campo.Nombre}}</button></a></div></div><div class="col-md-6" ng-if="item.Campo.CampoTipo.Codigo==\'TEXTENR\'"><label class="col-xs-6 col-md-6 center-label" ng-if="item.Campo.CampoTipo.Codigo != \'LINK\'" ng-style="$ctrl.styleFontTitle"><b>{{item.Campo.Nombre}}:</b></label><div class="col-md-6"><wysiwyg textarea-id="{{item.Campo.Id}}" textarea-class="form-control" textarea-height="180px" textarea-name="{{item.Campo.Id}}" textarea-required="" ng-model="item.Valor" enable-bootstrap-title="true"></wysiwyg></div></div><div class="col-md-6" ng-if="item.Campo.CampoTipo.Codigo==\'COND\'"><label class="col-xs-6 col-md-6 center-label" ng-if="item.Campo.CampoTipo.Codigo != \'LINK\'" ng-style="$ctrl.styleFontTitle"><b>{{item.Campo.Nombre}}:</b></label><div><label class="col-xs-12 col-md-12 center-label">{{item.TablaFilas[0].Valor[1]}}</label><div ng-repeat="col in item.Campo.Columnas track by $index"><div class="add-top-space col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo != \'TITLE\'" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="center-label"><b>{{col.ColumnaCampo.Nombre}}:</b></label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'TEXT\' || col.ColumnaCampo.CampoTipo.Codigo==\'TEXTAREA\' || col.ColumnaCampo.CampoTipo.Codigo==\'INT\' || col.ColumnaCampo.CampoTipo.Codigo==\'DECIMAL\'" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><label class="center-label">{{item.TablaFilas[0].Valor[1]}}</label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'DATE\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="center-label">{{item.TablaFilas[0].Valor[1]|date:\'dd-MM-yyyy\'}}</label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'DATETIMEREGIONAL\'" style="margin-bottom:10px; color: #757171;" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="center-label">{{item.TablaFilas[0].Valor[1]|date:\'dd-MM-yyyy\'}}</label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'BOOL\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><input type="checkbox" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" ng-change="$ctrl.onChangeInputTableCond($parent.$parent.$parent.$index, 0, 1,item.TablaFilas[0].Valor[1])" readonly=""></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'ATTACH\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><a href="" ng-click="$ctrl.openAttachment(item.ValorObjeto)">{{item.ValorObjeto}}</a></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'IMG\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><img src="{{$ctrl.imgFile}}{{item.ValorObjeto}}" height="350" width="350" ng-if="item.TablaFilas[0].Valor[1]!=\'\'"></div></div></div></div><div class="col-md-6" ng-if="item.Campo.CampoTipo.Codigo==\'JERARQ\'"><label class="col-xs-6 col-md-6 center-label" ng-if="item.Campo.CampoTipo.Codigo != \'LINK\'" ng-style="$ctrl.styleFontTitle"><b>{{item.Campo.Nombre}}:</b></label><div class="col-md-6"><div ng-repeat="j in item.ValorObjeto"><label class="col-xs-12 col-md-12 center-label tituloTextColor">{{j.Nombre}}</label><div ng-show="j.NoResults"><i class="glyphicon glyphicon-remove"></i> Valor no encontrado</div><div class="col-md-12" ng-show="j.MostrarDetalle" ng-repeat="det in j.Detalles"><label><b>{{det.Titulo}}:</b> {{det.Valor}}</label></div></div></div></div></div></div><uib-tabset active="$ctrl.active"><uib-tab index="0" heading="Campos a Cargar" ng-disabled="true"><div ba-panel="" ba-panel-class="with-scroll" ng-show="$ctrl.anularVista" class="add-top-space"><label class="center-label" ng-show="!$ctrl.viewLoading">{{$ctrl.motivoBloqueo}}</label> <label class="center-label" ng-show="$ctrl.viewLoading">Cargando datos...</label></div><div ba-panel="" ba-panel-class="with-scroll" class="add-top-space" ng-show="!$ctrl.anularVista"><div class="col-md-12" ng-show="$ctrl.isCamposLoading">Cargando...</div><div class="col-md-12" ng-if="$ctrl.verTemplate==false">No permitido.</div><div ng-show="!$ctrl.isCamposLoading" ng-if="$ctrl.soloLectura==0 && $ctrl.verTemplate!=false"><div ng-repeat="item in $ctrl.camposList" style="clear: both;"><div class="col-md-3 center-label cssForCamposLabel" ng-if="item.Campo.CampoTipo.Codigo != \'TITLE\'"><label class="col-md-12 center-label"><b>{{item.Campo.Nombre}}:</b></label></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'PROCEDURE\'"><i class="glyphicon glyphicon-cog" style="font-size: 18px;float: left;padding: 9px;"></i><ba-switcher switcher-style="primary" switcher-value="item.ValorObjeto" ng-if="item.Campo.runProcedure==\'0\'"></ba-switcher></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'TEXT\'"><input type="text" class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto"></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'TEXTAREA\'"><textarea class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" cols="40" rows="5">\r\n                                        </textarea></div><div class="col-md-3" ng-if="item.Campo.CampoTipo.Codigo==\'INT\'"><input type="text" class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" ng-keydown="$ctrl.evaluatenumber($event)" style="text-align:right;" ng-focus="item.ValorObjeto = $ctrl.onNumericInputGotFocus(item.ValorObjeto)" ng-blur="item.ValorObjeto = $ctrl.onNumericInputLostFocus(item.ValorObjeto)"></div><div class="col-md-3" ng-if="item.Campo.CampoTipo.Codigo==\'DECIMAL\'"><input type="text" class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" ng-keydown="$ctrl.evaluatenumberDecimal($event)" maxlength="22" style="text-align:right;" ng-focus="item.ValorObjeto = $ctrl.onNumericInputGotFocus(item.ValorObjeto)" ng-blur="item.ValorObjeto = $ctrl.onNumericInputLostFocus(item.ValorObjeto)"></div><div class="col-md-3" ng-if="item.Campo.CampoTipo.Codigo==\'DATE\'"><input type="date" class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" min="1900-01-01" max="2100-12-31" style="min-height: 35px;"></div><div class="col-md-3" ng-if="item.Campo.CampoTipo.Codigo==\'DATETIMEREGIONAL\'"><input type="text" class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" min="2001-01-01T00:00:00" style="color: #757171;" max="2013-12-31T00:00:00" readonly=""></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'BOOL\'"><ba-switcher switcher-style="primary" switcher-value="item.ValorObjeto"></ba-switcher></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'LIST\'"><select name="{{item.Campo.Id}}" class="form-control" ng-model="item.ValorObjeto" ng-options="j as j.Nombre for j in item.SourceObjeto track by j.Id"></select></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'MULTI_LIST\'"><div class="col-md-6" style="margin-bottom: 10px; margin-left: 2px;"><input type="text" class="form-control" ng-model="item.TextoBusqueda" name="" ng-change="$ctrl.onChangeInputCampostList(item.TextoBusqueda, item)" placeholder="Buscar"></div><ul class="list-group col-md-6"><li class="list-group-item active">Para Seleccionar</li><div style="min-height: 100px; max-height: 190px; overflow-y: auto;"><li multiple="" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" ng-repeat="j in item.SourceObjeto track by j.Id" ng-click="$ctrl.actionAddOnClick(j, item);" style="padding: 2px 2px;" class="list-group-item list-group-item-action"><a class="list-group-item list-group-item-action list-group-item-dark" ng-click="$ctrl.actionAddOnClick(j, item);">{{j.Nombre}}</a></li></div></ul><ul class="list-group col-md-6"><li class="list-group-item active">Seleccionado</li><div style="min-height: 100px; max-height: 190px; overflow-y: auto;"><li multiple="" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" ng-repeat="j in item.ValorObjeto track by j.Id" class="list-group-item list-group-item-action" style="padding: 2px 2px;" ng-click="$ctrl.actionRemoveOnClick(j, item);"><a class="list-group-item list-group-item-action list-group-item-dark">{{j.Nombre}}</a></li></div></ul></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'JERARQ\'"><div ng-repeat="j in item.ValorObjeto"><input type="text" ng-model="j.ValorInput" placeholder="{{j.Placeholder}}" autocomplete="off" uib-typeahead="i as i.Nombre for i in $ctrl.searchJerarquia(j.ValorInput, j.JerarquiaPadreId)" typeahead-wait-ms="500" typeahead-loading="j.LoadingJerarquia" typeahead-no-results="j.NoResults" class="form-control" typeahead-on-select="$ctrl.onSelectJerarquia($parent.$index, $index, $model)"> <i ng-show="j.LoadingJerarquia" class="glyphicon glyphicon-refresh"></i><div ng-show="j.NoResults"><i class="glyphicon glyphicon-remove"></i> Valor no encontrado</div><a href="" class="pull-right" ng-if="item.Campo.PermiteAltaJerarquia" ng-click="$ctrl.altaNuevaJerarquia($parent.$parent.$index, $parent.$index)"><i class="ion-plus-circled"></i></a><div class="col-md-12" ng-show="j.MostrarDetalle" ng-repeat="det in j.Detalles"><label>{{det.Titulo}}: {{det.Valor}}</label></div></div></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'NOTIF\'"><input type="text" class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" required=""> <label class="center-label" style="margin-top:5px"><h6><u>NOTA</u>: para ingresar m\xFAltiples direcciones de mail, separe cada una con punto y coma (;).</h6></label></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'USER\'"><div class="col-md-3"><input type="text" style="width: 195px;" ng-model="$ctrl.usuarioCargado" placeholder="Ingrese un usuario a agregar..." uib-typeahead="i as i.Login for i in $ctrl.searchCampoUsuario($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingUsuario" typeahead-no-results="noResultsUsuario" class="form-control" typeahead-on-select="$ctrl.onSelectUsuarioMultiList($index, $model)"> <i ng-show="loadingUsuario" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsUsuario"><i class="glyphicon glyphicon-remove"></i> Usuario no encontrado</div></div><div class="col-md-9" style="margin-top:5px;margin-bottom:20px"><i class="glyphicon glyphicon-info-sign"></i> <a href="" ng-click="$ctrl.onSelectUsuarioMultiList($index, $ctrl.camposList[0].SolicitudProcesoTemplate.Solicitud.UsuarioCreacion)">Usuario Solicitante: {{$ctrl.camposList[0].SolicitudProcesoTemplate.Solicitud.UsuarioCreacion.NombreMostrar}}</a></div><table class="table" style="margin-bottom: 20px;" st-table="item.ValorObjeto"><thead><tr class="sortable"><th class="text-center">Login</th><th class="text-center">Nombre</th><th class="text-center">Apellido</th><th class="text-center">Acci\xF3n</th></tr></thead><tbody><tr ng-repeat="u in item.ValorObjeto"><td align="center">{{u.Login}}</td><td align="center">{{u.Nombre}}</td><td align="center">{{u.Apellido}}</td><td align="center"><a href="" ng-click="$ctrl.deleteCampoUsuario($parent.$index, u.Id)">Quitar</a></td></tr></tbody></table></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'SOLPROCESOSREL\'" ng-init="$ctrl.initListadoProcesos()"><div class="col-xs-12 col-md-12" style="margin-bottom:20px"><label>Seleccione el proceso:</label><select name="templates" ng-model="$ctrl.procesoSeleccionado" class="form-control" ng-change="$ctrl.onChangeSelectProcesoSeleccionado($ctrl.procesoSeleccionado)" ng-options="item as item.Nombre for item in $ctrl.listadoDeProcesos track by item.Id"></select></div><div class="col-xs-12 col-md-4" style="margin-bottom:20px"><label>Seleccione la solicitud:</label> <input type="text" ng-model="$ctrl.solicitudCargada" placeholder="Ingrese una Solicitud" uib-typeahead="descripcion as solicitud.Descripcion for solicitud in $ctrl.searchCampoSolicitud($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingSolicitud" typeahead-no-results="noResultsSolicitud" class="form-control" typeahead-editable="false" typeahead-on-select="$ctrl.onSelectSolicitudMultiList($index, $item)"> <i ng-show="loadingSolicitud" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsSolicitud"><i class="glyphicon glyphicon-remove"></i> Solicitud no encontrada</div></div><table class="table" st-table="item.ValorObjeto"><thead><tr class="sortable"><th class="text-center">Nombre Proceso</th><th class="text-center">Descripcion Resumida</th><th class="text-center">Numero Completo</th><th class="text-center">LINK</th><th class="text-center">Acci\xF3n</th></tr></thead><tbody><tr ng-repeat="obj in item.ValorObjeto track by $index"><td align="center">{{obj.Proceso.Nombre}}</td><td align="center">{{obj.DescripcionResumida}}</td><td align="center">{{obj.NumeroCompleto}}</td><td align="center"><a href="#/solicitud/edit/{{obj.Id}}/{{obj.Proceso.GrupoId}}/{{obj.Proceso.Id}}/0" target="_blank">Abrir link</a></td><td align="center"><a href="" ng-click="$ctrl.deleteCampoSolicitud($parent.$index, obj.Id)">Quitar</a></td></tr></tbody></table></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'SOLPROCESOSREL_DOCASO\'" ng-init="$ctrl.initListadoProcesos_doc()"><div class="col-xs-12 col-md-12" style="margin-bottom:20px"><label>Seleccione el proceso:</label><select name="templates" ng-model="$ctrl.procesoSeleccionado_doc" class="form-control" ng-change="$ctrl.onChangeSelectProcesoSeleccionado_doc($ctrl.procesoSeleccionado_doc)" ng-options="item as item.Nombre for item in $ctrl.listadoDeProcesos_doc track by item.Id"></select></div><div class="col-xs-12 col-md-4" style="margin-bottom:20px"><label>Seleccione la solicitud:</label> <input type="text" ng-model="$ctrl.solicitudCargada_doc" placeholder="Ingrese una Solicitud" uib-typeahead="descripcion as solicitud.Descripcion for solicitud in $ctrl.searchCampoSolicitud_doc($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingSolicitud" typeahead-no-results="noResultsSolicitud" class="form-control" typeahead-editable="false" typeahead-on-select="$ctrl.onSelectSolicitudMultiList_doc($index, $item)"> <i ng-show="loadingSolicitud" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsSolicitud"><i class="glyphicon glyphicon-remove"></i> Solicitud no encontrada</div></div><table class="table" st-table="item.ValorObjeto"><thead><tr class="sortable"><th class="text-center">Nombre Proceso</th><th class="text-center">Descripcion Resumida</th><th class="text-center">Numero Completo</th><th class="text-center">LINK</th><th class="text-center">Acci\xF3n</th></tr></thead><tbody><tr ng-repeat="obj in item.ValorObjeto track by $index"><td align="center">{{obj.Proceso.Nombre}}</td><td align="center">{{obj.DescripcionResumida}}</td><td align="center">{{obj.NumeroCompleto}}</td><td align="center"><a href="#/solicitud/edit/{{obj.Id}}/{{obj.Proceso.GrupoId}}/{{obj.Proceso.Id}}/0" target="_blank">Abrir link</a></td><td align="center"><a href="" ng-click="$ctrl.deleteCampoSolicitud($parent.$index, obj.Id)">Quitar</a></td></tr></tbody></table></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'ATTACH\'"><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item)" ng-disabled="$ctrl.isBusy">Seleccionar</div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment(item)" ng-disabled="$ctrl.isBusy">Eliminar</div><a href="" ng-click="$ctrl.openAttachment(item.ValorObjeto)">{{item.ValorObjeto}}</a><p ng-show="item.isLoading">Cargando archivo...</p></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'IMG\'"><img src="{{$ctrl.imgFile}}{{item.ValorObjeto}}" height="350" width="350" ng-if="item.ValorObjeto!=\'\'"><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item)" ngf-accept="\'image/*\'" ng-disabled="$ctrl.isBusy">Seleccionar</div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment(item)" ng-disabled="$ctrl.isBusy">Eliminar</div><p ng-show="item.isLoading">Cargando Imagen...</p></div><div class="col-md-3" ng-if="item.Campo.CampoTipo.Codigo==\'VERSION\' && $ctrl.model.Estado.Codigo==\'ALTA\'"><input type="number" min="0" pattern="[0-9]*" ng-keydown="$ctrl.evaluatenumberDigit($event)" class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto"></div><div class="col-md-3" ng-if="item.Campo.CampoTipo.Codigo==\'VERSION\' && $ctrl.model.Estado.Codigo!=\'ALTA\'"><inputtype="number" class="col-md-3" min="0" pattern="[0-9]*" ng-keydown="$ctrl.evaluatenumberDigit($event)" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" readonly=""></inputtype="number"></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'NUMERADOR\'"><input type="text" class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" readonly=""></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'LINK\'"><a href="{{item.ValorObjeto}}" target="_blank"><button class="col-xs-12 col-sm-3 col-md-3 col-lg-2 btn btn-success pull-right" style="margin-top: 15px;" ng-click="$ctrl.openLink(item.ValorObjeto);"><span class="glyphicon glyphicon-link" aria-hidden="true"></span> {{item.Campo.Nombre}}</button></a></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'TEXTENR\'"><wysiwyg textarea-id="{{item.Campo.Id}}" textarea-class="form-control" textarea-height="180px" textarea-name="{{item.Campo.Id}}" textarea-required="" ng-model="item.ValorObjeto" enable-bootstrap-title="true"></wysiwyg></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'COND\'"><select name="{{item.Campo.Id}}" class="form-control" ng-model="item.TablaFilas[0].Valor[0]" ng-options="j.condicion as j.condicion for j in item.Campo.Columnas" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></select></div><div ng-if="item.Campo.CampoTipo.Codigo==\'COND\'"><div ng-repeat="col in item.Campo.Columnas track by $index"><div class="add-top-space col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo != \'TITLE\'" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="center-label">{{col.ColumnaCampo.Nombre}}:</label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'TEXT\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><input type="text" class="form-control" name="TEXT" ng-model="item.TablaFilas[0].Valor[1]" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'TEXTAREA\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><textarea class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" cols="40" rows="5" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)">\r\n                                                </textarea></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'DECIMAL\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><input type="text" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" maxlength="22" style="text-align:right;"></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'INT\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><input type="text" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" style="text-align:right;" maxlength="22" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)" ng-keydown="$ctrl.evaluatenumber($event)" ng-focus="item.TablaFilas[0].Valor[1] = $ctrl.onNumericInputGotFocus(item.TablaFilas[0].Valor[1])" ng-blur="item.TablaFilas[0].Valor[1] = $ctrl.onNumericInputLostFocus(item.TablaFilas[0].Valor[1])"></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'DATE\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><input type="date" class="form-control" name="{{item.Campo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" min="1900-01-01" max="2100-12-31" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'DATETIMEREGIONAL\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><input type="text" class="form-control" name="{{item.Campo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" readonly="" style="color: #757171;" ng-change="$ctrl.onChangeInputTableCond($parent.$parent.$parent.$index, 0, 1,item.TablaFilas[0].Valor[1])"></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'BOOL\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><input type="checkbox" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'ATTACH\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><a href="" ng-click="$ctrl.openAttachment(item.TablaFilas[0].Valor[1])">{{item.TablaFilas[0].Valor[1]}}</a><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item)" ng-disabled="$ctrl.isBusy">Seleccionar</div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment(item)" ng-disabled="$ctrl.isBusy">Eliminar</div></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'IMG\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><img src="{{$ctrl.imgFile}}{{item.TablaFilas[0].Valor[1]}}" height="350" width="350" ng-if="item.TablaFilas[0].Valor[1]!=\'\'"><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item)" ngf-accept="\'image/*\'" accept="image/*" ng-disabled="$ctrl.isBusy">Seleccionar</div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment(item)" ng-disabled="$ctrl.isBusy">Eliminar</div><p ng-show="item.isLoading">Cargando Imagen...</p></div></div></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'TEMPLATE\'"><select name="{{item.Campo.Id}}" class="form-control" ng-model="item.ValorObjeto" ng-options="t as t.Template.Nombre for t in item.SourceObjeto track by t.Id"></select></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'TITLE\'" style="text-align: center;"><h3 class="campo-title">{{item.Campo.Nombre}}</h3></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'PERIODO\'"><select name="{{item.Campo.Id}}" class="form-control" ng-model="item.ValorObjeto" ng-options="j as j.Nombre for j in item.SourceObjeto track by j.Id"></select></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'TABLE\'"><table class="table campo-tabla"><thead><tr class="sortable center-label"><th class="text-center" ng-repeat="col in item.Campo.Columnas">{{col.ColumnaCampo.Nombre}}</th></tr></thead><tbody><tr ng-repeat="fila in item.TablaFilas"><td align="center" ng-repeat="colValor in fila.Valor track by $index"><div ng-if="$index==0 && !item.Campo.permiteEditarColumna" id="no_permite_editar_columna"><div class="col-md-12" style="margin-bottom:10px"><label class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}">{{colValor}}</label></div></div><div id="permite_editar_columna" ng-if="$index==0 && item.Campo.permiteEditarColumna"><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'TEXT\'" style="margin-bottom:10px"><input type="text" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'TEXTAREA\'" style="margin-bottom:10px"><textarea class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" cols="40" rows="5" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)">\r\n                                                                    </textarea></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'INT\'" style="margin-bottom:10px"><input type="text" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" style="text-align:right;" maxlength="22" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)" ng-keydown="$ctrl.evaluatenumber($event)" ng-focus="colValor = $ctrl.onNumericInputGotFocus(colValor)" ng-blur="colValor = $ctrl.onNumericInputLostFocus(colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DECIMAL\'" style="margin-bottom:10px"><input type="text" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" maxlength="22" style="text-align:right;" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)" ng-keydown="$ctrl.evaluatenumberDecimal($event)" ng-focus="colValor = $ctrl.onNumericInputGotFocus(colValor)" ng-blur="colValor = $ctrl.onNumericInputLostFocus(colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DATE\'" style="margin-bottom:10px"><input type="date" class="form-control" name="{{item.Campo.Id}}" ng-model="colValor" min="1900-01-01" max="2100-12-31" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DATETIMEREGIONAL\'" style="margin-bottom:10px"><input type="text" class="form-control" name="{{item.Campo.Id}}" ng-model="colValor" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" readonly="" style="color: #757171;" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'BOOL\'" style="margin-bottom:10px"><input type="checkbox" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'ATTACH\'" style="margin-bottom:10px"><a href="" ng-click="$ctrl.openAttachment(colValor)">{{colValor}}</a><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item)" ng-disabled="$ctrl.isBusy">Seleccionar</div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment(item)" ng-disabled="$ctrl.isBusy">Eliminar</div></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'IMG\'" style="margin-bottom:10px"><img src="{{$ctrl.imgFile}}{{colValor}}" height="350" width="350" ng-if="colValor!=\'\'"><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item)" ngf-accept="\'image/*\'" accept="image/*" ng-disabled="$ctrl.isBusy">Seleccionar</div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment(item)" ng-disabled="$ctrl.isBusy">Eliminar</div><p ng-show="item.isLoading">Cargando Imagen...</p></div></div><div id="permite_editar_columna" ng-if="$index!=0"><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'TEXT\'" style="margin-bottom:10px"><input type="text" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'TEXTAREA\'" style="margin-bottom:10px"><textarea class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" cols="40" rows="5" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)">\r\n                                                                    </textarea></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'INT\'" style="margin-bottom:10px"><input type="text" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" style="text-align:right;" maxlength="22" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)" ng-keydown="$ctrl.evaluatenumber($event)" ng-focus="colValor = $ctrl.onNumericInputGotFocus(colValor)" ng-blur="colValor = $ctrl.onNumericInputLostFocus(colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DECIMAL\'" style="margin-bottom:10px"><input type="text" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" maxlength="22" style="text-align:right;" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)" ng-keydown="$ctrl.evaluatenumberDecimal($event)" ng-focus="colValor = $ctrl.onNumericInputGotFocus(colValor)" ng-blur="colValor = $ctrl.onNumericInputLostFocus(colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DATE\'" style="margin-bottom:10px"><input type="date" class="form-control" name="{{item.Campo.Id}}" ng-model="colValor" min="1900-01-01" max="2100-12-31" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DATETIMEREGIONAL\'" style="margin-bottom:10px"><input type="text" class="form-control" name="{{item.Campo.Id}}" ng-model="colValor" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" readonly="" style="color: #757171;" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'BOOL\'" style="margin-bottom:10px"><input type="checkbox" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'ATTACH\'" style="margin-bottom:10px"><a href="" ng-click="$ctrl.openAttachment(colValor)">{{colValor}}</a><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item)" ng-disabled="$ctrl.isBusy">Seleccionar</div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment(item)" ng-disabled="$ctrl.isBusy">Eliminar</div></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'IMG\'" style="margin-bottom:10px"><img src="{{$ctrl.imgFile}}{{colValor}}" height="350" width="350" ng-if="colValor!=\'\'"><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item)" ngf-accept="\'image/*\'" accept="image/*" ng-disabled="$ctrl.isBusy">Seleccionar</div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment(item)" ng-disabled="$ctrl.isBusy">Eliminar</div><p ng-show="item.isLoading">Cargando Imagen...</p></div></div></td></tr></tbody></table></div><br><div style="clear: both;"></div></div></div><div ng-show="!$ctrl.isCamposLoading" ng-if="$ctrl.soloLectura==1 && $ctrl.verTemplate==true"><div ng-repeat="item in $ctrl.camposList" style="margin-bottom: 2px;"><div class="col-md-3 center-label cssForCamposLabel" ng-if="item.Campo.CampoTipo.Codigo != \'TITLE\'"><label class="col-md-12 center-label"><b>{{item.Campo.Nombre}}</b></label></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'TITLE\'" style="text-align: center;"><h3 class="campo-title">{{item.Campo.Nombre}}</h3></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'TEXTAREA\'" style="display: inline;"><label class="col-md-9 center-label" style="font-weight:normal; font-weight: normal;margin-left: 0px;padding-left: 0px;">{{item.Valor}}</label></div><div ng-if="item.Campo.CampoTipo.Codigo==\'DATE\'" style="display: inline;"><label class="col-md-3 center-label">{{item.Valor | date:\'dd/MM/yyyy\'}}</label></div><div ng-if="item.Campo.CampoTipo.Codigo==\'ATTACH\' && item.Valor != \'\'" style="display: inline;"><a class="col-md-9" href="" ng-click="$ctrl.openAttachment(item.Valor)">Documento</a></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'IMG\'" style="display: inline;"><img src="{{$ctrl.imgFile}}{{item.Valor}}" height="350" width="350" ng-if="item.Valor!=\'\'"></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'NUMERADOR\'" style="display: inline;"><label class="col-md-9 center-label" style="font-weight:normal">{{item.Valor}}</label></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'LINK\'" style="display: inline;"><a href="{{item.ValorObjeto}}" target="_blank"><button class="col-xs-12 col-sm-3 col-md-3 col-lg-2 btn btn-success pull-right" style="margin-top: 15px;" ng-click="$ctrl.openLink(item.ValorObjeto);"><span class="glyphicon glyphicon-link" aria-hidden="true"></span> {{item.Campo.Nombre}}</button></a></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'TEXTENR\'" style="display: inline;"><div ng-bind-html="item.Valor"></div></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'PROCEDURE\'"><i class="glyphicon glyphicon-cog" style="font-size: 18px;float: left;padding: 9px;"></i></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'COND\'" style="display: inline;"><input type="text" style="color:black" class="form-control" name="{{item.Campo.Id}}" ng-model="item.TablaFilas[0].Valor[0]" readonly=""></div><div ng-if="item.Campo.CampoTipo.Codigo==\'COND\'"><div ng-repeat="col in item.Campo.Columnas track by $index"><div class="add-top-space col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo != \'TITLE\'" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="center-label">{{col.ColumnaCampo.Nombre}}:</label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'TEXT\'" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><input type="text" style="color:black" class="form-control" name="{{item.Campo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" readonly=""></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'TEXTAREA\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="center-label" style="font-weight:normal">{{item.TablaFilas[0].Valor[1]}}</label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'INT\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="center-label" style="font-weight:normal">{{item.TablaFilas[0].Valor[1]}}</label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'DECIMAL\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="center-label" style="font-weight:normal">{{item.TablaFilas[0].Valor[1]}}</label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'DATE\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="col-md-12 center-label" style="font-weight:normal">{{item.TablaFilas[0].Valor[1] | date:\'dd/MM/yyyy\'}}</label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'DATETIMEREGIONAL\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="col-md-12 center-label" style="font-weight:normal">{{item.TablaFilas[0].Valor[1] | date:\'dd/MM/yyyy\'}}</label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'BOOL\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><input type="checkbox" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" readonly=""></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'ATTACH\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><a href="" ng-click="$ctrl.openAttachment(item.TablaFilas[0].Valor[1])">{{item.TablaFilas[0].Valor[1]}}</a><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item)" ng-disabled="$ctrl.isBusy"></div></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'IMG\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><img src="{{$ctrl.imgFile}}{{item.TablaFilas[0].Valor[1]}}" height="350" width="350" ng-if="item.TablaFilas[0].Valor[1]!=\'\'"></div></div></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'JERARQ\'" style="display: inline;"><div style="font-family:inherit; color:black; -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */ -moz-box-sizing: border-box; /* Firefox, other Gecko */ box-sizing: border-box; /* Opera/IE 8+ */ padding:1%; border:none; padding-left: 0px; padding-top: 0px;"><div ng-repeat="j in item.ValorObjeto"><label class="center-label" style="font-weight:normal; margin: 2px;">{{j.ValorInput}}</label><div class="col-md-12" ng-show="j.MostrarDetalle" ng-repeat="det in j.Detalles" style="display: inline;"><label>{{det.Titulo}}: {{det.Valor}}</label></div></div></div></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'SOLPROCESOSREL\'" style="display: inline;"><table class="table" st-table="item.ValorObjeto"><thead><tr class="sortable"><th class="text-center">Nombre Proceso</th><th class="text-center">Descripcion Resumida</th><th class="text-center">Numero Completo</th><th class="text-center">LINK</th><th class="text-center">Acci\xF3n</th></tr></thead><tbody><tr ng-repeat="obj in item.ValorObjeto track by $index"><td align="center">{{obj.Proceso.Nombre}}</td><td align="center">{{obj.DescripcionResumida}}</td><td align="center">{{obj.NumeroCompleto}}</td><td align="center"><a href="#/solicitud/edit/{{obj.Id}}/{{obj.Proceso.GrupoId}}/{{obj.Proceso.Id}}/0" target="_blank">Abrir link</a></td><td align="center"></td></tr></tbody></table></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'SOLPROCESOSREL_DOCASO\'" style="display: inline;"><table class="table" st-table="item.ValorObjeto"><thead><tr class="sortable"><th class="text-center">Nombre Proceso</th><th class="text-center">Descripcion Resumida</th><th class="text-center">Numero Completo</th><th class="text-center">LINK</th><th class="text-center">Acci\xF3n</th></tr></thead><tbody><tr ng-repeat="obj in item.ValorObjeto track by $index"><td align="center">{{obj.Proceso.Nombre}}</td><td align="center">{{obj.DescripcionResumida}}</td><td align="center">{{obj.NumeroCompleto}}</td><td align="center"><a href="#/solicitud/edit/{{obj.Id}}/{{obj.Proceso.GrupoId}}/{{obj.Proceso.Id}}/0" target="_blank">Abrir link</a></td><td align="center"></td></tr></tbody></table></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'MULTI_LIST\'" style="display: inline;"><ul class="list-group col-md-12" style="margin-bottom: 2px;"><div style="min-height: 100px; overflow-y: auto;"><li multiple="" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" ng-repeat="j in item.ValorObjeto track by j.Id" class="list-group-item list-group-item-action">{{j.Nombre}}</li></div></ul></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'TABLE\'"><table class="table"><thead><tr class="sortable center-label"><th class="text-center" ng-repeat="col in item.Campo.Columnas">{{col.ColumnaCampo.Nombre}}</th></tr></thead><tbody><tr ng-repeat="fila in item.TablaFilas"><td align="center" ng-repeat="colValor in fila.Valor track by $index"><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo!=\'TEXTAREA\' && item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo!=\'DATE\' && item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo!=\'ATTACH\' && item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo!=\'INT\' && item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo!=\'DECIMAL\'">{{colValor}}</div><div ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'INT\' || item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DECIMAL\'" align="right">{{colValor}}</div><div class="col-md-12" ng-if="colValor!=\'null\' && item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'ATTACH\'" style="margin-bottom:10px"><a class="col-md-12" href="" style="font-weight:normal" ng-click="$ctrl.openAttachment(colValor)">{{colValor}}</a></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'IMG\'" style="margin-bottom:10px"><img src="{{$ctrl.imgFile}}{{colValor}}" height="350" width="350" ng-if="colValor!=\'\'"></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'TEXTENR\'"><wysiwyg textarea-id="{{item.Campo.Id}}" textarea-class="form-control" textarea-height="180px" textarea-name="{{item.Campo.Id}}" textarea-required="" ng-model="colValor" enable-bootstrap-title="true"></wysiwyg></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'COND\'"><label class="center-label" style="font-weight:normal">{{item.TablaFilas[0].Valor[0]}}</label></div><div ng-if="item.Campo.CampoTipo.Codigo==\'COND\'"><div ng-repeat="col in item.Campo.Columnas track by $index"><div class="add-top-space col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo != \'TITLE\'" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="center-label">{{col.ColumnaCampo.Nombre}}:</label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'TEXT\'" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><label class="center-label" style="font-weight:normal">{{item.TablaFilas[0].Valor[1]}}</label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'TEXTAREA\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="center-label" style="font-weight:normal">{{item.TablaFilas[0].Valor[1]}}</label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'INT\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="center-label" style="font-weight:normal">{{item.TablaFilas[0].Valor[1]}}</label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'DECIMAL\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="center-label" style="font-weight:normal">{{item.TablaFilas[0].Valor[1]}}</label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'DATE\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="col-md-12 center-label" style="font-weight:normal">{{item.TablaFilas[0].Valor[1] | date:\'dd/MM/yyyy\'}}</label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'DATETIMEREGIONAL\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="col-md-12 center-label" style="font-weight:normal">{{item.TablaFilas[0].Valor[1] | date:\'dd/MM/yyyy\'}}</label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'BOOL\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><input type="checkbox" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" readonly=""></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'ATTACH\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><a href="" ng-click="$ctrl.openAttachment(item.TablaFilas[0].Valor[1])">{{item.TablaFilas[0].Valor[1]}}</a><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item)" ng-disabled="$ctrl.isBusy"></div></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'IMG\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><img src="{{$ctrl.imgFile}}{{item.TablaFilas[0].Valor[1]}}" height="350" width="350" ng-if="item.TablaFilas[0].Valor[1]!=\'\'"></div></div></div><div ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'TEXTAREA\'"><pre class="col-md-12" style="background: transparent; border: transparent; font-family:inherit">{{colValor}}</pre></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DATE\'" style="margin-bottom:10px"><input type="date" class="form-control" name="{{item.Campo.Id}}" ng-model="colValor" min="1900-01-01" max="2100-12-31" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$index,$parent.$parent.$index,$parent.$index,colValor)" readonly=""></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DATETIMEREGIONAL\'" style="margin-bottom:10px"><input type="text" class="form-control" name="{{item.Campo.Id}}" ng-model="colValor" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" readonly="" style="color: #757171;" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$index,$parent.$parent.$index,$parent.$index,colValor)"></div></td></tr></tbody></table></div><div ng-if="item.Campo.CampoTipo.Codigo!==\'TABLE\' && item.Campo.CampoTipo.Codigo!==\'TEXTAREA\' && item.Campo.CampoTipo.Codigo!==\'DATE\' && item.Campo.CampoTipo.Codigo!==\'ATTACH\' && item.Campo.CampoTipo.Codigo!==\'COND\' && item.Campo.CampoTipo.Codigo!==\'JERARQ\' && item.Campo.CampoTipo.Codigo!==\'TEXTENR\' && item.Campo.CampoTipo.Codigo!==\'SOLPROCESOSREL\' && item.Campo.CampoTipo.Codigo!==\'SOLPROCESOSREL_DOCASO\' && item.Campo.CampoTipo.Codigo!==\'NUMERADOR\' && item.Campo.CampoTipo.Codigo!==\'PROCEDURE\' && item.Campo.CampoTipo.Codigo!==\'LINK\' && item.Campo.CampoTipo.Codigo!==\'TITLE\' && item.Campo.CampoTipo.Codigo!==\'IMG\' && item.Campo.CampoTipo.Codigo!==\'MULTI_LIST\'" style="display: inline;"><label class="col-md-9 center-label" style="font-weight:normal">{{item.Valor}}</label></div><div style="clear: both;"></div></div></div><div class="add-top-space col-md-12" ng-if="$ctrl.solicitudHasProceduresField"><label class="center-label">Desea generar automaticamente todos los procesos relacionados?:</label></div><div class="col-md-12" ng-if="$ctrl.solicitudHasProceduresField"><ba-switcher switcher-style="primary" switcher-value="$ctrl.generaProcesoRelacionados"></ba-switcher></div></div></uib-tab><uib-tab index="1" heading="Notificaciones" ng-disabled="true" ng-if="$ctrl.soloLectura==0" ng-show="!$ctrl.anularVista"><div ba-panel="" ba-panel-title="Mensaje de la Notificaci\xF3n" ba-panel-class="with-scroll"><textarea class="form-control" name="" ng-model="$ctrl.mensajeNotificacion" placeholder="Escriba el mensaje que ser\xE1 entregado con la notificaci\xF3n..." cols="40" rows="5">\r\n                            </textarea></div><div ba-panel="" ba-panel-title="Usuarios del Proceso Disponibles para ser Notificados" ba-panel-class="with-scroll"><table class="table" st-table="$ctrl.procesoUsuariosDS" st-safe-src="$ctrl.procesoUsuariosList"><thead><tr class="sortable"><th class="text-center" st-sort="Usuario.Login">Usuario</th><th class="text-center" st-sort="Usuario.Nombre">Nombre</th><th class="text-center" st-sort="Usuario.Apellido">Apellido</th><th class="text-center">Rol</th><th class="text-center">Acci\xF3n</th></tr><tr><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Usuario.Login" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por usuario" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Usuario.Nombre" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por nombre" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Usuario.Apellido" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por apellido" aria-describedby="basic-addon1"></div></th><th></th><th></th></tr></thead><tbody ng-show="!$ctrl.isProcesoUsuarioSearching"><tr ng-repeat="item in $ctrl.procesoUsuariosDS" ng-click="$ctrl.addUsuarioNotificar(item)" style="cursor: pointer"><td align="center">{{item.Usuario.Login}}</td><td align="center">{{item.Usuario.Nombre}}</td><td align="center">{{item.Usuario.Apellido}}</td><td align="center">{{$ctrl.concatRolesString(item.RolProcesoList)}}</td><td align="center"><a href="" ng-click="$ctrl.addUsuarioNotificar(item)">Notificar</a></td></tr></tbody><tbody ng-show="$ctrl.isProcesoUsuarioSearching"><tr><td colspan="5" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="5" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table></div><div ba-panel="" ba-panel-title="Usuarios a Notificar" ba-panel-class="with-scroll"><table class="table" st-table="$ctrl.procesoUsuariosNotifcarDS" st-safe-src="$ctrl.procesoUsuariosNotificarList"><thead><tr class="sortable"><th class="text-center" st-sort="Usuario.Login">Usuario</th><th class="text-center" st-sort="Usuario.Nombre">Nombre</th><th class="text-center" st-sort="Usuario.Apellido">Apellido</th><th class="text-center">Rol</th><th class="text-center">Acci\xF3n</th></tr><tr><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Usuario.Login" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por usuario" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Usuario.Nombre" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por nombre" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Usuario.Apellido" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por apellido" aria-describedby="basic-addon1"></div></th><th></th><th></th></tr></thead><tbody ng-show="!$ctrl.isProcesoUsuarioSearching"><tr ng-repeat="item in $ctrl.procesoUsuariosNotificarDS"><td align="center">{{item.Usuario.Login}}</td><td align="center">{{item.Usuario.Nombre}}</td><td align="center">{{item.Usuario.Apellido}}</td><td align="center">{{$ctrl.concatRolesString(item.RolProcesoList)}}</td><td align="center"><a href="" ng-click="$ctrl.removeUsuarioNotificar($index)">Eliminar</a></td></tr></tbody><tbody ng-show="$ctrl.isProcesoUsuarioSearching"><tr><td colspan="5" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="5" class="text-center"><div st-pagination="" st-items-by-page="50" st-displayed-pages="5"></div></td></tr></tfoot></table></div><div ba-panel="" ba-panel-title="Destinatarios Externos" ba-panel-class="with-scroll"><input type="text" class="form-control" name="" ng-model="$ctrl.mailsAdicionales"> <label class="center-label" style="margin-top:5px"><h6><u>NOTA</u>: para ingresar m\xFAltiples direcciones de mail, separe cada una con punto y coma (;).</h6></label></div></uib-tab><uib-tab index="3" heading="Autorizaci\xF3n A" ng-disabled="true" ng-if="$ctrl.soloLectura==0 && $ctrl.solicitudProcesoTemplateId!=0 && $ctrl.allowToAutoriceA" ng-show="!$ctrl.anularVista"><div ba-panel="" ba-panel-title="Mensaje de la Autorizaci\xF3n" ba-panel-class="with-scroll"><div class="col-md-12"><label class="col-md-12 center-label">Comentarios*:</label><div class="col-md-12"><input type="text" class="form-control" ng-model="$ctrl.AutorizarMsg" name="" required=""></div><div class="col-md-12"><button class="btn btn-success pull-right col-md-2" ng-click="$ctrl.AutorizarActionTemplate(1)" ng-disabled="$ctrl.isBusy" style="margin-left: 2px;font-size: 15px; margin-top: 8px;"><span class="glyphicon glyphicon-ok" aria-hidden="true"></span> Autorizar</button></div></div></div></uib-tab><uib-tab index="2" heading="Autorizaci\xF3n B" ng-disabled="true" ng-if="$ctrl.soloLectura==0 && $ctrl.solicitudProcesoTemplateId!=0 && $ctrl.allowToAutoriceB" ng-show="!$ctrl.anularVista"><div ba-panel="" ba-panel-title="Mensaje de la Autorizaci\xF3n" ba-panel-class="with-scroll"><div class="col-md-12"><label class="col-md-12 center-label">Comentarios*:</label><div class="col-md-12"><input type="text" class="form-control" ng-model="$ctrl.AutorizarMsg" name="" required=""></div><div class="col-md-12"><button class="btn btn-success pull-right col-md-2" ng-click="$ctrl.AutorizarActionTemplate(0)" ng-disabled="$ctrl.isBusy" style="margin-left: 2px;font-size: 15px; margin-top: 8px;"><span class="glyphicon glyphicon-ok" aria-hidden="true"></span> Autorizar</button></div></div></div></uib-tab></uib-tabset></div></form></div><div class="col-md-12"><button class="btn btn-success" ng-show="$ctrl.soloLectura==0 && !$ctrl.anularVista" ng-click="$ctrl.save(form)" ng-disabled="$ctrl.isBusy">Guardar</button> <button class="btn btn-danger" ng-click="$ctrl.cancel()" ng-disabled="$ctrl.isBusy">Cerrar</button> <button class="btn btn-danger pull-right" ng-click="$ctrl.delete()" ng-disabled="$ctrl.isBusy" ng-show="$ctrl.puedeBorrarTemplate && !$ctrl.anularVista">Borrar Gesti\xF3n</button> <button class="btn btn-success" ng-show="$ctrl.showBtnLink" ng-disabled="$ctrl.isBusy" ng-click="$ctrl.openLinkTemplate()"><span class="glyphicon glyphicon-link" aria-hidden="true"></span> {{$ctrl.LinkTemplate.TipoCampo}}</button></div></div>');
$templateCache.put('app/pages/template/edit.template.html','<div ba-panel="" ba-panel-title="{{$ctrl.title}}" ba-panel-class="with-scroll"><form editable-form="" name="form" novalidate=""><div class="form-group" ng-class="{ \'has-error\': form.name.$invalid && (form.name.$dirty || $ctrl.showError) }"><uib-tabset active="$ctrl.active"><uib-tab index="0" heading="Datos del Template" ng-disabled="true"><div ba-panel="" ba-panel-class="with-scroll" class="add-top-space"><label class="col-md-2 center-label">C\xF3digo*:</label><div class="col-md-4"><input type="text" class="form-control" ng-model="$ctrl.model.Codigo" name="" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el c\xF3digo.</span></div></div><label class="col-md-2 center-label">Nombre*:</label><div class="col-md-4"><input type="text" class="form-control" ng-model="$ctrl.model.Nombre" name="" placeholder="" required="" ng-change="$ctrl.actualizarTitulo()"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el nombre.</span></div></div><label class="col-md-2 center-label">Activo*:</label><div class="col-md-4"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.Activo"></ba-switcher></div><label class="col-md-2 center-label">Permite Editar*:</label><div class="col-md-04"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.PermiteEditarTemplate"></ba-switcher></div><label class="col-md-12 center-label">Configuraci\xF3n de T\xEDtulo: <a href="" style="margin-left:5px" ng-click="$ctrl.showTituloConfigText = !$ctrl.showTituloConfigText"><i class="fa fa-eye"></i></a></label><div class="col-md-12" ng-show="!$ctrl.showTituloConfigText"><input type="text" class="form-control" ng-model="$ctrl.model.ConfiguracionTitulo" placeholder="" id="configuracionTitulo" ng-change="$ctrl.actualizarTituloConfigText()" ng-model-options="{ debounce: 1500 }"></div><label class="col-md-12 center-label" ng-show="$ctrl.showTituloConfigText" style="margin-top: 0px">{{$ctrl.configuracionTituloText}}</label><div class="col-md-12" style="margin-top:5px"><a href="" ng-click="$ctrl.buscarCampoTitulo(!$ctrl.showCampoTituloSelect)"><i class="ion-ios-search-strong"></i> Incluir campo del template</a></div><div class="col-md-12"><div class="col-md-6" style="margin-top:10px"><input type="checkbox" ng-model="$ctrl.model.tieneAutorizacionA" name="" ng-disabled="$ctrl.isBusy"> Tiene Autorizaci\xF3n A</div><div ng-show="$ctrl.model.tieneAutorizacionA"><label class="col-md-2 center-label">Autorizaci\xF3n A:</label><div class="col-md-4"><select name="grupo" class="form-control" ng-model="$ctrl.model.gUsuariosAutorizaA" ng-options="item.Id as item.Nombre for item in $ctrl.GruposUsuariosList"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un grupo.</span></div></div></div></div><div class="col-md-12"><div class="col-md-6" style="margin-top:10px"><input type="checkbox" ng-model="$ctrl.model.tieneAutorizacionB" name="" ng-disabled="$ctrl.isBusy"> Tiene Autorizaci\xF3n B</div><div ng-show="$ctrl.model.tieneAutorizacionB"><label class="col-md-2 center-label">Autorizaci\xF3n B:</label><div class="col-md-4"><select name="grupo" class="form-control" ng-model="$ctrl.model.gUsuariosAutorizaB" ng-options="item.Id as item.Nombre for item in $ctrl.GruposUsuariosList"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un grupo.</span></div></div></div></div><div class="col-md-4" ng-show="$ctrl.showCampoTituloSelect"><select name="" class="form-control" ng-model="$ctrl.campoTituloSeleccionado" ng-options="item as item.Campo.Nombre for item in $ctrl.templateCamposList track by item.Campo.Id" ng-change="$ctrl.onSelectCampoTitulo($ctrl.campoTituloSeleccionado)"><option value="" disabled="" selected="">Seleccione un campo...</option></select></div></div><div ba-panel="" ba-panel-title="Grupo de Usuarios" ba-panel-class="with-scroll"><div class="col-md-12" style="margin-top:10px"><label class="col-md-2 center-label">Creaci\xF3n:</label><div class="col-md-4"><select name="grupo" class="form-control" ng-model="$ctrl.model.gUsuariosCreacion" ng-options="item.Id as item.Nombre for item in $ctrl.GruposUsuariosList"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un grupo.</span></div></div><label class="col-md-2 center-label">Lectura:</label><div class="col-md-4"><select name="grupo" class="form-control" ng-model="$ctrl.model.gUsuariosLectores" ng-options="item.Id as item.Nombre for item in $ctrl.GruposUsuariosList"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un grupo.</span></div></div></div><div class="col-md-12" style="margin-top:10px"><label class="col-md-2 center-label">Notificaci\xF3n:</label><div class="col-md-4"><select name="grupo" class="form-control" ng-model="$ctrl.model.gUsuariosNotificacion" ng-options="item.Id as item.Nombre for item in $ctrl.GruposUsuariosList"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un grupo.</span></div></div></div></div></uib-tab><uib-tab index="1" heading="Campos de Template" ng-disabled="true"><div ba-panel="" ba-panel-title="Datos del Campo" ba-panel-class="with-scroll" class="add-top-space"><label class="col-md-2 center-label">Campo*:</label><div class="col-md-4"><select name="" ng-model="$ctrl.campoCargado.Campo" class="form-control" ng-options="item as item.Nombre for item in $ctrl.camposList track by item.Id"></select></div><label class="col-md-2 center-label">Orden*:</label><div class="col-md-4"><input type="text" class="form-control" name="" ng-model="$ctrl.campoCargado.Orden" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"></div><label class="col-md-2 center-label">Obligatorio*:</label><div class="col-md-4"><ba-switcher switcher-style="primary" switcher-value="$ctrl.campoCargado.Obligatorio"></ba-switcher></div><div class="col-md-12"><button class="btn btn-warning" ng-click="$ctrl.clearCampo()" ng-disabled="$ctrl.isBusy">Limpiar</button> <button class="btn btn-success pull-right" ng-click="$ctrl.editCampo(form)" ng-disabled="$ctrl.isBusy">Guardar</button></div></div><div ba-panel="" ba-panel-title="Campos Cargados" ba-panel-class="with-scroll"><table class="table" st-table="$ctrl.templateCamposDS" st-safe-src="$ctrl.templateCamposList"><thead><tr class="sortable"><th class="text-center">Nombre</th><th class="text-center">Tipo</th><th class="text-center" st-sort-default="true">Orden</th><th class="text-center">Obligatorio</th><th class="text-center">Acciones</th></tr><tr><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Campo.Nombre" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por campo" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Campo.CampoTipo.Nombre" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por tipo de campo" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Orden" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por orden" aria-describedby="basic-addon1"></div></th><th></th></tr></thead><tbody ng-show="!$ctrl.isCampoSearching"><tr ng-repeat="item in $ctrl.templateCamposDS" ng-click="$ctrl.cargarCampo(item)" style="cursor: pointer"><td align="center">{{item.Campo.Nombre}}</td><td align="center">{{item.Campo.CampoTipo.Nombre}}</td><td align="center">{{item.Orden}}</td><td align="center"><i class="fa fa-check" style="color:green" ng-show="item.Obligatorio"></i> <i class="fa fa-times" style="color:red" ng-hide="item.Obligatorio"></i></td><td align="center"><button class="btn btn-success editable-table-button btn-xs" ng-click="$ctrl.cargarCampo(item)" ng-disabled="$ctrl.isBusy">Ver</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.eliminarCampo($index)" ng-disabled="$ctrl.isBusy">Eliminar</button></td></tr></tbody><tbody ng-show="$ctrl.isCampoSearching"><tr><td colspan="4" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="4" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table></div></uib-tab><uib-tab index="2" heading="Tipo de Template" select="$ctrl.loadTipoTemplateTab()" ng-disabled="true"><div ba-panel="" ba-panel-class="with-scroll" class="add-top-space"><label class="col-md-2 center-label">Tipo*:</label><div class="col-md-4"><select name="" class="form-control" ng-model="$ctrl.model.TipoTemplate" ng-options="item as item.Nombre for item in $ctrl.tipoTemplateList track by item.Id"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un tipo.</span></div></div><div class="col-md-12" ng-if="$ctrl.model.TipoTemplate.Codigo == \'ENVIO_MAIL\'"><label class="col-md-2 center-label">Destinatario:</label><div class="col-md-4"><select name="" class="form-control" ng-model="$ctrl.tipoEnvioMailConfig.CampoDestinatario" ng-options="item as item.Nombre for item in $ctrl.camposBasicosList track by item.Id"></select></div><label class="col-md-2 center-label">Copia:</label><div class="col-md-4"><select name="" class="form-control" ng-model="$ctrl.tipoEnvioMailConfig.CampoCopia" ng-options="item as item.Nombre for item in $ctrl.camposBasicosList track by item.Id"></select></div><label class="col-md-2 center-label">Asunto:</label><div class="col-md-4"><select name="" class="form-control" ng-model="$ctrl.tipoEnvioMailConfig.CampoAsunto" ng-options="item as item.Nombre for item in $ctrl.camposBasicosList track by item.Id"></select></div><label class="col-md-2 center-label">Mensaje*:</label><div class="col-md-4"><select name="" class="form-control" ng-model="$ctrl.tipoEnvioMailConfig.CampoMensaje" ng-options="item as item.Nombre for item in $ctrl.camposBasicosList track by item.Id"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un campo mensaje.</span></div></div></div><div class="col-md-12" ng-if="$ctrl.model.TipoTemplate.Codigo == \'CREA_NOTI_DOC\'"><label class="col-md-2 center-label">Destinatario:</label><div class="col-md-4"><select name="" class="form-control" ng-model="$ctrl.tipoEnvioMailConfig.CampoDestinatario" ng-options="item as item.Nombre for item in $ctrl.camposBasicosList track by item.Id"></select></div><label class="col-md-2 center-label">Copia:</label><div class="col-md-4"><select name="" class="form-control" ng-model="$ctrl.tipoEnvioMailConfig.CampoCopia" ng-options="item as item.Nombre for item in $ctrl.camposBasicosList track by item.Id"></select></div><label class="col-md-2 center-label">Asunto:</label><div class="col-md-4"><select name="" class="form-control" ng-model="$ctrl.tipoEnvioMailConfig.CampoAsunto" ng-options="item as item.Nombre for item in $ctrl.camposBasicosList track by item.Id"></select></div><label class="col-md-2 center-label">Mensaje*:</label><div class="col-md-4"><input type="text" class="form-control" ng-model="$ctrl.model.CuerpoMensaje" name="" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el cuerpo del mensaje.</span></div></div><div class="col-md-12"><label class="col-md-2 center-label">Se envia a todos los usuarios del proceso?*:</label><div class="col-md-4"><label ng-if="$ctrl.model.enviotodos">S\xED</label> <label ng-if="!$ctrl.model.enviotodos">No</label></div><div class="col-md-4"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.enviotodos"></ba-switcher></div></div><div class="col-md-12"><label class="col-md-2 center-label">Se envia a todos los usuarios del sistema?*:</label><div class="col-md-4"><label ng-if="$ctrl.model.enviosistema">S\xED</label> <label ng-if="!$ctrl.model.enviosistema">No</label></div><div class="col-md-4"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.enviosistema"></ba-switcher></div></div></div><div class="col-md-12" ng-if="$ctrl.model.TipoTemplate.Codigo == \'HAB_USUARIO\'"><label class="col-md-2 center-label">Usuario a Habilitar*:</label><div class="col-md-4"><select name="" class="form-control" ng-model="$ctrl.tipoHabilitacionUsuarioConfig.CampoUsuarioHabilitar" ng-options="item as item.Nombre for item in $ctrl.camposUsuarioList track by item.Id"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un campo usuario a habilitar.</span></div></div><label class="col-md-2 center-label">Template a Habilitar*:</label><div class="col-md-4"><select name="" class="form-control" ng-model="$ctrl.tipoHabilitacionUsuarioConfig.CampoTemplatesHabilitar" ng-options="item as item.Nombre for item in $ctrl.camposTemplateList track by item.Id"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un campo templates a habilitar.</span></div></div><label class="col-md-12 center-label" style="margin-top: 30px">Datos propios de la notificaci\xF3n que se enviar\xE1 cuando se habilite el template:</label> <label class="col-md-2 center-label">Copia:</label><div class="col-md-4"><select name="" class="form-control" ng-model="$ctrl.tipoHabilitacionUsuarioConfig.CampoCopia" ng-options="item as item.Nombre for item in $ctrl.camposBasicosList track by item.Id"></select></div><label class="col-md-2 center-label">Asunto:</label><div class="col-md-4"><select name="" class="form-control" ng-model="$ctrl.tipoHabilitacionUsuarioConfig.CampoAsunto" ng-options="item as item.Nombre for item in $ctrl.camposBasicosList track by item.Id"></select></div><label class="col-md-2 center-label">Mensaje*:</label><div class="col-md-4"><select name="" class="form-control" ng-model="$ctrl.tipoHabilitacionUsuarioConfig.CampoMensaje" ng-options="item as item.Nombre for item in $ctrl.camposBasicosList track by item.Id"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un campo mensaje.</span></div></div></div><div class="col-md-12" ng-if="$ctrl.model.TipoTemplate.Codigo == \'RECURSIVO\'"><label class="col-md-2 center-label">Condici\xF3n*:</label><div class="col-md-4"><select name="" class="form-control" ng-model="$ctrl.tipoRecursivoConfig.CampoCondicion" ng-options="item as item.Nombre for item in $ctrl.camposBasicosList track by item.Id"></select></div><label class="col-md-2 center-label">Valor de Condici\xF3n*:</label><div class="col-md-4"><input type="text" class="form-control" ng-model="$ctrl.tipoRecursivoConfig.ValorCondicion" name="" placeholder=""></div><label class="col-md-2 center-label">Fecha Inicial*:</label><div class="col-md-4"><select name="" class="form-control" ng-model="$ctrl.tipoRecursivoConfig.CampoFechaInicia" ng-options="item as item.Nombre for item in $ctrl.camposFechaList track by item.Id"></select></div><label class="col-md-2 center-label">Periodicidad*:</label><div class="col-md-4"><select name="" class="form-control" ng-model="$ctrl.tipoRecursivoConfig.CampoPeriodicidad" ng-options="item as item.Nombre for item in $ctrl.camposPeriodoList track by item.Id"></select></div><label class="col-md-12 center-label">Campos a Repetir:</label><table class="table" st-table="$ctrl.templateCamposList"><thead><tr class="sortable"><th class="text-center">Seleccionado</th><th class="text-center">Campo</th><th class="text-center">Tipo</th></tr></thead><tbody ng-show="!$ctrl.isCampoSearching"><tr ng-repeat="item in $ctrl.templateCamposList"><td align="center"><input type="checkbox" ng-model="item.Campo.Seleccionado" name="" ng-disabled="$ctrl.isBusy"></td><td align="center">{{item.Campo.Nombre}}</td><td align="center">{{item.Campo.CampoTipo.Nombre}}</td></tr></tbody><tbody ng-show="$ctrl.isCampoSearching"><tr><td colspan="4" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="4" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></uib-tab></uib-tabset><div class="col-md-12"><button class="btn btn-success" ng-click="$ctrl.save(form)" ng-disabled="$ctrl.isBusy">Guardar</button> <button class="btn btn-danger" ng-click="$ctrl.cancel()" ng-disabled="$ctrl.isBusy">Cancelar</button> <button class="btn btn-warning pull-right" ng-click="$ctrl.delete()" ng-disabled="$ctrl.isBusy" ng-show="$ctrl.showDelete">Borrar</button></div></div></form></div>');
$templateCache.put('app/pages/template/list.template.html','<div class="col-md-12" ng-if="$ctrl.anularVista"><h5>No tiene permisos para visualizar esta vista.</h5></div><div class="add-row-editable-table" ng-if="!$ctrl.anularVista"><button class="btn btn-primary" ng-click="$ctrl.add()">Agregar</button></div><table class="table" st-pipe="$ctrl.buscar" st-table="$ctrl.resultList" ng-if="!$ctrl.anularVista"><thead><tr class="sortable"><th class="text-center" st-sort="Codigo">C\xF3digo</th><th class="text-center" st-sort="Nombre">Nombre</th><th class="text-center" st-sort="Activo">Activo</th><th class="text-center" st-sort="TipoTemplate.Nombre">Tipo</th><th class="text-center">Acci\xF3n</th></tr><tr><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Codigo" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por c\xF3digo" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Nombre" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por nombre" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Activo" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por activo" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="TipoTemplate.Nombre" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por tipo" aria-describedby="basic-addon1"></div></th><th></th></tr></thead><tbody ng-show="!$ctrl.isSearching"><tr ng-repeat="item in $ctrl.resultList" ng-click="$ctrl.edit(item.Id)" style="cursor: pointer"><td align="center">{{item.Codigo}}</td><td align="center">{{item.Nombre}}</td><td align="center"><i class="fa fa-check" style="color:green" ng-show="item.Activo"></i> <i class="fa fa-times" style="color:red" ng-hide="item.Activo"></i></td><td align="center">{{item.TipoTemplate.Nombre}}</td><td align="center"><a href="" ng-click="$ctrl.edit(item.Id)">Ver</a> <a href="{{item.UrlLink}}" target="_blank">{{item.NombreLink}}</a></td></tr></tbody><tbody ng-show="$ctrl.isSearching"><tr><td colspan="4" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="4" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table>');
$templateCache.put('app/pages/usuario/edit.template.html','<div ba-panel="" ba-panel-title="{{$ctrl.title}}" ba-panel-class="with-scroll"><form name="form" novalidate=""><div class="form-group" ng-class="{ \'has-error\': form.name.$invalid && (form.name.$dirty || $ctrl.showError) }"><div ba-panel="" ba-panel-title="Datos de Conexi\xF3n" ba-panel-class="with-scroll" class="add-top-space"><label class="col-md-2 center-label">Nombre de Usuario*:</label><div class="col-md-10"><input type="text" class="form-control" ng-model="$ctrl.model.Login" name="login" placeholder="" required="" ng-disabled="!$ctrl.lsuarioLogueadoIsSysAdmin"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el nombre de usuario.</span></div><br></div><label class="col-md-2 center-label">Contrase\xF1a*:</label><div class="col-md-4"><input type="password" class="form-control" ng-model="$ctrl.model.Clave" name="clave" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar la contrase\xF1a.</span></div><br></div><label class="col-md-2 center-label">Confirmar Contrase\xF1a*:</label><div class="col-md-4"><input type="password" class="form-control" ng-model="$ctrl.model.ConfirmaClave" name="clave" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar la confirmaci\xF3n de la contrase\xF1a.</span></div><br></div><label class="col-md-12 center-label">Roles*:</label><div class="col-md-12"><select multiple="" name="roles" class="form-control" ng-model="$ctrl.rolesSeleccionados" ng-options="item as item.Nombre for item in $ctrl.rolesList track by item.Id" ng-disabled="!$ctrl.lsuarioLogueadoIsSysAdmin"></select></div></div><div ba-panel="" ba-panel-title="Datos del Usuario" ba-panel-class="with-scroll" class="add-top-space"><label class="col-md-2 center-label">Nombre:</label><div class="col-md-4"><input type="text" class="form-control" ng-model="$ctrl.model.Nombre" name="name" placeholder=""><br></div><label class="col-md-2 center-label">Apellido:</label><div class="col-md-4"><input type="text" class="form-control" ng-model="$ctrl.model.Apellido" name="apellido" placeholder=""><br></div></div><div ba-panel="" ba-panel-title="Datos de Contacto" ba-panel-class="with-scroll"><label class="col-md-2 center-label" style="margin-top:10px">Correo Electr\xF3nico:</label><div class="col-md-8"><input type="text" class="form-control" ng-model="$ctrl.mailIngresado"></div><button class="btn btn-primary" ng-click="$ctrl.addMail()" style="margin-bottom:20px">Guardar</button><table class="table" st-table="$ctrl.model.Mails"><thead><tr><th class="text-center">Correo Electr\xF3nico</th><th class="text-center">Acci\xF3n</th></tr></thead><tbody><tr ng-repeat="item in $ctrl.model.Mails"><td align="center">{{item.Mail}}</td><td align="center"><button class="btn btn-danger editable-table-button btn-xs" ng-disabled="$ctrl.isBusy" ng-click="$ctrl.eliminarMail($index)">Quitar</button></td></tr></tbody></table></div><div ba-panel="" ba-panel-title="Permisos a nivel de usuario" ba-panel-class="with-scroll" class="add-top-space"><div layout="row" layout-sm="row" layout-align="start end" layout-xs="row"><label class="col-md-2 center-label" style="margin-top:25px">Puede crear Procesos:</label><div class="col-md-4"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.CanCreateProcess"></ba-switcher></div></div></div><div class="col-md-12"><br><button class="btn btn-success" ng-click="$ctrl.save(form)" ng-disabled="$ctrl.isBusy">Guardar</button> <button class="btn btn-danger" ng-click="$ctrl.cancel()" ng-disabled="$ctrl.isBusy">Cancelar</button> <button class="btn btn-warning pull-right" ng-click="$ctrl.delete()" ng-disabled="$ctrl.isBusy" ng-show="$ctrl.showDelete">Borrar</button></div></div></form></div>');
$templateCache.put('app/pages/usuario/list.template.html','<div class="add-row-editable-table" ng-if="$ctrl.lsuarioLogueadoIsSysAdmin"><button class="btn btn-primary" ng-click="$ctrl.add()">Agregar</button></div><table class="table" st-pipe="$ctrl.buscar" st-table="$ctrl.resultList"><thead><tr class="sortable"><th class="text-center" st-sort="Login">Login</th><th class="text-center" st-sort="Nombre">Nombre</th><th class="text-center" st-sort="Apellido">Apellido</th><th class="text-center">Acci\xF3n</th></tr><tr><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Login" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por login" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Nombre" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por nombre" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Apellido" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por apellido" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Mail" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por mail" aria-describedby="basic-addon1"></div></th></tr></thead><tbody ng-show="!$ctrl.isSearching"><tr ng-repeat="item in $ctrl.resultList" ng-click="$ctrl.edit(item.Id)" style="cursor: pointer"><td align="center">{{item.Login}}</td><td align="center">{{item.Nombre}}</td><td align="center">{{item.Apellido}}</td><td align="center"><a href="" ng-click="$ctrl.edit(item.Id)">Ver</a></td></tr></tbody><tbody ng-show="$ctrl.isSearching"><tr><td colspan="4" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="4" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link">{{ ::subSubitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">{{ ::subitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span> previous</button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','');
$templateCache.put('app/theme/components/pageTop/pageTop.html','');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"><h1 class="al-title">{{ activePageTitle }}</h1><ul class="breadcrumb al-breadcrumb"><li><a href="#/dashboard">Home</a></li><li>{{ activePageTitle }}</li></ul></div>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/directives/templateshtml/listHistorialAutorizacion.html','<div ba-panel="" ba-panel-title="Historial de Autorizaciones" ba-panel-class="with-scroll" ng-show="$ctrl.model.Id > 0 && !$ctrl.anularVista && $ctrl.listadoHistorialAutorizaciones.length>0" id="lusuarios"><div ng-repeat="obj in $ctrl.listadoHistorialAutorizaciones"><div style="margin-bottom: 5px;background-color: #62666921; border-radius: 20px;padding-bottom: 10px;"><div class="panel-heading clearfix panel-headingV2"><h5 class="panel-title ng-binding" style="font-size: 14px;color: white;font-weight: 700;">{{obj.EtapaNombre}}</h5></div><div style="margin-bottom: 5px; min-height: 55px;" class="mdc-card cardAutorizaciones"><img src="/images/user1.png" height="40" width="40" style="float: left;margin: 5px;display: block;"><div class="demo-card__title"><label style="padding: 16px;">{{ obj.Usuario.Nombre }} - {{ obj.Usuario.Login }}</label> <img src="/images/check2.png" height="40" width="40" style="float: right;margin: 5px;" ng-show="obj.autoriza==true"> <img src="/images/cancel1.png" height="40" width="40" style="float: right;margin: 5px;" ng-show="obj.autoriza!=true"></div><div class="demo-card__subhead"><label style="margin: 0px; font-size: 13px;margin-left: 10px;padding: 3px;">Comentarios: {{ obj.Comentario }}</label></div><div class="demo-card__subhead"><label style="margin: 0px; font-size: 13px;margin-left: 10px;padding: 3px;">Fecha Autorizacion: {{ obj.CreationDate}}</label></div><div class="demo-card__subhead"><label style="margin: 0px; font-size: 13px;margin-left: 10px;padding: 3px;">Etapa: {{ obj.EtapaNombre}}</label></div></div></div></div></div>');
$templateCache.put('app/theme/directives/templateshtml/listUsuariosAutorizacion.html','<div ba-panel="" ba-panel-title="Usuarios que pueden Autorizar" ba-panel-class="with-scroll" ng-show="$ctrl.model.Id > 0 && !$ctrl.anularVista && $ctrl.listadoUsuariosAutorizanSolicitudEtapa.length>0" id="lusuarios"><div ng-repeat="obj in $ctrl.listadoUsuariosAutorizanSolicitudEtapa"><div style="margin-bottom: 5px;background-color: white;border-radius: 20px;padding-bottom: 10px;"><div class="panel-heading clearfix panel-headingV2"><h5 class="panel-title ng-binding" style="font-size: 14px;color: white;font-weight: 700;">{{obj.Nombre}}</h5></div><div ng-repeat="usuario in obj.gruposUsuariosRelacion" style="margin-bottom: 5px; min-height: 55px;" class="mdc-card cardAutorizaciones"><img src="/images/user1.png" height="40" width="40" style="float: left;margin: 5px;display: block;"><div class="demo-card__title"><label style="padding: 16px; font-size: 13px;">{{ usuario.Usuario.Nombre }} - {{ usuario.Usuario.Login }}</label> <img src="/images/canAutorice.png" height="40" width="40" style="float: right;margin: 5px;"></div></div></div></div></div>');
$templateCache.put('app/theme/directives/templateshtml/modal.html','<div id="divContainerData" ba-panel="" ba-panel-title="Datos" ba-panel-class="with-scroll" ng-show="!$ctrl.anularVista && $ctrl.showModalDataContainer" class="add-top-space"><div class="col-md-12" ng-show="$ctrl.isCamposLoading">Cargando...</div><div ng-show="!$ctrl.isCamposLoading" ng-if="$ctrl.puedeEditarCampos"><div ng-repeat="item in $ctrl.camposList"><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'JERARQ\' && item.Campo.tipoNumerador==true && item.Solicitud.Proceso.campoIdAutorizacion == item.Campo.Id"><label class="center-label">{{item.Campo.Nombre}}:</label><div ng-repeat="j in item.ValorObjeto"><input type="text" ng-model="j.ValorInput" placeholder="{{j.Placeholder}}" autocomplete="off" uib-typeahead="i as i.Nombre for i in $ctrl.searchJerarquia(j.ValorInput, j.JerarquiaPadreId)" typeahead-wait-ms="500" typeahead-loading="j.LoadingJerarquia" typeahead-no-results="j.NoResults" class="form-control" typeahead-on-select="$ctrl.onSelectJerarquia($parent.$index, $index, $model)" ng-readonly="!$ctrl.model.Id==0" style="color: #666666;"> <i ng-show="j.LoadingJerarquia" class="glyphicon glyphicon-refresh"></i><div ng-show="j.NoResults"><i class="glyphicon glyphicon-remove"></i> Valor no encontrado</div><a href="" class="pull-right" ng-if="item.Campo.PermiteAltaJerarquia" ng-click="$ctrl.altaNuevaJerarquia($parent.$parent.$index, $parent.$index)"><i class="ion-plus-circled"></i></a><div class="col-md-12" ng-show="j.MostrarDetalle" ng-repeat="det in j.Detalles"><label>{{det.Titulo}}: {{det.Valor}}</label></div></div></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'JERARQ\' && item.Campo.tipoNumerador==false && item.Solicitud.Proceso.campoIdAutorizacion == item.Campo.Id"><label class="center-label">{{item.Campo.Nombre}}:</label><div ng-repeat="j in item.ValorObjeto"><input type="text" ng-model="j.ValorInput" placeholder="{{j.Placeholder}}" autocomplete="off" uib-typeahead="i as i.Nombre for i in $ctrl.searchJerarquia(j.ValorInput, j.JerarquiaPadreId)" typeahead-wait-ms="500" typeahead-loading="j.LoadingJerarquia" typeahead-no-results="j.NoResults" class="form-control" typeahead-on-select="$ctrl.onSelectJerarquia($parent.$index, $index, $model)"> <i ng-show="j.LoadingJerarquia" class="glyphicon glyphicon-refresh"></i><div ng-show="j.NoResults"><i class="glyphicon glyphicon-remove"></i> Valor no encontrado</div><a href="" class="pull-right" ng-if="item.Campo.PermiteAltaJerarquia" ng-click="$ctrl.altaNuevaJerarquia($parent.$parent.$index, $parent.$index)"><i class="ion-plus-circled"></i></a><div class="col-md-12" ng-show="j.MostrarDetalle" ng-repeat="det in j.Detalles"><label>{{det.Titulo}}: {{det.Valor}}</label></div></div></div></div></div></div>');
$templateCache.put('app/pages/tables/basic/tables.html','<div class="widgets"><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Hover Rows" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/hoverRows.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Bordered Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/borderedTable.html"></div></div></div></div><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Condensed Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/condensedTable.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Striped Rows" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/stripedRows.html"></div></div></div></div><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Contextual Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/contextualTable.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Responsive Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/responsiveTable.html"></div></div></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">SI</span> <span class="handle"></span> <span class="handle handle-off">NO</span></div></div></label>');
$templateCache.put('app/pages/tables/smart/tables.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Editable Rows" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/editableRowTable.html"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Editable Cells" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/editableTable.html"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Smart Table With Filtering, Sorting And Pagination" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/smartTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/tables/widgets/basicTable.html','<div class="horizontal-scroll"><table class="table"><thead><tr><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="table-arr"></th><th class="align-right">Downloads</th><th class="table-arr"></th><th class="align-right">Purchases</th><th class="table-arr"></th><th class="align-right">DAU</th><th class="table-arr"></th><th class="align-right">MAU</th><th class="table-arr"></th><th class="align-right">LTV</th><th class="table-arr"></th><th class="align-right">Users %</th><th class="table-arr"></th></tr></thead><tbody><tr><td><img src="img/chrome.svg" width="20" height="20"></td><td class="nowrap">Google Chrome</td><td class="align-right">10,392</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">3,822</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">4,214</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">899</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">7,098</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">178</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">45%</td><td class="table-arr"><i class="icon-up"></i></td></tr><tr><td><img src="img/firefox.svg" width="20" height="20"></td><td class="nowrap">Mozilla Firefox</td><td class="align-right">7,873</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">6,003</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,031</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">897</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">8,997</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">102</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">28%</td><td class="table-arr"><i class="icon-up"></i></td></tr><tr><td><img src="img/ie.svg" width="20" height="20"></td><td class="nowrap">Internet Explorer</td><td class="align-right">5,890</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,492</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">2,102</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">27</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">4,039</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">99</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">17%</td><td class="table-arr"><i class="icon-down"></i></td></tr><tr><td><img src="img/safari.svg" width="20" height="20"></td><td class="nowrap">Safari</td><td class="align-right">4,001</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">2,039</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">1,001</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">104</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,983</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">209</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">14%</td><td class="table-arr"><i class="icon-down"></i></td></tr><tr><td><img src="img/opera.svg" width="20" height="20"></td><td class="nowrap">Opera</td><td class="align-right">1,833</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">983</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">83</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">19</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">1,099</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">103</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">5%</td><td class="table-arr"><i class="icon-up"></i></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/borderedTable.html','<div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="align-right">Purchases</th><th class="align-right">%</th></tr></thead><tbody><tr ng-repeat="item in metricsTableData"><td><img ng-src="{{::( item.image | appImage )}}" width="20" height="20"></td><td ng-class="nowrap">{{item.browser}}</td><td class="align-right">{{item.visits}}</td><td class="align-right">{{item.purchases}}</td><td class="align-right">{{item.percent}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/condensedTable.html','<div class="horizontal-scroll"><table class="table table-condensed"><thead><tr><th class="table-id">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Status</th></tr></thead><tbody><tr ng-repeat="item in peopleTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td><button class="status-button btn btn-xs btn-{{item.status}}">{{item.status}}</button></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/contextualTable.html','<table class="table"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr class="primary"><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class="email-link" ng-href="mailto:mdo@gmail.com" href="mailto:mdo@gmail.com">mdo@gmail.com</a></td><td>28</td></tr><tr class="success"><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class="email-link" ng-href="mailto:fat@yandex.ru" href="mailto:fat@yandex.ru">fat@yandex.ru</a></td><td>45</td></tr><tr class="warning"><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class="email-link" ng-href="mailto:twitter@outlook.com" href="mailto:twitter@outlook.com">twitter@outlook.com</a></td><td>18</td></tr><tr class="danger"><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class="email-link" ng-href="mailto:snow@gmail.com" href="mailto:snow@gmail.com">snow@gmail.com</a></td><td>20</td></tr><tr class="info"><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class="email-link" ng-href="mailto:jack@yandex.ru" href="mailto:jack@yandex.ru">jack@yandex.ru</a></td><td>30</td></tr></table>');
$templateCache.put('app/pages/tables/widgets/editableRowTable.html','<div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addUser()">Add row</button></div><table class="table table-bordered table-hover table-condensed"><tr><td></td><td>Name</td><td>Status</td><td>Group</td><td>Actions</td></tr><tr ng-repeat="user in users" class="editable-row"><td>{{$index}}</td><td><span editable-text="user.name" e-name="name" e-form="rowform" e-required="">{{ user.name || \'empty\' }}</span></td><td class="select-td"><span editable-select="user.status" e-name="status" e-form="rowform" e-selectpicker="" e-ng-options="s.value as s.text for s in statuses">{{ showStatus(user) }}</span></td><td class="select-td"><span editable-select="user.group" e-name="group" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.text for g in groups">{{ showGroup(user) }}</span></td><td><form editable-form="" name="rowform" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == user"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="removeUser($index)">Delete</button></div></td></tr></table>');
$templateCache.put('app/pages/tables/widgets/editableTable.html','<div class="horizontal-scroll"><table class="table table-hover" st-table="editableTableData"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="firstName">First Name</th><th st-sort="lastName">Last Name</th><th st-sort="username">Username</th><th st-sort="email">Email</th><th st-sort="age">Age</th></tr></thead><tbody><tr ng-repeat="item in editableTableData" class="editable-tr-wrap"><td class="table-id">{{item.id}}</td><td><span editable-text="item.firstName" blur="cancel">{{item.firstName}}</span></td><td><span editable-text="item.lastName" blur="cancel">{{item.lastName}}</span></td><td><span editable-text="item.username" blur="cancel">{{item.username}}</span></td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td><span editable-text="item.age" blur="cancel">{{item.age}}</span></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="12" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/tables/widgets/hoverRows.html','<div class="horizontal-scroll"><table class="table table-hover"><thead><tr class="black-muted-bg"><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="table-arr"></th><th class="align-right">Purchases</th><th class="table-arr"></th><th class="align-right">%</th><th class="table-arr"></th></tr></thead><tbody><tr ng-repeat="item in metricsTableData" class="no-top-border"><td><img ng-src="{{::( item.image | appImage )}}" width="20" height="20"></td><td ng-class="nowrap">{{item.browser}}</td><td class="align-right">{{item.visits}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isVisitsUp, \'icon-down\': !item.isVisitsUp }"></i></td><td class="align-right">{{item.purchases}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isPurchasesUp, \'icon-down\': !item.isPurchasesUp }"></i></td><td class="align-right">{{item.percent}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isPercentUp, \'icon-down\': !item.isPercentUp }"></i></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/responsiveTable.html','<div class="table-responsive"><table class="table"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class="email-link" ng-href="mailto:mdo@gmail.com" href="mailto:mdo@gmail.com">mdo@gmail.com</a></td><td>28</td></tr><tr><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class="email-link" ng-href="mailto:fat@yandex.ru" href="mailto:fat@yandex.ru">fat@yandex.ru</a></td><td>45</td></tr><tr><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class="email-link" ng-href="mailto:twitter@outlook.com" href="mailto:twitter@outlook.com">twitter@outlook.com</a></td><td>18</td></tr><tr><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class="email-link" ng-href="mailto:snow@gmail.com" href="mailto:snow@gmail.com">snow@gmail.com</a></td><td>20</td></tr><tr><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class="email-link" ng-href="mailto:jack@yandex.ru" href="mailto:jack@yandex.ru">jack@yandex.ru</a></td><td>30</td></tr></table></div>');
$templateCache.put('app/pages/tables/widgets/smartTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table class="table" st-table="smartTableData"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="firstName">First Name</th><th st-sort="lastName">Last Name</th><th st-sort="username">Username</th><th st-sort="email">Email</th><th st-sort="age">Age</th></tr><tr><th></th><th><input st-search="firstName" placeholder="Search First Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastName" placeholder="Search Last Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="username" placeholder="Search Username" class="input-sm form-control search-input" type="search"></th><th><input st-search="email" placeholder="Search Email" class="input-sm form-control search-input" type="search"></th><th><input st-search="age" placeholder="Search Age" class="input-sm form-control search-input" type="search"></th></tr></thead><tbody><tr ng-repeat="item in smartTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/tables/widgets/stripedRows.html','<div class="vertical-scroll"><table class="table table-striped"><thead><tr><th class="table-id">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr></thead><tbody><tr ng-repeat="item in smartTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody></table></div>');}]);